(function () {
  'use strict';

  angular
    .module('app.core', [
    ]);

  angular
    .module('fileUpload', ['ngFileUpload']);

  angular
    .module('app', [
      'app.core',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'daterangepicker',
      'pascalprecht.translate',
      'fileUpload',
      'angular-uuid',
      'angular-sly',
      'tmh.dynamicLocale',
      'angular-google-analytics'
    ]);

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/landingPage/landingPage.html","<div id=landing-page odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#434C53><div class=\"landing-buttons display__flex flex-direction-column flex-justify-content-center flex-align-item-center\" ng-if=!landingPage.modalDiv.show><!-- Overview Groups (General + Cross-country) --><div class=\"overview-groups display__flex flex-justify-content-center flex-align-item-center\" ng-if=\"landingPage.menuLanding.generalView.visible || landingPage.menuLanding.countriesView.visible\"><!-- General Overview group bubble --><div class=\"group-bubble display__flex flex-justify-content-center flex-align-item-center\" ng-if=landingPage.menuLanding.generalView.visible><odec-d3-bubble-landing text-bubble=landingPage.menuLanding.generalView.groupBubble.text icon-bubble=landingPage.menuLanding.generalView.groupBubble.icon index-bubble=0 fn-bubble=landingPage.fnBubble props-bubble=landingPage.groupBubbleProps.generalView is-group=landingPage.menuLanding.generalView.groupBubble.isGroup group-source=landingPage.menuLanding.generalView.groupBubble.groupSource></odec-d3-bubble-landing></div><!-- Cross-country group bubble --><div class=\"group-bubble display__flex flex-justify-content-center flex-align-item-center\" ng-if=landingPage.menuLanding.countriesView.visible><odec-d3-bubble-landing text-bubble=landingPage.menuLanding.countriesView.groupBubble.text icon-bubble=landingPage.menuLanding.countriesView.groupBubble.icon index-bubble=1 fn-bubble=landingPage.fnBubble props-bubble=landingPage.groupBubbleProps.countriesView is-group=landingPage.menuLanding.countriesView.groupBubble.isGroup group-source=landingPage.menuLanding.countriesView.groupBubble.groupSource></odec-d3-bubble-landing></div></div><!-- Detailed Overview --><div class=\"detailed-view display__flex flex-direction-column flex-justify-content-center flex-align-item-center\"><div class=\"title bold--700 display__flex flex-justify-content-center flex-align-item-center\" ng-if=landingPage.menuLanding.detailedView.visible><p class=text-center>{{ \'LANDING_DETAILED_OVERVIEW\' | translationWithPrefix }}</p></div><div class=\"bubbles display__flex flex-justify-content-center flex-align-item-start flex-wrap\" ng-if=landingPage.menuLanding.detailedView.visible><div class=\"bubble-button padding--0_5 display__flex flex-justify-content-center flex-align-item-center\" ng-repeat=\"button in landingPage.menuLanding.detailedView.bubbles track by $index\" ng-if=button.visible ng-style=\"{\'width\': (100 / landingPage.menuLanding.detailedView.properties.maxBubbles) + \'%\'}\"><odec-d3-bubble-landing text-bubble=button.text icon-bubble=button.icon index-bubble=$index fn-bubble=landingPage.fnBubble params-url-bubble=button.paramsUrl state-bubble=button.url props-bubble=landingPage.menuLanding.detailedView.properties is-modal=button.isModal is-historic=button.isHistoric></odec-d3-bubble-landing></div></div></div></div><div class=\"modal-landing ng-animate-fade\" ng-if=landingPage.modalDiv.show ng-style=\"{\n                \'width\':landingPage.modalDiv.width,\n                \'height\':landingPage.modalDiv.height,\n                \'top\':\'calc(51% - \'+landingPage.modalDiv.height/2+\'px)\',\n                \'left\':\'calc(50% - \'+landingPage.modalDiv.width/2+\'px)\'\n            }\"><a href class=close-modal-landing ng-click=landingPage.modalDiv.close()><i class=\"icon-size-lg icon-close\"></i></a><div class=\"collection display__flex flex-align-item-center flex-justify-content-center flex-wrap\" ng-if=\"!landingPage.modalDiv.historic.isHistoric && !landingPage.modalDiv.group.isGroup\"><div class=\"item-collection padding--2 text-center\" ng-repeat=\"image in landingPage.modalDiv.collection\"><a href ng-click=\"landingPage.modalDiv.goTo(landingPage.modalDiv.state,landingPage.modalDiv.web, image.brand, image.text)\"><img ng-src=assets/data/statics/images/brands/T/{{image.id}}.svg></a></div></div><!-- Group modules --><div class=\"group-collection display__flex flex-direction-column flex-align-item-center flex-justify-content-center\" ng-if=landingPage.modalDiv.group.isGroup><div class=\"title-group display__flex flex-justify-content-center flex-align-item-center\"><span class=bold--700>{{ landingPage.modalDiv.group.title | translationWithPrefix }}</span></div><div class=\"bubbles display__flex flex-justify-content-center flex-align-item-center flex--1\"><div class=bubble-button ng-repeat=\"button in landingPage.modalDiv.group.elements track by button.id\"><odec-d3-bubble-landing text-bubble=button.text icon-bubble=button.icon index-bubble=$index fn-bubble=landingPage.fnBubble params-url-bubble=button.paramsUrl props-bubble=landingPage.modalDiv.group.properties is-modal=button.isModal></odec-d3-bubble-landing></div></div></div><!-- Caso del historico --><div class=\"historic-collection display__flex flex-direction-column flex-align-item-center flex-justify-content-center flex-wrap\" ng-if=landingPage.modalDiv.historic.isHistoric><div class=\"title-historic display__flex flex-justify-content-center flex-align-item-center\"><span class=bold--700>{{ \'HISTORY_MODAL_TITLE\' | translationWithPrefix }}</span></div><div class=\"bubbles display__flex flex-justify-content-center flex-align-item-center flex--1\"><div class=bubble-button ng-repeat=\"button in landingPage.modalDiv.historic.elements track by button.id\"><odec-d3-bubble-landing text-bubble=button.text icon-bubble=button.icon index-bubble=$index fn-bubble=landingPage.fnBubble params-url-bubble=button.paramsUrl state-bubble=button.url props-bubble=landingPage.menuLanding.detailedView.properties></odec-d3-bubble-landing></div></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=login-wrapper><div class=login-wrapper--inner><form><div class=\"logo-wrapper text-center margin-top--2 display__flex flex-justify-content-center flex-align-item-center flex-direction-column\"><img src=assets/images/logo_puig.svg alt=\"Logo Puig\" style=height:120px><p class=\"bold--700 margin-top--1\">Welcome to Puig’s Brand Essentials Tracker</p></div><div class=\"login-form padding--1\"><div class=\"margin-top--2 login-input\"><input type=text name=username placeholder=user autofocus ng-model=login.username autocomplete=off></div><div class=\"margin-top--1_5 login-input\"><input #password type=password name=password placeholder=password ng-model=login.password autocomplete=off></div></div><div class=\"login-errors padding-left--1 ng-animate-fade\" ng-if=login.errorMessage><span class=\"label text-error message_wrapped no-padding bold--700\"><small>{{login.errorMessage}}</small></span></div><div class=\"login-button text-center margin--2_5\"><odec-loading-button class=padding--0_5 ng-click=login.login(login.username,login.password) odec-loading-button-loading=login.loading><span class=bold--700>LOGIN</span></odec-loading-button></div></form></div><odec-notice-popup></odec-notice-popup></div>");
$templateCache.put("app/main/main.html","<odec-layout-ui><div class=main-content ng-class=\"{\'production-date\': main.productionDate}\"><odec-header class=no-print ng-class=\"{\'opened-filter-header\': main.filterOpened}\"><div class=\"header-bar display__flex flex-justify-content-between flex-align-item-center\"><div class=\"header-logo padding--0_5 display__flex flex-center flex-align-item-center\"><img src=assets/images/logo_puig.svg alt=\"Logo Puig\" style=\"height: 50px\"></div><div class=\"actions-header display__flex flex-align-item-center flex-justify-content-center\"><!--Task Scheduler--><odec-task-scheduler class=margin-right--1 ng-if=main.showTaskScheduler></odec-task-scheduler><!--Link HOME--> <a href ui-sref=landingPage class=margin-right--1><i class=\"icon-size-lg icon-home\"></i></a><!--Link Glossary--> <a href><i class=\"icon-size-lg icon-glossary margin-right--1\" tooltip-placement=bottom-right tooltip-trigger=\"\'outsideClick\'\" uib-tooltip-html=main.glossary.contenGlossary tooltip-class=\"custom-class glossary-tooltip width-600\"></i> </a><!--Print Module Button--> <button class=\"btn btn-md btn-transparent no-padding margin-right--1\" ng-click=main.print.printModule() ng-if=main.showTaskScheduler ga-track-event=\"[\'Print jobs\', \'click\', \'printModule:\'+ main.print.nameModule ]\"><i class=icon-size-lg ng-class=\"{\n                                    \'icon-print\':!main.print.loading,\n                                    \'icon-spinner22 animated-spin\':main.print.loading\n                        }\"></i></button><div class=\"header-nav-notifications margin-right--1 ng-animate-fade\" ng-if=\"main.notifications.snapshots > 0\"><a ui-sref=main.snapshots class=header-nav-notifications-item uib-tooltip=\"{{ \'MAIN_SNAPSHOTS\'| translationWithPrefix }}\" tooltip-placement=bottom><i class=\"icon-size-lg icon-camara\"></i> <span id=n-interviews class=badge>{{main.notifications.snapshots}}</span></a></div><!--Drowdown USER--><div class=\"user-dropdown margin-right--1\" uib-dropdown auto-close=outsideClick><button id=btn-append-to-single-button type=button uib-dropdown-toggle><i class=\"icon-size-lg icon-user\"></i><!--<span class=\"caret\"></span>--></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu aria-labelledby=btn-append-to-single-button><li role=menuitem><a class=flex-align-item-center><i class=\"icon-size-lg icon-user2 margin-right--0_5\"></i> <span class=bold--700>{{main.user.name}}</span></a></li><!-- <li role=\"menuitem\"><a href class=\"flex-align-item-center\"\n                                    ng-click=\"main.actions.stateGo(main.actions.states.changePassword)\"><i\n                                        class=\"icon-size-lg icon-settings margin-right--0_5\"></i> <span>\n                                        {{ \'CHANGE_PASSWORD\' | translationWithPrefix}}</span></a></li> --><li role=menuitem><a href class=flex-align-item-center ng-click=main.actions.stateGo(main.actions.states.logout)><i class=\"icon-size-lg icon-power-off margin-right--0_5\"></i> <span>{{ \'LOGOUT\' | translationWithPrefix }} </span></a></li><!--<li class=\"divider\"></li>\n                                <li role=\"menuitem\"><a href=\"#\">Separated link</a></li>--></ul></div></div></div></odec-header><div class=content-wrapper><!--breadcrumb--><odec-breadcrumb></odec-breadcrumb><odec-sidebar-overlay odec-sidebar-overlay-opened=main.hideFilter.opened odec-sidebar-overlay-close=main.hideFilter.close(false)></odec-sidebar-overlay><div ui-view=content></div></div></div></odec-layout-ui>");
$templateCache.put("app/worldMap/worldMap.html","<div id=worldMap class=padding--1_5><img src=assets/images/logo_puig.svg alt=\"Logo Puig\" style=\"height: 90px; position: absolute; top: 10px\"><odec-draw-maps fn-click=worldMap.clickCountry country-selected=worldMap.countrySelected></odec-draw-maps></div>");
$templateCache.put("app/snapshots/snapshots.html","<div id=snapshots class=padding--1_5><div class=\"snapshots-collections-actions padding-bottom--2 row\"><div class=col-md-6><button class=\"btn btn-md btn-action\" ng-disabled=!snapshots.lastState.state.name ng-click=snapshots.goBack() uib-tooltip=\"{{ \'SNAPSHOTS_GO_BACK\' | translationWithPrefix }}\"><i class=\"icon-size-lg icon-arrow_back text-system\"></i></button></div><div class=\"col-md-6 text-right\" ng-if=\"snapshots.snapshotsCollection.length > 0\"><button class=\"btn btn-md btn-action\" ng-disabled=snapshots.exportingPPT ng-click=snapshots.createPPT(snapshots.snapshotsCollection) uib-tooltip=\"{{ \'SNAPSHOTS_DOWNLOAD_PPT\' | translationWithPrefix }}\"><i class=\"icon-size-lg icon-ppt-business-presentation-file-format-symbol text-system\"></i> <i ng-if=snapshots.exportingPPT class=\"icon-size-md icon-spinner22 animated-spin margin-left--0_5\"></i></button> <button class=\"btn btn-md btn-action\" ng-click=snapshots.clearAll() uib-tooltip=\"{{ \'SNAPSHOTS_DELETE_ALL\' | translationWithPrefix}}\"><i class=\"icon-size-lg icon-times text-system\"></i></button></div></div><odec-no-data-display ng-if=\"!snapshots.snapshotsCollection.length > 0\"></odec-no-data-display><div class=\"snapshots-miniatures-wrapper panel-like-borders row\" ng-if=\"snapshots.snapshotsCollection.length > 0\"><div class=\"col-md-12 snapshots-collection-strip padding--1\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D><div class=snapshots-miniatures-horizontal-scroller><a class=\"snapshots-miniature margin-left--1\" ng-repeat=\"snap in snapshots.snapshotsCollection track by $index\" ng-click=\"snapshots.selectedImage = snap;snapshots.selectedImage.index = $index;\"><img ng-src={{snap.image}} alt=\"\"></a></div></div></div><div class=margin-top--1 ng-if=\"snapshots.snapshotsCollection.length > 0\"><p>* {{ \'SNAPSHOTS_SELECT_FOR_EDIT\' | translationWithPrefix}}</p></div><div class=\"margin-top--2 separator-bottom\" ng-if=snapshots.selectedImage><p>{{ \'SNAPSHOTS_EDIT_SNAPSHOT\' | translationWithPrefix}}</p></div><div class=\"snapshots-image-viz margin-top--2 row\" ng-if=snapshots.selectedImage><div class=col-md-8><img ng-src={{snapshots.selectedImage.image}} class=snapshots-image-full alt=\"\"></div><div class=\"col-md-4 row\"><form name=snapshotsForm><div class=\"col-md-12 form-group\"><label class=control-label>Título</label><input type=text class=\"form-control material-input\" ng-model=snapshots.selectedImage.title></div><div class=\"col-md-12 form-group\"><label class=control-label>Filtro</label><input type=text class=\"form-control material-input\" ng-model=snapshots.selectedImage.filter></div><div class=\"col-md-12 form-group\"><label class=control-label>Descripción</label><input type=text name=\"\" class=\"form-control material-input\" ng-model=snapshots.selectedImage.description></div><div class=\"col-md-12 text-right padding--1\"><button class=\"btn btn-md btn-action\" ng-if=snapshotsForm.$dirty ng-click=snapshots.update(snapshots.selectedImage) uib-tooltip=Guardar><i class=\"icon-size-lg icon-save text-system\"></i></button> <button class=\"btn btn-md btn-action\" ng-click=snapshots.remove(snapshots.selectedImage) uib-tooltip=\"{{ \'SNAPSHOTS_DELETE\' | translationWithPrefix}}\"><i class=\"icon-size-lg icon-bin text-system\"></i></button></div></form></div></div></div>");
$templateCache.put("app/components/odecBreadcrumb/odecBreadcrumb.html","<div class=\"odec-breadcrumb padding-left--1 display__flex flex-align-item-center no-print\" ng-if=odecBreadcrumb.breadcrumbActive.label><span ng-if=!odecBreadcrumb.breadcrumbActive.icon><img src={{odecBreadcrumb.breadcrumbActive.svg}} style=\"height:14px; vertical-align:middle\"> </span><i class=\"icon-size-lg {{odecBreadcrumb.breadcrumbActive.icon}}\" ng-if=odecBreadcrumb.breadcrumbActive.icon></i> <span class=\"active margin-left--0_5\">/ {{ odecBreadcrumb.breadcrumbActive.label| translationWithPrefix }}</span> <span class=\"active margin-left--0_5\" ng-if=odecBreadcrumb.breadcrumbParams.text>/ {{ odecBreadcrumb.breadcrumbParams.text }}</span></div>");
$templateCache.put("app/components/layout-ui/layoutUi.html","<div class=main-page><ng-transclude ng-class=\"{\'sidebar--open\':vm.opened}\"></ng-transclude></div>");
$templateCache.put("app/components/odecButtonExpandable/odecButtonExpandable.html","<div class=btn-expandable ng-class=\"{\'opened\':odecButtonExpandable.odecButtonExpandableOpened}\"><a href ng-click=odecButtonExpandable.toggleOpen()><i class=\"icon-size-xl icon-search3\"></i></a><div class=btn-expandable-zone ng-transclude></div></div>");
$templateCache.put("app/components/odecCopyToClipboard/odecCopyToClipboard.html","<a ng-click=odecCopyToClipboard.copyToClipboard()><i class=\"icon-size-lg icon-paste2 pointer\" tooltip-placement=bottom-right uib-tooltip-html=odecCopyToClipboard.copyText tooltip-class=\"custom-class text-left\"></i> </a>");
$templateCache.put("app/components/odecCoverModule/odecCoverModule.html","<div id=odec-cover-module class=\"display__flex flex-direction-column\"><img class=background-image ng-src=assets/images/login-background.png> <img class=logo-cover ng-src=assets/images/logo_puig.svg width=90><div class=\"cover-filters display__flex flex-direction-column flex-align-item-center flex-justify-content-start padding--1_5\"><div class=\"cover-title display__flex flex-align-item-start flex-justify-content-start padding--1\"><i class=\"icon-size-xxl {{ odecCoverModule.coverIcon }}\"></i><p class=\"title-module margin-left--1\">{{\'COVER_MODULE\' | translationWithPrefix | uppercase}} <span class=bold--700>{{ odecCoverModule.coverText | uppercase }}</span></p></div><div class=\"filters display__flex flex-direction flex-align-item-start flex-justify-content-start padding--1 flex-wrap\"><p ng-repeat=\"itemFilter in odecCoverModule.coverFilter track by $index\" class=margin-right--1_5>{{ itemFilter.label | translate }}: <span class=bold--700>{{ odecCoverModule.getInfoSelected(itemFilter.id) }}</span></p></div></div></div>");
$templateCache.put("app/components/odecD3BubbleLanding/odecD3BubbleLanding.html","<a id=download href=# download=graph.png>Download</a>");
$templateCache.put("app/components/odecDrawMaps/odecDrawMaps.html","<div class=\"world-map text-center\"></div>");
$templateCache.put("app/components/odecFilter/odecFilter.html","<div class=\"filter-view no-print\" ng-class=\"{\'filter-hidebar\': odecFilter.hideFilterBar}\" ng-class=\"{\'opened\':odecFilter.opened}\"><div class=\"filter-info display__flex flex-direction-row flex-justify-content-center flex-align-item-center\" ng-if=!odecFilter.hideFilterBar><odec-filter-pills odec-filter-pills-collection=odecFilter.pillsCollection></odec-filter-pills><div class=\"button-open-filter display__flex flex-align-item-center flex-justify-content-end padding-right--2\"><button href class=filter-view-toggle ng-click=odecFilter.open(true)><i class=\"icon-size-xl icon-filter_list\" uib-tooltip=\"{{\'FILTER_OPEN\'|translate}}\" tooltip-class=custom-class></i></button></div></div><div class=filter-view-content ng-if=odecFilter.opened><div class=menu-accordion odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#434C53 odec-scrollable-show={{odecFilter.opened}}><uib-accordion close-others=true><div uib-accordion-group class=\"filter-group text-center padding-left--0_5 padding-right--0_5\" ng-repeat=\"group in odecFilter.displayer track by $index\" ng-init=\"status = {isOpen: $first ? true:false}\" is-open=status.isOpen ng-if=\"group.data.length > 0 && !group.hide\"><uib-accordion-heading><div class=filter-group-header><div class=\"text-heading text-left\"><span class=bold--700>{{group.viewLabel | translate | capitalize}}</span></div><i class=\"state-heading icon-size-lg\" ng-class=\"{\'icon-keyboard_arrow_down\': status.isOpen, \'icon-keyboard_arrow_right\': !status.isOpen}\"></i></div></uib-accordion-heading><div class=filter-group-body><div class=filter-group-body-item><div class=filter-group-body-item-rendered-wrapper ng-if=!child.hide ng-repeat=\"child in group.data track by $index\"><!--<div class=\"title-select display__flex flex-direction-row flex-align-item-center\">\n                                        <p class=\"text-left label-select\">{{child.viewLabel | translate | capitalize}}</p>\n                                        <i ng-if=\"odecFilter.loading\" class=\"icon-size-md icon-spinner22 animated-spin\"></i>\n                                    </div>--><div odec-renderer odec-renderer-config=child odec-renderer-disabled=odecFilter.loading></div></div></div></div></div></uib-accordion></div><div class=\"filter-group filter-view-content-action-buttons text-right display__flex flex-justify-content-center flex-align-item-center\"><button class=\"btn btn-md btn-action btn-action-filter\" ng-click=odecFilter.applyFilter() uib-tooltip=\"{{ \'APPLY_FILTER\' | translationWithPrefix }}\"><img ng-src=assets/images/check-filter.svg width=35 height=35></button></div></div></div>");
$templateCache.put("app/components/odecLanguageSelector/odecLanguageSelector.html","<div class=\"header-nav-notifications header-nav-item-dropdown language-selector\" uib-dropdown><a href class=header-nav-notifications-item uib-dropdown-toggle><img ng-src=./assets/images/flags/{{odecLanguageSelector.languageSelector.language.selected.image}} alt=\"\"> <small ng-if=!odecLanguageSelector.languageSelector.isLoading class=hidden-xs>{{odecLanguageSelector.languageSelector.language.selected.lang | translate}} </small><span ng-if=odecLanguageSelector.languageSelector.isLoading><i class=\"icon-size icon-spinner22 animated-spin\"></i></span></a><ul class=\"dropdown-menu dropdown-menu-right flags\" uib-dropdown-menu aria-labelledby=simple-dropdown><li class=dropdown-menu-header>{{odecLanguageSelector.languageSelector.status.label | translate}}</li><!-- LIST --><ul ng-if=\"odecLanguageSelector.languageSelector.status.label===\'HOME_SELECT_COUNTRY\'\" id=langs class=\"country-grid dropdown-list normal-list text-center\"><li uib-tooltip={{country.country}} ng-repeat=\"country in odecLanguageSelector.languageSelector.language.list track by $index\" ng-click=odecLanguageSelector.languageSelector.countrySelectionChange($event,country)><a href><img ng-src=./assets/images/flags/{{country.image}} style=max-height:14px alt=\"\"></a></li></ul><ul ng-if=\"odecLanguageSelector.languageSelector.status.label===\'HOME_SELECT_LANGUAGE\'\" id=langs class=\"lang-grid dropdown-list normal-list text-center\"><li class=\"bordered-b padding--0_5\"><a href class=\"d-block text-right\" ng-click=odecLanguageSelector.languageSelector.returnCountrySelection();$event.stopPropagation()><i class=\"icon-size-lg icon-close\"></i></a></li><li ng-repeat=\"language in odecLanguageSelector.languageSelector.filteredLanguageList track by $index\" class=\"variant-selector padding--0_5\"><a href translate ng-click=odecLanguageSelector.languageSelector.languageSelectionChange(language)>{{language.lang}}</a></li></ul></ul></div>");
$templateCache.put("app/components/odecLegend/odecLegend.html","<div id=legend-content class=\"legend-content display__flex flex-align-item-center flex-justify-content-between padding-left--1 padding-right--1\"><div class=\"left-legend display__flex flex-direction-column flex-align-item-start\" ng-class=\"{\'flex-justify-content-start\':odecLegend.odecLeftLegend.length > 1, \'flex-justify-content-center\':odecLegend.odecLeftLegend.length <= 1}\"><p class=\"text-legend bold--700 text-left\" ng-repeat=\"left in odecLegend.odecLeftLegend\" ng-if=odecLegend.odecLeftLegend><span>{{ left | translationWithPrefix }}</span></p></div><div class=\"right-legend display__flex flex-direction-column flex-align-item-end flex-justify-content-center\"><p class=\"text-legend bold--700 text-right\" ng-repeat=\"right in odecLegend.odecRightLegend\"><i class=\"icon-pill margin-right--0_5\" ng-style=\"{\'color\':odecLegend.legend.colorsSignification.up}\" ng-if=!odecLegend.hideSignification></i> <i class=\"icon-pill margin-right--0_5\" ng-style=\"{\'color\':odecLegend.legend.colorsSignification.down}\" ng-if=!odecLegend.hideSignification></i> <span>{{ right | translationWithPrefix }}</span></p></div></div>");
$templateCache.put("app/components/odecLoadingButton/odecLoadingButton.html","<button class=\"btn btn-action\" ng-disabled=odecLoadingButton.odecLoadingButtonLoading><ng-transclude class=button-text></ng-transclude><i ng-if=odecLoadingButton.odecLoadingButtonLoading class=\"icon-size-md icon-spinner22 animated-spin margin-left--0_5\"></i></button>");
$templateCache.put("app/components/odecModal/odecModal.html","<!-- BUTTON, ANCHOR, ... --><ng-transclude></ng-transclude><!-- MODAL TEMPLATE --><script type=text/ng-template id=odecModal.html><div class=\"modal-header\">\n        <h2 class=\"modal-title\">{{modalCtrl.headerTitle | translate}}</h2>\n    </div>\n    <div class=\"modal-body\">\n        <div>{{modalCtrl.bodyMessage | translate}}</div>\n        <!-- Additional data to show -->\n        <div ng-if=\"modalCtrl.showData\" class=\"margin-top--1\">\n            <!-- Wait dialog for async data (if is defined but no lenght) -->\n            <div ng-if=\"modalCtrl.showData.length === 0\">\n                <i class=\"icon-spinner22 animated-spin\"></i>\n            </div>\n            <!-- END wait dialog -->\n            <div ng-repeat=\"data in modalCtrl.showData track by $index\">\n                <span>{{data.key | translate}}</span>\n                <span><b>{{data.value}}</b></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-md btn-system no-print icon-size-lg\" \n                type=\"button\" \n                ng-click=\"modalCtrl.closeModal()\">\n                <i class=\"icon-close2\"></i>\n        </button>\n        <button class=\"btn btn-md btn-system no-print icon-size-lg\" \n                type=\"button\"\n                ng-click=\"modalCtrl.accept()\">\n                <i class=\"icon-check2\"></i>\n        </button>\n    </div></script>");
$templateCache.put("app/components/odecNoDataDisplay/odecNoDataDisplay.html","<div id=no-data-display class=\"display__flex flex-justify-content-center flex-align-item-center\"><!-- ICON --><!-- <div class=\"margin-right--0_5\"><i class=\"icon-size-xl {{ displayCtrl.message.icon }}\"></i></div> --><!-- KEY --><div class=text-center>{{ displayCtrl.message.key | translationWithPrefix }}</div></div>");
$templateCache.put("app/components/odecNoticePopup/odecNoticePopup.html","<div class=notice-popup ng-if=noticeCtrl.visible><div class=notice-popup--panel><button type=button class=notice-popup--close aria-label=Close ng-click=noticeCtrl.close()><i class=icon-close2></i></button><p class=notice-popup--paragraph>To access BET results, please use the <b>new Dashboard link</b>, using your Puig email.</p><p class=notice-popup--paragraph>Please make sure to <b>save the new link</b>.</p><p class=notice-popup--link><span class=bold--700>Access new BET Dashboard:</span> <a href=\"https://app.powerbi.com/groups/me/reports/6c093ec6-346d-46cc-8275-5a4024fe7a33/7c3a096f0ab18759b254?ctid=1e355c04-e0a4-42ed-8e2d-7351591f0ef1&openReportSource=ReportInvitation&experience=power-bi\" target=_blank rel=\"noopener noreferrer\">Here</a></p></div></div>");
$templateCache.put("app/components/odecPanel/odecPanel.html","<div class=\"panel panel-like-borders\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/odecSelect2/odecSelect2.html","<select style=width:100%></select>");
$templateCache.put("app/components/odecSelectionPills/odecSelectionPills.html","<a ng-repeat=\"label in odecSelectionPills.odecSelectionPillsCollection track by $index\" href class=\"label bg-grey-dark padding--0_5 margin--0_5 display__inline-block\" ng-click=odecSelectionPills.onSelection(label)>{{label.text|translate}}<i ng-if=label.isSelected class=\"icon-checkmark padding-left--0_5 text-success\"></i></a>");
$templateCache.put("app/components/odecStarRenderer/odecStarRenderer.html","<p><span ng-repeat=\"item in odecStarRenderer.full | lodashRange\"><i class=\"icon-size-xl icon-star-full text-accent\"></i></span> <span ng-repeat=\"item in odecStarRenderer.partial | lodashRange\"><i class=\"icon-size-xl icon-star-half2 text-accent\"></i></span> <span ng-repeat=\"item in odecStarRenderer.empty| lodashRange\"><i class=\"icon-size-xl icon-star-empty text-accent\"></i></span></p>");
$templateCache.put("app/components/odecTaskScheduler/odecTaskScheduler.html","<div class=\"header-nav-notifications header-nav-item-dropdown\" uib-dropdown ng-if=\"odecTaskScheduler.tasks.totalTasks > 0\" auto-close=outsideClick><a href class=menu-list-task-button uib-dropdown-toggle tooltip-placement=bottom><i class=\"icon-size-lg icon-tasks\"></i> <span ng-if=\"odecTaskScheduler.tasks.doneErrorNum > 0\" class=\"badge bg-grey-menu\">{{odecTaskScheduler.tasks.doneErrorNum}} </span></a><!-- DROPDOWN MENU --><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=simple-dropdown><li class=\"dropdown-menu-header padding--0_5\"><span class=bold--700>{{\'MENU_TASKS_SCHEDULER\' | translationWithPrefix }}</span></li><ul class=tasks><!-- class=\"dropdown-list normal-list noticias\" --><div class=\"showing padding--0_5\"><span class=\"number-tasks bold--700\">{{\'MENU_TASKS_SHOWING\' | translationWithPrefix }} <b>{{odecTaskScheduler.tasks.data.length}}/{{odecTaskScheduler.tasks.totalTasks}}</b></span></div><li class=padding--0_5 ng-repeat=\"task in odecTaskScheduler.tasks.data track by $index\"><div class=text-left><div class=task-header><span class=task-title>{{task.title | translate}}</span> <span class=\"task-status margin-left--0_5\"><span class=\"status status-done bold--700\" ng-if=\"task.state === odecTaskScheduler.tasks.tasksState.done\">{{\'MENU_TASKS_DONE\' | translationWithPrefix }}</span> <span class=\"status status-pendent\" ng-if=\"task.state === odecTaskScheduler.tasks.tasksState.scheduled\">{{\'MENU_TASKS_PENDENT\' | translationWithPrefix }}</span> <span class=\"status status-progress\" ng-if=\"task.state === odecTaskScheduler.tasks.tasksState.started\">{{\'MENU_TASKS_PROGRESS\' | translationWithPrefix }}</span> <span class=\"status status-error\" ng-if=\"task.state === odecTaskScheduler.tasks.tasksState.error\">{{\'MENU_TASKS_ERROR\' | translationWithPrefix }}</span></span></div><div class=task-sub-header><span ng-repeat=\"param in task.params track by $index\" class=\"overflow_ellipsis params\" ng-style=\"{\'max-width\': 100/task.params.length + \'%\'}\" uib-tooltip={{param}}><span class=param-divider ng-if=!$first>|</span>{{param}}</span></div></div><div class=status-scheduler><div class=progress><div class=progress-bar ng-class=\"{\n                                    \'progress-bar-success\': task.state === odecTaskScheduler.tasks.tasksState.done,\n                                    \'progress-bar-striped active\': task.state === odecTaskScheduler.tasks.tasksState.started,\n                                    \'progress-bar-danger\': task.state === odecTaskScheduler.tasks.tasksState.error, \n                                    \'progress-bar-striped active progress-bar-pendent\': task.state === odecTaskScheduler.tasks.tasksState.scheduled\n                                }\" role=progressbar style=\"width: 100%\"><span class=sr-only>{{task.title}}</span></div></div><a class=icon ng-click=\"odecTaskScheduler.tasks.onClickReport(task.id, task.state, task.type)\"><i ng-class=\"{\n                                    \'icon-download-task icon-size-md bold--700 pointer\': task.state === odecTaskScheduler.tasks.tasksState.done,\n                                    \'icon-clock inactive icon-size-md bold--700\': task.state === odecTaskScheduler.tasks.tasksState.started || task.state === odecTaskScheduler.tasks.tasksState.scheduled,\n                                    \'icon-close pointer icon-size-md bold--700\': task.state === odecTaskScheduler.tasks.tasksState.error}\"></i></a></div></li></ul></ul></div>");
$templateCache.put("app/components/odecSnapshotButton/odecSnapshotButton.html","<button class=\"btn btn-md btn-transparent no-padding {{odecSnapshotButton.odecSnapshotButtonTargetOptions.extraCss}}\" uib-tooltip=\"{{ \'GENERATE_CAPTURE\' | translationWithPrefix }}\" ng-click=odecSnapshotButton.createSnapshot() tooltip-placement=bottom-right tooltip-class=custom-class><i class=\"icon-size-lg icon-camara\"></i></button>");
$templateCache.put("app/components/odecToggle/odecToggle.html","<div class=odecToggle ng-class=\"{\'ok\': odecToggle.odecToggleActive, \'no\':!odecToggle.odecToggleActive}\"><div ng-click=odecToggle.onClick() class=selector></div></div>");
$templateCache.put("app/components/odecTransitionPage/odecTransitionPage.html","<div class=transitionPage ng-class=\"{\'entering\':odecTransitionPage.loading}\"><img src=assets/images/landing-icons/icon-layout-1-wh.svg alt=loader style=\"height: 120px\"></div>");
$templateCache.put("app/components/odecViewDataLoader/odecViewDataLoader.html","<div class=\"loading-bar-wrapper margin-top--0_5\" ng-if=odecViewDataLoader.odecViewDataLoaderLoading><div class=\"loader-bar-animated text-center\"><i class=\"icon-size-xl icon-spinner22 animated-spin\"></i></div></div>");
$templateCache.put("app/crossCountry/layout20/layout20.html","<div id=layout20 class=layout20-content><odec-filter odec-filter-data=layout20.filter.data pre-apply-filter=layout20.filter.preApplyFilter></odec-filter><div class=\"widgets-layout20 padding--1\" ng-class=\"{\'print-report\':!layout20.isWeb}\"><div class=\"module-content display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><div class=purchase-funnel><purchase-funnel-l20 changed-filter=layout20.filter.applied service-view=layout20.serviceView filter-data=layout20.filter.data></purchase-funnel-l20></div></div></div></div><odec-legend odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_VALUES\']\"></odec-legend>");
$templateCache.put("app/crossCountry/layout21/layout21.html","<div id=layout21 class=layout21-content><!-- FILTERS --><odec-filter odec-filter-data=layout21.filter.data pre-apply-filter=layout21.filter.preApplyFilter></odec-filter><div class=widgets-layout21 ng-class=\"{\'print-report\':!layout21.isWeb}\"><odec-cover-module cover-text=layout21.cover.text cover-icon=layout21.cover.icon cover-filter=layout21.filter.data ng-if=!layout21.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout21.view.loading && !layout21.view.hasData\" odec-view-data-loader-loading=\"layout21.view.loading && !layout21.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout21.view.loading && !layout21.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout21.view.loading && layout21.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_METRICS_ACROSS_BRANDS_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=layout21.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout21.copyXls.copyToXlsFn snapshot-id=layout21.view.id info-text=layout21.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><div class=\"brands-selected display__flex flex-align-item-center flex-justify-content-center\"><div class=\"image-selected display__flex flex-align-item-center flex-justify-content-center\" ng-class=\"{\'has-svg\':layout21.view.images.typeImages[0] === \'svg\'}\"><img class=\"margin-left--2 margin-right--2\" ng-src=assets/data/statics/images/brands/{{layout21.view.images.typeView}}/{{layout21.view.images.data[0]}}.{{layout21.view.images.typeImages[0]}} ng-if=\"layout21.view.images.typeImages[0] === \'png\'\" alt=\"Brand Logo\"><odec-draw-svg image=layout21.view.images.data[0] url=\"\'assets/data/statics/images/brands/\'\" type-view=layout21.view.images.typeView type-image=layout21.view.images.typeImages[0] ng-if=\"layout21.view.images.typeImages[0] === \'svg\'\"></odec-draw-svg></div></div><odec-highcharts id={{layout21.view.chart.id}} odec-highcharts-config=layout21.view.chart.config odec-highcharts-data=layout21.view.chart.data odec-highcharts-categories=layout21.view.chart.categories></odec-highcharts></div></div></div></div></div></div><odec-legend odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_ACROSS_BRANDS\']\"></odec-legend>");
$templateCache.put("app/crossCountry/layout22/layout22.html","<div id=layout22 class=layout22-content><!-- FILTERS --><odec-filter odec-filter-data=layout22.filter.data pre-apply-filter=layout22.filter.preApplyFilter></odec-filter><div class=\"widgets-layout22 padding--0_5\" ng-class=\"{\'print-report\':!layout22.isWeb}\"><odec-cover-module cover-text=layout22.cover.text cover-filter=layout22.filter.data cover-icon=layout22.cover.icon ng-if=!layout22.isWeb></odec-cover-module><!-- USAR EL MISMO COMPONENTE QUE LAYOUT 4 --><brand-essential-tracking-values-l22 changed-filter=layout22.filter.applied type-view=layout22.typeView service-view=layout22.serviceView type-content=layout22.typeContent></brand-essential-tracking-values-l22></div></div><odec-legend odec-right-legend=\"[\'GENERAL_LEGEND\']\"></odec-legend>");
$templateCache.put("app/crossCountry/layout23/layout23.html","<div id=layout23 class=layout23-content><!-- FILTERS --><odec-filter odec-filter-data=layout23.filter.data pre-apply-filter=layout23.filter.preApplyFilter></odec-filter><div class=widgets-layout23 ng-class=\"{\'print-report\':!layout23.isWeb}\"><odec-cover-module cover-text=layout23.cover.text cover-icon=layout23.cover.icon cover-filter=layout23.filter.data ng-if=!layout23.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout23.view.loading && !layout23.view.hasData\" odec-view-data-loader-loading=\"layout23.view.loading && !layout23.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout23.view.loading && !layout23.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout23.view.loading && layout23.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_BY_MEDIA\' | translationWithPrefix\" copy-to-clipboard-data=layout23.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout23.copyXls.copyToXlsFn snapshot-id=layout23.view.id info-text=layout23.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><table-layout23 events=layout23.dataTable.events brand-name=layout23.dataTable.brandName row-headers=layout23.dataTable.rowHeaders column-headers=layout23.dataTable.columnHeaders table-data=layout23.dataTable.data legend-data=layout23.dataTable.legend web=layout23.isWeb></table-layout23></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_NON_LINEAR_TV\', \'GENERAL_LEGEND_NON_LINEAR_TV_YOUTUBE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_NEW_RECOGNITION\',\'GENERAL_LEGEND_TYPE_MEDIA_TARGET_NEW\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/crossCountry/layout24/layout24.html","<div id=layout24 class=layout24-content><!-- FILTERS --><odec-filter odec-filter-data=layout24.filter.data pre-apply-filter=layout24.filter.preApplyFilter></odec-filter><div class=widgets-layout24 ng-class=\"{\'print-report\':!layout24.isWeb}\"><odec-cover-module cover-text=layout24.cover.text cover-icon=layout24.cover.icon cover-filter=layout24.filter.data ng-if=!layout24.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout24.view.loading && !layout24.view.hasData\" odec-view-data-loader-loading=\"layout24.view.loading && !layout24.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout24.view.loading && !layout24.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout24.view.loading && layout24.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_RECOG_EVOLUTION_CROSS_COUNTRY\' | translationWithPrefix\" copy-to-clipboard-data=layout24.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout24.copyXls.copyToXlsFn snapshot-id=layout24.view.id info-text=layout24.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><!-- Custom legend: una columna por país --><div class=\"custom-chart-legend display__flex flex-justify-content-center\" ng-if=\"layout24.view.chart.legendGroups.length > 0\"><div ng-repeat=\"group in layout24.view.chart.legendGroups track by $index\" class=legend-country-col ng-class=\"{\'legend-country-no-data\': !group.hasData}\"><div class=\"country-name bold--700 text-center\" ng-style=\"{\'color\': group.hasData ? \'#333\' : \'#bbb\'}\">{{ group.countryName }}</div><div ng-repeat=\"item in group.series track by $index\" class=\"legend-item display__flex flex-align-item-center\" ng-click=\"group.hasData && layout24.toggleSeries(item.seriesIndex, item)\" ng-class=\"{\'legend-item-hidden\': !item.visible && group.hasData}\"><svg class=legend-symbol width=30 height=12><line x1=0 y1=6 x2=30 y2=6 ng-attr-stroke=\"{{group.hasData ? (item.visible ? item.color : \'#ccc\') : \'#ccc\'}}\" ng-attr-stroke-width={{item.lineWidth}} ng-attr-stroke-dasharray={{item.dashArray}} /></svg> <span class=legend-text ng-style=\"{\'color\': group.hasData ? (item.visible ? \'#333\' : \'#ccc\') : \'#bbb\'}\">{{ item.name }}</span></div></div></div><odec-highcharts id={{layout24.view.chart.id}} odec-highcharts-config=layout24.view.chart.config odec-highcharts-data=layout24.view.chart.data odec-highcharts-categories=layout24.view.chart.categories></odec-highcharts><div class=\"bottom-info-table display__flex flex-justify-content-end\"><div class=\"right-legend display__flex flex-direction-row flex-justify-content-end flex-align-item-end\"><div class=\"display__flex flex-direction-column flex-align-item-end\"><!-- Norma country: primer país (solo para FRECOTOTAL, estilo layout 23) --><div ng-repeat=\"countryGroup in layout24.legend.normasByCountry | limitTo: 1 track by $index\" ng-if=\"layout24.legend.typeLegend === \'FRECOTOTAL\'\" class=\"legend-country margin-bottom--0_5\"><!-- Info del país encima --><div class=\"legend-context text-right padding-right--0_5\" ng-if=\"layout24.legend.normasByCountry.length > 1\"><span class=bold--700><span ng-if=countryGroup.country>{{countryGroup.country}}</span></span></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':layout24.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':layout24.legend.c2}\"></i></div><div class=\"text-legend display__flex\"><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: </span><span ng-repeat=\"norma in countryGroup.normas track by $index\">{{ norma.year }} - {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ norma.default.T +\'%\'}} <span ng-if=!$last>|</span></span></div></div></div><!-- Sig. Test vs Previous period (siempre visible) --><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-caret-up icon-size-lg\" ng-style=\"{\'color\':layout24.legend.bg1}\"></i> <span class=separator>/ </span><i class=\"icon-caret-down icon-size-lg\" ng-style=\"{\'color\':layout24.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}}<b> {{\'TABLE_LEGEND_TEST_PREVIOUS_PERIOD\' | translationWithPrefix}}</b></span></div></div></div><!-- Botón \"Ver más\" si hay más de un país (solo FRECOTOTAL) --><div ng-if=\"layout24.legend.typeLegend === \'FRECOTOTAL\' && layout24.legend.normasByCountry.length > 1\" class=\"view-more-legend margin-left--1 margin-bottom--0_5\"><button class=\"btn btn-xs btn-default\" ng-click=layout24.openLegendModal()>{{ \'VIEW_MORE\' | translationWithPrefix }}</button></div></div></div></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_NON_LINEAR_TV\']\" odec-right-legend=\"[\'GENERAL_LEGEND_NEW_RECOGNITION\']\" odec-legend-hide-signification=true></odec-legend><!-- Modal template para ver todas las normas por país (estilo layout 17) --><script type=text/ng-template id=legendModalLayout24.html><div class=\"display__flex flex-justify-content-end flex-align-item-center margin-right--0_5\">\n        <i class=\"icon-close icon-size-lg pointer\" ng-click=\"vm.close()\"></i>\n    </div>\n    <div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto;\">\n        <div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\">\n            <div ng-repeat=\"countryGroup in vm.legend.normasByCountry track by $index\" class=\"legend-country margin-bottom--1\">\n                <!-- Info del país encima -->\n                <div class=\"legend-context text-right padding-right--0_5\">\n                    <span class=\"bold--700\">\n                        <span ng-if=\"countryGroup.country\">{{countryGroup.country}}</span>\n                    </span>\n                </div>\n                <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\">\n                    <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                        <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':vm.legend.c1}\"></i>\n                        <span class=\"separator\"> / </span>\n                        <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':vm.legend.c2}\"></i>\n                    </div>\n                    <div class=\"text-legend display__flex\">\n                        <span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: </span>\n                        <span ng-repeat=\"norma in countryGroup.normas track by $index\">\n                            {{ norma.year }} - {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ norma.default.T +\'%\'}}\n                            <span ng-if=\"!$last\"> | </span>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/detailOverview/layout10/layout10.html","<div id=layout10 class=layout10-content><!-- FILTERS --><odec-filter odec-filter-data=layout10.filter.data pre-apply-filter=layout10.filter.preApplyFilter></odec-filter><div class=widgets-layout10 ng-class=\"{\'print-report\':!layout10.isWeb}\"><odec-cover-module cover-text=layout10.cover.text cover-icon=layout10.cover.icon cover-filter=layout10.filter.data ng-if=!layout10.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout10.view.loading && !layout10.view.hasData\" odec-view-data-loader-loading=\"layout10.view.loading && !layout10.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout10.view.loading && !layout10.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout10.view.loading && layout10.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_METRICS_ACROSS_METRICS_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=layout10.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout10.copyXls.copyToXlsFn snapshot-id=layout10.view.id info-text=layout10.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><div class=\"brands-selected display__flex flex-align-item-center flex-justify-content-center\"><div class=\"image-selected display__flex flex-align-item-center flex-justify-content-center\" ng-repeat=\"img in layout10.view.images.data track by $index\" ng-class=\"{\'has-svg\':layout10.view.images.typeImages[$index] === \'svg\'}\"><img class=\"margin-left--2 margin-right--2\" ng-src=assets/data/statics/images/brands/{{layout10.view.images.typeView}}/{{img}}.{{layout10.view.images.typeImages[$index]}} ng-if=\"layout10.view.images.typeImages[$index] === \'png\'\"><odec-draw-svg image=img url=\"\'assets/data/statics/images/brands/\'\" type-view=layout10.view.images.typeView type-image=layout10.view.images.typeImages[$index] ng-if=\"layout10.view.images.typeImages[$index] === \'svg\'\"></odec-draw-svg></div></div><odec-highcharts id={{layout10.view.chart.id}} odec-highcharts-config=layout10.view.chart.config odec-highcharts-data=layout10.view.chart.data odec-highcharts-categories=layout10.view.chart.categories></odec-highcharts></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA\',\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA_NOT_AVAILABLE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_ACROSS_BRANDS\']\"></odec-legend>");
$templateCache.put("app/detailOverview/layout11/layout11.html","<div id=layout11 class=layout11-content><!-- FILTERS --><odec-filter odec-filter-data=layout11.filter.data></odec-filter><div class=widgets-layout11 ng-class=\"{\'print-report\':!layout11.isWeb}\"><odec-cover-module cover-text=layout11.cover.text cover-icon=layout11.cover.icon cover-filter=layout11.filter.data ng-if=!layout11.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout11.view.loading && !layout11.view.hasData\" odec-view-data-loader-loading=\"layout11.view.loading && !layout11.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout11.view.loading && !layout11.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout11.view.loading && layout11.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_BY_MEDIA\' | translationWithPrefix\" copy-to-clipboard-data=layout11.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout11.copyXls.copyToXlsFn snapshot-id=layout11.view.id info-text=layout11.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><table-layout11 row-headers=layout11.dataTable.rowHeaders column-headers=layout11.dataTable.columnHeaders table-data=layout11.dataTable.data legend-data=layout11.dataTable.legend web=layout11.isWeb></table-layout11></div></div></div></div></div></div><odec-legend odec-left-legend=[] odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_MEDIA\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/detailOverview/layout12/layout12.html","<div id=layout12 class=layout12-content><!-- FILTERS --><odec-filter odec-filter-data=layout12.filter.data pre-apply-filter=layout12.filter.preApplyFilter></odec-filter><div class=widgets-layout12 ng-class=\"{\'print-report\':!layout12.isWeb}\"><odec-cover-module cover-text=layout12.cover.text cover-icon=layout12.cover.icon cover-filter=layout12.filter.data ng-if=!layout12.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout12.view.loading && !layout12.view.hasData\" odec-view-data-loader-loading=\"layout12.view.loading && !layout12.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout12.view.loading && !layout12.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout12.view.loading && layout12.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_BY_MEDIA_TARGET\' | translationWithPrefix\" copy-to-clipboard-data=layout12.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout12.copyXls.copyToXlsFn snapshot-id=layout12.view.id info-text=layout12.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><table-layout12 events=layout12.dataTable.events row-headers=layout12.dataTable.rowHeaders column-headers=layout12.dataTable.columnHeaders table-data=layout12.dataTable.data legend-data=layout12.dataTable.legend web=layout12.isWeb></table-layout12></div></div></div></div></div></div><odec-legend odec-left-legend=[] odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_MEDIA_TARGET\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/detailOverview/layout13/layout13.html","<div id=layout13 class=layout13-content><!-- FILTERS --><odec-filter odec-filter-data=layout13.filter.data></odec-filter><div class=widgets-layout13 ng-class=\"{\'print-report\':!layout13.isWeb}\"><odec-cover-module cover-text=layout13.cover.text cover-icon=layout13.cover.icon cover-filter=layout13.filter.data ng-if=!layout13.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout13.view.loading && !layout13.view.hasData\" odec-view-data-loader-loading=\"layout13.view.loading && !layout13.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout13.view.loading && !layout13.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout13.view.loading && layout13.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_RECOG_GENERAL_AUDIENCE\' | translationWithPrefix\" copy-to-clipboard-data=layout13.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout13.copyXls.copyToXlsFn snapshot-id=layout13.view.id info-text=layout13.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><odec-highcharts id={{layout13.view.chart.id}} odec-highcharts-config=layout13.view.chart.config odec-highcharts-data=layout13.view.chart.data odec-highcharts-categories=layout13.view.chart.categories></odec-highcharts><div class=\"bottom-info-table display__flex\"><!-- <div class=\"left-legend display__flex flex-wrap \">\n                                <div class=\"item-legend display__flex flex-align-item-center flex-justify-content-start\" ng-repeat=\"itemLegend in layout13.legend.events track by $index\">\n                                    <i class=\"icon-square margin-right--0_5 margin-left--0_5\" ng-style=\"{\'color\':itemLegend.color}\"></i>\n                                    <span>{{ itemLegend.text | translationWithPrefix }}</span>\n                                </div>\n                            </div> --><div class=\"right-legend display__flex flex-direction-column flex-align-item-center\"><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':layout13.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':layout13.legend.c2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ layout13.legend.data.TOT +\'%\'}}; {{\'GROUP_TV\' | translationWithPrefix}} {{ layout13.legend.data.TV +\'%\'}}; {{\'GROUP_PRINT\' | translationWithPrefix}} {{ layout13.legend.data.PRN +\'%\'}}; {{\'GROUP_OUTDOOR\' | translationWithPrefix}} {{ layout13.legend.data.OUT +\'%\'}}; {{\'GROUP_DIGITAL\' | translationWithPrefix}} {{ layout13.legend.data.ONL +\'%\'}}</span></div></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-caret-up icon-size-lg\" ng-style=\"{\'color\':layout13.legend.bg1}\"></i> <span class=separator>/ </span><i class=\"icon-caret-down icon-size-lg\" ng-style=\"{\'color\':layout13.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}}<b> {{\'TABLE_LEGEND_TEST_PREVIOUS_PERIOD\' | translationWithPrefix}}</b></span></div></div></div></div></div></div></div></div></div></div><!-- <odec-legend odec-left-legend=\"[]\" odec-right-legend=\"\'GENERAL_LEGEND_TYPE_MEDIA\'\" odec-legend-hide-signification=\"true\"></odec-legend> -->");
$templateCache.put("app/detailOverview/layout14/layout14.html","<div id=layout14 class=layout14-content><!-- FILTERS --><odec-filter odec-filter-data=layout14.filter.data></odec-filter><div class=widgets-layout14 ng-class=\"{\'print-report\':!layout14.isWeb}\"><odec-cover-module cover-text=layout14.cover.text cover-icon=layout14.cover.icon cover-filter=layout14.filter.data ng-if=!layout14.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout14.view.loading && !layout14.view.hasData\" odec-view-data-loader-loading=\"layout14.view.loading && !layout14.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout14.view.loading && !layout14.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout14.view.loading && layout14.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_BY_MEDIA\' | translationWithPrefix\" copy-to-clipboard-data=layout14.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout14.copyXls.copyToXlsFn snapshot-id=layout14.view.id info-text=layout14.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><table-layout14 row-headers=layout14.dataTable.rowHeaders column-headers=layout14.dataTable.columnHeaders table-data=layout14.dataTable.data legend-data=layout14.dataTable.legend web=layout14.isWeb></table-layout14></div></div></div></div></div></div><odec-legend odec-left-legend=[] odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_MEDIA\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/detailOverview/layout15/layout15.html","<div id=layout15 class=layout15-content><!-- FILTERS --><odec-filter odec-filter-data=layout15.filter.data></odec-filter><div class=widgets-layout15 ng-class=\"{\'print-report\':!layout15.isWeb}\"><odec-cover-module cover-text=layout15.cover.text cover-icon=layout15.cover.icon cover-filter=layout15.filter.data ng-if=!layout15.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout15.view.loading && !layout15.view.hasData\" odec-view-data-loader-loading=\"layout15.view.loading && !layout15.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout15.view.loading && !layout15.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout15.view.loading && layout15.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_BY_MEDIA\' | translationWithPrefix\" copy-to-clipboard-data=layout15.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout15.copyXls.copyToXlsFn snapshot-id=layout15.view.id info-text=layout15.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><table-layout15 events=layout15.dataTable.events row-headers=layout15.dataTable.rowHeaders column-headers=layout15.dataTable.columnHeaders table-data=layout15.dataTable.data legend-data=layout15.dataTable.legend web=layout15.isWeb></table-layout15></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_NON_LINEAR_TV\', \'GENERAL_LEGEND_NON_LINEAR_TV_YOUTUBE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_NEW_RECOGNITION\',\'GENERAL_LEGEND_TYPE_MEDIA_TARGET_NEW\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/detailOverview/layout16/layout16.html","<div id=layout16 class=layout16-content><!-- FILTERS --><odec-filter odec-filter-data=layout16.filter.data pre-apply-filter=layout16.filter.preApplyFilter></odec-filter><div class=widgets-layout16 ng-class=\"{\'print-report\':!layout16.isWeb}\"><odec-cover-module cover-text=layout16.cover.text cover-icon=layout16.cover.icon cover-filter=layout16.filter.data ng-if=!layout16.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout16.view.loading && !layout16.view.hasData\" odec-view-data-loader-loading=\"layout16.view.loading && !layout16.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout16.view.loading && !layout16.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout16.view.loading && layout16.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_BY_MEDIA_TARGET\' | translationWithPrefix\" copy-to-clipboard-data=layout16.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout16.copyXls.copyToXlsFn snapshot-id=layout16.view.id info-text=layout16.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><table-layout16 events=layout16.dataTable.events row-headers=layout16.dataTable.rowHeaders column-headers=layout16.dataTable.columnHeaders table-data=layout16.dataTable.data legend-data=layout16.dataTable.legend web=layout16.isWeb></table-layout16></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_NON_LINEAR_TV\', \'GENERAL_LEGEND_NON_LINEAR_TV_YOUTUBE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_NEW_RECOGNITION\',\'GENERAL_LEGEND_TYPE_MEDIA_TARGET_NEW\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/detailOverview/layout17/layout17.html","<div id=layout17 class=layout17-content><!-- FILTERS --><odec-filter odec-filter-data=layout17.filter.data></odec-filter><div class=widgets-layout17 ng-class=\"{\'print-report\':!layout17.isWeb}\"><odec-cover-module cover-text=layout17.cover.text cover-icon=layout17.cover.icon cover-filter=layout17.filter.data ng-if=!layout17.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout17.view.loading && !layout17.view.hasData\" odec-view-data-loader-loading=\"layout17.view.loading && !layout17.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout17.view.loading && !layout17.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout17.view.loading && layout17.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'CAMPAIGN_RECOG_GENERAL_AUDIENCE\' | translationWithPrefix\" copy-to-clipboard-data=layout17.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout17.copyXls.copyToXlsFn snapshot-id=layout17.view.id info-text=layout17.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><odec-highcharts id={{layout17.view.chart.id}} odec-highcharts-config=layout17.view.chart.config odec-highcharts-data=layout17.view.chart.data odec-highcharts-categories=layout17.view.chart.categories></odec-highcharts><div class=\"bottom-info-table display__flex\"><!-- <div class=\"left-legend display__flex flex-wrap \">\n                                <div class=\"item-legend display__flex flex-align-item-center flex-justify-content-start\" ng-repeat=\"itemLegend in layout17.legend.events track by $index\">\n                                    <i class=\"icon-square margin-right--0_5 margin-left--0_5\" ng-style=\"{\'color\':itemLegend.color}\"></i>\n                                    <span>{{ itemLegend.text | translationWithPrefix }}</span>\n                                </div>\n                            </div> --><div class=\"right-legend display__flex flex-direction-column flex-align-item-center\"><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" ng-if=\"layout17.legend.typeLegend === \'FRECOTOTAL\'\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':layout17.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':layout17.legend.c2}\"></i></div><div class=\"text-legend display__flex\"><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: </span><span ng-if=\"layout17.legend.typeLegend === \'FRECOTOTAL\'\"><span ng-repeat=\"item in layout17.legend.data\">{{ item.year }} - {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ item.T +\'%\'}} | </span></span><!-- {{\'GROUP_TV\' | translationWithPrefix}} {{ layout17.legend.data.TV +\'%\'}};\n                                            {{\'GROUP_PRINT\' | translationWithPrefix}} {{ layout17.legend.data.PRN +\'%\'}};\n                                            {{\'GROUP_OUTDOOR\' | translationWithPrefix}} {{ layout17.legend.data.OUT +\'%\'}};\n                                            {{\'GROUP_DIGITAL\' | translationWithPrefix}} {{ layout17.legend.data.ONL +\'%\'}} --></div></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-caret-up icon-size-lg\" ng-style=\"{\'color\':layout17.legend.bg1}\"></i> <span class=separator>/ </span><i class=\"icon-caret-down icon-size-lg\" ng-style=\"{\'color\':layout17.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}}<b> {{\'TABLE_LEGEND_TEST_PREVIOUS_PERIOD\' | translationWithPrefix}}</b></span></div></div></div></div></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_NON_LINEAR_TV\']\" odec-right-legend=\"[\'GENERAL_LEGEND_NEW_RECOGNITION\']\" odec-legend-hide-signification=true></odec-legend>");
$templateCache.put("app/detailOverview/layout6/layout6.html","<div id=layout6 class=layout6-content><!-- FILTERS --><odec-filter odec-filter-data=layout6.filter.data></odec-filter><div class=\"widgets-layout6 padding--1\" ng-class=\"{\'print-report\':!layout6.isWeb}\"><odec-cover-module cover-text=layout6.cover.text cover-filter=layout6.filter.data cover-icon=layout6.cover.icon ng-if=!layout6.isWeb></odec-cover-module><div class=\"module-content display__flex flex-direction-row flex-align-item-center flex-justify-content-center\"><div class=\"emotional-connection-and-purchase-funnel display__flex flex-direction-column\"><div class=emotional-connection><emotional-connection-l6 changed-filter=layout6.filter.applied service-view=layout6.serviceView></emotional-connection-l6></div><div class=purchase-funnel><purchase-funnel-l6 changed-filter=layout6.filter.applied service-view=layout6.serviceView></purchase-funnel-l6></div></div><div class=brand-image><brand-image-l6 changed-filter=layout6.filter.applied service-view=layout6.serviceView></brand-image-l6></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_BRAND_OVERVIEW\',\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA_UNIQUE_LOVE_NOT_AVALIABLE\']\" odec-right-legend=\"[\'GENERAL_LEGEND\']\"></odec-legend>");
$templateCache.put("app/detailOverview/layout7/layout7.html","<div id=layout7 class=layout7-content><!-- FILTERS --><odec-filter odec-filter-data=layout7.filter.data pre-apply-filter=layout7.filter.preApplyFilter></odec-filter><div class=\"widgets-layout7 padding--1\" ng-class=\"{\'print-report\':!layout7.isWeb}\"><odec-cover-module cover-text=layout7.cover.text cover-filter=layout7.filter.data cover-icon=layout7.cover.icon ng-if=!layout7.isWeb></odec-cover-module><div class=\"module-content display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><div class=purchase-funnel><purchase-funnel-l7 changed-filter=layout7.filter.applied service-view=layout7.serviceView></purchase-funnel-l7></div><div class=\"emotional-connection-and-brand-image display__flex\"><div class=emotional-connection><emotional-connection-l7 changed-filter=layout7.filter.applied service-view=layout7.serviceView></emotional-connection-l7></div><div class=brand-image><brand-image-l7 changed-filter=layout7.filter.applied service-view=layout7.serviceView></brand-image-l7></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_BRAND_OVERVIEW\',\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA_UNIQUE_LOVE_NOT_AVALIABLE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_ACROSS_BRANDS\']\"></odec-legend>");
$templateCache.put("app/detailOverview/layout8/layout8.html","<div id=layout8 class=layout8-content><!-- FILTERS --><odec-filter odec-filter-data=layout8.filter.data pre-apply-filter=layout8.filter.preApplyFilter></odec-filter><div class=\"widgets-layout8 padding--1\" ng-class=\"{\'print-report\':!layout8.isWeb}\"><odec-cover-module cover-text=layout8.cover.text cover-filter=layout8.filter.data cover-icon=layout8.cover.icon ng-if=!layout8.isWeb></odec-cover-module><div class=\"module-content display__flex flex-direction-row flex-align-item-center flex-justify-content-center\"><div class=\"emotional-connection-and-purchase-funnel display__flex flex-direction-column\"><div class=emotional-connection><emotional-connection-l8 changed-filter=layout8.filter.applied service-view=layout8.serviceView></emotional-connection-l8></div><div class=purchase-funnel><purchase-funnel-l8 changed-filter=layout8.filter.applied service-view=layout8.serviceView></purchase-funnel-l8></div></div><div class=brand-image><brand-image-l8 changed-filter=layout8.filter.applied service-view=layout8.serviceView></brand-image-l8></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_BRAND_OVERVIEW\',\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA_UNIQUE_LOVE_NOT_AVALIABLE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_ACROSS_PERIODS\']\"></odec-legend>");
$templateCache.put("app/detailOverview/layout9/layout9.html","<div id=layout9 class=layout9-content><!-- FILTERS --><odec-filter odec-filter-data=layout9.filter.data pre-apply-filter=layout9.filter.preApplyFilter></odec-filter><div class=widgets-layout9 ng-class=\"{\'print-report\':!layout9.isWeb}\"><odec-cover-module cover-text=layout9.cover.text cover-icon=layout9.cover.icon cover-filter=layout9.filter.data ng-if=!layout9.isWeb></odec-cover-module><div class=\"chart-evolution padding--1\" odec-responsive-chart><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"layout9.view.loading && !layout9.view.hasData\" odec-view-data-loader-loading=\"layout9.view.loading && !layout9.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!layout9.view.loading && !layout9.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!layout9.view.loading && layout9.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_METRICS_ACROSS_BRANDS_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=layout9.copyXls.copyToXlsData copy-to-clipboard-format-fn=layout9.copyXls.copyToXlsFn snapshot-id=layout9.view.id info-text=layout9.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding--1\"><div class=\"brands-selected display__flex flex-align-item-center flex-justify-content-center\"><div class=\"image-selected display__flex flex-align-item-center flex-justify-content-center\" ng-repeat=\"img in layout9.view.images.data track by $index\" ng-class=\"{\'has-svg\':layout9.view.images.typeImages[$index] === \'svg\'}\"><img class=\"margin-left--2 margin-right--2\" ng-src=assets/data/statics/images/brands/{{layout9.view.images.typeView}}/{{img}}.{{layout9.view.images.typeImages[$index]}} ng-if=\"layout9.view.images.typeImages[$index] === \'png\'\"><odec-draw-svg image=img url=\"\'assets/data/statics/images/brands/\'\" type-view=layout9.view.images.typeView type-image=layout9.view.images.typeImages[$index] ng-if=\"layout9.view.images.typeImages[$index] === \'svg\'\"></odec-draw-svg></div></div><odec-highcharts id={{layout9.view.chart.id}} odec-highcharts-config=layout9.view.chart.config odec-highcharts-data=layout9.view.chart.data odec-highcharts-categories=layout9.view.chart.categories></odec-highcharts></div></div></div></div></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA\',\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_TBCA_NOT_AVAILABLE\']\" odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_METRICS_ACROSS_BRANDS\']\"></odec-legend>");
$templateCache.put("app/generalOverview/layout1/layout1.html","<div id=layout1 class=layout1-content><!-- FILTERS --><odec-filter odec-filter-data=layout1.filter.data></odec-filter><div class=widgets-layout1 ng-class=\"{\'print-report\':!layout1.isWeb}\"><odec-cover-module cover-text=layout1.cover.text cover-icon=layout1.cover.icon cover-filter=layout1.filter.data ng-if=!layout1.isWeb></odec-cover-module><brand-essential-tracking changed-filter=layout1.filter.applied type-view=layout1.typeView service-view=layout1.serviceView type-content=layout1.typeContent></brand-essential-tracking></div></div><odec-legend odec-left-legend=[] odec-right-legend=\"[\'GENERAL_LEGEND\']\"></odec-legend>");
$templateCache.put("app/generalOverview/layout2/layout2.html","<div id=layout2 class=layout2-content><!-- FILTERS --><odec-filter odec-filter-data=layout2.filter.data></odec-filter><div class=widgets-layout2 ng-class=\"{\'print-report\':!layout2.isWeb}\"><odec-cover-module cover-text=layout2.cover.text cover-icon=layout2.cover.icon cover-filter=layout2.filter.data ng-if=!layout2.isWeb></odec-cover-module><brand-essential-tracking changed-filter=layout2.filter.applied type-view=layout2.typeView service-view=layout2.serviceView type-content=layout2.typeContent></brand-essential-tracking></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_PURCHASE_MEN_WOMEN\',\'GENERAL_LEGEND_EMOTIONAL_CONNECTION_WOMEN\']\" odec-right-legend=\"[\'GENERAL_LEGEND\']\"></odec-legend>");
$templateCache.put("app/generalOverview/layout3/layout3.html","<div id=layout3 class=layout3-content><!-- FILTERS --><odec-filter odec-filter-data=layout3.filter.data></odec-filter><div class=widgets-layout3 ng-class=\"{\'print-report\':!layout3.isWeb}\"><odec-cover-module cover-text=layout3.cover.text cover-icon=layout3.cover.icon cover-filter=layout3.filter.data ng-if=!layout3.isWeb></odec-cover-module><brand-essential-tracking changed-filter=layout3.filter.applied type-view=layout3.typeView service-view=layout3.serviceView type-content=layout3.typeContent></brand-essential-tracking></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_PURCHASE_MEN_WOMEN\',\'GENERAL_LEGEND_EMOTIONAL_CONNECTION_MEN\']\" odec-right-legend=\"[\'GENERAL_LEGEND\']\"></odec-legend>");
$templateCache.put("app/generalOverview/layout4/layout4.html","<div id=layout4 class=layout4-content><!-- FILTERS --><odec-filter odec-filter-data=layout4.filter.data></odec-filter><div class=widgets-layout4 ng-class=\"{\'print-report\':!layout4.isWeb}\"><odec-cover-module cover-text=layout4.cover.text cover-icon=layout4.cover.icon cover-filter=layout4.filter.data ng-if=!layout4.isWeb></odec-cover-module><brand-essential-tracking-values changed-filter=layout4.filter.applied type-view=layout4.typeView service-view=layout4.serviceView type-content=layout4.typeContent></brand-essential-tracking-values></div></div><odec-legend odec-right-legend=\"[\'GENERAL_LEGEND_TYPE_GENERAL_BRAND_VALUES\']\" odec-left-legend=\"[\'GENERAL_LEGEND_IMAGE_ADDITIONAL_MEN_WOMEN\', \'GENERAL_LEGEND_IMAGE_MEN_WOMEN\']\"></odec-legend>");
$templateCache.put("app/generalOverview/layout5/layout5.html","<div id=layout5 class=layout5-content><!-- FILTERS --><odec-filter odec-filter-data=layout5.filter.data></odec-filter><div class=widgets-layout5 ng-class=\"{\'print-report\':!layout5.isWeb}\"><odec-cover-module cover-text=layout5.cover.text cover-icon=layout5.cover.icon cover-filter=layout5.filter.data ng-if=!layout5.isWeb></odec-cover-module><brand-essential-tracking changed-filter=layout5.filter.applied type-view=layout5.typeView service-view=layout5.serviceView type-content=layout5.typeContent></brand-essential-tracking></div></div><odec-legend odec-left-legend=\"[\'GENERAL_LEGEND_PURCHASE_MEN_WOMEN\',\'GENERAL_LEGEND_EMOTIONAL_CONNECTION_MEN_WOMEN\']\" odec-right-legend=\"[\'GENERAL_LEGEND\']\"></odec-legend>");
$templateCache.put("app/settings/changePassword/changePassword.html","<div id=change-password class=\"padding-left--2_5 padding-right--2_5\"><div class=card><form><div class=\"password-form display__flex flex-direction-row flex-wrap\"><div class=\"new-password password-input flex-direction-column padding--1_5\"><label for=newPassword>{{ \'NEW_PASSWORD\' | translationWithPrefix }}</label><input #password type=password name=newPassword ng-model=changePassword.password.newPassword autocomplete=off></div><div class=\"confirm-password password-input flex-direction-column padding--1_5\"><label for=confirmPassword>{{ \'CONFIRM_PASSWORD\' | translationWithPrefix }}</label><input #password type=password name=confirmPassword ng-model=changePassword.password.confirmPassword autocomplete=off></div><div class=\"password-button text-center padding--1_5 display__flex flex-align-item-center flex-justify-content-center\"><odec-loading-button class=padding--0_5 ng-click=changePassword.actions.changePassword(changePassword.password.newPassword) odec-loading-button-loading=changePassword.password.loading><span class=bold--700>{{ \'CHANGE_PASSWORD\' | translationWithPrefix }}</span></odec-loading-button></div></div></form></div></div>");
$templateCache.put("app/components/d3/odecD3HalfDonut/odecD3HalfDonut.html","<div id=odec-d3-half-donut><div class=\"wrapper wrapper-half-donut\"></div></div>");
$templateCache.put("app/components/d3/odecD3Progress/odecD3Progress.html","");
$templateCache.put("app/components/d3/odecD3TargetDonut/odecD3TargetDonut.html","");
$templateCache.put("app/components/layout-ui/odecHeader/odecHeader.html","<header class=card><ng-transclude></ng-transclude></header>");
$templateCache.put("app/components/layout-ui/odecMenuLink/odecMenuLink.html","<li ng-if=odecMenuLink.odecMenuLinkVisible class=sidebar-nav-submenu-item><a href ng-click=odecMenuLink.onClick($event)>{{odecMenuLink.odecMenuLinkLabel|translate}}</a></li>");
$templateCache.put("app/components/layout-ui/odecMenuList/odecMenuList.html","<ul class=\"sidebar-nav margin-top--1\"><odec-menu-list-item ng-repeat=\"menuItem in odecMenuList.data.odecMenuListCollection track by $index\" ng-if=menuItem.visible odec-menu-list-item-icon=menuItem.icon odec-menu-list-item-label=menuItem.label odec-menu-list-item-selected=menuItem.selected odec-menu-list-item-submenu-childs=menuItem.child ng-click=odecMenuList.onSelect($event,menuItem)></odec-menu-list-item></ul>");
$templateCache.put("app/components/layout-ui/odecSidebar/odecSidebar.html","<div class=\"sidebar no-print\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D odec-scrollable-show={{odecSidebar.odecSidebarOpened}}><div class=sidebar-logo><img ng-src=assets/images/logocope-web.png alt=\"\"></div><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/layout-ui/odecMenuListItem/odecMenuListItem.html","<li class=sidebar-nav-item ng-class=\"{\'sidebar-nav-item--opened\':vm.odecMenuListItemSelected}\"><a href=\"\" class=sidebar-nav-toggle ng-click=vm.odecMenuListItemSelectedOnSelect()><i class=\"sidebar-nav-toggle-icon icon-size-lg {{vm.odecMenuListItemIcon}}\"></i><span class=sidebar-nav-toggle-description>{{vm.odecMenuListItemLabel|translate}}</span></a><odec-submenu-list><odec-menu-link ng-repeat=\"link in vm.odecMenuListItemSubmenuChilds track by $index\" odec-menu-link-label=link.label odec-menu-link-state=link.state odec-menu-link-url=link.url odec-menu-link-visible=link.visible></odec-menu-link></odec-submenu-list></li>");
$templateCache.put("app/components/layout-ui/odecSidebarOverlay/odecSidebarOverlay.html","<div class=sidebar-overlay ng-if=odecSidebarOverlay.odecSidebarOverlayOpened ng-click=odecSidebarOverlay.closeOverlay({value:false})></div>");
$templateCache.put("app/components/layout-ui/odecSidebarToggle/odecSidebarToggle.html","<button class=btn-menu ng-click=odecSidebarToggle.clicked({value:true})><i class=\"icon-menu5 icon-size-xl\"></i></button>");
$templateCache.put("app/components/layout-ui/odecSubmenuList/odecSubmenuList.html","<ul class=sidebar-nav-submenu><ng-transclude></ng-transclude></ul>");
$templateCache.put("app/components/odecFilter/odecFilterPills/odecFilterPills.html","<div class=\"filter-view-pills display__flex flex-align-item-center flex-justify-content-center\"><div class=filter-view-pills-item ng-repeat=\"pill in odecFilterPills.odecFilterPillsCollection track by $index\"><span>{{pill.label|translate}}</span>: <span class=item-selected>{{ pill.value }}</span></div></div>");
$templateCache.put("app/components/odecPanel/odecPanelBody/odecPanelBody.html","<div class=panel-body ng-if=!odecPanelBody.odecPanelCtrl.isCollapsed><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/odecPanel/odecPanelBodyBar/odecPanelBodyBar.html","<div class=panel-body-actions><div class=row><div class=col-md-6><ul class=\"panel-body-actions-list panel-body-actions-list--left\"><li class=panel-body-actions-list-item><odec-button-expandable odec-button-expandable-opened=false odec-button-expandable-closable=true><input type=text autofocus ng-model=odecPanelBodyBar.odecPanelBodyBarSearchText ng-attr-placeholder={{odecPanelBodyBar.odecPanelBodyBarSearchPlaceholder|translate}}></odec-button-expandable></li></ul></div><div class=col-md-6><ul class=\"panel-body-actions-list panel-body-actions-list--right\" ng-transclude=exports></ul></div></div><div class=row ng-transclude=multiwaveexport></div></div>");
$templateCache.put("app/components/odecPanel/odecPanelBodyBarActionButton/odecPanelBodyBarActionButton.html","<a href=\"\" ng-click=odecPanelBodyBarActionButton.onButtonClick($event)><i class=\"icon-size-xl {{odecPanelBodyBarActionButton.icon}}\" uib-tooltip=\"{{odecPanelBodyBarActionButton.odecPanelBodyBarActionButtonTooltip | translate }}\"></i> </a>");
$templateCache.put("app/components/odecPanel/odecPanelFooter/odecPanelFooter.html","<div class=panel-footer ng-if=!odecPanelFooter.odecPanelCtrl.isCollapsed><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/odecPanel/odecPanelHeader/odecPanelHeader.html","<header class=panel-heading ng-class=\"{\'notools\':noTools}\"><div class=\"widget-tools no-snapshot\"><a href class=widget-tools-item ng-click=odecPanelHeader.odecPanelCtrl.collapse() ng-if=odecPanelHeader.odecPanelHeaderConfig.isCollapsable><i class=\"icon-size-lg icon-keyboard_arrow_down\" uib-tooltip=\"{{\'WIDGET_HIDE\'|translate}}\" ng-if=!odecPanelHeader.odecPanelCtrl.isCollapsed></i> <i class=\"icon-size-lg icon-keyboard_arrow_up\" uib-tooltip=\"{{\'WIDGET_SHOW\'|translate}}\" ng-if=odecPanelHeader.odecPanelCtrl.isCollapsed></i> </a><a href class=widget-tools-item ng-if=odecPanelHeader.odecPanelHeaderConfig.isClosable ng-click=odecPanelHeader.odecPanelCtrl.close()><i class=\"icon-size-lg icon-close\" uib-tooltip=\"{{\'WIDGET_CLOSE\'|translate}}\"></i> </a><span ng-if=odecPanelHeader.odecPanelHeaderConfig.moreActions class=\"widget-tools-item widget-tools-dropdown\" uib-dropdown><a href class=widget-tools-item-toggle uib-dropdown-toggle><i class=\"icon-size-lg icon-more_vert\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=simple-dropdown><li ng-repeat=\"action in odecPanelHeader.odecPanelHeaderConfig.moreActions track by $index\" ng-class=\"{\'divider\':action.type === \'divider\'}\"><a href ng-if=\"action.type === \'action\'\" ng-click=\"action[\'method\']()\">{{action.text|translate}}</a></li></ul></span></div><div class=widget-header-titles><p class=title>{{odecPanelHeader.odecPanelHeaderConfig.title|translate}} <i ng-class=\"{\'fa fa-circle-o-notch fa-spin\':isLoading}\"></i></p><p class=subtitle ng-repeat=\"subtitle in odecPanelHeader.odecPanelHeaderConfig.subtitle track by $index\">{{subtitle|translate}}</p></div></header>");
$templateCache.put("app/components/odecSnapshotButton/odecSnapshotModal/odecSnapshotModal.html","<div class=\"odecSnapshotModal ng-animate-slide\" ng-if=odecSnapshotModal.visible><div class=odecSnapshotModalScroll odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D><div class=\"odecSnapshotModal-wrapper margin-top--2\"><div class=\"odecSnapshotModal-actions text-center\"><button class=\"btn btn-md btn-action\" ng-click=odecSnapshotModal.doSnapshot() uib-tooltip=\"{{ \'SNAPSHOTS_CONFIRM_BUTTON\'| translationWithPrefix }}\"><i class=\"icon-size-lg icon-check text-system\"></i></button> <button class=\"btn btn-md btn-transparent\" ng-click=odecSnapshotModal.cancelSnapshot() uib-tooltip=\"{{ \'SNAPSHOTS_CANCEL_BUTTON\'| translationWithPrefix }}\"><i class=\"icon-size-lg icon-times text-danger\"></i></button></div><div class=\"odecSnapshotModal-content margin-top--1\" ng-if=odecSnapshotModal.visible><div class=\"odecSnapshotModal-wrapper display__inline-block horizontal--centered\" ng-bind-html=odecSnapshotModal.content|trustAsHTML></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetHeader/odecWidgetHeader.html","<div id=odec-header-widget class=\"display__flex flex-align-item-center\"><div class=\"title display__flex\" ng-bind-html=\"odecWidgetHeader.titleHeader | boldWords:odecWidgetHeader.extraOptions.boldWords\"></div><div class=\"actions display__flex flex-justify-content-end\"><div class=\"filters display__flex\" ng-if=odecWidgetHeader.filters><div class=\"filter display__flex flex-justify-content-center\" ng-repeat=\"filterGroup in odecWidgetHeader.filters\" ng-style=\"{\'width\':\'calc(100% /\'+odecWidgetHeader.filters.length+\')\'}\"><odec-filter-header class=padding-right--1 filter=filterGroup filter-id=odecWidgetHeader.filterId></odec-filter-header></div></div><div class=\"extra display__flex flex-justify-content-end flex-align-items-center no-snapshot no-print\"><!-- <odec-snapshot-button odec-snapshot-button-target-id=\"odecWidgetHeader.snapshotId\" class=\"margin-right--1\"></odec-snapshot-button> --><odec-copy-to-clipboard class=margin-right--1 ng-if=odecWidgetHeader.copyToClipboardData odec-copy-to-clipboard-data=odecWidgetHeader.copyToClipboardData odec-copy-to-clipboard-format-fn=odecWidgetHeader.copyToClipboardFormatFn></odec-copy-to-clipboard><!-- <i \n                class=\"icon-size-lg icon-file-excel pointer margin-right--1\"\n                tooltip-placement=\"left-bottom\"  \n                uib-tooltip=\"{{ \'DOWNLOAD_XLS\' | translationWithPrefix }}\">\n            </i> --> <i class=\"icon-size-lg icon-info2 pointer\" tooltip-placement=bottom-right uib-tooltip-html=odecWidgetHeader.infoText tooltip-class=\"custom-class width-300\"></i></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetHeader/odecFilterHeader/odecFilterHeader.html","<div id=filter-header-widget class=\"display__flex flex-justify-content-center\"><a href=\"\" class=\"selected display__flex flex-justify-content-center flex-align-item-center\" ng-class=\"{\'block-link\': odecFilterHeader.filter.childs.length <= 1}\" ng-click=odecFilterHeader.clickFilter(odecFilterHeader.selected.text)><span class=\"bold--700 selected-text\">{{odecFilterHeader.selected.text | uppercase}}</span> <i ng-if=\"odecFilterHeader.filter.childs.length > 1\" ng-class=\"{\'icon-caret-down\':!odecFilterHeader.isOpen,\'icon-caret-up\':odecFilterHeader.isOpen}\"></i></a><div class=\"card list-item display__flex flex-direction-column flex-align-item-start flex-justify-content-center\" ng-if=odecFilterHeader.isOpen><a class=padding--0_5 href=\"\" ng-click=odecFilterHeader.onSelectOption(item) ng-repeat=\"item in odecFilterHeader.filter.childs\">{{item.text}}</a></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout12/tableLayout12.html","<div id=table-layout12><div class=\"table-media-target display__flex\"><div class=left-content><div class=\"empty-campaigns-and-events display__flex flex-justify-content-center flex-align-item-center padding--0_5\"><!-- <img ng-src=\"assets/images/campaigns/scandal.jpg\" style=\"height:70%;width: 100%;\"> --></div><!--row headers--><div class=row-headers><div class=\"header display__flex flex-justify-content-end flex-align-item-center padding-right--1\" ng-repeat=\"header in tableLayout12.table.categories\" ng-style=\"{\n                        \'height\':tableLayout12.getSize(tableLayout12.table.categories.length)\n                    }\" ng-class=\"{\'print-version\':!tableLayout12.web}\"><span class=bold--700>{{header.text}}</span></div></div></div><div class=right-content><div class=\"campaigns display__flex\"><div class=\"group display__flex flex-justify-content-center flex-align-item-center\" ng-repeat=\"group in tableLayout12.table.groups.data track by $index\" ng-style=\"{\n                        \'width\':tableLayout12.getSize(tableLayout12.table.groups.data.length)\n                    }\" ng-class=\"{\'print-version\':!tableLayout12.web}\"><span class=bold--700 style=color:#B89A50 ng-if=\"$index === 0\">{{group.text | translationWithPrefix | uppercase}}</span> <img ng-if=\"$index > 0\" ng-src=assets/images/campaigns/{{group.logo}} uib-tooltip=\"{{group.text | translationWithPrefix}}\"></div></div><div class=events-headers><div class=\"groups display__flex\"><div class=\"group display__flex\" ng-repeat=\"event in tableLayout12.table.groups.getEvents(tableLayout12.table.groups.events) track by $index\" ng-style=\"{\n                            \'width\':tableLayout12.getSize(tableLayout12.table.groups.getEvents(tableLayout12.table.groups.events,true))\n                        }\" ng-class=\"{\n                            \'last-header\':  tableLayout12.islastEvent($index+1, tableLayout12.table.groups.events.length),\n                            \'print-version\':!tableLayout12.web\n                        }\"><div class=\"rotated padding-top--0_5 padding-bottom--0_5 display__flex flex-justify-content-start flex-align-item-center\"><span class=bold--700>{{event.text | uppercase}}</span></div></div></div></div><!--row data--><div class=row-data><div class=all-rows style=\"width: 100%;height: 100%\"><div class=\"row-cells display__flex\" ng-repeat=\"row in tableLayout12.table.data track by $index\" ng-style=\"{\n                                    \'width\':\'100%\',\n                                    \'height\':tableLayout12.getSize(tableLayout12.table.categories.length)\n                                }\" ng-init=\"rowIndex = $index\"><div class=\"cell display__flex flex-justify-content-center flex-align-item-center ng-animate-fade\" ng-repeat=\"cellData in row track by $index\" ng-init=\"cellIndex = $index\" ng-class=\"{\n                                \'last-header\':  tableLayout12.islastEvent($index+1, tableLayout12.table.groups.events.length),\n                                \'print-version\':!tableLayout12.web\n                            }\" ng-style=\"{\n                                \'width\':tableLayout12.getSize(tableLayout12.table.groups.getEvents(tableLayout12.table.groups.events,true)),\n                                \'height\':\'100%\',\n                                \'background\':cellData.value > 0 ? cellData.background : \'transparent\'\n                            }\"><span class=\"cell-values-{{rowIndex}}-{{cellIndex}} bold--700\" number-counter colorcell={{cellData.color}} cellvalue=\"{{cellData.value | round:0 }}\" animated={{tableLayout12.web}}></span></div></div></div></div></div></div><!--legend table--><div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\"><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout12.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout12.legend.c2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ tableLayout12.legendData.default.TOT +\'%\'}}; {{\'GROUP_TV\' | translationWithPrefix}} {{ tableLayout12.legendData.default.TV +\'%\'}}; {{\'GROUP_PRINT\' | translationWithPrefix}} {{ tableLayout12.legendData.default.PRN +\'%\'}}; {{\'GROUP_OUTDOOR\' | translationWithPrefix}} {{ tableLayout12.legendData.default.OUT +\'%\'}}; {{\'GROUP_DIGITAL\' | translationWithPrefix}} {{ tableLayout12.legendData.default.ONL +\'%\'}}</span></div></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=icon-square ng-style=\"{\'color\':tableLayout12.legend.bg1}\"></i> <span class=separator>/ </span><i class=icon-square ng-style=\"{\'color\':tableLayout12.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ tableLayout12.legendData.prestige.TOT +\'%\'}}; {{\'GROUP_TV\' | translationWithPrefix}} {{ tableLayout12.legendData.prestige.TV +\'%\'}}; {{\'GROUP_PRINT\' | translationWithPrefix}} {{ tableLayout12.legendData.prestige.PRN +\'%\'}}; {{\'GROUP_OUTDOOR\' | translationWithPrefix}} {{ tableLayout12.legendData.prestige.OUT +\'%\'}}; {{\'GROUP_DIGITAL\' | translationWithPrefix}} {{ tableLayout12.legendData.prestige.ONL +\'%\'}}</span></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout11/tableLayout11.html","<div id=table-layout11><div class=\"table-media-target display__flex flex-direction-column\"><div class=\"top-content display__flex\"><div class=\"empty-campaigns-and-events display__flex flex-justify-content-center flex-align-item-center padding--0_5\"><!-- <img ng-src=\"assets/images/campaigns/scandal.jpg\" style=\"height:70%;width: 100%;\"> --></div><div class=\"campaigns display__flex\"><div class=\"group display__flex flex-justify-content-center flex-align-item-center\" ng-repeat=\"group in tableLayout11.table.groups.data track by $index\" ng-style=\"{\n                                    \'width\':tableLayout11.getSize(tableLayout11.table.groups.data.length)\n                                }\" ng-class=\"{\'print-version\':!tableLayout11.web}\"><span class=bold--700 style=color:#B89A50 ng-if=\"$index === 0\">{{group.text | translationWithPrefix | uppercase}}</span> <img ng-if=\"$index > 0\" ng-src=assets/images/campaigns/{{group.logo}} uib-tooltip=\"{{group.text | translationWithPrefix}}\"></div></div></div><div class=\"data-content display__flex\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#434C53><!--row headers--><div class=row-headers><div class=\"header display__flex flex-justify-content-end flex-align-item-center padding-right--1\" ng-repeat=\"header in tableLayout11.table.categories\" ng-style=\"{\n                                    \'height\':tableLayout11.getSize(tableLayout11.table.maxRows)\n                                }\" ng-class=\"{\'print-version\':!tableLayout11.web}\"><span class=bold--700>{{header.text}}</span></div></div><!--row data--><div class=row-data><div class=all-rows style=\"width: 100%;height: 100%\"><div class=\"row-cells display__flex\" ng-repeat=\"row in tableLayout11.table.data track by $index\" ng-style=\"{\n                                    \'width\':\'100%\',\n                                    \'height\':tableLayout11.getSize(tableLayout11.table.maxRows)\n                                }\" ng-init=\"rowIndex = $index\"><div class=\"cell display__flex flex-justify-content-center flex-align-item-center ng-animate-fade\" ng-repeat=\"cellData in row track by $index\" ng-init=\"cellIndex = $index\" ng-class=\"{\n                                \'print-version\':!tableLayout11.web\n                            }\" ng-style=\"{\n                                \'width\':tableLayout11.getSize(tableLayout11.table.groups.data.length),\n                                \'height\':\'100%\',\n                                \'background\':cellData.value > 0 ? cellData.background : \'transparent\'\n                            }\"><span class=\"cell-values-{{rowIndex}}-{{cellIndex}} bold--700\" number-counter colorcell={{cellData.color}} cellvalue=\"{{cellData.value | round:0 }}\" animated={{tableLayout11.web}}></span></div></div></div></div></div></div><!--legend table--><div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\"><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout11.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout11.legend.c2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ tableLayout11.legendData.default.TOT +\'%\'}}; {{\'GROUP_TV\' | translationWithPrefix}} {{ tableLayout11.legendData.default.TV +\'%\'}}; {{\'GROUP_PRINT\' | translationWithPrefix}} {{ tableLayout11.legendData.default.PRN +\'%\'}}; {{\'GROUP_OUTDOOR\' | translationWithPrefix}} {{ tableLayout11.legendData.default.OUT +\'%\'}}; {{\'GROUP_DIGITAL\' | translationWithPrefix}} {{ tableLayout11.legendData.default.ONL +\'%\'}}</span></div></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=icon-square ng-style=\"{\'color\':tableLayout11.legend.bg1}\"></i> <span class=separator>/ </span><i class=icon-square ng-style=\"{\'color\':tableLayout11.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: {{\'GROUP_CAMPAIGN\' | translationWithPrefix}} {{ tableLayout11.legendData.prestige.TOT +\'%\'}}; {{\'GROUP_TV\' | translationWithPrefix}} {{ tableLayout11.legendData.prestige.TV +\'%\'}}; {{\'GROUP_PRINT\' | translationWithPrefix}} {{ tableLayout11.legendData.prestige.PRN +\'%\'}}; {{\'GROUP_OUTDOOR\' | translationWithPrefix}} {{ tableLayout11.legendData.prestige.OUT +\'%\'}}; {{\'GROUP_DIGITAL\' | translationWithPrefix}} {{ tableLayout11.legendData.prestige.ONL +\'%\'}}</span></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout15/tableLayout15.html","<div id=table-layout15><div class=\"table-media-target display__flex flex-direction-column\"><div class=\"top-content display__flex\"><div class=\"empty-campaigns-and-events display__flex flex-justify-content-center flex-align-item-center padding--0_5\"><!-- <img ng-src=\"assets/images/campaigns/scandal.jpg\" style=\"height:70%;width: 100%;\"> --></div><div class=\"campaigns display__flex\"><div class=\"group display__flex flex-justify-content-center flex-align-item-center\" ng-repeat=\"group in tableLayout15.table.groups.data track by $index\" ng-class=\"{\'print-version\':!tableLayout15.web}\"><span class=bold--700 style=color:#333333 ng-if=\"$index === 0\">{{group.text | translationWithPrefix | uppercase}}</span> <span class=bold--700 style=color:#AEAE9F ng-if=\"$index > 0\">{{group.text | translationWithPrefix | uppercase}}</span><!-- <img ng-if=\"$index > 0\" ng-src=\"assets/images/campaigns/{{group.logo}}\"\n                        uib-tooltip=\"{{group.text | translationWithPrefix}}\"> --></div></div></div><div class=\"data-content display__flex\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#434C53><!--row headers--><div class=row-headers><div class=\"header display__flex flex-justify-content-end flex-align-item-center padding-right--1\" ng-repeat=\"header in tableLayout15.table.categories\" ng-style=\"{\'height\':tableLayout15.getSize(tableLayout15.table.maxRows)}\" ng-class=\"{\'print-version\':!tableLayout15.web}\"><span class=bold--700>{{header.text}}</span></div></div><!--row data--><div class=row-data><div class=all-rows style=\"width: 100%;height: 100%\"><div class=\"row-cells display__flex\" ng-repeat=\"row in tableLayout15.table.data track by $index\" ng-style=\"{\n                                    \'width\':\'100%\',\n                                    \'height\':tableLayout15.getSize(tableLayout15.table.maxRows)\n                                }\" ng-init=\"rowIndex = $index\"><div class=\"cell display__flex flex-justify-content-center flex-align-item-center ng-animate-fade\" ng-repeat=\"cellData in row track by $index\" ng-init=\"cellIndex = $index\" ng-class=\"{\n                                \'print-version\':!tableLayout15.web\n                            }\" ng-style=\"{\n                                \'width\': tableLayout16.getSize(tableLayout16.table.groups.getEvents(tableLayout16.table.groups.events, true)),\n                                \'height\': \'100%\',\n                                \'background\': (cellData.hasCellColor || cellData.value <= 0) ? \'transparent\' : cellData.background\n                            }\"><span class=\"cell-values-{{rowIndex}}-{{cellIndex}} bold--700\" number-counter colorcell=\"{{cellData.hasCellColor ? \'\' : cellData.color}}\" cellvalue=\"{{cellData.value | round:0 }}\" animated={{tableLayout15.web}}></span></div></div></div></div></div></div><!--legend table--><div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\"><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" ng-if=\"tableLayout15.table.typeLegend === \'FRECOTOTAL\'\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout15.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout15.legend.c2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: {{ tableLayout15.table.groups.data[0].text | translationWithPrefix}} {{ tableLayout15.table.groups.data[0].legendNorma +\'%\'}}</span></div></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=icon-square ng-style=\"{\'color\':tableLayout15.legend.bg1}\"></i> <span class=separator>/ </span><i class=icon-square ng-style=\"{\'color\':tableLayout15.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: </span><span ng-repeat=\"title in tableLayout15.table.groups.data track by $index\">{{ title.text | translationWithPrefix}} {{ title.legendPrestige +\'%\'}} <span ng-if=tableLayout15.notLastMedia($index)>;</span></span></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout16/tableLayout16.html","<div id=table-layout16><div class=\"table-media-target display__flex\"><div class=left-content><div class=\"empty-campaigns-and-events display__flex flex-justify-content-center flex-align-item-center padding--0_5\"><!-- <img ng-src=\"assets/images/campaigns/scandal.jpg\" style=\"height:70%;width: 100%;\"> --></div><!--row headers--><div class=row-headers><div class=\"header display__flex flex-justify-content-end flex-align-item-center padding-right--1\" ng-repeat=\"header in tableLayout16.table.categories\" ng-style=\"{\n                        \'height\':tableLayout16.getSize(tableLayout16.table.categories.length)\n                    }\" ng-class=\"{\'print-version\':!tableLayout16.web}\"><span class=bold--700>{{header.text}}</span></div></div></div><div class=right-content ng-style=\"{\'width\':tableLayout16.getSizeColumns(tableLayout16.table.groups.data.length)}\"><div class=\"campaigns display__flex\"><div class=\"group display__flex flex-justify-content-center flex-align-item-center\" ng-repeat=\"group in tableLayout16.table.groups.data track by $index\" ng-style=\"{\n                        \'width\':tableLayout16.getSize(tableLayout16.table.groups.data.length)\n                    }\" ng-class=\"{\'print-version\':!tableLayout16.web}\"><span class=bold--700 style=color:#333333 ng-if=\"$index === 0\">{{group.text | translationWithPrefix | uppercase}}</span> <span class=bold--700 style=color:#AEAE9F ng-if=\"$index > 0\">{{group.text | translationWithPrefix | uppercase}}</span><!-- <img ng-if=\"$index > 0\" ng-src=\"assets/images/campaigns/{{group.logo}}\" uib-tooltip=\"{{group.text | translationWithPrefix}}\"> --></div></div><div class=events-headers><div class=\"groups display__flex\"><div class=\"group display__flex\" ng-repeat=\"event in tableLayout16.table.groups.getEvents(tableLayout16.table.groups.events) track by $index\" ng-style=\"{\n                            \'width\':tableLayout16.getSize(tableLayout16.table.groups.getEvents(tableLayout16.table.groups.events,true))\n                        }\" ng-class=\"{\n                            \'last-header\':  tableLayout16.islastEvent($index+1, tableLayout16.table.groups.events.length),\n                            \'print-version\':!tableLayout16.web\n                        }\"><div class=\"rotated padding-top--0_5 padding-bottom--0_5 display__flex flex-justify-content-start flex-align-item-center\"><span class=bold--700>{{event.text | uppercase}}</span></div></div></div></div><!--row data--><div class=row-data><div class=all-rows style=\"width: 100%; height: 100%\"><div class=\"row-cells display__flex\" ng-repeat=\"row in tableLayout16.table.data track by $index\" ng-style=\"{\n                            \'width\':\'100%\',\n                            \'height\':tableLayout16.getSize(tableLayout16.table.categories.length)\n                        }\" ng-init=\"rowIndex = $index\"><div class=\"cell display__flex flex-justify-content-center flex-align-item-center ng-animate-fade\" ng-repeat=\"cellData in row track by $index\" ng-init=\"cellIndex = $index\" ng-class=\"{\n                                \'last-header\': tableLayout16.islastEvent($index+1, tableLayout16.table.groups.events.length),\n                                \'print-version\': !tableLayout16.web\n                            }\" ng-style=\"{\n                                \'width\': tableLayout16.getSize(tableLayout16.table.groups.getEvents(tableLayout16.table.groups.events, true)),\n                                \'height\': \'100%\',\n                                \'background\': (cellData.hasCellColor && cellData.value > 1) ? cellData.background : \'transparent\'\n                            }\"><span class=\"cell-values-{{rowIndex}}-{{cellIndex}} bold--700\" number-counter colorcell=\"{{ cellData.hasCellColor ? cellData.color : \'\'}}\" cellvalue=\"{{ cellData.value | round:0 }}\" animated={{tableLayout16.web}}></span></div></div></div></div></div></div><!--legend table--><div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\"><!-- <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" ng-if=\"tableLayout16.table.legend.typeLegend === \'FRECOTOTAL\'\">\n            <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout16.legend.c1}\"></i>\n                <span class=\"separator\"> / </span>\n                <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout16.legend.c2}\"></i>\n            </div>\n            <div class=\"text-legend display__flex\">\n                <span> {{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b> {{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>:\n                    {{ tableLayout16.table.groups.data[0].text | translationWithPrefix}} {{ tableLayout16.table.groups.data[0].legendNorma +\'%\'}}\n                </span>\n            </div> \n        </div>\n        <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" >\n            <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                <i class=\"icon-square\" ng-style=\"{\'color\':tableLayout16.legend.bg1}\"></i>\n                <span class=\"separator\"> / </span>\n                <i class=\"icon-square\" ng-style=\"{\'color\':tableLayout16.legend.bg2}\"></i>\n            </div>\n            <div class=\"text-legend\">\n                <span> {{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b> {{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>:  </span>\n                <span ng-repeat=\"title in tableLayout16.table.groups.data track by $index\">\n                    {{ title.text | translationWithPrefix}} {{ title.legendPrestige +\'%\'}}\n                    <span ng-if=\"tableLayout16.notLastMedia($index)\">;</span>\n                </span> --><div class=\"display__flex flex-direction-row flex-justify-content-end flex-align-item-end\"><div ng-repeat=\"legendItem in tableLayout16.table.legend | limitTo: 1 track by $index\" class=\"legend-group margin-bottom--0_5\"><!-- Mostrar información de contexto (año, target, país) si hay múltiples leyendas --><div class=\"legend-context text-right padding-right--0_5\" ng-if=\"tableLayout16.table.legend.length > 1\"><span class=bold--700><span ng-if=legendItem.year>{{legendItem.year}}</span> <span ng-if=legendItem.target>- {{legendItem.target}}</span> <span ng-if=legendItem.country>({{legendItem.country}})</span></span></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" ng-if=\"legendItem.typeLegend === \'FRECOTOTAL\'\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout16.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout16.legend.c2}\"></i></div><div class=\"text-legend display__flex\"><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: {{ tableLayout16.table.groups.data[0].text | translationWithPrefix}} {{ (legendItem.default && legendItem.default.T) +\'%\'}}</span></div></div><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=icon-square ng-style=\"{\'color\':tableLayout16.legend.bg1}\"></i> <span class=separator>/ </span><i class=icon-square ng-style=\"{\'color\':tableLayout16.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: </span><span ng-repeat=\"title in tableLayout16.table.groups.data track by $index\">{{ title.text | translationWithPrefix}} {{ (legendItem.prestige && legendItem.prestige[title.key]) +\'%\'}} <span ng-if=tableLayout16.notLastMedia($index)>;</span></span></div></div></div><div ng-if=\"tableLayout16.table.legend.length > 1\" class=view-more-legend><button class=\"btn btn-xs btn-default\" ng-click=tableLayout16.openLegendModal()>{{ \'VIEW_MORE\' | translationWithPrefix }}</button></div></div></div></div><script type=text/ng-template id=legendModal.html><div class=\"display__flex flex-justify-content-end flex-align-item-center margin-right--0_5\">\n        <i class=\"icon-close icon-size-lg pointer\" ng-click=\"vm.close()\"></i>\n    </div>\n    <div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto;\">\n        <div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\">\n            <div ng-repeat=\"legendItem in vm.tableLayout16.table.legend track by $index\">\n                <div class=\"legend-group margin-bottom--0_5\" ng-if=\"legendItem.year >= 2025 || legendItem.target === \'Total\'\">                    \n                    <div class=\"legend-context text-right padding-right--0_5\" >\n                        <span class=\"bold--700\">\n                            <span ng-if=\"legendItem.year\">{{legendItem.year}}</span>\n                            <span ng-if=\"legendItem.target\"> - {{legendItem.target}}</span>                        \n                        </span>\n                    </div>\n\n                    <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"\n                        ng-if=\"legendItem.typeLegend === \'FRECOTOTAL\' && legendItem.target === \'Total\'\">\n                        <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                            <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':vm.tableLayout16.legend.c1}\"></i>\n                            <span class=\"separator\"> / </span>\n                            <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':vm.tableLayout16.legend.c2}\"></i>\n                        </div>\n                        <div class=\"text-legend display__flex\">\n                            <span> {{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>\n                                    {{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>:\n                                {{ vm.tableLayout16.table.groups.data[0].text | translationWithPrefix}} {{ (legendItem.default &&\n                                legendItem.default.T) +\'%\'}}\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\">\n                        <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                            <i class=\"icon-square\" ng-style=\"{\'color\':vm.tableLayout16.legend.bg1}\"></i>\n                            <span class=\"separator\"> / </span>\n                            <i class=\"icon-square\" ng-style=\"{\'color\':vm.tableLayout16.legend.bg2}\"></i>\n                        </div>\n                        <div class=\"text-legend\">\n                            <span> {{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>\n                                    {{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: </span>\n                            <span ng-repeat=\"title in vm.tableLayout16.table.groups.data track by $index\">\n                            {{ title.text | translationWithPrefix}} {{ (legendItem.prestige &&\n                                legendItem.prestige[title.key]) +\'%\'}}\n                                <span ng-if=\"vm.tableLayout16.notLastMedia($index)\">;</span>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/components/odecWidgetCollection/views/crossCountry/layout22/brandEssentialTrackingValues/brandEssentialTrackingValues.html","<div id={{brandEssentialTrackingValuesL22.view.id}}><div class=\"module-content card display__flex flex-direction-column\"><odec-view-data-loader ng-if=\"brandEssentialTrackingValuesL22.view.loading && !brandEssentialTrackingValuesL22.view.hasData\" odec-view-data-loader-loading=\"brandEssentialTrackingValuesL22.view.loading && !brandEssentialTrackingValuesL22.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!brandEssentialTrackingValuesL22.view.loading && !brandEssentialTrackingValuesL22.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!brandEssentialTrackingValuesL22.view.loading && brandEssentialTrackingValuesL22.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_ESSENTIALS_TRACKING_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=brandEssentialTrackingValuesL22.copyXls.copyToXlsData copy-to-clipboard-format-fn=brandEssentialTrackingValuesL22.copyXls.copyToXlsFn snapshot-id=brandEssentialTrackingValuesL22.view.id info-text=brandEssentialTrackingValuesL22.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding-right--0_5\"><content-widget-brand-essential-tracking-values-l22 content-data=brandEssentialTrackingValuesL22.brandValuesData.data type-view=brandEssentialTrackingValuesL22.typeView max-value=brandEssentialTrackingValuesL22.brandValuesData.allMax></content-widget-brand-essential-tracking-values-l22></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/crossCountry/layout20/purchaseFunnel/purchaseFunnel.html","<div id={{purchaseFunnelL20.view.id}} class=padding--0_5><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'PURCHASE_FUNNEL_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=purchaseFunnelL20.view.data copy-to-clipboard-format-fn=purchaseFunnelL20.copyXls snapshot-id=purchaseFunnelL20.view.id info-text=purchaseFunnelL20.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1 padding--1\"><odec-view-data-loader ng-if=\"purchaseFunnelL20.view.loading && !purchaseFunnelL20.view.hasData\" odec-view-data-loader-loading=\"purchaseFunnelL20.view.loading && !purchaseFunnelL20.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!purchaseFunnelL20.view.loading && !purchaseFunnelL20.view.hasData\"></odec-no-data-display><div class=\"data-widgets display__flex\" ng-if=\"!purchaseFunnelL20.view.loading && purchaseFunnelL20.view.hasData\"><div class=\"left-headers display__flex flex-direction-column flex-align-item-end flex-justify-content-end\"><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'BOUGHT_LAST_YEAR\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'EVER_BOUGHT\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'CONSIDERATION\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'AWARENESS\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-total-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE\' | translationWithPrefix }}</p></div></div><div class=\"brands display__flex\"><div class=brand ng-repeat=\"column in purchaseFunnelL20.view.data\"><div class=\"row-brand display__flex flex-align-item-center flex-justify-content-center padding-left--0_5 padding-right--0_5\"><p class=\"total-value text-center\">{{column.text}}</p></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.bought.value color=column.bought.type max=purchaseFunnelL20.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.everBought.value color=column.everBought.type max=purchaseFunnelL20.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.consideration.value color=column.consideration.type max=purchaseFunnelL20.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.awareness.value color=column.awareness.type max=purchaseFunnelL20.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand display__flex flex-align-item-end flex-justify-content-end padding-left--0_5 padding-right--0_5\"><p class=\"total-value text-center\">{{purchaseFunnelL20.view.totalSample[$index]}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/crossCountry/layout23/tableLayout23/tableLayout23.html","<div id=table-layout23><div class=\"table-media-target display__flex flex-direction-column\"><!-- Header row with metrics (like layout15 groups) --><div class=\"top-content display__flex\"><div class=\"empty-campaigns-and-events display__flex flex-justify-content-center flex-align-item-center padding--0_5\"></div><div class=\"campaigns display__flex\"><div class=\"group display__flex flex-justify-content-center flex-align-item-center\" ng-repeat=\"header in tableLayout23.table.columnHeaders track by $index\" ng-class=\"{\'print-version\':!tableLayout23.web}\"><span class=bold--700 style=color:#333333 ng-if=\"$index === 0\">{{header.text | translationWithPrefix | uppercase}}</span> <span class=bold--700 style=color:#AEAE9F ng-if=\"$index > 0\">{{header.text | translationWithPrefix | uppercase}}</span></div></div></div><!-- Data rows (countries as rows) --><div class=\"data-content display__flex\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#434C53><!-- Row headers (countries) --><div class=row-headers><div class=\"header display__flex flex-justify-content-end flex-align-item-center padding-right--1\" ng-repeat=\"rowHeader in tableLayout23.table.rowHeaders\" ng-style=\"{\'height\':tableLayout23.getSize(tableLayout23.table.maxRows)}\" ng-class=\"{\'print-version\':!tableLayout23.web}\"><span class=bold--700>{{rowHeader.text}}</span></div></div><!-- Row data (metrics for each country) --><div class=row-data><div class=all-rows style=\"width: 100%;height: 100%\"><div class=\"row-cells display__flex\" ng-repeat=\"row in tableLayout23.table.data track by $index\" ng-style=\"{\n                            \'width\':\'100%\',\n                            \'height\':tableLayout23.getSize(tableLayout23.table.maxRows)\n                        }\" ng-init=\"rowIndex = $index\"><!-- Iterate over metrics (cells) --><div class=\"cell display__flex flex-justify-content-center flex-align-item-center ng-animate-fade\" ng-repeat=\"cellData in row track by $index\" ng-init=\"cellIndex = $index\" ng-class=\"{\n                                \'print-version\':!tableLayout23.web\n                            }\" ng-style=\"{\n                                \'height\': \'100%\',\n                                \'background\': (cellData.hasCellColor && cellData.value > 1) ? cellData.background : \'transparent\'\n                            }\"><span class=\"cell-values-{{rowIndex}}-{{cellIndex}} bold--700\" number-counter colorcell=\"{{ cellData.hasCellColor ? cellData.color : \'\'}}\" cellvalue=\"{{cellData.value | round:0 }}\" animated={{tableLayout23.web}}></span></div></div></div></div></div></div><!-- Legend table - Muestra solo el primer país con botón \"Ver más\" --><div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\"><div class=\"display__flex flex-direction-row flex-justify-content-end flex-align-item-end\"><!-- Mostrar solo la primera leyenda --><div ng-repeat=\"norma in tableLayout23.table.normas | limitTo: 1 track by $index\" class=\"legend-country margin-bottom--0_5\"><!-- Info del país --><div class=\"legend-context text-right padding-right--0_5\" ng-if=\"tableLayout23.table.normas.length > 1\"><span class=bold--700><span ng-if=norma.country>{{norma.country}}</span></span></div><!-- Fila de norma country (solo para FRECOTOTAL) --><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" ng-if=\"tableLayout23.table.typeLegend === \'FRECOTOTAL\'\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout23.legend.c1}\"></i> <span class=separator>/ </span><i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':tableLayout23.legend.c2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>: {{ tableLayout23.table.columnHeaders[0].text | translationWithPrefix}} {{ tableLayout23.getNormaValue(norma, tableLayout23.table.columnHeaders[0], \'norma\') +\'%\'}}</span></div></div><!-- Fila de prestige --><div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\"><div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\"><i class=icon-square ng-style=\"{\'color\':tableLayout23.legend.bg1}\"></i> <span class=separator>/ </span><i class=icon-square ng-style=\"{\'color\':tableLayout23.legend.bg2}\"></i></div><div class=text-legend><span>{{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: </span><span ng-repeat=\"title in tableLayout23.table.columnHeaders track by $index\">{{ title.text | translationWithPrefix}} {{ tableLayout23.getNormaValue(norma, title, \'prestige\') +\'%\'}} <span ng-if=tableLayout23.notLastMedia($index)>;</span></span></div></div></div><!-- Botón \"Ver más\" si hay más de un país --><div ng-if=\"tableLayout23.table.normas.length > 1\" class=\"view-more-legend margin-left--1 margin-bottom--0_5\"><button class=\"btn btn-xs btn-default\" ng-click=tableLayout23.openLegendModal()>{{ \'VIEW_MORE\' | translationWithPrefix }}</button></div></div></div></div><!-- Modal template para ver todas las leyendas --><script type=text/ng-template id=legendModalLayout23.html><div class=\"display__flex flex-justify-content-end flex-align-item-center margin-right--0_5\">\n        <i class=\"icon-close icon-size-lg pointer\" ng-click=\"vm.close()\"></i>\n    </div>\n    <div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto;\">\n        <div class=\"legend display__flex flex-direction-column flex-justify-content-end flex-align-item-end\">\n            <div ng-repeat=\"norma in vm.tableLayout23.table.normas track by $index\" class=\"legend-country margin-bottom--1\">\n                <!-- Info del país -->\n                <div class=\"legend-context text-right padding-right--0_5\">\n                    <span class=\"bold--700\">\n                        <span ng-if=\"norma.country\">{{norma.country}}</span>\n                    </span>\n                </div>\n                <!-- Fila de norma country (solo para FRECOTOTAL) -->\n                <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\" ng-if=\"vm.tableLayout23.table.typeLegend === \'FRECOTOTAL\'\">\n                    <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                        <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':vm.tableLayout23.legend.c1}\"></i>\n                        <span class=\"separator\"> / </span>\n                        <i class=\"icon-close icon-size-md\" ng-style=\"{\'color\':vm.tableLayout23.legend.c2}\"></i>\n                    </div>\n                    <div class=\"text-legend\">\n                        <span>{{\'TABLE_LEGEND_TEST_COUNTRY\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_COUNTRY\' | translationWithPrefix}}</b>:\n                            {{ vm.tableLayout23.table.columnHeaders[0].text | translationWithPrefix}} {{ vm.tableLayout23.getNormaValue(norma, vm.tableLayout23.table.columnHeaders[0], \'norma\') +\'%\'}}\n                        </span>\n                    </div>\n                </div>\n                <!-- Fila de prestige -->\n                <div class=\"legend-row display__flex flex-justify-content-end flex-align-item-center\">\n                    <div class=\"icons padding-right--0_5 display__flex flex-justify-content-end flex-align-item-center\">\n                        <i class=\"icon-square\" ng-style=\"{\'color\':vm.tableLayout23.legend.bg1}\"></i>\n                        <span class=\"separator\"> / </span>\n                        <i class=\"icon-square\" ng-style=\"{\'color\':vm.tableLayout23.legend.bg2}\"></i>\n                    </div>\n                    <div class=\"text-legend\">\n                        <span>{{\'TABLE_LEGEND_TEST_PRESTIGE\' | translationWithPrefix}} <b>{{\'TABLE_LEGEND_TEST_NORM_PRESTIGE\' | translationWithPrefix}}</b>: </span>\n                        <span ng-repeat=\"title in vm.tableLayout23.table.columnHeaders track by $index\">\n                            {{ title.text | translationWithPrefix}} {{ vm.tableLayout23.getNormaValue(norma, title, \'prestige\') +\'%\'}}\n                            <span ng-if=\"vm.tableLayout23.notLastMedia($index)\">;</span>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div></script>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout6/brandImage/brandImage.html","<div id={{brandImageL6.view.id}}><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_IMAGE_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=brandImageL6.view.data copy-to-clipboard-format-fn=brandImageL6.copyXls snapshot-id=brandImageL6.view.id info-text=brandImageL6.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"brandImageL6.view.loading && !brandImageL6.view.hasData\" odec-view-data-loader-loading=\"brandImageL6.view.loading && !brandImageL6.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!brandImageL6.view.loading && !brandImageL6.view.hasData\"></odec-no-data-display><div class=data-widgets ng-if=\"!brandImageL6.view.loading && brandImageL6.view.hasData\"><div class=\"row-widget display__flex flex-align-item-center flex-justify-content-end\" ng-repeat=\"row in brandImageL6.view.data track by $index\" ng-style=\"{\n                        \'width\':\'100%\',\n                        \'height\':\'calc(95% / \'+brandImageL6.view.data.length+\')\'\n                    }\"><p class=\"label-row text-right padding-right--0_5\">{{ row.text }}</p><odec-d3-bar index-bar=$index value=row.value max=brandImageL6.view.maxValue color=row.type mark-value=row.isBold></odec-d3-bar></div><!--TOTAL SAMPLE--><div class=\"total-row-widget total-sample display__flex flex-align-item-end flex-justify-content-start\"><p class=\"label-total-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}</p><p class=\"total-value text-center\" ng-style=\"{\'width\': brandImageL6.view.totalSample > 0 ? \'56%\' : \'65%\' }\">{{brandImageL6.view.totalSample}}</p><div class=empty></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout6/emotionalConnection/emotionalConnection.html","<div id={{emotionalConnectionL6.view.id}} class=padding-right--0_5><div class=\"widget card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'EMOTIONAL_CONNECTION_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=emotionalConnectionL6.view.data copy-to-clipboard-format-fn=emotionalConnectionL6.copyXls snapshot-id=emotionalConnectionL6.view.id info-text=emotionalConnectionL6.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"emotionalConnectionL6.view.loading && !emotionalConnectionL6.view.hasData\" odec-view-data-loader-loading=\"emotionalConnectionL6.view.loading && !emotionalConnectionL6.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!emotionalConnectionL6.view.loading && !emotionalConnectionL6.view.hasData\"></odec-no-data-display><div class=\"data-widgets display__flex\" ng-if=\"!emotionalConnectionL6.view.loading && emotionalConnectionL6.view.hasData\"><div class=\"donut-info display__flex flex-direction-column\"><div class=\"donuts display__flex\"><odec-d3-progress ng-repeat=\"circle in emotionalConnectionL6.view.data track by $index\" odec-d3-progress-options=\"{\'id\':circle.id, \'value\':circle.value, \'text\':circle.text, \'type\':circle.type}\"></odec-d3-progress></div><div class=\"base-item display__flex flex-justify-content-center flex-align-item-center\"><span>{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}: {{emotionalConnectionL6.view.base | round:0}}</span></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout7/brandImage/brandImage.html","<div id={{brandImageL7.view.id}} class=\"padding-right--0_5 padding-left--0_5\"><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_IMAGE_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=brandImageL7.view.data copy-to-clipboard-format-fn=brandImageL7.copyXls snapshot-id=brandImageL7.view.id info-text=brandImageL7.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"brandImageL7.view.loading && !brandImageL7.view.hasData\" odec-view-data-loader-loading=\"brandImageL7.view.loading && !brandImageL7.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!brandImageL7.view.loading && !brandImageL7.view.hasData\" class=ng-animate-fade></odec-no-data-display><div class=\"data-widgets display__flex flex-direction-column\" ng-if=\"!brandImageL7.view.loading && brandImageL7.view.hasData\"><div class=\"data display__flex\"><div class=\"left-headers display__flex flex-direction-column flex-align-item-start flex-justify-content-start\"><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"></div><div class=\"header display__flex flex-align-item-center flex-justify-content-end\" ng-repeat=\"column in brandImageL7.view.leftHeaders track by $index\"><p class=\"label-row text-right padding-right--0_5\" uib-tooltip={{column}} tooltip-class=custom-class>{{ column }}</p></div></div><div class=\"brands display__flex\"><div class=brand ng-repeat=\"column in brandImageL7.view.data track by $index\"><div class=\"row-brand display__flex flex-align-item-center flex-justify-content-center padding-left--0_5 padding-right--0_5\"><p class=\"total-value text-center\" uib-tooltip={{column.text}} tooltip-class=custom-class>{{column.text}}</p></div><div class=row-brand ng-repeat=\"donut in column.data track by $index\"><odec-d3-half-donut value=donut.value color=donut.type></odec-d3-half-donut></div></div></div></div><div class=\"total-sample display__flex\"><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}</p></div><div class=\"row-brand display__flex flex-align-item-end flex-justify-content-center padding-left--0_5 padding-right--0_5\" ng-repeat=\"column in brandImageL7.view.sample track by $index\"><p class=\"total-value text-center\">{{column}}</p></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout7/emotionalConnection/emotionalConnection.html","<div id={{emotionalConnectionL7.view.id}} class=\"padding-right--0_5 padding-left--0_5\"><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'EMOTIONAL_CONNECTION_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=emotionalConnectionL7.view.data copy-to-clipboard-format-fn=emotionalConnectionL7.copyXls snapshot-id=emotionalConnectionL7.view.id info-text=emotionalConnectionL7.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"emotionalConnectionL7.view.loading && !emotionalConnectionL7.view.hasData\" odec-view-data-loader-loading=\"emotionalConnectionL7.view.loading && !emotionalConnectionL7.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!emotionalConnectionL7.view.loading && !emotionalConnectionL7.view.hasData\" class=ng-animate-fade></odec-no-data-display><div class=\"data-widgets display__flex flex-direction-column\" ng-if=\"!emotionalConnectionL7.view.loading && emotionalConnectionL7.view.hasData\"><div class=\"data display__flex\"><div class=\"left-headers display__flex flex-direction-column flex-align-item-start flex-justify-content-start\"><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"></div><div class=\"header display__flex flex-align-item-center flex-justify-content-end\" ng-repeat=\"column in emotionalConnectionL7.view.leftHeaders track by $index\"><p class=\"label-row text-right padding-right--0_5\" uib-tooltip={{column}} tooltip-class=custom-class>{{ column }}</p></div></div><div class=\"brands display__flex\"><div class=brand ng-repeat=\"column in emotionalConnectionL7.view.data track by $index\"><div class=\"row-brand display__flex flex-align-item-center flex-justify-content-center padding-left--0_5 padding-right--0_5\"><p class=\"total-value text-center\" uib-tooltip={{column.text}} tooltip-class=custom-class>{{column.text}}</p></div><div class=row-brand ng-repeat=\"metricId in emotionalConnectionL7.view.metricIds track by $index\"><odec-d3-half-donut value=column.metrics[metricId].value color=column.metrics[metricId].type></odec-d3-half-donut></div></div></div></div><div class=\"total-sample display__flex\"><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}</p></div><div class=\"row-brand display__flex flex-align-item-end flex-justify-content-center padding-left--0_5 padding-right--0_5\" ng-repeat=\"column in emotionalConnectionL7.view.data track by $index\"><p class=\"total-value text-center\">{{ column.base | round:0 }}</p></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout7/purchaseFunnel/purchaseFunnel.html","<div id={{purchaseFunnelL7.view.id}} class=padding--0_5><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'PURCHASE_FUNNEL_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=purchaseFunnelL7.view.data copy-to-clipboard-format-fn=purchaseFunnelL7.copyXls snapshot-id=purchaseFunnelL7.view.id info-text=purchaseFunnelL7.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1 padding--1\"><odec-view-data-loader ng-if=\"purchaseFunnelL7.view.loading && !purchaseFunnelL7.view.hasData\" odec-view-data-loader-loading=\"purchaseFunnelL7.view.loading && !purchaseFunnelL7.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!purchaseFunnelL7.view.loading && !purchaseFunnelL7.view.hasData\"></odec-no-data-display><div class=\"data-widgets display__flex\" ng-if=\"!purchaseFunnelL7.view.loading && purchaseFunnelL7.view.hasData\"><div class=\"left-headers display__flex flex-direction-column flex-align-item-end flex-justify-content-end\"><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'BOUGHT_LAST_YEAR\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'EVER_BOUGHT\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'CONSIDERATION\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'AWARENESS\' | translationWithPrefix }}</p></div><div class=\"header display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-total-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE\' | translationWithPrefix }}</p></div></div><div class=\"brands display__flex\"><div class=brand ng-repeat=\"column in purchaseFunnelL7.view.data\"><div class=\"row-brand display__flex flex-align-item-center flex-justify-content-center padding-left--0_5 padding-right--0_5\"><p class=\"total-value text-center\">{{column.text}}</p></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.bought.value color=column.bought.type max=purchaseFunnelL7.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.everBought.value color=column.everBought.type max=purchaseFunnelL7.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.consideration.value color=column.consideration.type max=purchaseFunnelL7.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=column.awareness.value color=column.awareness.type max=purchaseFunnelL7.view.maxValue></odec-d3-bar-extremes></div><div class=\"row-brand display__flex flex-align-item-end flex-justify-content-end padding-left--0_5 padding-right--0_5\"><p class=\"total-value text-center\">{{purchaseFunnelL7.view.totalSample[$index]}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout6/purchaseFunnel/purchaseFunnel.html","<div id={{purchaseFunnelL6.view.id}} class=\"padding-right--0_5 padding-top--0_5\"><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'PURCHASE_FUNNEL_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=purchaseFunnelL6.view.data copy-to-clipboard-format-fn=purchaseFunnelL6.copyXls snapshot-id=purchaseFunnelL6.view.id info-text=purchaseFunnelL6.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"purchaseFunnelL6.view.loading && !purchaseFunnelL6.view.hasData\" odec-view-data-loader-loading=\"purchaseFunnelL6.view.loading && !purchaseFunnelL6.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!purchaseFunnelL6.view.loading && !purchaseFunnelL6.view.hasData\"></odec-no-data-display><div class=data-widgets ng-if=\"!purchaseFunnelL6.view.loading && purchaseFunnelL6.view.hasData\"><!--BOUGHT LAST YEAR--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'BOUGHT_LAST_YEAR\' | translationWithPrefix }}</p><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL6.view.data.bought.value color=purchaseFunnelL6.view.data.bought.type max=purchaseFunnelL6.view.maxValue></odec-d3-bar-extremes><div class=empty></div></div><!--EVER BOUGHT--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'EVER_BOUGHT\' | translationWithPrefix }}</p><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL6.view.data.everBought.value color=purchaseFunnelL6.view.data.everBought.type max=purchaseFunnelL6.view.maxValue></odec-d3-bar-extremes><div class=empty></div></div><!--CONSIDERATION--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'CONSIDERATION\' | translationWithPrefix }}</p><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL6.view.data.consideration.value color=purchaseFunnelL6.view.data.consideration.type max=purchaseFunnelL6.view.maxValue></odec-d3-bar-extremes><div class=empty></div></div><!--AWARENESS--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--0_5\">{{ \'AWARENESS\' | translationWithPrefix }}</p><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL6.view.data.awareness.value color=purchaseFunnelL6.view.data.awareness.type max=purchaseFunnelL6.view.maxValue></odec-d3-bar-extremes><div class=empty></div></div><!--TOTAL SAMPLE--><div class=\"row-widget total-sample display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-total-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE\' | translationWithPrefix }}</p><p class=\"total-value text-center\">{{purchaseFunnelL6.view.totalSample}}</p><div class=empty></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout8/brandImage/brandImage.html","<div id={{brandImageL8.view.id}}><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_IMAGE_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=brandImageL8.view.data copy-to-clipboard-format-fn=brandImageL8.copyXls snapshot-id=brandImageL8.view.id info-text=brandImageL8.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"brandImageL8.view.loading && !brandImageL8.view.hasData\" odec-view-data-loader-loading=\"brandImageL8.view.loading && !brandImageL8.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!brandImageL8.view.loading && !brandImageL8.view.hasData\"></odec-no-data-display><div class=data-widgets ng-if=\"!brandImageL8.view.loading && brandImageL8.view.hasData\"><!--TOTAL SAMPLE--><div class=\"total-row-widget total-sample display__flex flex-align-item-end flex-justify-content-start\"><p class=\"label-total-row text-right\"></p><div class=\"bar-extremes padding-left--0_5 padding-right--0_5 display__flex flex-align-item-center flex-justify-content-center\" ng-repeat=\"pText in brandImageL8.view.periodsText\"><p class=\"total-value text-center\">{{pText}}</p></div></div><div class=\"row-widget display__flex flex-align-item-center flex-justify-content-end\" ng-repeat=\"row in brandImageL8.view.data track by $index\" ng-style=\"{\n                        \'width\':\'100%\',\n                        \'height\':\'calc(90% / \'+brandImageL8.view.data.length+\')\'\n                    }\"><p class=\"label-row text-right padding-right--0_5\">{{ row.text }}</p><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar index-bar=$index value=row.valueFP max=brandImageL8.view.maxValue color=row.typeFP mark-value=row.isBold></odec-d3-bar></div><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar index-bar=$index value=row.valueSP max=brandImageL8.view.maxValue color=row.typeSP mark-value=row.isBold></odec-d3-bar></div></div><!--TOTAL SAMPLE--><div class=\"total-row-widget total-sample display__flex flex-align-item-end\"><p class=\"label-total-row text-right padding-right--0_5\">{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}</p><div class=\"bar-extremes display__flex flex-align-item-end flex-justify-content-center padding-left--0_5 padding-right--0_5\" ng-repeat=\"sample in brandImageL8.view.totalSample track by $index\"><p class=\"total-value text-center\">{{sample}}</p></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout8/emotionalConnection/emotionalConnection.html","<div id={{emotionalConnectionL8.view.id}} class=padding-right--0_5><div class=\"widget card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'EMOTIONAL_CONNECTION_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=emotionalConnectionL8.view.data copy-to-clipboard-format-fn=emotionalConnectionL8.copyXls snapshot-id=emotionalConnectionL8.view.id info-text=emotionalConnectionL8.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"emotionalConnectionL8.view.loading && !emotionalConnectionL8.view.hasData\" odec-view-data-loader-loading=\"emotionalConnectionL8.view.loading && !emotionalConnectionL8.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!emotionalConnectionL8.view.loading && !emotionalConnectionL8.view.hasData\"></odec-no-data-display><div class=\"data-widgets display__flex flex-direction-column\" ng-if=\"!emotionalConnectionL8.view.loading && emotionalConnectionL8.view.hasData\"><!-- Contenedor de círculos en fila horizontal --><div class=\"circles-container display__flex\"><!-- Grupo de la primera ola --><div class=\"wave-group first-wave display__flex\" ng-if=\"emotionalConnectionL8.view.data.firstPeriod.length > 0\"><div class=circle-with-base ng-repeat=\"circle in emotionalConnectionL8.view.data.firstPeriod track by $index\"><odec-d3-progress odec-d3-progress-options=\"{\'id\':circle.id, \'value\':circle.value, \'text\':circle.text, \'type\':circle.type, \'period\':circle.period}\"></odec-d3-progress><div class=base-value><span class=period-label>{{circle.period}}</span> <span class=sample-label>{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}: {{circle.base}}</span></div></div></div><!-- Grupo de la segunda ola --><div class=\"wave-group second-wave display__flex\" ng-if=\"emotionalConnectionL8.view.data.secondPeriod.length > 0\"><div class=circle-with-base ng-repeat=\"circle in emotionalConnectionL8.view.data.secondPeriod track by $index\"><odec-d3-progress odec-d3-progress-options=\"{\'id\':circle.id, \'value\':circle.value, \'text\':circle.text, \'type\':circle.type, \'period\':circle.period}\"></odec-d3-progress><div class=base-value><span class=period-label>{{circle.period}}</span> <span class=base-number>{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}: {{circle.base}}</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/detailed/layout8/purchaseFunnel/purchaseFunnel.html","<div id={{purchaseFunnelL8.view.id}} class=\"padding-right--0_5 padding-top--0_5\"><div class=\"widget card\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'PURCHASE_FUNNEL_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=purchaseFunnelL8.view.data copy-to-clipboard-format-fn=purchaseFunnelL8.copyXls snapshot-id=purchaseFunnelL8.view.id info-text=purchaseFunnelL8.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column flex-justify-content-center flex-align-item-center padding--1\"><odec-view-data-loader ng-if=\"purchaseFunnelL8.view.loading && !purchaseFunnelL8.view.hasData\" odec-view-data-loader-loading=\"purchaseFunnelL8.view.loading && !purchaseFunnelL8.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!purchaseFunnelL8.view.loading && !purchaseFunnelL8.view.hasData\"></odec-no-data-display><div class=data-widgets ng-if=\"!purchaseFunnelL8.view.loading && purchaseFunnelL8.view.hasData\"><!--HEADERS--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-end\"><p class=\"label-row text-right padding-right--1_5\"></p><div class=\"bar-extremes display__flex flex-justify-content-center flex-align-item-center padding-left--0_5 padding-right--0_5\" ng-repeat=\"pText in purchaseFunnelL8.view.periodsText track by $index\"><p class=text-center>{{pText}}</p></div></div><!--BOUGHT LAST YEAR--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-center\"><p class=\"label-row text-right padding-right--1_5\">{{ \'BOUGHT_LAST_YEAR\' | translationWithPrefix }}</p><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.bought.valueFP color=purchaseFunnelL8.view.data.bought.typeFP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.bought.valueSP color=purchaseFunnelL8.view.data.bought.typeSP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div></div><!--EVER BOUGHT--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-center\"><p class=\"label-row text-right padding-right--1_5\">{{ \'EVER_BOUGHT\' | translationWithPrefix }}</p><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.everBought.valueFP color=purchaseFunnelL8.view.data.everBought.typeFP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.everBought.valueSP color=purchaseFunnelL8.view.data.everBought.typeSP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div></div><!--CONSIDERATION--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-center\"><p class=\"label-row text-right padding-right--1_5\">{{ \'CONSIDERATION\' | translationWithPrefix }}</p><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.consideration.valueFP color=purchaseFunnelL8.view.data.consideration.typeFP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.consideration.valueSP color=purchaseFunnelL8.view.data.consideration.typeSP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div></div><!--AWARENESS--><div class=\"row-widget display__flex flex-align-item-end flex-justify-content-center\"><p class=\"label-row text-right padding-right--1_5\">{{ \'AWARENESS\' | translationWithPrefix }}</p><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.awareness.valueFP color=purchaseFunnelL8.view.data.awareness.typeFP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div><div class=\"bar-extremes padding-left--0_5 padding-right--0_5\"><odec-d3-bar-extremes is-pyramid=true value=purchaseFunnelL8.view.data.awareness.valueSP color=purchaseFunnelL8.view.data.awareness.typeSP max=purchaseFunnelL8.view.maxValue></odec-d3-bar-extremes></div></div><!--TOTAL SAMPLE--><div class=\"row-widget total-sample display__flex flex-align-item-end\"><p class=\"label-total-row text-right padding-right--1_5\">{{ \'TOTAL_SAMPLE\' | translationWithPrefix }}</p><div class=\"bar-extremes display__flex flex-justify-content-center flex-align-item-end padding-left--0_5 padding-right--0_5\" ng-repeat=\"sample in purchaseFunnelL8.view.totalSample track by $index\"><p class=text-center>{{sample}}</p></div></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/general/layout1/brandEssentialTracking/brandEssentialTracking.html","<div id={{brandEssentialTracking.view.id}} class=padding--1><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"brandEssentialTracking.view.loading && !brandEssentialTracking.view.hasData\" odec-view-data-loader-loading=\"brandEssentialTracking.view.loading && !brandEssentialTracking.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!brandEssentialTracking.view.loading && !brandEssentialTracking.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!brandEssentialTracking.view.loading && brandEssentialTracking.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_ESSENTIALS_TRACKING_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=brandEssentialTracking.copyXls.copyToXlsData copy-to-clipboard-format-fn=brandEssentialTracking.copyXls.copyToXlsFn snapshot-id=brandEssentialTracking.view.id info-text=brandEssentialTracking.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding-left--1 padding-right--1\"><content-widget-brand-essential-tracking class=display__flex content-data=brandEssentialTracking.totalData.ownData max-value=brandEssentialTracking.totalData.allMax type-view=brandEssentialTracking.types.top type-content=brandEssentialTracking.typeContent.top ng-if=\"brandEssentialTracking.totalData.ownData.length > 0\"></content-widget-brand-essential-tracking><content-widget-brand-essential-tracking class=display__flex content-data=brandEssentialTracking.totalData.competitionData max-value=brandEssentialTracking.totalData.allMax type-view=brandEssentialTracking.types.bottom type-content=brandEssentialTracking.typeContent.bottom ng-if=\"brandEssentialTracking.totalData.competitionData.length > 0\"></content-widget-brand-essential-tracking></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/general/layout4/brandEssentialTrackingValues/brandEssentialTrackingValues.html","<div id={{brandEssentialTrackingValues.view.id}} class=padding--1><div class=\"module-content card display__flex flex-direction-column flex-align-item-center flex-justify-content-center\"><odec-view-data-loader ng-if=\"brandEssentialTrackingValues.view.loading && !brandEssentialTrackingValues.view.hasData\" odec-view-data-loader-loading=\"brandEssentialTrackingValues.view.loading && !brandEssentialTrackingValues.view.hasData\"></odec-view-data-loader><odec-no-data-display ng-if=\"!brandEssentialTrackingValues.view.loading && !brandEssentialTrackingValues.view.hasData\"></odec-no-data-display><div class=widget ng-if=\"!brandEssentialTrackingValues.view.loading && brandEssentialTrackingValues.view.hasData\"><odec-widget-header class=\"padding-left--1 padding-right--1\" title-header=\"\'BRAND_ESSENTIALS_TRACKING_TITLE_WIDGET\' | translationWithPrefix\" copy-to-clipboard-data=brandEssentialTrackingValues.copyXls.copyToXlsData copy-to-clipboard-format-fn=brandEssentialTrackingValues.copyXls.copyToXlsFn snapshot-id=brandEssentialTrackingValues.view.id info-text=brandEssentialTrackingValues.infoText></odec-widget-header><div class=\"content-widget display__flex flex-direction-column padding-left--1 padding-right--1\"><content-widget-brand-essential-tracking-values content-data=brandEssentialTrackingValues.brandValuesData.data type-view=brandEssentialTrackingValues.typeView max-value=brandEssentialTrackingValues.brandValuesData.allMax></content-widget-brand-essential-tracking-values></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/crossCountry/layout22/brandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues.html","<div id=content-widget-brand-essential-tracking-values-l22 class=\"display__flex flex-direction-column\"><div class=\"data-section display__flex\"><!-- COLUMNA IZQUIERDA: Headers de image attributes --><div class=\"columns-headers display__flex flex-direction-column\"><div class=\"row-brands padding--0_5\"><p></p></div><div class=\"info display__flex flex-direction-column padding--0_5 text-right\"><div class=\"item-header display__flex flex-align-item-center flex-justify-content-end ng-animate-fade\" ng-repeat=\"imageAttr in contentWidgetBrandEssentialTrackingValuesL22.contentData.data track by imageAttr.id\" ng-style=\"{\'height\':\'calc(100% / \'+contentWidgetBrandEssentialTrackingValuesL22.contentData.data.length+\')\'}\"><p>{{ imageAttr.text }}</p></div></div></div><!-- COLUMNAS DE PAÍSES: Cada país es una columna vertical con barras --><div class=\"brands-collection display__flex\"><div class=\"brand display__flex flex-direction-column\" ng-repeat=\"country in contentWidgetBrandEssentialTrackingValuesL22.contentData.categories track by $index\"><!-- Header del país --><div class=\"row-brands display__flex flex-align-item-center flex-justify-content-center ng-animate-fade padding--1\"><p class=bold--700>{{ country }}</p></div><!-- Valores (barras) para cada image attribute en este país --><div class=\"info display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-start\"><odec-d3-bar ng-repeat=\"imageAttr in contentWidgetBrandEssentialTrackingValuesL22.contentData.data track by imageAttr.id\" index-bar=$index value=imageAttr.values[$parent.$index].value max=contentWidgetBrandEssentialTrackingValuesL22.maxValue color=imageAttr.values[$parent.$index].type mark-value=imageAttr.values[$parent.$index].hasMark ng-style=\"{\'height\':\'calc(100% / \'+contentWidgetBrandEssentialTrackingValuesL22.contentData.data.length+\')\'}\"></odec-d3-bar></div></div></div></div><!-- FILA DE TOTAL SAMPLE --><div class=\"total-sample-row display__flex\" ng-if=contentWidgetBrandEssentialTrackingValuesL22.contentData.samples><div class=\"columns-headers display__flex flex-align-item-center flex-justify-content-end padding--0_5\"><p class=text-right>{{ \'TOTAL_SAMPLE_HEARD_OF\' | translationWithPrefix }}</p></div><div class=\"brands-collection display__flex\"><div class=\"brand display__flex flex-align-item-center flex-justify-content-center padding--0_5\" ng-repeat=\"sample in contentWidgetBrandEssentialTrackingValuesL22.contentData.samples track by $index\"><p class=bold--700>{{ sample !== null ? sample : \'-\' }}</p></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/general/layout1/brandEssentialTracking/contentWidgetBrandEssentialTracking/contentWidgetBrandEssentialTracking.html","<div id=content-widget-brand-essential-tracking class=display__flex><div class=\"columns-headers display__flex flex-direction-column\"><div class=\"row-brands padding-right--0_5 display__flex flex-align-item-end flex-justify-content-end\"><p class=\"bold--700 text-right\" ng-if=\"contentWidgetBrandEssentialTracking.typeContent === \'own\'\">{{ \'PUIG\' | translationWithPrefix }}</p><p class=\"bold--700 text-right\" ng-if=\"contentWidgetBrandEssentialTracking.typeContent === \'competitors\'\">{{ \'COMPETITORS\' | translationWithPrefix }}</p><p class=\"bold--700 text-right fem-title\" ng-if=\"contentWidgetBrandEssentialTracking.typeContent === \'feminine\'\">{{ \'FEMININE\' | translationWithPrefix | uppercase}}</p><i class=\"icon-size-lg icon-layout-2 bold--700\" ng-if=\"contentWidgetBrandEssentialTracking.typeContent === \'feminine\'\"></i><p class=\"bold--700 text-right masc-title\" ng-if=\"contentWidgetBrandEssentialTracking.typeContent === \'masculine\'\">{{ \'MASCULINE\' | translationWithPrefix | uppercase}}</p><i class=\"icon-size-lg icon-layout-3 bold--700\" ng-if=\"contentWidgetBrandEssentialTracking.typeContent === \'masculine\'\"></i></div><div class=\"item-header-group display__flex flex-align-item-end flex-justify-content-end bold--700 text-right padding-right--0_5\"><p>{{ \'PURCHASE_FUNNEL_LABEL\' | translationWithPrefix }}</p></div><div class=\"top-info display__flex flex-direction-column padding--0_5 text-right\"><div class=\"item-header display__flex flex-align-item-end flex-justify-content-end\"><p>{{ \'BOUGHT_LAST_YEAR\' | translationWithPrefix }}</p></div><div class=\"item-header display__flex flex-align-item-end flex-justify-content-end\"><p>{{ \'CONSIDERATION\' | translationWithPrefix }}</p></div><div class=\"item-header display__flex flex-align-item-end flex-justify-content-end\"><p>{{ \'AWARENESS\' | translationWithPrefix }}</p></div></div><div class=\"item-header-group display__flex flex-align-item-end flex-justify-content-end bold--700 text-right padding-right--0_5\"><p>{{ \'EMOTIONAL_CONNECTION\' | translationWithPrefix }}</p></div><div class=\"bottom-info display__flex flex-direction-column padding--0_5 text-right\"><div class=\"item-header display__flex flex-align-item-end flex-justify-content-end\"><p>{{ \'ADVOCACY_RECOMMEND\' | translationWithPrefix }}</p></div><div class=\"item-header display__flex flex-align-item-end flex-justify-content-end\"><p>{{ \'DESIRABILITY\' | translationWithPrefix }}</p></div><div class=\"item-header display__flex flex-align-item-end flex-justify-content-end\"><p>{{ \'PREMIUM_LUXURY\' | translationWithPrefix }}</p></div></div></div><div class=\"brands-collection display__flex\"><div class=\"brand display__flex flex-direction-column\" ng-repeat=\"brand in contentWidgetBrandEssentialTracking.contentData\"><div class=\"row-brands display__flex flex-align-item-center flex-justify-content-center padding--1\"><img ng-src=assets/data/statics/images/brands/{{contentWidgetBrandEssentialTracking.typeView}}/{{brand.id}}.{{brand.typeImg}} ng-if=\"brand.typeImg === \'png\'\"><odec-draw-svg image=brand.id url=\"\'assets/data/statics/images/brands/\'\" type-view=contentWidgetBrandEssentialTracking.typeView type-image=brand.typeImg ng-if=\"brand.typeImg === \'svg\'\"></odec-draw-svg></div><div class=\"top-info display__flex flex-direction-column padding--0_5 text-right\"><odec-d3-bar-extremes ng-repeat=\"brandV in brand.purchaseFunnel track by $index\" index-bar=$index is-pyramid=true value=brandV.value color=brandV.type max=contentWidgetBrandEssentialTracking.maxValue></odec-d3-bar-extremes></div><div class=\"item-header-group display__flex flex-align-item-end flex-justify-content-end bold--700 text-right\"></div><div class=\"bottom-info display__flex flex-direction-column padding--0_5 text-right\"><odec-d3-bar-extremes ng-repeat=\"brandV in brand.emotionalConnection track by $index\" index-bar=$index is-pyramid=true value=brandV.value color=brandV.type max=contentWidgetBrandEssentialTracking.maxValue></odec-d3-bar-extremes></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/views/general/layout4/brandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues.html","<div id=content-widget-brand-essential-tracking-values class=display__flex><div class=\"columns-headers display__flex flex-direction-column\"><div class=\"row-brands padding--0_5\"><p></p></div><div class=\"info display__flex flex-direction-column padding--0_5 text-right\"><div class=\"item-header display__flex flex-align-item-center flex-justify-content-end ng-animate-fade\" ng-repeat=\"cat in contentWidgetBrandEssentialTrackingValues.contentData.categories track by $index\" ng-style=\"{\'height\':\'calc(100% / \'+contentWidgetBrandEssentialTrackingValues.contentData.categories.length+\')\'}\"><p>{{ cat }}</p></div></div></div><div class=\"brands-collection display__flex\"><div class=\"brand display__flex flex-direction-column\" ng-repeat=\"brand in contentWidgetBrandEssentialTrackingValues.contentData.data\"><div class=\"row-brands display__flex flex-align-item-center flex-justify-content-center ng-animate-fade padding--1\"><odec-draw-svg image=brand.id url=\"\'assets/data/statics/images/brands/\'\" type-view=contentWidgetBrandEssentialTrackingValues.typeView type-image=brand.typeImg></odec-draw-svg></div><div class=\"info display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-start\"><odec-d3-bar ng-repeat=\"brandV in brand.values track by $index\" index-bar=$index value=brandV.value max=contentWidgetBrandEssentialTrackingValues.maxValue color=brandV.type mark-value=brandV.hasMark ng-style=\"{\'height\':\'calc(100% / \'+brand.values.length+\')\'}\"></odec-d3-bar></div></div></div></div>");}]);
(function() {
    'use strict';

    angular
        .module('app')
        .directive('contentWidgetBrandEssentialTrackingValues', contentWidgetBrandEssentialTrackingValues);

    contentWidgetBrandEssentialTrackingValues.$inject = [];
    function contentWidgetBrandEssentialTrackingValues() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/general/layout4/brandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues.html',
            bindToController: true,
            controller: contentWidgetBrandEssentialTrackingValuesController,
            controllerAs: 'contentWidgetBrandEssentialTrackingValues',
            link: link,
            restrict: 'EA',
            scope: {
                contentData:'<',
                maxValue:'<',
                typeView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function contentWidgetBrandEssentialTrackingValuesController () {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('contentWidgetBrandEssentialTracking', contentWidgetBrandEssentialTracking);

    contentWidgetBrandEssentialTracking.$inject = [];
    function contentWidgetBrandEssentialTracking() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/general/layout1/brandEssentialTracking/contentWidgetBrandEssentialTracking/contentWidgetBrandEssentialTracking.html',
            bindToController: true,
            controller: contentWidgetBrandEssentialTrackingController,
            controllerAs: 'contentWidgetBrandEssentialTracking',
            link: link,
            restrict: 'EA',
            scope: {
                contentData:'<',
                maxValue:'<',
                typeView:'<',
                typeContent:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function contentWidgetBrandEssentialTrackingController () {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('contentWidgetBrandEssentialTrackingValuesL22', contentWidgetBrandEssentialTrackingValuesL22);

    contentWidgetBrandEssentialTrackingValuesL22.$inject = [];
    function contentWidgetBrandEssentialTrackingValuesL22() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/crossCountry/layout22/brandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues/contentWidgetBrandEssentialTrackingValues.html',
            bindToController: true,
            controller: contentWidgetBrandEssentialTrackingValuesControllerL22,
            controllerAs: 'contentWidgetBrandEssentialTrackingValuesL22',
            link: link,
            restrict: 'EA',
            scope: {
                contentData:'<',
                maxValue:'<',
                typeView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function contentWidgetBrandEssentialTrackingValuesControllerL22 () {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('emotionalConnectionL8', emotionalConnectionL8);

    emotionalConnectionL8.$inject = [];
    function emotionalConnectionL8() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout8/emotionalConnection/emotionalConnection.html',
            bindToController: true,
            controller: emotionalConnectionL8Controller,
            controllerAs: 'emotionalConnectionL8',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function emotionalConnectionL8Controller($scope, $filter, filterHelperService) {
        var vm = this;

        vm.view = {
            id:'emotional-connection-l8',
            loading: true,
            hasData: false,
            data:{
                firstPeriod:[],
                secondPeriod:[]
            },
            firstPeriodLabel:null,
            firstPeriodValue:null,
            secondPeriodLabel:null,
            secondPeriodValue:null
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('DESIRABILITY_IB')+'</span>. '+$filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('LOVE_IB')+'</span>. '+$filter('translationWithPrefix')('LOVE_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('UNIQUENESS_IB')+'</span>. '+$filter('translationWithPrefix')('UNIQUENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('ADVOCACY_IB')+'</span>. '+$filter('translationWithPrefix')('ADVOCACY_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('emotionalConnectionL8.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            
            vm.serviceView.getW1()
            .then(function(data){
                vm.view.data.firstPeriod = getDataCircles(data && data[0],data && data[1], data && data[2], 0);
                vm.view.data.secondPeriod = getDataCircles(data && data[0],data && data[1], data && data[2], 1);
                
                vm.view.firstPeriodLabel = _.chain(vm.view.data.firstPeriod).map('period').uniq().toString().value();
                vm.view.firstPeriodValue = _.chain(vm.view.data.firstPeriod).map('base').uniq().toString().value();
                vm.view.secondPeriodLabel = _.chain(vm.view.data.secondPeriod).map('period').uniq().toString().value();
                vm.view.secondPeriodValue = _.chain(vm.view.data.secondPeriod).map('base').uniq().toString().value();
                
                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('emotionalConnectionL8Loaded','emotionalConnectionL8');
            });
        }

        function copyXls(data){
            var columnHeaders = [
                "",
                _.chain(data).result('firstPeriod').map('period').uniqBy().value(),
                "",
                _.chain(data).result('secondPeriod').map('period').uniqBy().value()
            ];
            var rowHeaders = _.chain(data).flatMap().map('id').uniqBy().value();
            
            var columnDataFP = _.chain(data).result('firstPeriod').value();

            var columnDataSP = _.chain(data).result('secondPeriod').value();

            var columns = [columnHeaders];
            _.each(rowHeaders, function(item){
                var newColumn = [];
                newColumn.push(_.chain(columnDataFP).find({'id':item}).result('text').value());
                newColumn.push($filter('round')( _.chain(columnDataFP).find({'id':item}).result('value').value(),0) +'%' );
                newColumn.push($filter('round')(_.chain(columnDataFP).find({ 'id': item }).result('base').value(), 0));
                                
                newColumn.push($filter('round')( _.chain(columnDataSP).find({'id':item}).result('value').value(),0) +'%' );
                newColumn.push($filter('round')(_.chain(columnDataSP).find({ 'id': item }).result('base').value(), 0));
                columns.push(newColumn);
            });           
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }

        function getDataCircles(data, basePrevious, baseCurrent, period){
            return _.chain(data).first().result('values')
            .reduce(function(aggr,item){
                var newData = {
                    id:'',
                    text:'',
                    type:'',
                    value:'',
                    period:'',
                    base:''
                };

                var textCircle = (item && item.parent && item.parent.text).split('*');

                newData.id = item && item.id;
                newData.text = textCircle && textCircle[1];

                newData.type = _.chain(item && item.values).get(period).result('type').value();
                newData.value = _.chain(item && item.values).get(period).result('value').value();
                newData.period = _.chain(item && item.values).get(period).result('text').value();
                
                var market = filterHelperService.getPropertySelected('market');
                if(market === 'T'){
                    if (period === 0) {
                        newData.base = _.chain(basePrevious).result('Data').flatMap().map(function (item) { return _.toNumber(item); }).sum().value();
                    }
                    else {
                        newData.base = _.chain(baseCurrent).result('Data').flatMap().map(function (item) { return _.toNumber(item); }).sum().value();
                    }
                }
                else{
                    if (period === 0) {
                        newData.base = _.chain(basePrevious).result('Data').slice(1).first().first().value();
                    }
                    else {
                        newData.base = _.chain(baseCurrent).result('Data').slice(1).first().first().value();
                    }
                }
                aggr.push(newData);
                return aggr;

            },[]).value();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('purchaseFunnelL8', purchaseFunnelL8);

    purchaseFunnelL8.$inject = [];
    function purchaseFunnelL8() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout8/purchaseFunnel/purchaseFunnel.html',
            bindToController: true,
            controller: purchaseFunnelL8Controller,
            controllerAs: 'purchaseFunnelL8',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function purchaseFunnelL8Controller ($scope, $filter, filterHelperService) {
        var vm = this;

        vm.view = {
            id:'purchase-funnel-l8',
            loading: false,
            hasData: true,
            data:{
                bought:null,
                everBought:null,
                consideration:null,
                awareness:null
            },
            totalSample:[],
            maxValue:null,
            periodsText:[]
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('EVER_BOUGHT_IB')+'</span>. '+$filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('purchaseFunnelL8.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            vm.view.totalSample = [];
            vm.serviceView.getW3()
            .then(function(data){
                var brandSelected = filterHelperService.getPropertySelected('brand');

                vm.view.data.bought = {
                    valueFP: _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').get(0).result('value').value(),
                    typeFP: _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').get(0).result('type').value(),
                    valueSP: _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').get(1).result('value').value(),
                    typeSP: _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').get(1).result('type').value()
                };

                vm.view.data.everBought = {
                    valueFP: _.chain(data  && data[0]).first().result('values').find({'id':'EVER'+brandSelected}).result('values').get(0).result('value').value(),
                    typeFP: _.chain(data  && data[0]).first().result('values').find({'id':'EVER'+brandSelected}).result('values').get(0).result('type').value(),
                    valueSP: _.chain(data  && data[0]).first().result('values').find({'id':'EVER'+brandSelected}).result('values').get(1).result('value').value(),
                    typeSP: _.chain(data  && data[0]).first().result('values').find({'id':'EVER'+brandSelected}).result('values').get(1).result('type').value()
                };

                vm.view.data.consideration = {
                    valueFP: _.chain(data  && data[0]).first().result('values').find({'id':'CONSI'+brandSelected}).result('values').get(0).result('value').value(),
                    typeFP: _.chain(data  && data[0]).first().result('values').find({'id':'CONSI'+brandSelected}).result('values').get(0).result('type').value(),
                    valueSP: _.chain(data  && data[0]).first().result('values').find({'id':'CONSI'+brandSelected}).result('values').get(1).result('value').value(),
                    typeSP: _.chain(data  && data[0]).first().result('values').find({'id':'CONSI'+brandSelected}).result('values').get(1).result('type').value()
                };

                vm.view.data.awareness = {
                    valueFP: _.chain(data  && data[0]).first().result('values').find({'id':'AWA'+brandSelected}).result('values').get(0).result('value').value(),
                    typeFP: _.chain(data  && data[0]).first().result('values').find({'id':'AWA'+brandSelected}).result('values').get(0).result('type').value(),
                    valueSP: _.chain(data  && data[0]).first().result('values').find({'id':'AWA'+brandSelected}).result('values').get(1).result('value').value(),
                    typeSP: _.chain(data  && data[0]).first().result('values').find({'id':'AWA'+brandSelected}).result('values').get(1).result('type').value()
                };

                vm.view.periodsText = _.chain([].concat(
                                        _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').get(0).result('text').value(),
                                        _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').get(1).result('text').value()
                                    )
                ).value();

                var maxFP = _.chain(vm.view.data).map('valueFP').max().value();
                var maxSP = _.chain(vm.view.data).map('valueSP').max().value();
                maxFP = maxFP === '-' ? 0 : maxFP;
                maxSP = maxSP === '-' ? 0 : maxSP;
                vm.view.maxValue = _.max([maxFP, maxSP]);
                var total = _.chain(data && data[1]).find({ 'id': 'TOTAL' }).result('values').value();
                var valuesWithoutTotal = _.chain(data && data[1]).reject({ 'id': 'TOTAL' }).value();
                var valueBrand = _.chain(valuesWithoutTotal).find({ 'id': 'BASEAWA' + brandSelected }).result('values').value();
                _.each(valueBrand,function(item, index){
                    vm.view.totalSample.push(item === 0 ? "-" : total[index]);
                });
                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('purchaseFunnelL8Loaded','purchaseFunnelL8');
            });
        }

        function copyXls(data){
            var columnHeaders = [
                "",
                $filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB'),
                $filter('translationWithPrefix')('EVER_BOUGHT_IB'),
                $filter('translationWithPrefix')('CONSIDERATION_IB'),
                $filter('translationWithPrefix')('AWARENESS_IB'),
                $filter('translationWithPrefix')('TOTAL_SAMPLE')
            ];

            var columnDataFP = [];
            var columnDataSP = [];
            columnDataFP.push(vm.view.periodsText[0]+'');
            columnDataSP.push(vm.view.periodsText[1]+'');
            
            _.each(data, function (item) {
                columnDataFP.push( $filter('round')(item && item.valueFP, 0) + '%');
                columnDataSP.push( $filter('round')(item && item.valueSP, 0) + '%' );
            });

            columnDataFP.push(vm.view.totalSample[0]+'');
            columnDataSP.push(vm.view.totalSample[1]+'');

            var columns = [columnHeaders, columnDataFP, columnDataSP];

            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function (i) {
                return i.join('\t');
            });
            return rows.join('\n');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('brandImageL8', brandImageL8);

    brandImageL8.$inject = [];
    function brandImageL8() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout8/brandImage/brandImage.html',
            bindToController: true,
            controller: brandImageL8Controller,
            controllerAs: 'brandImageL8',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter: '<',
                serviceView: '<'
            }
        };
        return directive;

        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function brandImageL8Controller($scope, $filter) {
        var vm = this;

        vm.view = {
            id: 'brand-image-l8',
            loading: false,
            hasData: true,
            data: [],
            maxValue: 0,
            totalSample: 0,
            periodsText: []
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
            '<div class="item-info">' +
            '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('BRAND_IMAGE_IB') + '</span>. ' + $filter('translationWithPrefix')('BRAND_IMAGE_INFO_TEXT_IB') + '</p>' +
            '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('brandImageL8.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init() {
            vm.view.loading = true;
            vm.view.hasData = false;

            vm.serviceView.getW2()
                .then(function (data) {
                    vm.view.data = _.chain(data[0]).reduce(function (aggr, item) {
                        var newImage = {
                            id: '',
                            text: '',
                            valueFP: '',
                            typeFP: '',
                            valueSP: '',
                            typeSP: '',
                            isBold: false // ⬅️ Correcto
                        };

                        var firstValue = _.chain(item && item.values).first();
                        
                        // 1. OBTENER EL TEXTO ORIGINAL
                        var originalText = firstValue.result('text').value();
                        
                        // ⬅️ CALCULAR isBold
                        newImage.isBold = originalText && originalText.includes('%%'); 

                        newImage.id = firstValue.result('id').value();
                        
                        // 2. LIMPIAR EL TEXTO
                        newImage.text = originalText ? originalText.replace('%%', '') : ''; 
                        
                        newImage.valueFP = firstValue.result('values').get(0).result('value').value();
                        newImage.typeFP = firstValue.result('values').get(0).result('type').value();
                        newImage.valueSP = firstValue.result('values').get(1).result('value').value();
                        newImage.typeSP = firstValue.result('values').get(1).result('type').value();

                        aggr.push(newImage);
                        return aggr;
                    }, []).value();

                    var maxFP = _.chain(vm.view.data).map('valueFP').max().value();
                    var maxSP = _.chain(vm.view.data).map('valueSP').max().value();
                    maxFP = maxFP === '-' ? 0 : maxFP;
                    maxSP = maxSP === '-' ? 0 : maxSP;

                    vm.view.maxValue = _.max([maxFP, maxSP]);
                    vm.view.totalSample = _.chain(data && data[1]).result('Data').first().value();
                    vm.view.periodsText = _.chain([].concat(
                        _.chain(data && data[0]).first().result('values').first().result('values').get(0).result('text').value(),
                        _.chain(data && data[0]).first().result('values').first().result('values').get(1).result('text').value()
                    )
                    ).value();
                    vm.view.hasData = true;
                })
                .catch(function () {
                    vm.view.hasData = false;
                })
                .finally(function () {
                    vm.view.loading = false;
                    $scope.$emit('brandImageL8Loaded', 'brandImageL8');
                });
        }

        function copyXls(data) {
            var columnHeaders = [].concat("", _.chain(data).map('text').value(), $filter('translationWithPrefix')('TOTAL_SAMPLE_HEARD_OF'));
            
            var columnDataFP = [];
            var columnDataSP = [];
            columnDataFP.push(vm.view.periodsText[0]);
            columnDataSP.push(vm.view.periodsText[1]);
            
            _.each(data, function (item) {
                columnDataFP.push( $filter('round')(item && item.valueFP, 0) + '%');
                columnDataSP.push( $filter('round')(item && item.valueSP, 0) + '%' );
            });

            columnDataFP.push(vm.view.totalSample[0]+'');
            columnDataSP.push(vm.view.totalSample[1]+'');

            var columns = [columnHeaders, columnDataFP, columnDataSP];

            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function (i) {
                return i.join('\t');
            });
            return rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('purchaseFunnelL7', purchaseFunnelL7);

    purchaseFunnelL7.$inject = [];
    function purchaseFunnelL7() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout7/purchaseFunnel/purchaseFunnel.html',
            bindToController: true,
            controller: purchaseFunnelL7Controller,
            controllerAs: 'purchaseFunnelL7',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function purchaseFunnelL7Controller (filterHelperService, $scope, $filter) {
        var vm = this;

        vm.view = {
            id:'purchase-funnel-l7',
            loading: false,
            hasData: true,
            data:[],
            totalSample:[],
            maxValue:null
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('EVER_BOUGHT_IB')+'</span>. '+$filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('purchaseFunnelL7.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            vm.view.data = [];
            vm.view.totalSample = [];
            vm.serviceView.getW1()
            .then(function(data){
                var brandSelected = filterHelperService.getPropertySelected('brand');
                var allValues = [];
                _.each(data[0], function(item, index){
                    var newGroup = {
                        text:item && item.group,
                        bought:{
                            value: _.chain(item).result('values').find({'id':'BOUGHT'+brandSelected[index]}).result('values').first().result('value').value(),
                            type: _.chain(item).result('values').find({'id':'BOUGHT'+brandSelected[index]}).result('values').first().result('type').value()
                        },
                        everBought:{
                            value: _.chain(item).result('values').find({'id':'EVER'+brandSelected[index]}).result('values').first().result('value').value(),
                            type: _.chain(item).result('values').find({'id':'EVER'+brandSelected[index]}).result('values').first().result('type').value()
                        },
                        consideration:{
                            value: _.chain(item).result('values').find({'id':'CONSI'+brandSelected[index]}).result('values').first().result('value').value(),
                            type: _.chain(item).result('values').find({'id':'CONSI'+brandSelected[index]}).result('values').first().result('type').value()
                        },
                        awareness:{
                            value: _.chain(item).result('values').find({'id':'AWA'+brandSelected[index]}).result('values').first().result('value').value(),
                            type: _.chain(item).result('values').find({'id':'AWA'+brandSelected[index]}).result('values').first().result('type').value()
                        }
                    };
                    allValues = allValues.concat(_.chain(newGroup).map('value').compact().value());
                    vm.view.data.push(newGroup);
                    
                    var total = _.chain(data && data[1]).find({ 'id': 'TOTAL' }).result('values').first().value();
                    var valuesWithoutTotal = _.chain(data && data[1]).reject({ 'id': 'TOTAL' }).value();
                    var valueBrand = _.chain(valuesWithoutTotal).find({ 'id': 'BASEAWA'+brandSelected[index]}).result('values').first().value();
                    vm.view.totalSample.push(valueBrand === 0 ? "-" : total);
                });
                vm.view.maxValue = _.chain(allValues).max().value();
                
                
                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('purchaseFunnelL7Loaded','purchaseFunnelL7');
            });
        }

        function copyXls(data){
            var columnHeaders = [
                "",
                $filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB'),
                $filter('translationWithPrefix')('EVER_BOUGHT_IB'),
                $filter('translationWithPrefix')('CONSIDERATION_IB'),
                $filter('translationWithPrefix')('AWARENESS_IB'),
                $filter('translationWithPrefix')('TOTAL_SAMPLE')
            ];

            var columnData = _.chain(data).map(function(item, index){
                var values = _.chain(item).map('value').compact().map(function(item){
                    return $filter('round')(item,0)+'%';
                }).value();
                values = [].concat(item && item.text, values, vm.view.totalSample[index]);
                return values;
            }).value();


            var columns = [];
            columns.push(columnHeaders);

            _.each(columnData, function(item){
                columns.push(item);
            });
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('emotionalConnectionL7', emotionalConnectionL7);

    emotionalConnectionL7.$inject = [];
    function emotionalConnectionL7() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout7/emotionalConnection/emotionalConnection.html',
            bindToController: true,
            controller: emotionalConnectionL7Controller,
            controllerAs: 'emotionalConnectionL7',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function emotionalConnectionL7Controller ($scope,  $filter, filterHelperService) {
        var vm = this;

        vm.view = {
            id:'emotional-connection-l7',
            loading: true,
            hasData: false,
            data:[],
            leftHeaders:[],
            metricIds:[]
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('DESIRABILITY_IB')+'</span>. '+$filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('LOVE_IB')+'</span>. '+$filter('translationWithPrefix')('LOVE_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('UNIQUENESS_IB')+'</span>. '+$filter('translationWithPrefix')('UNIQUENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('ADVOCACY_IB')+'</span>. '+$filter('translationWithPrefix')('ADVOCACY_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('emotionalConnectionL7.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            vm.view.data = [];

            vm.serviceView.getW2()
            .then(function(data){
                var brandSelected = filterHelperService.getPropertySelected('brand');
                var market = filterHelperService.getPropertySelected('market');
                var allValues = [];
                var basesValues;
                
                if(market === 'T'){
                    var valsFeminines = _.chain(data && data[1]).result('Data').take(brandSelected.length).map(function(item){ return _.toNumber(item); }).value();
                    var valsMasculines = _.chain(data && data[1]).result('Data').takeRight(brandSelected.length).map(function(item){ return _.toNumber(item); }).value();
                    var definitiveValues = _.zip(valsFeminines, valsMasculines);
                    basesValues = _.chain(definitiveValues).map(function (item) { return [_.chain(item).sum().value()]; }).value();
                }
                else{
                    basesValues = _.chain(data && data[1]).result('Data').slice(1).value();
                }
                

                var metricIds = [];
                var currentMetricHeaders = [];

                _.each(data && data[0], function(item, index){
                    var brandSelected = filterHelperService.getPropertySelected('brand');
                    
                    var newGroup = {
                        text: item && item.group,
                        base: _.chain(basesValues[index]).first().value(),
                        metrics: {} // Objeto para contener SÓLO las métricas devueltas
                    };

                    // 1. Iterar sobre las métricas que SÍ están presentes en la respuesta (item.values)
                    _.each(item && item.values, function(metric) {
                        // Extraer ID (ej: ADVOT -> ADVO) y Nombre (ej: ADVOT*ADVOCACY -> ADVOCACY)
                        var metricId = metric.parent.id.substring(0, 4); 
                        var metricName = metric.parent.text.split('*').pop();
                        
                        // Almacenar los datos de la métrica de forma dinámica
                        newGroup.metrics[metricId] = {
                            value: _.chain(metric).result('values').first().result('value').value(),
                            type: _.chain(metric).result('values').first().result('type').value()
                        };

                        // Almacenar el ID y Nombre de la métrica para construir los headers dinámicamente
                        if (!_.find(currentMetricHeaders, {id: metricId})) {
                            currentMetricHeaders.push({id: metricId, name: metricName});
                        }
                    });

                    // 2. Recolectar valores para el cálculo del valor máximo
                    var currentValues = _.chain(newGroup.metrics).map('value').compact().value();
                    allValues = allValues.concat(currentValues);

                    vm.view.data.push(newGroup);
                });

                // 3. Establecer las listas finales de headers e IDs de métricas
                vm.view.metricIds = _.chain(currentMetricHeaders).map('id').uniq().value(); // [ 'ADVO' ]
                vm.view.leftHeaders = _.chain(currentMetricHeaders).map('name').uniq().value(); // [ 'ADVOCACY' ]
                vm.view.maxValue = _.chain(allValues).max().value();
                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('emotionalConnectionL7Loaded','emotionalConnectionL7');
            });
        }

        function copyXls(data){
            var columnHeaders = [].concat("", vm.view.leftHeaders);
            var columnData = _.chain(data).map(function(item){
                // Recorre los IDs de métricas en el orden correcto
                var values = _.chain(vm.view.metricIds) 
                    .map(function(metricId) {
                        // Accede al valor de forma dinámica (ej. item.metrics.ADVO.value)
                        var metric = _.get(item.metrics, metricId); 
                        var val = metric ? metric.value : null;

                        // Formatea el valor si existe, si no, devuelve cadena vacía
                        return val !== null ? $filter('round')(val,0)+'%': '';
                    }).value();

                values = [].concat(item && item.text, values, item.base);
                return values;
            }).value();
            var columns = [];
            columns.push(columnHeaders);

            _.each(columnData, function(item){
                columns.push(item);
            });

            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('brandImageL7', brandImageL7);

    brandImageL7.$inject = [];
    function brandImageL7() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout7/brandImage/brandImage.html',
            bindToController: true,
            controller: brandImageL7Controller,
            controllerAs: 'brandImageL7',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter: '<',
                serviceView: '<'
            }
        };
        return directive;

        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function brandImageL7Controller($scope, $filter) {
        var vm = this;

        vm.view = {
            id: 'brand-image-l7',
            loading: true,
            hasData: false,
            data: [],
            leftHeaders: [],
            sample:null
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
            '<div class="item-info">' +
            '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('BRAND_IMAGE_IB') + '</span>. ' + $filter('translationWithPrefix')('BRAND_IMAGE_INFO_TEXT_IB') + '</p>' +
            '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('brandImageL7.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init() {
            vm.view.loading = true;
            vm.view.hasData = false;
            vm.view.data = [];
            vm.view.leftHeaders = [];

            vm.serviceView.getW3()
                .then(function (data) {                  
                    vm.view.data = _.map(data && data[0], function (itemBrand) {
                        var newGroup = {
                            text:null,
                            data:[]
                        };

                        newGroup.text = _.chain(itemBrand).result('text').split('*').get(1).trim().value();
                        newGroup.data = _.chain(itemBrand && itemBrand.values).map(function(item){
                            var newValues = {
                                value:null,
                                type:null
                            };

                            newValues.value = _.chain(item).result('values').first().result('value').value();
                            newValues.type = _.chain(item).result('values').first().result('type').value();
                            vm.view.leftHeaders.push(item && item.text && item.text.replace('%%', '') && item.text.replace('%%', '').trim());
                            return newValues;
                        }).value();

                        return newGroup;
                    });

                    vm.view.sample = _.chain(data && data[1]).result('Data').map(function(item){
                        return item && item.toString();
                    }).value();
                    vm.view.leftHeaders = _.chain(vm.view.leftHeaders).uniq().value();
                    vm.view.hasData = true;
                })
                .catch(function () {
                    vm.view.hasData = false;
                })
                .finally(function () {
                    vm.view.loading = false;
                    $scope.$emit('brandImageL7Loaded', 'brandImageL7');
                });
        }

        function copyXls(data) {
            var columnHeaders = [].concat("", vm.view.leftHeaders, $filter('translationWithPrefix')('TOTAL_SAMPLE_HEARD_OF'));
            var columnData = _.chain(data).map(function (item, index) {
                var values = _.chain(item).result('data').map('value').compact().map(function (item) {
                    return $filter('round')(item, 0) + '%';
                }).value();
                values = [].concat(item && item.text, values, vm.view.sample[index]);
                return values;
            }).value();

            columnData.push(vm.view.totalSample);
            var columns = [];
            columns.push(columnHeaders);

            _.each(columnData, function (item) {
                columns.push(item);
            });

            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function (i) {
                return i.join('\t');
            });
            return rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('purchaseFunnelL6', purchaseFunnelL6);

    purchaseFunnelL6.$inject = [];
    function purchaseFunnelL6() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout6/purchaseFunnel/purchaseFunnel.html',
            bindToController: true,
            controller: purchaseFunnelL6Controller,
            controllerAs: 'purchaseFunnelL6',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function purchaseFunnelL6Controller ($scope, $filter, filterHelperService) {
        var vm = this;

        vm.view = {
            id:'purchase-funnel-l6',
            loading: false,
            hasData: true,
            data:{
                bought:null,
                everBought:null,
                consideration:null,
                awareness:null
            },
            totalSample:null,
            maxValue:null
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('EVER_BOUGHT_IB')+'</span>. '+$filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('purchaseFunnelL6.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            
            vm.serviceView.getW3()
            .then(function(data){
                var brandSelected = filterHelperService.getPropertySelected('brand');
                vm.view.data.bought = {
                    value: _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').first().result('value').value(),
                    type: _.chain(data  && data[0]).first().result('values').find({'id':'BOUGHT'+brandSelected}).result('values').first().result('type').value()
                };

                vm.view.data.everBought = {
                    value: _.chain(data  && data[0]).first().result('values').find({'id':'EVER'+brandSelected}).result('values').first().result('value').value(),
                    type: _.chain(data  && data[0]).first().result('values').find({'id':'EVER'+brandSelected}).result('values').first().result('type').value()
                };

                vm.view.data.consideration = {
                    value: _.chain(data  && data[0]).first().result('values').find({'id':'CONSI'+brandSelected}).result('values').first().result('value').value(),
                    type: _.chain(data  && data[0]).first().result('values').find({'id':'CONSI'+brandSelected}).result('values').first().result('type').value()
                };

                vm.view.data.awareness = {
                    value: _.chain(data  && data[0]).first().result('values').find({'id':'AWA'+brandSelected}).result('values').first().result('value').value(),
                    type: _.chain(data  && data[0]).first().result('values').find({'id':'AWA'+brandSelected}).result('values').first().result('type').value()
                };

                vm.view.maxValue = _.chain(vm.view.data).map('value').max().value();
                
                var sampleBottom0 = _.chain(data && data[1]).result('Data').get(0).first().value() && parseInt(_.chain(data && data[1]).result('Data').get(0).first().value());
                var sampleBottom1 = _.chain(data && data[1]).result('Data').get(1).first().value() && parseInt(_.chain(data && data[1]).result('Data').get(1).first().value());
                //Si sampleBottom1 === 0, se muestra un "-"
                //Sino se muestra el valor de sampleBottom0
                vm.view.totalSample = sampleBottom1 === 0 ? "-" : sampleBottom0;

                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('purchaseFunnelL6Loaded','purchaseFunnelL6');
            });
        }

        function copyXls(data){
            var columnHeaders = [
                $filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB'),
                $filter('translationWithPrefix')('EVER_BOUGHT_IB'),
                $filter('translationWithPrefix')('CONSIDERATION_IB'),
                $filter('translationWithPrefix')('AWARENESS_IB'),
                $filter('translationWithPrefix')('TOTAL_SAMPLE')
            ];
            var columnData = _.chain(data).map('value').map(function(item){
                return $filter('round')(item,0) + '%';
            }).value();
            columnData.push(vm.view.totalSample);
            var columns = [columnHeaders, columnData];
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('emotionalConnectionL6', emotionalConnectionL6);

    emotionalConnectionL6.$inject = [];
    function emotionalConnectionL6() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout6/emotionalConnection/emotionalConnection.html',
            bindToController: true,
            controller: emotionalConnectionL6Controller,
            controllerAs: 'emotionalConnectionL6',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function emotionalConnectionL6Controller($scope, $filter, filterHelperService) {
        var vm = this;

        vm.view = {
            id:'emotional-connection-l6',
            loading: true,
            hasData: false,
            data:[],
            base:null
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('DESIRABILITY_IB')+'</span>. '+$filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('LOVE_IB')+'</span>. '+$filter('translationWithPrefix')('LOVE_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('UNIQUENESS_IB')+'</span>. '+$filter('translationWithPrefix')('UNIQUENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('ADVOCACY_IB')+'</span>. '+$filter('translationWithPrefix')('ADVOCACY_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('emotionalConnectionL6.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            
            vm.serviceView.getW1()
            .then(function(data){
                var market = filterHelperService.getPropertySelected('market');
                var basesValues = null;
                if(market === 'T'){
                    vm.view.base = _.chain(data && data[1]).result('Data').flatMap().map(function (item) { return _.toNumber(item); }).sum().value();
                }
                else{
                    basesValues = _.chain(data && data[1]).result('Data').slice(1).value();
                    vm.view.base = _.chain(basesValues[0]).first().value();
                }
                vm.view.data = _.chain(data && data[0]).first().result('values')
                    .reduce(function (aggr, item) {
                        var newData = {
                            id: '',
                            text: '',
                            type: '',
                            value: ''
                        };

                        var textCircle = (item && item.parent && item.parent.text).split('*');

                        newData.id = item && item.id;
                        newData.text = textCircle && textCircle[1];
                        newData.type = _.chain(item && item.values).first().result('type').value();
                        newData.value = _.chain(item && item.values).first().result('value').value();
                        //TODO - Hacer una consulta nueva para obtenerla.

                        aggr.push(newData);
                        return aggr;

                    }, []).value();
                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('emotionalConnectionL6Loaded','emotionalConnectionL6');
            });
        }

        function copyXls(data){
            var columnHeaders = _.chain(data).map('text').value();
            var bases = _.chain(data).map('base').value();
            var columnData = _.chain(data).map('value').map(function(item){
                return $filter('round')(item,0) + '%';
            }).value();
            var columns = [columnHeaders, columnData, bases];
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('brandImageL6', brandImageL6);

    brandImageL6.$inject = [];
    function brandImageL6() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout6/brandImage/brandImage.html',
            bindToController: true,
            controller: brandImageL6Controller,
            controllerAs: 'brandImageL6',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function brandImageL6Controller ($scope, $filter) {
        var vm = this;

        vm.view = {
            id:'brand-image-l6',
            loading: false,
            hasData: true,
            data:[],
            maxValue:0,
            totalSample:0
        };

        vm.copyXls = copyXls;

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BRAND_IMAGE_IB')+'</span>. '+$filter('translationWithPrefix')('BRAND_IMAGE_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('brandImageL6.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            
            vm.serviceView.getW2()
            .then(function(data){
                vm.view.data = _.chain(data[0]).reduce(function(aggr, item){
                    var newImage = {
                        id:'',
                        text:'',
                        value:'',
                        type:'',
                        isBold: false // ⬅️ NUEVA PROPIEDAD
                    };

                    var firstValue = _.chain(item && item.values).first();
                    
                    // 1. OBTENER EL TEXTO ORIGINAL
                    var originalText = firstValue.result('text').value();

                    // ⬅️ CAMBIO 1: DETERMINAR SI DEBE IR EN NEGRITA
                    newImage.isBold = originalText && originalText.includes('%%'); 

                    newImage.id = firstValue.result('id').value();
                    
                    // 2. LIMPIAR EL TEXTO SOLO PARA VISUALIZACIÓN
                    newImage.text = originalText ? originalText.replace('%%','') : '';
                    
                    newImage.value = firstValue.result('values').first().result('value').value();
                    newImage.type = firstValue.result('values').first().result('type').value();

                    aggr.push(newImage);
                    return aggr;
                },[]).value();
                vm.view.maxValue = _.chain(vm.view.data).map('value').max().value();
                vm.view.totalSample = data[1];
                vm.view.hasData = true;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('brandImageL6Loaded','brandImageL6');
            });
        }

        function copyXls(data){
            var columnHeaders = _.chain(data).map('text').value();
            var columnData = _.chain(data).map('value').map(function(item){
                return $filter('round')(item,0) + '%';
            }).value();
            var columns = [columnHeaders, columnData];
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('brandEssentialTrackingValues', brandEssentialTrackingValues);

    brandEssentialTrackingValues.$inject = [];
    function brandEssentialTrackingValues() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/general/layout4/brandEssentialTrackingValues/brandEssentialTrackingValues.html',
            bindToController: true,
            controller: brandEssentialTrackingValuesController,
            controllerAs: 'brandEssentialTrackingValues',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                typeView:'<',
                serviceView:'<',
                typeContent:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function brandEssentialTrackingValuesController ($scope, $timeout, layout4Service, $rootScope, $filter) {
        var vm  = this;

        vm.view = {
            id:'brand-essentials-tracking-values',
            loading: false,
            hasData: false
        };

        vm.brandValuesData = {
            allMax:0,
            data:[]
        };

        vm.copyXls = {
            copyToXlsFn:copyToXlsFn,
            copyToXlsData:[]
        };

        vm.typeView = 'T';

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BRAND_VALUES_IB')+'</span>. '+$filter('translationWithPrefix')('BRAND_VALUES_INFO_TEXT_IB')+'</p>'+
        '</div>'
        ;

        //Watchers
        var filterWatcher = $scope.$watch('brandEssentialTrackingValues.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            $rootScope.$emit('printReport', false);
            vm.view.loading = true;
            vm.view.hasData = false;
            $timeout(function(){
                getTracking()
                .then(function (data) {
                    vm.brandValuesData.data = data;
                    vm.copyXls.copyToXlsData = data;
                    vm.brandValuesData.allMax = _.chain(data && data.data).flatMap('values').map('value').max().value();
                    vm.view.hasData = true;
                })
                .catch(function (_err) {
                    vm.view.hasData = false;
                })
                .finally(function () {
                    vm.view.loading = false;
                    $rootScope.$emit('printReport', true);
                });
            }, 1000);
        }

        function getTracking() {
            return layout4Service.getW1();
        }

        function copyToXlsFn(data) {
            var ownData = copyBlock(data);
            return ownData;
        }

        function copyBlock(data){
            var columnHeaders = columnHeaders = _.concat([], '', data.categories);
            
            var columns = [columnHeaders];
            _.each(data && data.data, function(item){
                var text = item && item.text && item.text.split('*');
                var brand = text && text[1];
                var column = _.concat([], brand, _.chain(item && item.values).map(function (item) { return $filter('round')(item.value, 0) + '%';}).value());
                columns.push(column);
            }); 
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('brandEssentialTracking', brandEssentialTracking);

    brandEssentialTracking.$inject = [];
    function brandEssentialTracking() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/general/layout1/brandEssentialTracking/brandEssentialTracking.html',
            bindToController: true,
            controller: brandEssentialTrackingController,
            controllerAs: 'brandEssentialTracking',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                typeView:'<',
                serviceView:'<',
                typeContent:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function brandEssentialTrackingController ($q, $timeout, $scope, $rootScope, $filter) {
        var vm  = this;
        vm.view = {
            id:'brand-essentials-tracking',
            loading: false,
            hasData: false
        };

        vm.totalData = {
            allMax:0,
            ownData:[],
            competitionData:[]
        };

        vm.types = {
            top: vm.typeView ==='MF' ? 'M' : vm.typeView,
            bottom: vm.typeView ==='MF' ? 'F' : vm.typeView
        };

        vm.copyXls = {
            copyToXlsFn:copyToXlsFn,
            copyToXlsData:[]
        };

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('ADVOCACY_RECOMMEND_IB')+'</span>. '+$filter('translationWithPrefix')('ADVOCACY_RECOMMEND_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('DESIRABILITY_IB')+'</span>. '+$filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('PREMIUM_LUXURY_BRAND_IB')+'</span>. '+$filter('translationWithPrefix')('PREMIUM_LUXURY_BRAND_INFO_TEXT_IB')+'</p>'+
        '</div>'
        ;

        //Watchers
        var filterWatcher = $scope.$watch('brandEssentialTracking.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        //init();

        function init(){
            $rootScope.$emit('printReport', false);
            vm.view.loading = true;
            vm.view.hasData = false;
            $timeout(function(){
                getTotals()
                .then(function (data) {
                    vm.totalData.ownData = data && data[0];
                    vm.totalData.competitionData = data && data[1];
                    vm.copyXls.copyToXlsData = vm.totalData;
                    var maxOwnBrands = _.chain(vm.totalData.ownData).flatMap('values').flatMap('values').map('value').max().value();
                    var maxCompetitionBrands = _.chain(vm.totalData.competitionData).flatMap('values').flatMap('values').map('value').max().value();
                    vm.totalData.allMax = getAllMax(maxOwnBrands, maxCompetitionBrands);
                    vm.view.hasData = true;
                    if(vm.totalData.ownData.length <= 0 && vm.totalData.competitionData.length <= 0){
                        vm.view.hasData = false;
                    }
                })
                .catch(function (_err) {
                    vm.view.hasData = false;
                })
                .finally(function () {
                    vm.view.loading = false;
                    $rootScope.$emit('printReport', true);
                });
            }, 1000);
        }

        function getTotals() {
            return $q.all([vm.serviceView.getW1(), vm.serviceView.getW2()]);
        }

        function getAllMax(ownMax, competitionMax){
            return _.max([ownMax,competitionMax]);
        }

        function copyToXlsFn(data) {
            var ownData, compData;
            if(vm.typeView === 'MF'){
                //View Masculine and femenine
                ownData = copyBlock('MASCULINE', data && data.ownData);
                compData = '\n\n\n'+copyBlock('FEMININE', data && data.competitionData);
            }
            else{
                //PUIG vs COMPETITORS
                ownData = copyBlock('PUIG', data && data.ownData);
                compData = '\n\n\n'+copyBlock('COMPETITORS', data && data.competitionData);
            }
            return ownData+compData;
            
        }

        function copyBlock(group, data){
            var columnHeaders = [
                $filter('translationWithPrefix')(group),
                '',
                $filter('translationWithPrefix')('PURCHASE_FUNNEL_LABEL'),
                $filter('translationWithPrefix')('BOUGHT_LAST_YEAR'),
                $filter('translationWithPrefix')('CONSIDERATION'),
                $filter('translationWithPrefix')('AWARENESS'),
                '',
                $filter('translationWithPrefix')('EMOTIONAL_CONNECTION'),
                $filter('translationWithPrefix')('ADVOCACY_RECOMMEND'),
                $filter('translationWithPrefix')('DESIRABILITY'),
                $filter('translationWithPrefix')('PREMIUM_LUXURY')
            ];
            
            var columns = [columnHeaders];
            _.each(data, function(item){
                var column = [];
                column.push(item && item.group);
                column.push('');
                column.push('');
                _.each(item && item.purchaseFunnel, function(cat){
                    column.push($filter('round')(cat && cat.value,0)+'%');
                });
                column.push('');
                column.push('');
                _.each(item && item.emotionalConnection, function(cat){
                    column.push($filter('round')(cat && cat.value,0)+'%');
                });
                columns.push(column);
            }); 
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }

    
})();
(function () {
    "use strict";

    angular.module("app").directive("tableLayout23", tableLayout23);

    tableLayout23.$inject = [];
    function tableLayout23() {
        var directive = {
            templateUrl:
                "app/components/odecWidgetCollection/views/crossCountry/layout23/tableLayout23/tableLayout23.html",
            bindToController: true,
            controller: tableLayout23Controller,
            controllerAs: "tableLayout23",
            link: link,
            restrict: "EA",
            scope: {
                events: "<",
                brandName: "<",
                rowHeaders: "<",
                columnHeaders: "<",
                tableData: "<",
                legendData: "<",
                web: "<"
            }
        };
        return directive;

        function link(_scope, _element, _attrs) {}
    }

    /* @ngInject */
    function tableLayout23Controller(configurationLoaderService, $uibModal) {
        var vm = this;

        var backgroundColors = _.chain(configurationLoaderService.getConfig())
            .result("colors")
            .find({ type: "backgroundTable" })
            .result("color")
            .value();
        var colors = _.chain(configurationLoaderService.getConfig())
            .result("colors")
            .find({ type: "colorsTable" })
            .result("color")
            .value();

        vm.legend = {
            c1: _.chain(colors).find({ id: "U" }).result("value").value(),
            c2: _.chain(colors).find({ id: "D" }).result("value").value(),
            bg1: _.chain(backgroundColors).find({ id: "U" }).result("value").value(),
            bg2: _.chain(backgroundColors).find({ id: "D" }).result("value").value()
        };

        vm.table = {
            brandName: '',
            columnHeaders: [],
            rowHeaders: [],  // Países
            data: [],
            maxRows: 10,
            maxRowPrinting: 15,
            typeLegend: null,
            typeMedia: null,
            normas: []  // Array de normas por país
        };

        vm.getSize = getSize;
        vm.notLastMedia = notLastMedia;
        vm.getNormaValue = getNormaValue;
        vm.openLegendModal = openLegendModal;

        // Usar $onChanges para detectar cuando los datos cambian
        vm.$onChanges = function(changes) {
            if (changes.legendData || changes.columnHeaders || changes.tableData || changes.rowHeaders) {
                init();
                addHasCellColor();
            }
        };

        vm.$onInit = function() {
            init();
            addHasCellColor();
        };

        function init() {
            vm.table.brandName = vm.brandName || '';
            vm.table.columnHeaders = vm.columnHeaders || [];
            vm.table.typeLegend = vm.legendData && vm.legendData.typeLegend;
            vm.table.typeMedia = vm.legendData && vm.legendData.typeMedia;
            vm.table.periodYear = vm.legendData && vm.legendData.periodYear;
            vm.table.normas = vm.legendData && vm.legendData.normas || [];
            vm.table.rowHeaders = vm.web
                ? vm.rowHeaders
                : _.chain(vm.rowHeaders).take(vm.table.maxRowPrinting).value();
            vm.table.data = vm.web
                ? vm.tableData
                : _.chain(vm.tableData).take(vm.table.maxRowPrinting).value();
            vm.table.maxRows = vm.web ? vm.table.maxRows : vm.table.maxRowPrinting;
        }

        // Función para abrir el modal con todas las leyendas
        function openLegendModal() {
            $uibModal.open({
                templateUrl: 'legendModalLayout23.html',
                controller: function ($uibModalInstance, tableLayout23) {
                    var modalVm = this;
                    modalVm.tableLayout23 = tableLayout23;
                    modalVm.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    tableLayout23: function () {
                        return vm;
                    }
                }
            });
        }

        // Función para obtener el valor de norma para un país y columna específicos
        function getNormaValue(norma, columnHeader, type) {
            if (!norma || !columnHeader) return '';
            // Usar la propiedad key del columnHeader directamente
            var key = columnHeader.key || columnHeader.id;
            if (type === 'norma') {
                return norma.default && norma.default[key];
            }
            return norma.prestige && norma.prestige[key];
        }

        function addHasCellColor() {
            if (!vm.table.data || !vm.table.data.length) return;

            var targetGroups = ["digital_tv", "social_networks"];
            var shouldApplyYearLogic = vm.table.periodYear && vm.table.periodYear <= 20;

            vm.table.data.forEach(function (row) {
                row.forEach(function (cell, columnIndex) {
                    var isTargetCell = false;

                    // Lógica de grupos target (igual que layout 16)
                    if (vm.table.typeMedia === 'FRECOVIDEO' && vm.table.columnHeaders[columnIndex]) {
                        var columnId = vm.table.columnHeaders[columnIndex].id;
                        if (targetGroups.indexOf(columnId) !== -1 && shouldApplyYearLogic) {
                            isTargetCell = true;
                        }
                    }

                    if (isTargetCell && cell.value !== "-") {
                        row[columnIndex].hasCellColor = false;
                    }

                    if (cell.value < 1) {
                        row[columnIndex].hasCellColor = false;
                    }

                    if (!isTargetCell && cell.value >= 0 && cell.value !== "-") {
                        row[columnIndex].hasCellColor = true;
                    }
                });
            });
        }

        function getSize(number) {
            return "calc(100% / " + number + " )";
        }

        function notLastMedia(index) {
            return vm.table.columnHeaders.length - 1 === index ? false : true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('brandEssentialTrackingValuesL22', brandEssentialTrackingValuesL22);

    brandEssentialTrackingValuesL22.$inject = [];
    function brandEssentialTrackingValuesL22() {
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/crossCountry/layout22/brandEssentialTrackingValues/brandEssentialTrackingValues.html',
            bindToController: true,
            controller: brandEssentialTrackingValuesControllerL22,
            controllerAs: 'brandEssentialTrackingValuesL22',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                typeView:'<',
                serviceView:'<',  // ← Este es layout22Service
                typeContent:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function brandEssentialTrackingValuesControllerL22($scope, $timeout, $rootScope, $filter) {
        var vm  = this;

        vm.view = {
            id:'brand-essentials-tracking-values-l22',
            loading: false,
            hasData: false
        };

        vm.brandValuesData = {
            allMax:0,
            data:[]
        };

        vm.copyXls = {
            copyToXlsFn:copyToXlsFn,
            copyToXlsData:[]
        };

        vm.typeView = 'T';

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BRAND_VALUES_IB')+'</span>. '+$filter('translationWithPrefix')('BRAND_VALUES_INFO_TEXT_IB')+'</p>'+
        '</div>'
        ;

        //Watchers
        var filterWatcher = $scope.$watch('brandEssentialTrackingValuesL22.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            $rootScope.$emit('printReport', false);
            vm.view.loading = true;
            vm.view.hasData = false;
            $timeout(function(){
                getTracking()
                .then(function (data) {
                    vm.brandValuesData.data = data;
                    vm.copyXls.copyToXlsData = data;
                    vm.brandValuesData.allMax = _.chain(data && data.data).flatMap('values').map('value').max().value();
                    vm.view.hasData = true;
                })
                .catch(function (_err) {
                    vm.view.hasData = false;
                })
                .finally(function () {
                    vm.view.loading = false;
                    $rootScope.$emit('printReport', true);
                });
            }, 1000);
        }

        function getTracking() {
            // USAR EL SERVICIO QUE SE PASA POR PARÁMETRO (serviceView)
            // En lugar de hardcodear layout22Service
            if (vm.serviceView && vm.serviceView.getW1) {
                return vm.serviceView.getW1();
            }
            // Fallback por si acaso (no debería llegar aquí)
            return Promise.reject('No service provided');
        }

        function copyToXlsFn(data) {
            var ownData = copyBlock(data);
            return ownData;
        }

        function copyBlock(data){
            var columnHeaders = columnHeaders = _.concat([], '', data.categories);
            
            var columns = [columnHeaders];
            _.each(data && data.data, function(item){
                var text = item && item.text && item.text.split('*');
                var brand = text && text[1];
                var column = _.concat([], brand, _.chain(item && item.values).map(function (item) {
                    // Mostrar guion si el valor es null, undefined o 0
                    if (item.value === null || item.value === undefined || item.value === 0) {
                        return '-';
                    }
                    return $filter('round')(item.value, 0) + '%';
                }).value());
                columns.push(column);
            }); 
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return  rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('purchaseFunnelL20', purchaseFunnelL20);

    purchaseFunnelL20.$inject = [];
    function purchaseFunnelL20() {
        // ... (configuración de la directiva, no cambia) ...
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/crossCountry/layout20/purchaseFunnel/purchaseFunnel.html',
            bindToController: true,
            controller: purchaseFunnelL20Controller,
            controllerAs: 'purchaseFunnelL20',
            link: link,
            restrict: 'EA',
            scope: {
                changedFilter:'<',
                serviceView:'<',
                filterData: '<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function purchaseFunnelL20Controller (filterHelperService, $scope, $filter) {
        var vm = this;

        vm.view = {
            id:'purchase-funnel-l20',
            loading: false,
            hasData: true,
            data:[], // Aquí se almacenarán los funnels por país
            totalSample:[], // Aquí se almacenarán las bases muestrales por país
            maxValue:null
        };

        vm.copyXls = copyXls;
        
        // ... (vm.infoText no cambia) ...
        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('EVER_BOUGHT_IB')+'</span>. '+$filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>';

        //Watchers
        var filterWatcher = $scope.$watch('purchaseFunnelL20.changedFilter', init);

        $scope.$on('$destroy', function () {
            filterWatcher();
        });

        function init(){
            vm.view.loading = true;
            vm.view.hasData = false;
            vm.view.data = [];
            vm.view.totalSample = [];

            // --- INICIO DE LA MODIFICACIÓN ---

            // 1. Encontrar los datos del filtro de país
            var countryFilterData = _.chain(vm.filterData)
                                     .find({'id': 'country'})
                                     .result('data')
                                     .first()
                                     .result('datos') // Este es el array [{id: 'FR', text: 'France'}, ...]
                                     .value() || [];

            // 2. Crear un mapa de traducción (Objeto: {FR: 'France', ES: 'Spain'})
            var countryMap = _.chain(countryFilterData)
                              .keyBy('id')      // {FR: {id: 'FR', text: 'France'}, ...}
                              .mapValues('text') // {FR: 'France', ...}
                              .value();
            
            // --- FIN DE LA MODIFICACIÓN ---
            
            var selectedCountries = filterHelperService.getPropertySelected('country');
            if (selectedCountries && typeof selectedCountries === 'string') {
                selectedCountries = [selectedCountries];
            }

            vm.serviceView.getW1()
            .then(function(resultsByCountry){ 
                // 1. brandSelected será un STRING (ej: 'T0001')
                var brandSelected = filterHelperService.getPropertySelected('brand');
                
                // 2. La validación ahora solo comprueba que no esté vacío
                if (!brandSelected || _.isEmpty(resultsByCountry) || _.isEmpty(selectedCountries)) {
                    vm.view.hasData = false;
                    return;
                }
                
                var selectedBrandId = brandSelected;
                var allValues = [];
                
                _.each(resultsByCountry, function(countryResult, index){ 
                    var countryId = selectedCountries[index];
                    
                    // --- USA EL MAPA ---
                    var countryName = countryMap[countryId] || countryId; // Usa el nombre, o el ID si no lo encuentra

                    var widgetData = countryResult[0]; 
                    var totalData = countryResult[1]; 
                    
                    var item = widgetData && widgetData[0]; 

                    if (!item) {
                        var emptyGroup = {
                            text: countryName, // <-- USA EL NOMBRE
                            bought:      { value: '-' },
                            everBought:  { value: '-' },
                            consideration: { value: '-' },
                            awareness:   { value: '-' }
                        };
                        vm.view.data.push(emptyGroup);
                        vm.view.totalSample.push('-');
                        return; 
                    }

                    // Función auxiliar para convertir 0 en guion
                    var valueOrDash = function(val) {
                        return val === 0 ? '-' : val;
                    };

                    var newGroup = {
                        text: countryName, // <-- USA EL NOMBRE
                        bought:{
                            value: valueOrDash(_.chain(item).result('values').find({'id':'BOUGHT'+selectedBrandId}).result('values').first().result('value').value()),
                            type: _.chain(item).result('values').find({'id':'BOUGHT'+selectedBrandId}).result('values').first().result('type').value()
                        },
                        everBought:{
                            value: valueOrDash(_.chain(item).result('values').find({'id':'EVER'+selectedBrandId}).result('values').first().result('value').value()),
                            type: _.chain(item).result('values').find({'id':'EVER'+selectedBrandId}).result('values').first().result('type').value()
                        },
                        consideration:{
                            value: valueOrDash(_.chain(item).result('values').find({'id':'CONSI'+selectedBrandId}).result('values').first().result('value').value()),
                            type: _.chain(item).result('values').find({'id':'CONSI'+selectedBrandId}).result('values').first().result('type').value()
                        },
                        awareness:{
                            value: valueOrDash(_.chain(item).result('values').find({'id':'AWA'+selectedBrandId}).result('values').first().result('value').value()),
                            type: _.chain(item).result('values').find({'id':'AWA'+selectedBrandId}).result('values').first().result('type').value()
                        }
                    };
                    
                    // ... (resto de la lógica de 'numericValues' y 'totalSample') ...
                    var numericValues = _.chain(newGroup)
                                         .map('value')
                                         .filter(_.isNumber)
                                         .value();
                    allValues = allValues.concat(numericValues);

                    vm.view.data.push(newGroup);

                    // Verificar si todos los valores del grupo son guiones
                    // Excluimos 'text' porque no es un valor numérico
                    var allValuesAreDashes = newGroup.bought.value === '-' &&
                                            newGroup.everBought.value === '-' &&
                                            newGroup.consideration.value === '-' &&
                                            newGroup.awareness.value === '-';

                    var total = _.chain(totalData).find({ 'id': 'TOTAL' }).result('values').first().value();
                    var baseId = 'BASEAWA' + selectedBrandId;
                    var valueBrand = _.chain(totalData)
                                     .find({ 'id': baseId})
                                     .result('values')
                                     .first()
                                     .value();

                    // Mostrar guion si valueBrand es 0/null o si todos los valores son guiones
                    if (valueBrand === 0 || _.isNil(valueBrand) || allValuesAreDashes) {
                        vm.view.totalSample.push("-");
                    } else {
                        vm.view.totalSample.push(total);
                    }
                });
                
                vm.view.maxValue = _.isEmpty(allValues) ? 0 : _.chain(allValues).max().value();
                vm.view.hasData = vm.view.data.length > 0;
            })
            .catch(function(){
                vm.view.hasData = false;
            })
            .finally(function(){
                vm.view.loading = false;
                $scope.$emit('purchaseFunnelL20Loaded','purchaseFunnelL20');
            });
        }

        // ... (copyXls no cambia) ...
        function copyXls(data){
            var columnHeaders = [
                "",
                $filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB'),
                $filter('translationWithPrefix')('EVER_BOUGHT_IB'),
                $filter('translationWithPrefix')('CONSIDERATION_IB'),
                $filter('translationWithPrefix')('AWARENESS_IB'),
                $filter('translationWithPrefix')('TOTAL_SAMPLE')
            ];

            var columnData = _.chain(data).map(function(item, index){
                var values = _.chain(item).map('value').map(function(val){
                    if (val === '-') return '-'; 
                    if (!_.isNumber(val)) return '-'; 
                    return $filter('round')(val, 0) + '%';
                }).value();
                
                values = [].concat(item && item.text, values, vm.view.totalSample[index]);
                return values;
            }).value();


            var columns = [];
            columns.push(columnHeaders);

            _.each(columnData, function(item){
                columns.push(item);
            });
            
            var rows = _.zip.apply(_, columns);
            rows = _.map(rows, function(i){
                return i.join('\t');
            });
            return rows.join('\n');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('tableLayout11', tableLayout11);

    tableLayout11.$inject = [];
    function tableLayout11() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout11/tableLayout11.html',
            bindToController: true,
            controller: tableLayout11Controller,
            controllerAs: 'tableLayout11',
            link: link,
            restrict: 'EA',
            scope: {
                rowHeaders:'<',
                columnHeaders:'<',
                tableData:'<',
                legendData:'<',
                web:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function tableLayout11Controller(configurationLoaderService) {
        var vm = this;
 
        var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTableHistoric' }).result('color').value();
        var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTableHistoric' }).result('color').value();

        vm.legend = {
            c1 : _.chain(colors).find({'id':'U'}).result('value').value(),
            c2: _.chain(colors).find({'id':'D'}).result('value').value(),
            bg1: _.chain(backgroundColors).find({ 'id': 'U' }).result('value').value(),
            bg2 : _.chain(backgroundColors).find({'id':'D'}).result('value').value()
        };

        vm.table = {
            groups:{
                data:[]
            },
            categories:[],
            data:[],
            maxRows: 10,
            maxRowPrinting:15          
        };

        vm.getSize = getSize;
        init();

        function init(){
            vm.table.groups.data = vm.columnHeaders;
            vm.table.categories = vm.web ? vm.rowHeaders : _.chain(vm.rowHeaders).take(vm.table.maxRowPrinting).value();
            vm.table.data = vm.web ? vm.tableData : _.chain(vm.tableData).take(vm.table.maxRowPrinting).value();
            vm.table.maxRows = vm.web ? vm.table.maxRows : vm.table.maxRowPrinting;
        }

        function getSize(number){
            return 'calc(100% / '+number+' )';
        }
    }
})();
(function () {
  "use strict";

  angular.module("app").directive("tableLayout16", tableLayout16);

  tableLayout16.$inject = [];
  function tableLayout16() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl:
        "app/components/odecWidgetCollection/views/detailed/layout16/tableLayout16.html",
      bindToController: true,
      controller: tableLayout16Controller,
      controllerAs: "tableLayout16",
      link: link,
      restrict: "EA",
      scope: {
        events: "<",
        rowHeaders: "<",
        columnHeaders: "<",
        tableData: "<",
        legendData: "<",
        web: "<",
        noColorCells: "<"
      }
    };
    return directive;

    function link(_scope, _element, _attrs) { }
  }
  /* @ngInject */
  function tableLayout16Controller(configurationLoaderService, $uibModal, $scope) {
    var vm = this;

    var backgroundColors = _.chain(configurationLoaderService.getConfig())
      .result("colors")
      .find({ type: "backgroundTable" })
      .result("color")
      .value();
    var colors = _.chain(configurationLoaderService.getConfig())
      .result("colors")
      .find({ type: "colorsTable" })
      .result("color")
      .value();

    vm.legend = {
      c1: _.chain(colors).find({ id: "U" }).result("value").value(),
      c2: _.chain(colors).find({ id: "D" }).result("value").value(),
      bg1: _.chain(backgroundColors).find({ id: "U" }).result("value").value(),
      bg2: _.chain(backgroundColors).find({ id: "D" }).result("value").value()
    };

    vm.table = {
      groups: {
        data: [],
        events: [],
        getEvents: getEvents
      },
      categories: [],
      data: [],
     
      legend: _.isArray(vm.legendData) && vm.legendData.length > 0 ? vm.legendData : [vm.legendData],
      typeMedia: _.isArray(vm.legendData) && vm.legendData.length > 0 ? vm.legendData[0].typeMedia : vm.legendData.typeMedia,
      maxColumns: 9
    };

    vm.islastEvent = islastEvent;
    vm.getSize = getSize;
    vm.getSizeColumns = getSizeColumns;
    vm.notLastMedia = notLastMedia;
    vm.openLegendModal = openLegendModal;


    init();

    function openLegendModal() {
        $uibModal.open({
            templateUrl: 'legendModal.html',
            controller: function ($uibModalInstance, tableLayout16) {
                var vm = this;
                vm.tableLayout16 = tableLayout16;
                vm.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            },
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
                tableLayout16: function () {
                    return vm;
                }
            }
        });
    }

    function init() {
      vm.table.groups.data = vm.columnHeaders;
      vm.table.categories = vm.rowHeaders;
      vm.table.groups.events = vm.events;
      vm.table.data = vm.tableData;
    }
    addHasCellColor();



    function checkYearForEvent(event) {
      // Verificar si un evento específico tiene un año > 20
      var yearMatch = event.text.match(/\d+/); // Buscar números en el texto
      if (yearMatch) {
        var year = parseInt(yearMatch[0]); // Convertir el primer número encontrado a entero
        return year <= 20; // Verificar si el año es menor a 20 //18/12/2025 Cambiado a año 20
      }
      return false;
    }

    // Función para agregar hasCellColor a un grupo específico
    function addHasCellColor() {
      var targetGroups = ["digital_tv", "social_networks"]; // Grupos a los que quieres aplicar el color
      var length = vm.events.length;

      // Verifica el año (esto depende de tu implementación específica)

      // Itera sobre las filas de la tabla
      vm.table.data.forEach(function (row) {
        // Itera sobre las celdas de cada fila
        row.forEach(function (cell, columnIndex) {
          var isTargetCell = false;
          var currentIndex = 0;
          var currentEvent = null;
          var shouldApplyYearLogic = false;

          // Itera sobre los grupos para encontrar si el grupo actual es uno de los que nos interesa
          for (var i = 0; i < vm.table.groups.data.length; i++) {
            var currentGroup = vm.table.groups.data[i];
            if (targetGroups.indexOf(currentGroup.id) !== -1 && vm.table.typeMedia === 'FRECOVIDEO') {
              // Reemplazo de includes() para compatibilidad
              var groupEndIndex = currentIndex + length;

              if (columnIndex >= currentIndex && columnIndex < groupEndIndex) {
                // Calcular qué evento específico corresponde a esta columna
                var eventIndex = columnIndex - currentIndex;
                currentEvent = vm.events[eventIndex];

                // Verificar si este evento específico cumple la condición de año
                shouldApplyYearLogic = checkYearForEvent(currentEvent);

                // Verificar si está en un grupo de interés
                if (targetGroups.indexOf(currentGroup.id) !== -1 && vm.table.typeMedia === 'FRECOVIDEO' && shouldApplyYearLogic) {
                  isTargetCell = true;
                }
                break;
              }
            }

            // Actualiza currentIndex para la siguiente iteración
            currentIndex += length; // Avanzamos de según número de eventos
          }

          // Aplica color si está en un grupo de interés Y no es "-"
          if (isTargetCell && cell.value !== "-") {
            row[columnIndex].hasCellColor = false;
          }

          // Nueva condición: aplica color a celdas con valor menor a 1 aunque NO estén en targetGroups
          if (cell.value < 1) {
            row[columnIndex].hasCellColor = false;
          }

          // Si no cumple ninguna condición, añade hasCellColor si existe
          if (
            !isTargetCell &&
            cell.value >= 0 &&
            cell.value !== "-"
          ) {
            row[columnIndex].hasCellColor = true;
          }
        });
      });
    }


    function getEvents(events, getSize) {
      var allEvents = [];
      _.each(vm.table.groups.data, function () {
        allEvents = [].concat(allEvents, events);
      });
      if (getSize) {
        return allEvents && allEvents.length;
      }
      return allEvents;
    }

    function islastEvent(index, numberEvents) {
      return index % numberEvents ? false : true;
    }

    function getSize(number) {
      return "calc(100% / " + number + " )";
    }

    function getSizeColumns(numberColumns) {
      return "calc( ((100% - 110px) / 8) * " + numberColumns + " )";
    }

    function notLastMedia(index) {
      return vm.table.groups.data.length - 1 === index ? false : true;
    }


  }
})();

(function () {
  "use strict";

  angular.module("app").directive("tableLayout15", tableLayout15);

  tableLayout15.$inject = [];
  function tableLayout15() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl:
        "app/components/odecWidgetCollection/views/detailed/layout15/tableLayout15.html",
      bindToController: true,
      controller: tableLayout15Controller,
      controllerAs: "tableLayout15",
      link: link,
      restrict: "EA",
      scope: {
        events: "<",
        rowHeaders: "<",
        columnHeaders: "<",
        tableData: "<",
        legendData: "<",
        web: "<"
      }
    };
    return directive;

    function link(_scope, _element, _attrs) {}
  }
  /* @ngInject */
  function tableLayout15Controller(configurationLoaderService) {
    var vm = this;

    var backgroundColors = _.chain(configurationLoaderService.getConfig())
      .result("colors")
      .find({ type: "backgroundTable" })
      .result("color")
      .value();
    var colors = _.chain(configurationLoaderService.getConfig())
      .result("colors")
      .find({ type: "colorsTable" })
      .result("color")
      .value();

    vm.legend = {
      c1: _.chain(colors).find({ id: "U" }).result("value").value(),
      c2: _.chain(colors).find({ id: "D" }).result("value").value(),
      bg1: _.chain(backgroundColors).find({ id: "U" }).result("value").value(),
      bg2: _.chain(backgroundColors).find({ id: "D" }).result("value").value()
    };

    vm.table = {
      groups: {
        data: []
      },
      categories: [],
      data: [],
      maxRows: 10,
      maxRowPrinting: 15,
      maxColumns: 6,
      typeLegend: vm.legendData.typeLegend,
      typeMedia: vm.legendData.typeMedia
    };

    vm.getSize = getSize;
    vm.notLastMedia = notLastMedia;

    init();
    addHasCellColor();
    function init() {
      vm.table.groups.data = vm.columnHeaders;
      vm.table.categories = vm.web
        ? vm.rowHeaders
        : _.chain(vm.rowHeaders).take(vm.table.maxRowPrinting).value();
      vm.table.data = vm.web
        ? vm.tableData
        : _.chain(vm.tableData).take(vm.table.maxRowPrinting).value();
      vm.table.maxRows = vm.web ? vm.table.maxRows : vm.table.maxRowPrinting;
    }

    function getSize(number) {
      return "calc(100% / " + number + " )";
    }

    function notLastMedia(index) {
      return vm.table.groups.data.length - 1 === index ? false : true;
    }

    function checkYear() {
      // Buscar un número que sea menor a 20 en el texto del evento
      var selectedYear = vm.events.data[0].selectedNode;
      var yearMatch = selectedYear.match(/\d+/);
      if (yearMatch) {
        var year = parseInt(yearMatch[0]);
        return year <= 2020; // Verificar si el año es menor a 20 //18/12/2025 Cambiado a año 20
      } else {
        return false;
      }
   
    }

    // Función para agregar hasCellColor a un grupo específico
    function addHasCellColor() {
      var targetGroups = ["digital_tv", "social_networks"]; // Grupos a los que quieres aplicar el color

      // Verifica el año (esto depende de tu implementación específica)
      if (checkYear(vm.events)) {
        // Itera sobre las filas de la tabla
        vm.table.data.forEach(function (row) {
          // Itera sobre las celdas de cada fila (en este caso solo hay una columna por fila)
          row.forEach(function (cell, columnIndex) {
            var isTargetCell = false;
            var currentIndex = 0;
            // Itera sobre los grupos para encontrar si el grupo actual es uno de los que nos interesa
            for (var i = 0; i < vm.table.groups.data.length; i++) {
              var currentGroup = vm.table.groups.data[i];

              // Verifica si el grupo está en los grupos de interés
              if (targetGroups.includes(currentGroup.id) && vm.table.typeMedia === 'FRECOVIDEO') {
                // Aquí se aplica el color a las celdas de la columna actual
                // Si es uno de los grupos de interés
                if (columnIndex === currentIndex) {
                  isTargetCell = true;
                }
              }

              // Actualiza currentIndex para la siguiente iteración
              currentIndex += 1; // Como solo hay una columna, avanzamos de una en una
            }

            // Si la celda está en un grupo de interés y no es '-'
            if (isTargetCell && cell.value !== "-") {
              row[columnIndex].hasCellColor = true;
            } else {
              // Si la celda no está en el grupo, elimina el atributo si existe
              if (row[columnIndex].hasCellColor) {
                delete row[columnIndex].hasCellColor;
              }
            }
          });
        });
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('tableLayout12', tableLayout12);

    tableLayout12.$inject = [];
    function tableLayout12() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/views/detailed/layout12/tableLayout12.html',
            bindToController: true,
            controller: tableLayout12Controller,
            controllerAs: 'tableLayout12',
            link: link,
            restrict: 'EA',
            scope: {
                events:'<',
                rowHeaders:'<',
                columnHeaders:'<',
                tableData:'<',
                legendData:'<',
                web:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function tableLayout12Controller(configurationLoaderService) {
        var vm = this;

        var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTableHistoric' }).result('color').value();
        var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTableHistoric' }).result('color').value();

        vm.legend = {
            c1 : _.chain(colors).find({'id':'U'}).result('value').value(),
            c2: _.chain(colors).find({'id':'D'}).result('value').value(),
            bg1: _.chain(backgroundColors).find({ 'id': 'U' }).result('value').value(),
            bg2 : _.chain(backgroundColors).find({'id':'D'}).result('value').value()
        };

        vm.table = {
            groups:{
                data:[],
                events: [],
                getEvents:getEvents
            },
            categories:[],
            data:[]            
        };

        vm.islastEvent = islastEvent;
        vm.getSize = getSize;
        init();

        function init(){
            vm.table.groups.data = vm.columnHeaders;
            vm.table.categories = vm.rowHeaders;
            vm.table.groups.events = vm.events;
            vm.table.data = vm.tableData;
        }

        function getEvents(events, getSize){
            var allEvents = [];
            _.each(vm.table.groups.data, function () {
                allEvents = [].concat(allEvents, events);
            });
            if(getSize){
                return allEvents && allEvents.length;
            }
            return allEvents;
        }

        function islastEvent(index, numberEvents){
            return index % numberEvents ? false : true;
        }

        function getSize(number){
            return 'calc(100% / '+number+' )';
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecFilterHeader', odecFilterHeader);

    odecFilterHeader.$inject = ['$rootScope'];
    function odecFilterHeader($rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/odecWidgetCollection/odecWidgetHeader/odecFilterHeader/odecFilterHeader.html',
            bindToController: true,
            controller: odecWidgetHeaderController,
            controllerAs: 'odecFilterHeader',
            link: link,
            restrict: 'EA',
            scope: {
                filter: '<',
                filterId: '<'
            }
        };
        return directive;
        
        function link(scope, _element, _attrs) {
            var vm = scope.odecFilterHeader;

            vm.isOpen = false;
            vm.clickFilter = clickFilter;
            vm.onSelectOption = onSelectOption;
            vm.selected = vm.filter.selected || _.chain(vm.filter.childs).map().first().value();

            var filterWatcher = $rootScope.$on('odecFilterHeader:closeAll', function(_event,value){
                closeOptions(value);
            });

            /* var changeFilter = $rootScope.$on('odecFilterHeader:selectFilter', function(event,value){
                closeOptions(value);
            }); */

            scope.$on('destroy', function(){
                filterWatcher();
            });

            function clickFilter(item){
                $rootScope.$emit('odecFilterHeader:closeAll', item);
                vm.isOpen =  !vm.isOpen;
            }

            function closeOptions(item){
                if(item.title !== vm.filter.title){
                    vm.isOpen = false;
                }
                else{
                    vm.isOpen = vm.isOpen;
                }
            }

            function onSelectOption(item){
                vm.selected = item;
                $rootScope.$emit(vm.filterId ? ('odecFilterHeader:selectFilter:' + vm.filterId+':'+vm.filter.comboId) : 'odecFilterHeader:selectFilter', item);
                closeOptions(item);
            }

            function init() {
            }

            init();
        }
    }
    /* @ngInject */
    function odecWidgetHeaderController () {
        
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetHeader', odecWidgetHeader);

    odecWidgetHeader.$inject = [];
    function odecWidgetHeader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/odecWidgetCollection/odecWidgetHeader/odecWidgetHeader.html',
            bindToController: true,
            controller: odecWidgetHeaderController,
            controllerAs: 'odecWidgetHeader',
            link: link,
            restrict: 'EA',
            scope: {
                titleHeader:'<',
                showFilters:'<',
                filters:'<',
                filterId: '<',
                showInfo:'<',
                infoText:'<',
                showSnapshot:'<',
                extraOptions:'<',
                copyToClipboardData:'<',
                copyToClipboardFormatFn:'<',
                snapshotId:'<'
            }
        };
        return directive;
        
        function link(scope, _element, _attrs) {
            var vm = scope.odecWidgetHeader;

            var staticText =   '<div class="padding--0_5">'+
                            '<p class="no-margin text-left"><span class="bold--700"></span</p>'+
                            '</div>';

            
            vm.infoText = vm.infoText || staticText;
        }
    }
    /* @ngInject */
    function odecWidgetHeaderController () {
        
    }
})();
/*global canvg,html2canvas*/
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSnapshotModal', odecSnapshotModal);

    odecSnapshotModal.$inject = ['$rootScope'];
    function odecSnapshotModal($rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSnapshotButton/odecSnapshotModal/odecSnapshotModal.html',
            bindToController: true,
            controller: odecSnapshotModalController,
            controllerAs: 'odecSnapshotModal',
            link: link,
            restrict: 'EA',
            scope: {
            }
        };

        return directive;

        function link(scope, _element, _attrs) {
            var vm = scope.odecSnapshotModal;
            vm.visible = false;
            vm.model = {};
            vm.content = null;

            // listeners
            var snapItWatcher = $rootScope.$on('snapshot:snapIt', render);

            scope.$on('$destroy', function () {
                snapItWatcher();
            });

            // private method

            function render(_event, args) {
                vm.visible = true;
                vm.content = args.html;
                vm.model = args.model;
            }
        }
    }

    odecSnapshotModalController.$inject = ['snapshotsService','$q','errorHandlerService','$document'];
    function odecSnapshotModalController(snapshotsService,$q,errorHandlerService,$document) {
        var vm = this;

        vm.doSnapshot = doSnapshot;
        vm.cancelSnapshot = cancelSnapshot;

        function doSnapshot() {
            var element = angular.element('.odecSnapshotModal-content');
            
            transformSvgToCanvas(element.find('.odecSnapshotModal-wrapper'))
            .then(transformHtml2canvas)
            .then(addImage)
            .catch(errorHandlerService.callbackError);
        }

        function transformSvgToCanvas(el) {
            svgToCanvas(el);
            return $q.when(el);
        }

        function transformHtml2canvas(el) {
            return html2canvas(el, {/*allowTaint: true,*/logging: true})
                .then(function (canvas) {
                    var img = canvas.toDataURL('image/png');
                    var obj = _.extend({ image: img }, vm.model);
                    return obj;
                });
        }

        function addImage(obj) {
            snapshotsService.appendSnapshot(obj);
            vm.visible = false;
        }

        function cancelSnapshot() {
            if (vm.fnPostSnapshot) {
                vm.fnPostSnapshot();
            }
            vm.visible = false;
        }

        function svgToCanvas(targetElem) {
            var svgElem = targetElem.find('svg');

            svgElem.each(function (_index, node) {
                var parentNode = node.parentNode;

                // el ie es muy pijo...
                var s = new XMLSerializer();
                var svg = s.serializeToString(node);

                var canvas = $document && $document[0].createElement('canvas');

                canvg(canvas, svg);
                parentNode.removeChild(node);
                parentNode.appendChild(canvas);
            });
        }
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app')
        .directive('odecPanelHeader', odecPanelHeader);

    /* @ngInject */
    function odecPanelHeader() {
        // Usage:
        // <odec-panel-header 
        //   odec-panel-header-config="config">
        // </odec-panel-header>
        //
        // config = {
        //      title:'Este es el titulo',
        //      isClosable:true,
        //      isCollapsable:true,
        //      moreActions:[
        //          {
        //              type:'action',
        //              text:'Action 01',
        //              method:interviewlist.actions.fnAction01
        //          },{
        //              type:'divider'
        //          },{
        //              type:'action',
        //              text:'Action 02',
        //              method:interviewlist.actions.fnAction02
        //          }
        //      ]} 
        //
        // Creates:
        //

        
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelHeader/odecPanelHeader.html',
            bindToController: true,
            controller: odecPanelHeaderController,
            controllerAs: 'odecPanelHeader',
            link: link,
            restrict: 'EA',
            require:'^^odecPanel',
            scope: {
                odecPanelHeaderConfig:"<"
            }
        };
        return directive;
        
        function link(scope, _element, _attrs, ctrl) {
            var vm = scope.odecPanelHeader;
            //scope.odecPanelHeader.odecPanelHeaderConfig.isCollapsable = angular.isUndefined(vm.odecPanelHeaderConfig.isCollapsable)? true:false; 
            //scope.odecPanelHeader.odecPanelHeaderConfig.isClosable    = angular.isUndefined(vm.odecPanelHeaderConfig.isClosable)? true:false; 


            vm.odecPanelCtrl = ctrl;
        }
    }
    /* @ngInject */
    function odecPanelHeaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPanelFooter', odecPanelFooter);

    /* @ngInject */
    function odecPanelFooter() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelFooter/odecPanelFooter.html',
            bindToController: true,
            controller: odecPanelFooterController,
            controllerAs: 'odecPanelFooter',
            link: link,
            restrict: 'EA',
            transclude:true,
            require:'^^odecPanel',
            scope: {
            }
        };
        return directive;
        
        function link(scope, _element, _attrs, ctrl) {
            var vm = scope.odecPanelFooter;
            vm.odecPanelCtrl = ctrl;
        }
    }
    /* @ngInject */
    function odecPanelFooterController () {
        
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app')
        .directive('odecPanelBodyBarActionButton', odecPanelBodyBarActionButton);

    /* @ngInject */
    function odecPanelBodyBarActionButton() {

        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelBodyBarActionButton/odecPanelBodyBarActionButton.html',
            bindToController: true,
            controller: odecPanelBodyBarActionButtonController,
            controllerAs: 'odecPanelBodyBarActionButton',
            link: link,
            restrict: 'EA',
            require:'^^odecPanel',
            scope: {
                odecPanelBodyBarActionButtonOnClick:"<",
                odecPanelBodyBarActionButtonIcon:"<",
                odecPanelBodyBarActionButtonTooltip:"<"
            }
        };
        return directive;
        
        function link(scope, _element, _attrs, _ctrl) {
            var vm = scope.odecPanelBodyBarActionButton;
            vm.onButtonClick = onButtonClick; 
            vm.isLoading = false;
            vm.icon = vm.odecPanelBodyBarActionButtonIcon;

            // private methods
            function onButtonClick(event) {
                if (vm.isLoading) {
                    event.preventDefault();
                    return;
                }
                vm.isLoading = true;
                vm.icon = 'icon-spinner22 animated-spin';
                vm.odecPanelBodyBarActionButtonOnClick()
                .finally(function(){
                    vm.isLoading = false;
                    vm.icon = vm.odecPanelBodyBarActionButtonIcon;
                });
            }
        }
    }
    /* @ngInject */
    function odecPanelBodyBarActionButtonController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPanelBodyBar', odecPanelBodyBar);

    /* @ngInject */
    function odecPanelBodyBar() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelBodyBar/odecPanelBodyBar.html',
            bindToController: true,
            controller: odecPanelBodyBarController,
            controllerAs: 'odecPanelBodyBar',
            link: link,
            restrict: 'EA',
            transclude:{
                exports:'?odecPanelBodyBarSlotExports',
                multiwaveexport:'?odecPanelBodyBarSlotMultiwaveExport'
            },
            scope: {
                odecPanelBodyBarSearchText:'=?',
                odecPanelBodyBarSearchPlaceholder:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecPanelBodyBarController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPanelBody', odecPanelBody);

    /* @ngInject */
    function odecPanelBody() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelBody/odecPanelBody.html',
            bindToController: true,
            controller: odecPanelBodyController,
            controllerAs: 'odecPanelBody',
            link: link,
            restrict: 'EA',
            transclude:true,
            require:'^^odecPanel',
            scope: {
            }
        };
        return directive;
        
        function link(scope, _element, _attrs, ctrl) {
            var vm = scope.odecPanelBody;
            vm.odecPanelCtrl = ctrl;
        }
    }
    /* @ngInject */
    function odecPanelBodyController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('odecFilterPills', odecFilterPills);

    //odecFilterPills.$inject = [''];
    function odecFilterPills() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecFilter/odecFilterPills/odecFilterPills.html',
            bindToController: true,
            controller: odecFilterPillsController,
            controllerAs: 'odecFilterPills',
            link: link,
            restrict: 'EA',
            scope: {
                odecFilterPillsCollection:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecFilterPillsController () {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSubmenuList', odecSubmenuList);

    //odecSubmenuList.$inject = ['dep'];
    function odecSubmenuList() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSubmenuList/odecSubmenuList.html',
            bindToController: true,
            controller: odecSubmenuListController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecSubmenuListController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebarToggle', odecSidebarToggle);

    //odecSidebarToggle.$inject = ['dependency1'];
    function odecSidebarToggle() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSidebarToggle/odecSidebarToggle.html',
            bindToController: true,
            controller: odecSidebarToggleController,
            controllerAs: 'odecSidebarToggle',
            link: link,
            restrict: 'EA',
            scope: {
                odecSidebarToggleOpen:'&'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarToggleController () {
        var vm = this;

        vm.clicked = clicked;

        /** private methods */
        function clicked(value) {
            vm.odecSidebarToggleOpen(value);
        }    
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebarOverlay', odecSidebarOverlay);

    //odecSidebarOverlay.$inject = ['dependency1'];
    function odecSidebarOverlay() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/layout-ui/odecSidebarOverlay/odecSidebarOverlay.html',
            bindToController: true,
            controller: odecSidebarOverlayController,
            controllerAs: 'odecSidebarOverlay',
            link: link,
            restrict: 'EA',
            scope: {
                odecSidebarOverlayOpened:'=',
                odecSidebarOverlayClose:'&'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarOverlayController () {
        var vm = this;

        vm.closeOverlay = closeOverlay;

        /** private methods */

        function closeOverlay(value) {
            vm.odecSidebarOverlayClose(value);
        } 
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebar', odecSidebar);

    //odecSidebar.$inject = ['dependency1'];
    function odecSidebar() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSidebar/odecSidebar.html',
            bindToController: true,
            controller: odecSidebarController,
            controllerAs: 'odecSidebar',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
                odecSidebarOpened:'='
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarController () {
        
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuListItem', odecMenuListItem);

    //odecMenuListItem.$inject = ['dep'];
    function odecMenuListItem() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecMenuListItem/odecMenuListItem.html',
            bindToController: true,
            controller: odecMenuListItemController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuListItemSelected:'=',
                odecMenuListItemIcon:'<',
                odecMenuListItemSelectedOnSelect:'&',
                odecMenuListItemLabel:'<',
                odecMenuListItemSubmenuChilds:'<'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecMenuListItemController () {
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuList', odecMenuList);

    //odecMenuList.$inject = ['lodash'];
    function odecMenuList() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/layout-ui/odecMenuList/odecMenuList.html',
            bindToController: true,
            controller: odecMenuListController,
            controllerAs: 'odecMenuList',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuListCollection: '<'
            }
        };
        return directive;

        function link(scope) {
            var vm = scope.odecMenuList;
            // seleccionamos el primer item
            vm.data = {
                odecMenuListCollection: preSelect(vm.odecMenuListCollection)
            };
        }


        /** METODOS PRIVADOS */

        // si viene con algun elemento preseleccionado lo devolvemos tal cual sino
        // le preseleccionamos el primero
        function preSelect(collection) {
            var hasSelectedItem = _.chain(collection)
                .some(function (item) {
                    return item.selected;
                })
                .value();
            
            if (!hasSelectedItem) {
                return _.chain(collection)
                .map(function (item, index) {
                    if (index === 0) {
                        item.selected = true;
                    }
                    return item;
                })
                .value();
            }
            
            return collection;
        }
    }
    /* @ngInject */
    function odecMenuListController() {
        var vm = this;
        vm.onSelect = onSelect;

        /** private methods */
        function onSelect(_event,menuItem) {
            if (!menuItem) {
                return;
            }
            
            // quitamos todos los seleccionados y ponemos el que toca a seleccionados
            vm.data.odecMenuListCollection = _.chain(vm.data.odecMenuListCollection)
            .map(function(item){
                if(item === menuItem) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
                return item;
            })
            .value();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuLink', odecMenuLink);

    odecMenuLink.$inject = ['$state'];
    function odecMenuLink($state) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecMenuLink/odecMenuLink.html',
            bindToController: true,
            controller: odecMenuLinkController,
            controllerAs: 'odecMenuLink',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuLinkLabel:'<',
                odecMenuLinkState:'<',
                odecMenuLinkUrl:'<',
                odecMenuLinkOnClick:'&',
                odecMenuLinkVisible: '<'
            }
        };
        return directive;
        
        function link(scope) {
            var vm = scope.odecMenuLink;
            vm.onClick = onClick;

            /** metodos privados */

            function onClick() {
                scope.$emit('odecMenuLink:clicked');
                $state.go.apply(this,vm.odecMenuLinkState);
            }
        }
    }
    /* @ngInject */
    function odecMenuLinkController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecHeader', odecHeader);

    //odecHeader.$inject = ['dependency1'];
    function odecHeader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecHeader/odecHeader.html',
            bindToController: true,
            controller: odecHeaderController,
            controllerAs: 'odecHeader',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecHeaderController () {
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3TargetDonut', odecD3TargetDonut);

    odecD3TargetDonut.inject = ['d3', 'uuid', '$rootScope', 'odecD3Service', 'configurationLoaderService'];
    function odecD3TargetDonut(d3, uuid, $rootScope, odecD3Service, configurationLoaderService) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3TargetDonut/odecD3TargetDonut.html',
            bindToController: true,
            controller: odecD3TargetDonutController,
            controllerAs: 'odecD3TargetDonut',
            link: link,
            restrict: 'EA',
            scope: {
                odecD3TargetDonutData: '<',
                odecD3TargetDonutIcon: '<'
            }
        };
        return directive;

        function link(scope, element, _attrs) {
            var vm = scope.odecD3TargetDonut;
            var svg;
            var formatES = d3.formatLocale(odecD3Service.es_ES);
            var formatDecimal = formatES.format(",.1f");

            var _uuid = 'chart' + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var dataListener = scope.$watch('odecD3TargetDonut.odecD3TargetDonutData', function (newData) {
                if (newData) {
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                dataListener(); 
                repaintListener();
            });

            /***Tooltip */
            // var tip = d3.tip()
            // .attr("class", "d3-tip d3-tip-donut")
            // .html(function (data) {
            //     return '<p>' + data + '</p>';
            // });

            function update() {

                /*** If data/options change or window is resized we remove the svg and then repaint it ***/

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');

                var width = element.innerWidth();
                var height = element.innerHeight();
                var radius = Math.min(width, height) / 3;
                var colorSerie = _.chain(configurationLoaderService.getConfig()).result('colors').result('general').result('mainSerie').value();
                var color = d3.scaleOrdinal(colorSerie);
                var data = vm.odecD3TargetDonutData.values;
                var dataText = vm.odecD3TargetDonutData.text;

                /*** Chart options ***/

                //var numColumns = vm.odecD3TargetDonutOptions.numColumns; legend row num of elements
                var numColumns = 4;

                svg = d3.select('#' + element.attr('id'))
                    .append("svg")
                    .attr("width", width)
                    .attr("height", height);
                
                //svg.call(tip);

                var groupChart = svg.append("g")
                    .attr("class", "group-chart");

                var chartSlices = groupChart.append("g")
                    .attr("class", "slices");
                var chartLabels = groupChart.append("g")
                    .attr("class", "labels");
                var chartLines = groupChart.append("g")
                    .attr("class", "lines");

                

                var pie = d3.pie().sort(null).value(function (d) { return d; });
                var arc = d3.arc()
                    .innerRadius(radius * 0.75)
                    .outerRadius(radius * 0.6)
                    .padAngle(0.02);

                var outerArc = d3.arc()
                    .outerRadius(radius * 0.8)
                    .innerRadius(radius * 0.8);

                groupChart.attr("transform", "translate(" + width / 2 + "," + height / 2.5 + ")");

                chartSlices.selectAll('path')
                    .data(pie(data))
                    .enter()
                    .append('path')
                    .attr('fill', function (_d, i) { return color(i); })
                    .transition()
                    .ease(d3.easeBounce)
                    .duration(1000)
                    .attrTween("d", tweenPie)
                    .transition()
                    .ease(d3.easeElastic)
                    .delay(function (_d, i) { return 2000 + i * 50; })
                    .duration(750)
                    .attrTween("d", tweenDonut)
                    .attr("d", arc);

                function tweenPie(b) {
                    b.innerRadius = 0;
                    var i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                function tweenDonut(b) {
                    b.innerRadius = radius * 0.6;
                    var i = d3.interpolate({ innerRadius: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                chartLines
                    .selectAll('polyline')
                    .data(pie(data))
                    .enter().append('polyline')
                    .attr('points', function (d) {
                        var pos = outerArc.centroid(d);
                        pos[0] = midAngle(d) < Math.PI ? (pos[0] + 10) : (pos[0] - 10);
                        return [arc.centroid(d), outerArc.centroid(d), pos];
                    });

                var label = chartLabels.selectAll('text')
                    .data(pie(data))
                    .enter().append('text')
                    .attr('font-weight', 'bolder')
                    .attr('dy', '.35em')
                    .attr('fill', "black")
                    .text(function (d) {
                        return formatDecimal(d.data);
                    })
                    .attr('transform', function (d) {
                        var pos = outerArc.centroid(d);
                        pos[0] = midAngle(d) < Math.PI ? (pos[0] + 10) : (pos[0] - 10);
                        return 'translate(' + pos + ')';
                    })
                    .attr('text-anchor', function (d) {
                        return (midAngle(d)) < Math.PI ? 'start' : 'end';
                    });

                label
                    .append("tspan")
                    .attr('text-anchor', 'middle')
                    .attr('font-size', '.5em')
                    .attr('font-weight', 'bolder')
                    .text("%");

                var inside = svg.append("g").attr("class", "inside-items");

                var icon = inside.append("image")
                    .attr("class", "donut-center-icon")
                    .attr('height', radius * 0.4)
                    .attr('width', radius * 0.4)
                    .attr("xlink:href", "assets/images/" + vm.odecD3TargetDonutIcon);

                icon
                    .attr('x', function () {
                        var size = d3.select(this).node().getBBox();
                        return (width / 2 - size.width / 2);
                    })
                    .attr('y', function () {
                        var size = d3.select(this).node().getBBox();
                        return (height / 2.5 - size.height / 2);
                    });

                function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }

                //Add legend chart

                var sizeColLegend = angular.isDefined(numColumns) && numColumns > 0 ? width / numColumns : width / data.length;
                var legend = svg.append('g')
                    .attr('class', 'legend')
                    .attr("transform", "translate(" + radius / 3 + "," + (-15) + ")");

                var itemLegend = legend
                    .selectAll('.item-legend')
                    .data(dataText)
                    .enter()
                    .append('g');/*
                    .on('mouseenter', function (d) {
                        return tip.show(d);
                    })
                    .on('mouseleave', tip.hide);*/

                itemLegend
                    .append('circle')
                    .attr('fill', function (_d, i) {
                        return color(i);
                    })
                    .attr('r', 3.5)
                    .attr("transform", function (_d, i) {
                        if (angular.isDefined(numColumns) && numColumns > 0) {
                            var xOff = (i % numColumns) * sizeColLegend;
                            var yOff = Math.floor(i / numColumns) * 20;
                            return "translate(" + xOff + "," + yOff + ")";
                        }
                        else {
                            return "translate(" + (i * sizeColLegend) + "," + 0 + ")";
                        }
                    })
                    .attr("cx", 5)
                    .attr("cy", height * 0.84);

                itemLegend
                    .append('text')
                    .attr('font-size', 11)
                    .attr('class', 'item-legend')
                    .text(function (d) {
                        return d;
                    })
                    .attr("transform", function (_d, i) {
                        if (angular.isDefined(numColumns) && numColumns > 0) {
                            var xOff = (i % numColumns) * sizeColLegend;
                            var yOff = Math.floor(i / numColumns) * 20;
                            return "translate(" + xOff + "," + yOff + ")";
                        }
                        else {
                            return "translate(" + (i * sizeColLegend) + "," + 0 + ")";
                        }
                    })
                    .attr("dx", 12)
                    .attr("dy", height * 0.85)
                    .each(function () {
                        d3.select(this).call(odecD3Service.ellipsis.bind(d3.select(this).node(), sizeColLegend));
                    });
            }
        }
    }
    /* @ngInject */
    function odecD3TargetDonutController() {

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3Progress', odecD3Progress);

    odecD3Progress.inject = ['d3', 'uuid', '$rootScope','configurationLoaderService','odecD3Service','$filter'];
    function odecD3Progress(d3, uuid, $rootScope, configurationLoaderService, odecD3Service, $filter) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3Progress/odecD3Progress.html',
            bindToController: true,
            controller: odecD3ProgressController,
            controllerAs: 'odecD3Progress',
            link: link,
            restrict: 'EA',
            scope: {
                odecD3ProgressOptions: '<'
            }
        };
        return directive;

        function link(scope, element, _attrs) {
            var vm = scope.odecD3Progress.odecD3ProgressOptions;

            var formatDecimal = d3.format(",.0f");

            var _uuid = vm.name + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var svg;

            var optionsListener = scope.$watch('odecD3Progress.odecD3ProgressOptions', function (newData) {
                if (newData) {
                    vm = newData;
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                optionsListener(); 
                repaintListener();
            });

            function update() {

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');

                var value, showDash;
                if(!angular.isNumber(vm.value)){
                    value = parseFloat(0);
                    showDash = true;
                }
                else{
                    value = parseFloat(vm.value);
                    showDash = false;
                }
                

                var width = element.innerWidth();
                var height = width;
                
                var duration = 1000;
                var colors = configurationLoaderService.getConfig() && configurationLoaderService.getConfig().colors;

                var foregroundColor = angular.isDefined(vm.type) && _.chain(colors).find({'type': vm.type }).value() ? _.chain(colors).find({'type': vm.type }).result('color').value() : '#000000';
                var backgroundColor = _.chain(colors).find({'type':'BACKGROUND_COLOR_BARS'}).result('color').value();

                var radius = (Math.min(width, height) / 2)*.95;
                var thickness = radius*0.15;
                var color = d3.scaleOrdinal([foregroundColor, backgroundColor]);

                svg = d3.select('#' + element.attr('id'))
                .append('svg')
                .attr('width', width)
                .attr('height', element.innerHeight())
                .attr("preserveAspectRatio", "xMidYMid meet")
                .attr("viewBox", "0 0 " + width + " " + height);
                /*.on("mouseover", function() {
                    d3.select(this)
                    .transition()
                    .duration(50)
                    .style("transform", "scale(1.05,1.05)")
                    .style("cursor", 'pointer');
                })
                .on("mouseout", function() {
                    d3.select(this)
                    .transition()
                    .duration(50)
                    .style("transform", "scale(1,1)");
                })
                .on('click', function(_d){
                    $state.go('main.'+vm.name);
                  });*/

                var chart = svg.append('g')
                .attr('transform', 'translate(' + (width/2) + ',' + (height/2) + ')')
                //.attr("transform", "translate("+(width/2)+", "+(element.innerHeight()/2 - height/2)+")")
                .attr("class", "pie");
                //.attr("filter", "url(#dropshadow)");
                
                
                var arc = d3.arc()
                .innerRadius(radius - thickness)
                .outerRadius(radius)
                .padAngle(0.02);

                var pie = d3.pie()
                .sort(null);

                var path = chart.selectAll('path')
                .data(pie([0, 1]))
                .enter()
                .append('path')
                .attr('d', arc)
                .attr('fill', function(_d, i) {
                    return color(i);
                })
                .each(function(d) { this._current = d; });


                path.data(pie([value, 100-value]))
                .transition()
                .duration(duration)
                .attrTween('d', function(d) {
                    var interpolate = d3.interpolate(this._current, d);
                    this._current = interpolate(0);
                    return function(t) {
                        return arc(interpolate(t));
                    };
                });

                var inside = svg.append("g").attr("class", "inside-items")
                .attr('transform', 'translate(' + (width/2) + ',' + (height/2) + ')');

                var number = inside.append('text')
                .attr('text-anchor', 'middle')
                .attr('font-family','Montserrat')
                .attr('color', 'black');

                if(!showDash){
                    number
                    .append("tspan")
                    .attr('font-size', radius*0.4)
                    .attr('font-weight', 'bolder')
                    .attr('dy', radius*0.2)
    
                    .text(0)
                    .attr("opacity", 0)
                    .transition()
                    .delay(500)
                    .duration(duration)
                    .attr("opacity", 1)
                    .tween("text", function () {
                        var number = value / 100;
                        var that = d3.select(this),
                            i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
                            return function (t) {
                            that.text(formatDecimal(i(t)));
                        };
                    });
                    
    
                    number
                    .append("tspan")
                    .attr('font-size', radius*0.2)
                    .attr('font-weight', 'bolder')
                    .attr('dy', -radius*0.15 )
                    .attr("opacity", 0)
                    .transition()
                    .delay(500)
                    .duration(duration)
                    .attr("opacity", 1)
                    .text("%");
                }
                else{
                    number
                    .append("tspan")
                    .attr('font-size', radius*0.4)
                    .attr('font-weight', 'bolder')
                    .attr('dy', radius*0.2)
                    .text('-');
                }
                
                

                inside.append('text')
                .attr('font-family','Montserrat')
                .attr('text-anchor', 'middle')
                .attr('font-size', radius*0.12)
                .attr('color', 'black')
                .attr('y', radius*0.5)
                .text(vm.text)
                .call(odecD3Service.wrapText, radius,  "middle", radius*0.12, 3);
            

                inside.append("text")
                .attr('font-family','Montserrat')
                .attr('text-anchor', 'middle')
                .attr('font-size', radius*0.12)
                .attr('color', 'light-grey')
                .attr('y', -radius*0.25)
                .text(vm.period && $filter('uppercase')(vm.period))
                .call(odecD3Service.wrapText, radius, "middle", radius*0.12, 3);
                
            }
            
        }
    }
    /* @ngInject */
    function odecD3ProgressController() {

    }
})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .directive('odecD3Bar', odecD3Bar);
  
    odecD3Bar.$inject = ['d3', 'uuid', '$rootScope', '$stateParams','configurationLoaderService','odecD3Service'];
  
    function odecD3Bar(d3, uuid, $rootScope, $stateParams, configurationLoaderService, odecD3Service) {
      // Usage:
      //
      // Creates:
      //
      var directive = {
        bindToController: true,
        controller: odecD3BarController,
        controllerAs: 'odecD3Bar',
        link: link,
        restrict: 'EA',
        scope: {
          value:'<',
          color:'<',
          addBar:'<',
          indexBar:'<',
          max:'<',
          markValue:'<'
        }
      };
      return directive;
  
      function link(scope, element, _attrs) {
        var vm = scope.odecD3Bar;
        var svg, 
          heightBar, 
          x, 
          textBar,
          radius = 4,
          widthBar,
          sizeText;

        var formatDecimal = d3.format(".0f");
    
        /**Animations */
        var isWeb = $stateParams && $stateParams.web === 'true';
        var interval = 25;
        var delay = 50;
        var duration = 500;

        /**Colors */  
        var colors = _.chain(configurationLoaderService.getConfig()).result('colors').value();        
        var colorBackgroundBar = _.chain(colors).find({'type':'BACKGROUND_COLOR_BARS'}).result('color').value();
        vm.color = angular.isDefined(vm.color) ? _.chain(colors).find({'type':vm.color}).result('color').value() : '#000000';
  
        /***Tooltip */
        var tip = d3.tip()
          .attr("class", "d3-tip d3-tip-column-chart")
          .html(function (data) {
            return '<p>' + data.text + '</p>';
          });
  
        var _uuid = 'odec-d3-column-' + uuid.v4();
        element.attr('id', _uuid.replace(/-/g, ''));
        
  
  
        var margin = vm.odecD3Column && vm.odecD3Column.options && vm.odecD3Column.options.margin || {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        };
  
        var vw = element.innerWidth();
        var vh = element.innerHeight();
        var width = vw - margin.left - margin.right;
        var height = vh - margin.top - margin.bottom;
  
        var repaintListener = $rootScope.$on('window.resize', update);
  
        //Watchers
        var dataWatcher = scope.$watch(function () {
          return vm;
        }, update);
  
        scope.$on('$destroy', function () {
          repaintListener();
          dataWatcher();
        });
  
        function update() {              
          var elementRemove = d3.select('#' + element.attr('id'));
          elementRemove.select('svg').remove();
  
          var widgetBarExt = d3.select('#' + element.attr('id'));
  
          vw = element.innerWidth();
          vh = element.innerHeight();
          width = vw - margin.left - margin.right;
          height = vh - margin.top - margin.bottom;

          if(angular.isDefined(vm.addBar) && !vm.addBar){
            return;
          }

          svg = widgetBarExt.append("svg")
            .attr('width', width)
            .attr('height', height)
            .attr('viewBox', '0 0 ' + width + ' ' + height)
            .attr('preserveAspectRatio', 'xMinYMin meet')
            .attr('class', "odec-d3-bar-extremes");

          if(!_.isNumber(vm.value)){
            svg.append('text')
              .text('-')
              .attr('font-weight', 700)
              .attr('text-anchor','middle')
              .attr('x',width/2)
              .attr('y',height/2 + (height/2)*.8);
            return;
          }

          sizeText = (width+height)/2 * 0.008;
          sizeText = sizeText < 0.6 ? 0.6 : sizeText > 1.1 ? 1.1 : sizeText;
          
          svg.call(tip);

          //heightBar = height/4;
          widthBar = width*0.8;
          heightBar = 8;
          vm.max = vm.max > 90 ? 100 : vm.max*1.1;
          x = d3.scaleLinear()
            .range([0, widthBar])
            .domain([0, vm.max]);


          /**Fixed bar background */
          svg.append('rect')
          .attr('x',0)
          .attr('y',height/2 - heightBar/2)
          .attr('width',widthBar)
          .attr('height', heightBar)
          .attr('rx', 5)
          .attr("ry", 5)
          .attr("fill", colorBackgroundBar)
          .attr('opacity',0)
          .transition()
          .delay(function(){
            return vm.indexBar*(interval/2)+delay;
          })
          .duration(duration)
          .attr('opacity',1);

         
          printBar();
          

          /**Text over bar */
          
          textBar = svg.append('text')
          .attr('x',widthBar*1.05)
          .attr("font-family", "Montserrat")
          .attr('y', height/2 - heightBar/2 + heightBar*0.8 )
          .attr('text-anchor','start')
          .attr("fill", 'black');

          textBar
            .append('tspan')
            .attr('font-size', vm.markValue ? sizeText*1.05 + 'em' : sizeText + 'em')
            .attr('font-weight', vm.markValue ? 700 : 400)
            .transition()
            .duration(1000)
            .attr("opacity", 1)
            .tween("text", function () {
              var number = vm.value / 100;
              var that = d3.select(this),
                i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
              return function (t) {
                that.text(formatDecimal(i(t)));
              };
            });
          
          textBar
            .append('tspan')
            .attr('font-weight', vm.markValue ? 700 : 400)
            .attr('dy',-sizeText*3.5)
            .attr('font-size',sizeText*0.8 + 'em')
            .text('%');
        }

        function printBar(){
          svg.append('path')
          .attr("d", function() {
            return odecD3Service.rounded_rect(0, height/2 - heightBar/2, x(0), heightBar, radius, radius, radius, radius, radius);
          })
          .attr("fill", vm.color)
          .attr('opacity',0)
          .transition()
          .delay(function(){
            return vm.indexBar*interval+delay;
          })
          .duration(isWeb ? duration:0)
          .attr('opacity',1)
          .attr("d", function() {
            return odecD3Service.rounded_rect(0, height/2 - heightBar/2, x(vm.value), heightBar, radius, radius, radius, radius, radius);
          });
        }
      }
    }
    /* @ngInject */
    function odecD3BarController() {
  
    }
  })();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecD3HalfDonut', odecD3HalfDonut);

  odecD3HalfDonut.$inject = ['d3', '$rootScope', 'uuid', '$stateParams','configurationLoaderService'];

  function odecD3HalfDonut(d3, $rootScope, uuid, $stateParams, configurationLoaderService) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      bindToController: true,
      controller: odecD3HalfDonutController,
      controllerAs: 'halfDonut',
      link: link,
      restrict: 'EA',
      scope: {
        value: '<',
        color: '<'
      }
    };
    return directive;

    function link(scope, element) {
      var vm = scope.halfDonut;

      var svg,
        pies,
        data,
        arc,
        radis,
        anglesRange;

      var formatDecimal = d3.format(".0f");

      /**Animations */
      var isWeb = $stateParams && $stateParams.web === 'true';
      // var interval = 25;
      // var delay = 50;
      var duration = 500;

      /**Colors */
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').value();
      vm.color = angular.isDefined(vm.color) ? _.chain(colors).find({ 'type': vm.color }).result('color').value() : '#000000';

      var _uuid = 'odec-d3-half-donut' + uuid.v4();
      element.attr('id', _uuid.replace(/-/g, ''));

      var margin = {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      };

      var vw = element.innerWidth();
      var vh = element.innerHeight();
      var width = vw - margin.left - margin.right;
      var height = vh - margin.top - margin.bottom;

      var repaintListener = $rootScope.$on('window.resize', update);

      //Watchers
      var dataWatcher = scope.$watch(function () {
        return vm;
      }, update);

      scope.$on('$destroy', function () {
        repaintListener();
        dataWatcher();
      });

      function update() {
        var elementRemove = d3.select('#' + element.attr('id'));
        elementRemove.select('svg').remove();

        var widgetBarExt = d3.select('#' + element.attr('id'));

        vw = element.innerWidth();
        vh = element.innerHeight();
        width = vw - margin.left - margin.right;
        height = vh - margin.top - margin.bottom;

        var showDash;
        if(!angular.isNumber(vm.value)){
          vm.value = 0;
          showDash = true;
        }
        else{
          showDash = false;
        }

        data = [vm.value, 100 - vm.value];

        anglesRange = 0.5 * Math.PI;
        radis = Math.min(width, 2 * height) / 2;
        var thickness = width * 0.08;
        // Utility 

        var colors = [vm.color, "#D3D3D3"];

        pies = d3.pie()
          .value(function (d) {
            return d;
          })
          .sort(null)
          .startAngle(anglesRange * -1)
          .endAngle(anglesRange);

        arc = d3.arc()
          .outerRadius(radis)
          .innerRadius(radis - thickness);

        var translation = function (x, y) {
          return 'translate(' + x + ',' + y + ')';
        };

        // Feel free to change or delete any of the code you see in this editor!
        svg = widgetBarExt
          .append('svg')
          .attr("width", width)
          .attr("height", height)
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMinYMin meet')
          .attr('class', "odec-d3-half-donut");

        var group = svg
          .append("g")
          .attr("transform", translation(width / 2, height));

        group.selectAll("path")
          .data(pies(data))
          .enter()
          .append("path")
          .attr("fill", function (_d, i) {
            return colors[i];
          })
          .transition()
          .ease(d3.easeCircle)
          .duration(duration)
          .attrTween("d", tweenPie)
          .transition()
          .delay(function (_d, i) { return 2000 + i * 50; })
          .duration(duration)
          .attr("d", arc)
          ;

        var sizeText = height / 2 * 0.6;
        var text = group.append("text")
          .attr('font-size',sizeText)
          .attr('font-weight', 700)
          .attr("text-anchor", "middle")
          .attr("font-family", "Montserrat");
        if(!showDash){
          text
          .append('tspan')
          .attr('dy', '-2')
          .text(0)
          .transition()
            .duration(isWeb ? duration : 0)
            .attr("opacity", 1)
            .tween("text", function () {
              var number = vm.value / 100;
              var that = d3.select(this),
                i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
              return function (t) {
                that.text(formatDecimal(i(t)));
              };
            });

          text
            .append('tspan')
            .attr('font-size',sizeText*.6)
            .attr('dy', '-4')
            .text('%');
        }
        else{
          text
          .append('tspan')
          .attr('dy', '-2')
          .text('-');
        }
      }

      function tweenPie(b) {
        b.innerRadius = 0;
        var i = d3.interpolate({ startAngle: anglesRange * -1, endAngle: anglesRange }, b);
        return function (t) { return arc(i(t)); };
    }
    }
  }

  /* @ngInject */
  function odecD3HalfDonutController() {

  }

})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .directive('odecD3BarExtremes', odecD3BarExtremes);
  
    odecD3BarExtremes.$inject = ['d3', 'uuid', '$rootScope', '$stateParams','configurationLoaderService','odecD3Service'];
  
    function odecD3BarExtremes(d3, uuid, $rootScope, $stateParams, configurationLoaderService, odecD3Service) {
      // Usage:
      //
      // Creates:
      //
      var directive = {
        bindToController: true,
        controller: odecD3BarExtremesController,
        controllerAs: 'odecD3BarExtremes',
        link: link,
        restrict: 'EA',
        scope: {
          value:'<',
          color:'<',
          addBar:'<',
          indexBar:'<',
          isPyramid:'<',
          max:'<'
        }
      };
      return directive;
  
      function link(scope, element, _attrs) {
        var vm = scope.odecD3BarExtremes;
        var svg, 
          heightBar, 
          x, 
          textBar,
          radius = 4,
          sizeText;

        var formatDecimal = d3.format(".0f");
    
        /**Animations */
        var isWeb = $stateParams && $stateParams.web === 'true';
        var interval = 100;
        var delay = 50;
        var duration = 500;

        /**Colors */  
        var colors = _.chain(configurationLoaderService.getConfig()).result('colors').value();   
        var colorBackgroundBar = _.chain(colors).find({'type':'BACKGROUND_COLOR_BARS'}).result('color').value();     
        vm.color = angular.isDefined(vm.color) ? _.chain(colors).find({'type':vm.color}).result('color').value() : '#000000';
  
        /***Tooltip */
        var tip = d3.tip()
          .attr("class", "d3-tip d3-tip-column-chart")
          .html(function (data) {
            return '<p>' + data.text + '</p>';
          });
  
        var _uuid = 'odec-d3-column-' + uuid.v4();
        element.attr('id', _uuid.replace(/-/g, ''));
        
  
  
        var margin = vm.odecD3Column && vm.odecD3Column.options && vm.odecD3Column.options.margin || {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        };
  
        var vw = element.innerWidth();
        var vh = element.innerHeight();
        var width = vw - margin.left - margin.right;
        var height = vh - margin.top - margin.bottom;
  
        var repaintListener = $rootScope.$on('window.resize', update);
  
        //Watchers
        var dataWatcher = scope.$watch(function () {
          return vm;
        }, update);
  
        scope.$on('$destroy', function () {
          repaintListener();
          dataWatcher();
        });
  
        function update() {         
          var elementRemove = d3.select('#' + element.attr('id'));
          elementRemove.select('svg').remove();
  
          var widgetBarExt = d3.select('#' + element.attr('id'));
  
          vw = element.innerWidth();
          vh = element.innerHeight();
          width = vw - margin.left - margin.right;
          height = vh - margin.top - margin.bottom;

          if(angular.isDefined(vm.addBar) && !vm.addBar){
            return;
          }

          svg = widgetBarExt.append("svg")
            .attr('width', width)
            .attr('height', height)
            .attr('viewBox', '0 0 ' + width + ' ' + height)
            .attr('preserveAspectRatio', 'xMinYMin meet')
            .attr('class', "odec-d3-bar-extremes");

          if(!_.isNumber(vm.value)){
            svg.append('text')
              .text('-')
              .attr('font-weight', 700)
              .attr('text-anchor','middle')
              .attr('x',width/2)
              .attr('y',height/2 + (height/2)*.8);
            return;
          }

          vm.isPyramid = angular.isDefined(vm.isPyramid) ? vm.isPyramid : false;
          vm.indexBar = angular.isDefined(vm.indexBar) ? vm.indexBar : 0.5;
          
          
  
          svg.call(tip);

          //heightBar = height/4;
          heightBar = 8;
          vm.max = vm.max > 90 ? 100 : vm.max*1.1;
          x = d3.scaleLinear()
            .range([0, width])
            .domain([0, vm.max]);


          /**Fixed bar background */
          svg.append('rect')
          .attr('x',0)
          .attr('y',height - heightBar*1.5)
          .attr('width',width)
          .attr('height', heightBar)
          .attr('rx', 5)
          .attr("ry", 5)
          .attr("fill", colorBackgroundBar)
          .attr('opacity',0)
          .transition()
          .delay(function(){
            return vm.indexBar*(interval/2)+delay;
          })
          .duration(duration)
          .attr('opacity',1);

          if(vm.isPyramid){
            printBarPyramid();
          }
          else{
            printBar();
          }

          /**Text over bar */
          sizeText = (width+height)/2 * 0.008;
          sizeText = sizeText < 0.6 ? 0.6 : sizeText > 1.25 ? 1.25 : sizeText;
          

          textBar = svg.append('text')
          .attr('x',width/2)
          .attr("font-family", "Montserrat")
          .attr('y',height - heightBar*1.5 - heightBar/4 )
          .attr('text-anchor','middle')
          .attr('font-weight', 700)
          .attr("fill", 'black');

          textBar
            .append('tspan')
            .attr('font-size',sizeText+'em')
            .transition()
            .duration(1000)
            .attr("opacity", 1)
            .tween("text", function () {
              var number = vm.value / 100;
              var that = d3.select(this),
                i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
              return function (t) {
                that.text(formatDecimal(i(t)));
              };
            });
          
          textBar
            .append('tspan')
            .attr('dy',-sizeText*3.5)
            .attr('font-size',sizeText*0.8 + 'em')
            .text('%');
        }

        function printBarPyramid(){
          /**Negative bar */
          svg.append('path')
          .attr('class','neg-bar')
          .attr("d", function() {
            return odecD3Service.leftRoundedRect(width/2, height - heightBar*1.5, x(0), heightBar, 0);
          })
          .attr("fill", vm.color)
          .transition()
          .delay(function(){
            return vm.indexBar*interval+delay;
          })
          .duration(isWeb ? duration:0)
          .attr("d", function() {
            return odecD3Service.leftRoundedRect( width/2 -x(vm.value/2), height - heightBar*1.5, x(vm.value/2), heightBar, radius);
          });

          /**Positive bar */
          svg.append('path')
          .attr('class','pos-bar')
          .attr("d", function() {
            return odecD3Service.rightRoundedRect(width/2, height - heightBar*1.5, x(0), heightBar, 0);
          })
          .attr("fill", vm.color)
          .transition()
          .delay(function(){
            return vm.indexBar*interval+delay;
          })
          .duration(isWeb ? duration:0)
          .attr("d", function() {
            return odecD3Service.rightRoundedRect(width/2, height - heightBar*1.5, x(vm.value/2), heightBar, radius);
          });
        }

        function printBar(){
          svg.append('path')
          .attr("d", function() {
            return odecD3Service.rounded_rect(0, height - heightBar*1.5, x(0), heightBar, radius, radius, radius, radius, radius);
          })
          .attr("fill", vm.color)
          .transition()
          .delay(function(){
            return vm.indexBar*interval+delay;
          })
          .duration(isWeb ? duration:0)
          .attr("d", function() {
            return odecD3Service.rounded_rect(0, height - heightBar*1.5, x(vm.value), heightBar, radius, radius, radius, radius, radius);
          });
        }
      }
    }
    /* @ngInject */
    function odecD3BarExtremesController() {
  
    }
  })();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('changePasswordService', changePasswordService);

    changePasswordService.$inject = ['$http', 'userHelperService','globalHelpersService'];
    function changePasswordService($http, userHelperService,globalHelpersService) {
        var service = {
            changePassword:changePassword
        };
        
        return service;

        ////////////////
        function changePassword(password) { 
            var user  = userHelperService.getUser();
            return $http({
                method: 'PUT',
                url: './api/change-password/'+(user && user.id),
                data: {
                    password: password
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                transformRequest: globalHelpersService.httpPostParamsPrepare
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.changePassword', {
                url: '/changePassword',
                breadcrumb: { icon: 'icon-settings', label: 'MAIN_HOME_SETTINGS_CHANGE_PASSWORD' },
                views: {
                    content: {
                        templateUrl: 'app/settings/changePassword/changePassword.html',
                        controller: 'ChangePasswordController',
                        controllerAs: 'changePassword'
                    }
                },
                resolve: {
                    transition: transition
                }
            });
    }

    transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
    function transition(configurationLoaderService, _configuration, $timeout) {
        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('ChangePasswordController', ChangePasswordController);

    ChangePasswordController.$inject = ['changePasswordService','errorHandlerService','$filter'];
    function ChangePasswordController(changePasswordService,errorHandlerService, $filter) {
        var vm = this;
        

        vm.password = {
            loading:false,
            newPassword:null,
            confirmPassword:null
        };

        vm.actions = {
            changePassword:changePassword,
            clearPassword:clearPassword
        };

        function changePassword(newPassword){
            
            if(_.isNil(vm.password.newPassword) ||  _.isNil(vm.password.confirmPassword)){
                return errorHandlerService.callbackError( $filter('translationWithPrefix')('ERROR_EMPTY_PASSWORD') );
            }
            if(vm.password.newPassword !== vm.password.confirmPassword){
                return errorHandlerService.callbackError( $filter('translationWithPrefix')('ERROR_SAME_PASSWORD') );
            }
           
            /** 
             *  At least one special character
                At least one number
                Special characters are optional
                Minimum six characters and maximum 16 characters
             
            var regex = /^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/;
            if(!regex.test(vm.password.newPassword)){
                return errorHandlerService.callbackError( $filter('translationWithPrefix')('PASSWORD_CONDITIONS_ERROR') );
            }*/

            vm.password.loading = true;
            changePasswordService.changePassword(newPassword)
            .then(function(){
                errorHandlerService.callbackSuccess.call({text: $filter('translationWithPrefix')('SUCCESS_CHANGE_PASSWORD')});
            })
            .catch(function(_error){
                errorHandlerService.callbackError( $filter('translationWithPrefix')('ERROR_CHANGE_PASSWORD') );
            })
            .finally(function(){
                vm.password.loading = false;
                clearPassword();
            });
        }

        function clearPassword(){
            vm.password.newPassword = null;
            vm.password.confirmPassword = null;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout5Service', layout5Service);

  layout5Service.$inject = ['$http', 'filterHelperService','$state','$q'];
  function layout5Service($http, filterHelperService, $state, $q) {
    var service = {
      getW1: getMasc,
      getW2: getFem
    };

    return service;
 
    function getMasc() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParamsMas('Columns')
      })
      .then(function(data){
        return prepareData(data && data.data);
      })
      .catch(function(){
        return $q.when([]);
      });
    }

    function getFem() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParamsFem('Columns')
      })
      .then(function(data){
        return prepareData(data && data.data);
      })
      .catch(function(){
        return $q.when([]);
      });
    }


    function getParamsMas(grouping){
      return {
        datasource: "PUIG-19",
        query: "PUIG-18",
        parameters: {
          $country$: filterHelperService.getPropertySelected('country'),
          $BRAND$: $state && $state.params && $state.params.brand
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F16: [filterHelperService.getPropertySelected('period')],
          BRANDM: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function getParamsFem(grouping){
      return {
        datasource: "PUIG-20",
        query: "PUIG-18",
        parameters: {
          $country$: filterHelperService.getPropertySelected('country'),
          $BRAND$: $state && $state.params && $state.params.brand
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F16: [filterHelperService.getPropertySelected('period')],
          BRANDF: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function prepareData(data){
      return _.chain(data)
              .map(function(item, index){
                var getIdImage = _.chain(item.values).first().result('parent').result('id').value();
                var idCat = _.chain(item.values).first().result('id').value();
                item.id = idCat.replace(getIdImage,'');
                item.purchaseFunnel = _.chain(item && item.values).slice(0, 3).map(function(item){
                  item.value = _.chain(item && item.values).first().result('value').value();
                  item.type = _.chain(item && item.values).first().result('type').value();
                  return item;
                }).value();

                item.emotionalConnection = _.chain(item && item.values).slice(3, 6).map(function(item){
                  item.value = _.chain(item && item.values).first().result('value').value();
                  item.type = _.chain(item && item.values).first().result('type').value();
                  return item;
                }).value();
                item.typeImg = index === 0 ? 'svg' : 'png';
                return item;
              })
            .value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout5', {
                url: '/brand?brand&text&web&jobId',
                params: {
                    web: null,
                    text: null,
                    brand: null
                },
                breadcrumb: { icon: 'icon-layout-5', label: 'MAIN_HOME_LAYOUT5' },
                views: {
                    content: {
                        templateUrl: 'app/generalOverview/layout5/layout5.html',
                        controller: 'Layout5Controller',
                        controllerAs: 'layout5'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout5')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout5 is not enabled');
            }
            return $q.resolve();
        }


        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period
                };
                return mainService.getFilterModule('layout5', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout5', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout5Controller', Layout5Controller);

  /** @ngInject */
  function Layout5Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout5Service) {
    var vm = this;

    vm.filter = {
      data: [],
      applied:false
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.typeView = 'MF';
    vm.typeContent = {
      top:'masculine',
      bottom:'feminine'
    };
    vm.serviceView = layout5Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout4Service', layout4Service);

  layout4Service.$inject = ['$http', 'filterHelperService'];
  function layout4Service($http, filterHelperService) {
    var service = {
      getW1: getW1
    };

    return service;
 
    function getW1() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParams('Rows')
      })
      .then(function(data){
        return prepareData(data && data.data);
      });
    }

    function getParams(grouping){
      return {
        datasource: "PUIG-21",
        query: "PUIG-21"+filterHelperService.getPropertySelected('country'),
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F17: [filterHelperService.getPropertySelected('period')],
          F20: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function prepareData(data){
      var newData = {
        categories:null,
        data:[]
      };
      newData.data = _.chain(data)
              .map(function(item){
                item.id = _.chain((item && item.text).split('*')).last().value();
                item.values = _.chain(item.values).filter(function(item){return item.text !== 'base';}).map(function(item){
                  item.type = _.chain(item && item.values).first().result('type').value();
                  item.value = _.chain(item && item.values).first().result('value').value();
                  var splitToGetMark = (item && item.text).split('%%');
                  item.hasMark = splitToGetMark && splitToGetMark.length > 1 ? true: false;
                  return item;
                }).value();
                item.typeImg = 'svg';
                return item;
              })
            .value();
      newData.categories = _.chain(data)
              .first()
              .result('values')
              .map(function(item){
                return item && item.text && _.replace(item.text, '%%','');
              })
          .value();
      return newData;
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout4', {
                url: '/brandValues?web&jobId',
                breadcrumb: { icon: 'icon-layout-4', label: 'MAIN_HOME_LAYOUT4' },
                views: {
                    content: {
                        templateUrl: 'app/generalOverview/layout4/layout4.html',
                        controller: 'Layout4Controller',
                        controllerAs: 'layout4'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout4')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout4 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period
                };
                return mainService.getFilterModule('layout4', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout4', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout4Controller', Layout4Controller);

  /** @ngInject */
  function Layout4Controller($rootScope, $scope, filterData, $stateParams, $state, $filter) {
    var vm = this;

    vm.filter = {
      data: [],
      applied:false
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout2Service', layout2Service);

  layout2Service.$inject = ['$http', 'filterHelperService','$q'];
  function layout2Service($http, filterHelperService,$q) {
    var service = {
      getW1: getW1,
      getW2: getW2
    };

    return service;
 
    function getW1() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParams('Columns')
      })
      .then(function(data){
        return prepareData(data && data.data);
      })
      .catch(function(){
        return $q.when([]);
      });
    }

    function getW2() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParamsComp('Columns')
      })
      .then(function(data){
        return prepareData(data && data.data);
      })
      .catch(function(){
        return $q.when([]);
      });
    }


    function getParams(grouping){
      return {
        datasource: "PUIG-18",
        query: "PUIG-18",
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F16: [filterHelperService.getPropertySelected('period')],
          F11: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function getParamsComp(grouping){
      return {
        datasource: "PUIG-18",
        query: "PUIG-18",
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F16: [filterHelperService.getPropertySelected('period')],
          F12: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function prepareData(data){
      return _.chain(data)
              .map(function(item){
                var getIdImage = _.chain(item.values).first().result('parent').result('id').value();
                var idCat = _.chain(item.values).first().result('id').value();
                item.id = idCat.replace(getIdImage,'');
                item.purchaseFunnel = _.chain(item && item.values).slice(0, 3).map(function(item){
                  item.value = _.chain(item && item.values).first().result('value').value();
                  item.type = _.chain(item && item.values).first().result('type').value();
                  return item;
                }).value();

                item.emotionalConnection = _.chain(item && item.values).slice(3, 6).map(function(item){
                  item.value = _.chain(item && item.values).first().result('value').value();
                  item.type = _.chain(item && item.values).first().result('type').value();
                  return item;
                }).value();
                item.typeImg ='svg';
                return item;
              })
            .value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout2', {
                url: '/feminineFragrances?web&jobId',
                breadcrumb: { icon: 'icon-layout-2', label: 'MAIN_HOME_LAYOUT2' },
                views: {
                    content: {
                        templateUrl: 'app/generalOverview/layout2/layout2.html',
                        controller: 'Layout2Controller',
                        controllerAs: 'layout2'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout2')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout2 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period
                };
                return mainService.getFilterModule('layout2', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout2', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout2Controller', Layout2Controller);

  /** @ngInject */
  function Layout2Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout2Service) {
    var vm = this;

    vm.filter = {
      data: [],
      applied:false
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.typeView = 'T';
    vm.typeContent = {
      top:null,
      bottom:null
    };
    vm.serviceView = layout2Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout3Service', layout3Service);

  layout3Service.$inject = ['$http', 'filterHelperService','$q'];
  function layout3Service($http, filterHelperService, $q) {
    var service = {
      getW1: getW1,
      getW2: getW2
    };

    return service;
 
    function getW1() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParams('Columns')
      })
      .then(function(data){
        return prepareData(data && data.data);
      })
      .catch(function(){
        return $q.when([]);
      });
    }

    function getW2() {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: getParamsComp('Columns')
      })
      .then(function(data){
        return prepareData(data && data.data);
      })
      .catch(function(){
        return $q.when([]);
      });
    }


    function getParams(grouping){
      return {
        datasource: "PUIG-18",
        query: "PUIG-18",
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F16: [filterHelperService.getPropertySelected('period')],
          F13: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function getParamsComp(grouping){
      return {
        datasource: "PUIG-18",
        query: "PUIG-18",
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: {
          FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
          F16: [filterHelperService.getPropertySelected('period')],
          F14: null
        },
        transform: {
          template: 'Signification',
          parameters:{
            groupOn: grouping
          }
        }
      };
    }

    function prepareData(data){
      return _.chain(data)
              .map(function(item){
                var getIdImage = _.chain(item.values).first().result('parent').result('id').value();
                var idCat = _.chain(item.values).first().result('id').value();
                item.id = idCat.replace(getIdImage,'');
                item.purchaseFunnel = _.chain(item && item.values).slice(0, 3).map(function(item){
                  item.value = _.chain(item && item.values).first().result('value').value();
                  item.type = _.chain(item && item.values).first().result('type').value();
                  return item;
                }).value();

                item.emotionalConnection = _.chain(item && item.values).slice(3, 6).map(function(item){
                  item.value = _.chain(item && item.values).first().result('value').value();
                  item.type = _.chain(item && item.values).first().result('type').value();
                  return item;
                }).value();
                item.typeImg = 'svg';
                return item;
              })
            .value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout3', {
                url: '/masculineFragrances?web&jobId',
                breadcrumb: { icon: 'icon-layout-3', label: 'MAIN_HOME_LAYOUT3' },
                views: {
                    content: {
                        templateUrl: 'app/generalOverview/layout3/layout3.html',
                        controller: 'Layout3Controller',
                        controllerAs: 'layout3'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout3')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout3 is not enabled');
            }
            return $q.resolve();
        }


        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period
                };
                return mainService.getFilterModule('layout3', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout3', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout3Controller', Layout3Controller);

  /** @ngInject */
  function Layout3Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout3Service) {
    var vm = this;

    vm.filter = {
      data: [],
      applied:false
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.typeView = 'T';
    vm.typeContent = {
      top:null,
      bottom:null
    };
    vm.serviceView = layout3Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
    }
  }
})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .factory('layout1Service', layout1Service);
  
    layout1Service.$inject = ['$http', 'filterHelperService','$q'];
    function layout1Service($http, filterHelperService, $q) {
      var service = {
        getW1: getW1,
        getW2: getW2
      };
  
      return service;
   
      function getW1() {
        return $http({
          method: 'POST',
          url: './api/crosstab-engine-extract',
          data: getParams('Columns')
        })
        .then(function(data){
          return prepareData(data && data.data);
        })
        .catch(function(){
          return $q.when([]);
        });
      }

      function getW2() {
        return $http({
          method: 'POST',
          url: './api/crosstab-engine-extract',
          data: getParamsComp('Columns')
        })
        .then(function(data){
          return prepareData(data && data.data);
        })
        .catch(function(){
          return $q.when([]);
        });
      }


      function getParams(grouping){
        return {
          datasource: "PUIG-18",
          query: "PUIG-18",
          parameters: {
            $country$: filterHelperService.getPropertySelected('country')
          },
          filters: {
            FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
            F16: [filterHelperService.getPropertySelected('period')],
            F9: null
          },
          transform: {
            template: 'Signification',
            parameters:{
              groupOn: grouping
            }
          }
        };
      }

      function getParamsComp(grouping){
        return {
          datasource: "PUIG-18",
          query: "PUIG-18",
          parameters: {
            $country$: filterHelperService.getPropertySelected('country')
          },
          filters: {
            FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country')),
            F16: [filterHelperService.getPropertySelected('period')],
            F10: null
          },
          transform: {
            template: 'Signification',
            parameters:{
              groupOn: grouping
            }
          }
        };
      }
  
      function prepareData(data){
        return _.chain(data)
                .map(function(item){
                  var getIdImage = _.chain(item.values).first().result('parent').result('id').value();
                  var idCat = _.chain(item.values).first().result('id').value();
                  item.id = idCat.replace(getIdImage,'');
                  item.purchaseFunnel = _.chain(item && item.values).slice(0, 3).map(function(item){
                    item.value = _.chain(item && item.values).first().result('value').value();
                    item.type = _.chain(item && item.values).first().result('type').value();
                    return item;
                  }).value();

                  item.emotionalConnection = _.chain(item && item.values).slice(3, 6).map(function(item){
                    item.value = _.chain(item && item.values).first().result('value').value();
                    item.type = _.chain(item && item.values).first().result('type').value();
                    return item;
                  }).value();
                  item.typeImg = 'svg';
                  return item;
                })
              .value();
      }
    }
  })();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout1', {
                url: '/total?web&jobId',
                breadcrumb: { icon: '', label: 'MAIN_HOME_LAYOUT1',svg: '/assets/images/landing-icons/icon-layout-1-wh.svg' },
                views: {
                    content: {
                        templateUrl: 'app/generalOverview/layout1/layout1.html',
                        controller: 'Layout1Controller',
                        controllerAs: 'layout1'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout1')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout1 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService','filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period
                };
                return mainService.getFilterModule('layout1', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout1', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout1Controller', Layout1Controller);

  /** @ngInject */
  function Layout1Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout1Service) {
    var vm = this;

    vm.filter = {
      data: [],
      applied:false
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.typeView = 'T';
    vm.typeContent = {
      top:'own',
      bottom:'competitors'
    };
    vm.serviceView = layout1Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetRenderer', odecWidgetRenderer);

    odecWidgetRenderer.$inject = ['$compile'];
    function odecWidgetRenderer($compile) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecWidgetRendererController,
            controllerAs: 'odecWidgetRenderer',
            compile:compile,
            restrict: 'EA',
            scope: {
                config:'<'
            }
        };
        return directive;

        function compile(_el,_at) {
            return link;
        }
        
        function link(scope, element, _attrs) {
            var vm = scope.odecWidgetRenderer;
            function render() {
                var tmpl = '<' + vm.config.type + ' config="odecWidgetRenderer.config">' +'</' + vm.config.type + '>';
                element.replaceWith($compile(tmpl)(scope));
            }

            render();

        }
    }
    /* @ngInject */
    function odecWidgetRendererController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecViewDataLoader', odecViewDataLoader);

    //odecViewDataLoader.$inject = ['dependency1'];
    function odecViewDataLoader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecViewDataLoader/odecViewDataLoader.html',
            bindToController: true,
            controller: odevViewDataLoaderController,
            controllerAs: 'odecViewDataLoader',
            link: link,
            restrict: 'EA',
            scope: {
                odecViewDataLoaderLoading:'='
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odevViewDataLoaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLoginValidation', odecLoginValidation);

    /* @ngInject */
    function odecLoginValidation($q, $http, loginService) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            require: 'ngModel',
            link: link
        };
        return directive;
        
        function link(_scope, _element, attrs, ctrl) {

            //Defer object
            var def;
            //Original login (in case we are editing)
            var originalLogin = attrs.userOriginalLogin;
            //Login value
            var value;
            ctrl.$asyncValidators.loginValidation = function (modelValue, viewValue) {

                if (ctrl.$isEmpty(modelValue)) {
                    //Consider empty model valid
                    return $q.when();
                }

                //Login
                value = modelValue || viewValue;

                def = $q.defer();
                $http({
                    method:'GET',
                    url:'./api/users/user/check',
                    params: {
                        token: loginService.getToken(),
                        tipo: 'LOGIN',
                        value: modelValue || viewValue,
                        projectCode: loginService.getUser().userListExternalProjectName
                    }
                })
                .then(processData)
                .catch(reject);

                return def.promise;
            };
            
            function processData(data){
                if(data.data && originalLogin !== value){
                   reject();
                }
                else {
                    // The login is available
                    def.resolve();
                }
            }

            function reject(){
                //Login not available
                def.reject();
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecTransitionPage', odecTransitionPage);

    /* @ngInject */
    function odecTransitionPage() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecTransitionPage/odecTransitionPage.html',
            bindToController: true,
            controller: odecTransitionPageController,
            controllerAs: 'odecTransitionPage',
            link: link,
            restrict: 'EA',
            replace:true,
            scope: {
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecTransitionPageController ($rootScope,$scope) {
        var vm = this,
            startWatcher,
            endWatcher;


        vm.loading = true;

        /** watchers */
        startWatcher = $rootScope.$on('transition:start',function() {toggleLoading(true);});
        endWatcher = $rootScope.$on('transition:end',function() {toggleLoading(false);});

        $scope.$on('$destroy',function() {
            startWatcher();
            endWatcher();
        });


        /** private methods */
        function toggleLoading(value) {
            vm.loading = value;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecToggle', odecToggle);

    //odecToggle.$inject = ['dependency1'];
    function odecToggle() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecToggle/odecToggle.html',
            bindToController: true,
            controller: odecToggleController,
            controllerAs: 'odecToggle',
            link: link,
            restrict: 'EA',
            scope: {
                odecToggleActive:'=',
                odecToggleOnChange:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecToggleController () {
        var vm = this;

        vm.onClick = onClick;

        function onClick() {
            vm.odecToggleActive = !vm.odecToggleActive;
            vm.odecToggleOnChange.fn.apply(null,[vm.odecToggleActive].concat(vm.odecToggleOnChange.args));
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecTaskScheduler', odecTaskScheduler);

    /* @ngInject */
    function odecTaskScheduler() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            transclude: true,
            templateUrl: 'app/components/odecTaskScheduler/odecTaskScheduler.html',
            bindToController: true,
            controller: odecTaskSchedulerController,
            controllerAs: 'odecTaskScheduler',
            link: link,
            restrict: 'EA',
            scope: {}
        };
        return directive;

        function link(scope) {
            var taskCtrl = scope.odecTaskScheduler.tasks;

            //Initial load... (triggers the watch)
            taskCtrl.getData();

            //Watch for data changes
            scope.$watch('odecTaskScheduler.tasks.taskHelper.tasksList', taskCtrl.dataHandler);
        }
    }
    /* @ngInject */
    function odecTaskSchedulerController(taskHelper, configurationLoaderService, errorHandlerService, $filter, $log, socketService, $timeout) {
        var vm = this;
        var MAX_TASKS_TO_SHOW = 5;
        var reportType = configurationLoaderService.getConfig().views.taskHelper.tasksTypes.reports.type;

        vm.tasks = {
            data: null,
            tasksState: configurationLoaderService.getConfig().views.taskHelper.tasksState,
            taskHelper: taskHelper, //Needed to listen for the change ()
            getData: getData,
            dataHandler: dataHandler,
            totalTasks: 0,
            doneErrorNum: 0,
            onClickReport: onClickReport
        };

        function getData() {
            taskHelper.getTasksList();
        }

        socketService.socket.on('tasks patched', function (task) {
            var auxTasks;
            auxTasks = angular.copy(vm.tasks.taskHelper.tasksList);
            vm.tasks.taskHelper.tasksList = [];
            if(task.downloaded){
                $timeout(function(){
                    vm.tasks.taskHelper.tasksList = _.chain(auxTasks).reject({ 'id': task && task.id }).value();
                },0);
            }
            else{
                $timeout(function(){
                    vm.tasks.taskHelper.tasksList = _.chain(auxTasks).reduce(function(aggr, item){
                        if(task && task.id === item.id ){
                            item.state = task.state;
        
                            if(task && task.state === 'DONE'){
                                errorHandlerService.callbackSuccess.call({text:  $filter('translationWithPrefix')('REPORT_FINISHED')});
                            }

                            if(task && task.state === 'ERROR'){
                                errorHandlerService.callbackWarning.call({text:  $filter('translationWithPrefix')('LAUNCH_TASK_ERROR')});
                            }
                        }
                        aggr.push(item);
                        return aggr;
                        },[]).value();
                },0);
            }
            
        });

        socketService.socket.on('tasks created', function (_task) {
            errorHandlerService.callbackSuccess.call({text:  $filter('translationWithPrefix')('REPORT_STARTED')});
            var newTask = vm.tasks.taskHelper.parseTasksList(_.concat([], _task));
            vm.tasks.taskHelper.tasksList = _.concat([], newTask, vm.tasks.taskHelper.tasksList);
        });

        function dataHandler(data) {
            if (data) {
                var auxData = angular.copy(data);
                //We only need the ONE PAGER TASKS
                auxData = _.filter(auxData, function (item) { return item.type === reportType; });
                //Total tasks
                vm.tasks.totalTasks = auxData.length;
                //Total num. of DONE - ERROR (badge)
                vm.tasks.doneErrorNum = _.chain(auxData).filter(function (item) {
                    return (item.state === vm.tasks.tasksState.done || item.state === vm.tasks.tasksState.error);
                }).size().value();

                /** Sort the list */
                //B --> DONE tasks
                //A --> SCHEDULED OR STARTED
                //Z --> Anything else to the bottom
                auxData = _.sortBy(auxData, function (param) {
                    if (param.state === vm.tasks.tasksState.done) { return 'B'; }
                    else if (param.state === vm.tasks.tasksState.scheduled || param.state === vm.tasks.tasksState.started) { return 'A'; }
                    return 'Z';
                });
                
                vm.tasks.data = _.take(auxData, MAX_TASKS_TO_SHOW);
            }
        }

        /**
         * Depending on the task state...
         *
         * 1. DONE: Download the task
         * 2. ERROR: Delete the task
         */
        function onClickReport(taskId, taskState, taskType) {
            switch (taskState) {
                //DONE
                case vm.tasks.tasksState.done:
                    errorHandlerService.callbackSuccess.call({ text: $filter('translationWithPrefix')('MENU_TASKS_DOWNLOADING_DOCUMENT_' + taskType.toUpperCase()) });
                    taskHelper.downloadReport(taskId)
                        .catch(function () {
                            errorHandlerService.callbackError($filter('translationWithPrefix')('MENU_TASKS_ERROR_DOWNLOADING'));
                        });
                    break;
                //ERROR
                case vm.tasks.tasksState.error:
                    taskHelper.deleteTask(taskId)
                        .catch(function (error) {
                            $log.error('ERROR DELETING TASK', error);
                        });
                    break;
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecStarRenderer', odecStarRenderer);

    //odecStarRenderer.$inject = ['dependency1'];
    function odecStarRenderer() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecStarRenderer/odecStarRenderer.html',
            bindToController: true,
            controller: odecStarRendererController,
            controllerAs: 'odecStarRenderer',
            link: link,
            restrict: 'EA',
            scope: {
                odecStarRendererValue:'<',
                odecStarRendererOutof:'<'
            }
        };
        return directive;
        
        function link(scope, _element, _attrs) {
            var vm = scope.odecStarRenderer;
            
            vm.full = 0;
            vm.partial = 0;
            vm.empty = 0;
            
            var noDecimals,
                decimals,
                value,
                outOf,
                dataChangeWatcher;
            
            // roundig criteria
            // limit values for each range -> full | partial | empty
            var ROUND_UMBRAL_FLOOR = 0.25,ROUND_UMBRAL_HALF = 0.75;

            // we need the watcher cause we have a method init that only runs once, so if we want it
            // to run everytime the input changes we need the watch to invoke it. In case we didn't have
            // this init and all variables in html were direct from input we wouldn't need this
            dataChangeWatcher = scope.$watch(function(){return vm.odecStarRendererValue;},function(newValue) {
                if (newValue) {
                    init();
                }
            });

            scope.$on('$destroy',function(){
                dataChangeWatcher();
            });

            // private methods

            function init() {
                // generamos los numeros
                value = parseFloat(vm.odecStarRendererValue);
                outOf = parseFloat(vm.odecStarRendererOutof);

                if (isNaN(value)) { throw 'odecStarRenderer -> value is not a number';}
                if (isNaN(outOf)) { throw 'odecStarRenderer -> max. stars (outOf) is not a number';}

                if (value > outOf) {
                    throw 'odecStarRenderer -> Not a valid value value cannot be higher than limit';
                }

                // get not decimal part
                noDecimals = Math.floor(value);

                // javscript has problems with decimals and 0.2 -> 0.20000000018!!
                // fix it to have only 2 decimals
                decimals = (value % 1).toFixed(2);

                // create 3 vars we need, number of stars full, partial and empty,
                // dependind on the rounding criteria
                vm.full = noDecimals;
                if (decimals >= ROUND_UMBRAL_HALF) {
                    vm.full += 1;
                } else if (decimals < ROUND_UMBRAL_HALF && decimals >= ROUND_UMBRAL_FLOOR) {
                    vm.partial = 1;                
                }

                vm.empty = outOf - vm.full - vm.partial;
            } 

        }
    }
    /* @ngInject */
    function odecStarRendererController () {
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSnapshotButton', odecSnapshotButton);

    odecSnapshotButton.$inject = ['$rootScope','$filter'];
    function odecSnapshotButton($rootScope,$filter) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSnapshotButton/odecSnapshotButton.html',
            bindToController: true,
            controller: odecSnapshotButtonController,
            controllerAs: 'odecSnapshotButton',
            link: link,
            restrict: 'EA',
            scope: {
                odecSnapshotButtonTargetId:'<',
                odecSnapshotButtonTargetOptions:'<'
            }
        };
        return directive;

        function link(scope, _element, _attrs) {

            var vm = scope.odecSnapshotButton;

            vm.createSnapshot = createSnapshot;

            function createSnapshot() {

                $rootScope.$emit('snapshot:snapIt',{
                    html:$filter('htmlToString')(angular.element('#'+vm.odecSnapshotButtonTargetId).get(0)),
                    model:vm.odecSnapshotButtonTargetOptions
                });
            }
        }
    }
    /* @ngInject */
    function odecSnapshotButtonController() {
        var vm = this;
        vm.snapshotActive = false;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSelectionPills', odecSelectionPills);

    //odecSelectionPills.$inject = ['dependency1'];
    function odecSelectionPills() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSelectionPills/odecSelectionPills.html',
            bindToController: true,
            controller: odecSelectionPillsController,
            controllerAs: 'odecSelectionPills',
            link: link,
            restrict: 'EA',
            scope: {
                odecSelectionPillsCollection: '<',
                odecSelectionPillsOnSelection: '&'
            }
        };
        return directive;

        function link(scope, _element, _attrs) {
            var vm = scope.odecSelectionPills,
                preselectFirst = true;

            // if we want to set as selected the first item...
            if (preselectFirst) {
                vm.onSelection(vm.odecSelectionPillsCollection[0]);
            }            
        }
    }
    /* @ngInject */
    function odecSelectionPillsController() {
        var vm = this;

        vm.onSelection = onSelection;

        // private methods
        function onSelection(item) {
            // remove all selected items
            vm.odecSelectionPillsCollection = removeAllSelected(vm.odecSelectionPillsCollection);

            // find id and set it selected
            var objSelected = _.find(vm.odecSelectionPillsCollection, { id: item.id });

            if (objSelected) {
                objSelected.isSelected = true;
                vm.odecSelectionPillsOnSelection({ selection: getSelectedIds(vm.odecSelectionPillsCollection) });
            }
        }

        function removeAllSelected(collection) {
            var selected = _.filter(collection, { isSelected: true });

            _.each(selected, function (item) { item.isSelected = false; });

            return collection;
        }

        function getSelectedIds(collection) {
            return _.chain(collection)
                .filter({ isSelected: true })
                .map('id')
                .value();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSelect2', odecSelect2);

    /** @ngInject */
    function odecSelect2($rootScope) {
        var directive = {
            templateUrl: 'app/components/odecSelect2/odecSelect2.html',
            restrict: 'EA',
            replace:true,
            scope: {
                odecSelect2Data: '=',
                odecSelect2Event:'<',
                odecSelect2Selection: '=',
                odecSelect2Raw: '@',
                odecSelect2Placeholder: '@',
                odecSelect2ConfigExtra: '@',
                odecSelect2AllowClear: '=',
                odecSelect2Disabled: '<',
                odecSelect2Multiple: '<',
                odecHideSearchInput:'<',
                odecTheme:'<',
                odecSelect2MaxSelections:'<'
            },            
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el) {
            var select2Component,
                eventName = 'select2',
                options;

            if (scope.odecSelect2Multiple) {
                eventName = 'multiple';
            }

            if (scope.odecSelect2Event) {
                eventName += ':' + scope.odecSelect2Event;
            }

            /** private methods */
            function init(newData) {
                angular.element(el).html('');
                options = {                    
                    placeholder: scope.odecSelect2Placeholder || '...',
                    data: newData || [],
                    allowClear: scope.odecSelect2AllowClear,
                    multiple: scope.odecSelect2Multiple,
                    minimumResultsForSearch: scope.odecHideSearchInput ? Infinity : null,
                    theme: scope.odecTheme ? scope.odecTheme : 'default',
                    maximumSelectionLength:scope.odecSelect2MaxSelections
                };

                scope.odecSelect2Selection = scope.odecSelect2Selection || null;

                if (scope.odecSelect2Raw) {
                    initRaw();
                } else {
                    initWithData();
                }
            }

            function initWithData() {
                options.disabled=scope.odecSelect2Disabled;
                select2Component = angular.element(el).select2(options);
                select2Component.val(scope.odecSelect2Selection).trigger('change');
            }

            function initRaw() {
                select2Component = angular.element(el).select2(options);
                select2Component.val(scope.odecSelect2Selection).trigger('change');            
            }

            /** events */
            angular.element(el).on('select2:select',function(event){
                $rootScope.$emit(eventName,angular.extend(event.params.data,{events:{selecting:true, multiple: scope.odecSelect2Multiple}}));
            });

            angular.element(el).on('select2:unselect',function(event){
                $rootScope.$emit(eventName,angular.extend(event.params.data,{events:{removing:true, multiple: scope.odecSelect2Multiple}}));
            });
            

            /** listeners */
            
            var collectionWatcher = scope.$watch('odecSelect2Data', init);
            var selectionWatcher = scope.$watch('odecSelect2Selection',function(newValue){
                if (newValue) {
                    //select2Component.val(newValue);
                    select2Component.val(newValue).trigger('change');
                } 
                
            });
            var disabledWatcher = scope.$watch('odecSelect2Disabled',function(newValue) {
                select2Component.prop('disabled', newValue);
            });
            
            scope.$on('$destroy', function () {
                collectionWatcher();
                selectionWatcher();
                disabledWatcher();
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecScrollable', odecScrollable);

    /** @ngInject */
    function odecScrollable($timeout,$document) {
        var directive = {
            restrict: 'EA',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr) {
            var isMobile = mobileDetection();

            var transitionEvent = whichTransitionEvent();

            // param options passed to niceScroll
            var opciones = {};

            // width of bar
            opciones.width = attr.odecScrollableWidth || 7;

            // color of bar
            opciones.color = attr.odecScrollableColor || '#cecece';

            // align
            opciones.railalign = attr.odecScrollableRailalign || 'right';

            // time to wait before repaint, else sometimes on hide/show does not paint well
            opciones.waitAnimation = attr.odecScrollableWaitanimation || 300;

            // autohide param
            if (attr.odecScrollableAutohide === 'true') {
                opciones.autohide = true;
            } else if (attr.odecScrollableAutohide === 'false') {
                opciones.autohide = false;
            } else if (attr.odecScrollableAutohide) {
                opciones.autohide = attr.odecScrollableAutohide;
            } else {
                opciones.autohide = false;
            }


            // in case odecScrollableShow undefined create it else wait til it changes
            if (!attr.odecScrollableShow) {
                create();
            }

            /** private methods */

            // initialization
            function create() {
                if (isMobile.any) {
                    angular.element(el).css('overflow-y', 'scroll');
                    return;
                }

                if (angular.element(el).getNiceScroll().length !== 0) {
                    // if already exists repaint
                    resize();
                } else {
                    // if not already exists call pluggin 
                    angular.element(el).niceScroll({
                        autohidemode: opciones.autohide,
                        styler: 'fb',
                        cursorcolor: opciones.color,
                        cursorwidth: opciones.width,
                        cursorborderradius: '0px',
                        background: 'rgb(118,122,125)',
                        spacebarenabled: false,
                        cursorborder: '0',
                        railalign: opciones.railalign
                    });

                    resize();

                    // resize it just in case there's any animation
                    /*$timeout(function () {
                        angular.element(el).getNiceScroll().resize();
                    }, opciones.waitAnimation);*/
                }
            }

            // on destroy
            function destroy() {
                // clean it. wait in case there's any animation
                $timeout(function () {
                    angular.element(el).getNiceScroll().remove();
                    angular.element(el).attr('style', '');
                }, opciones.waitAnimation);
            }

            function whichTransitionEvent() {
                var t,
                    el = $document[0].createElement("fakeelement");

                var transitions = {
                    "transition": "transitionend",
                    "OTransition": "oTransitionEnd",
                    "MozTransition": "transitionend",
                    "WebkitTransition": "webkitTransitionEnd"
                };

                for (t in transitions) {
                    if (angular.isDefined(el.style[t])) {
                        return transitions[t];
                    }
                }
            }

            function resize() {
                return el.one(transitionEvent,function() {
                    angular.element(el).getNiceScroll().resize();
                });
            }

            /** listeners */

            // on show/hide change
            attr.$observe('odecScrollableShow', function (newValue) {
                if (newValue === 'false') {
                    // if hidding and already exists destroy it
                    if (angular.element(el).getNiceScroll().length !== 0) {
                        destroy();
                    }
                }

                // if showing initialize
                if (newValue === 'true') {
                    create();
                }
            });

            // on destroy
            scope.$on('$destroy', function () {
                destroy();
            });
        }

        function mobileDetection() {

            var mobileDetection,
                apple_phone = /iPhone/i,
                apple_ipod = /iPod/i,
                apple_tablet = /iPad/i,
                android_phone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
                android_tablet = /Android/i,
                amazon_phone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
                amazon_tablet = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
                windows_phone = /IEMobile/i,
                windows_tablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
                other_blackberry = /BlackBerry/i,
                other_blackberry_10 = /BB10/i,
                other_opera = /Opera Mini/i,
                other_chrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
                other_firefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
                seven_inch = new RegExp(
                    '(?:' + // Non-capturing group

                    'Nexus 7' + // Nexus 7

                    '|' + // OR

                    'BNTV250' + // B&N Nook Tablet 7 inch

                    '|' + // OR

                    'Kindle Fire' + // Kindle Fire

                    '|' + // OR

                    'Silk' + // Kindle Fire, Silk Accelerated

                    '|' + // OR

                    'GT-P1000' + // Galaxy Tab 7 inch

                    ')', // End non-capturing group

                    'i'); // Case-insensitive matching

            var match = function (regex, userAgent) {
                return regex.test(userAgent);
            };

            var IsMobileClass = function (userAgent) {
                var ua = userAgent || navigator.userAgent;

                // Facebook mobile app's integrated browser adds a bunch of strings that
                // match everything. Strip it out if it exists.
                var tmp = ua.split('[FBAN');
                if (typeof tmp[1] !== 'undefined') {
                    ua = tmp[0];
                }

                // Twitter mobile app's integrated browser on iPad adds a "Twitter for
                // iPhone" string. Same probable happens on other tablet platforms.
                // This will confuse detection so strip it out if it exists.
                tmp = ua.split('Twitter');
                if (typeof tmp[1] !== 'undefined') {
                    ua = tmp[0];
                }

                this.apple = {
                    phone: match(apple_phone, ua),
                    ipod: match(apple_ipod, ua),
                    tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
                    device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
                };
                this.amazon = {
                    phone: match(amazon_phone, ua),
                    tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
                    device: match(amazon_phone, ua) || match(amazon_tablet, ua)
                };
                this.android = {
                    phone: match(amazon_phone, ua) || match(android_phone, ua),
                    tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
                    device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
                };
                this.windows = {
                    phone: match(windows_phone, ua),
                    tablet: match(windows_tablet, ua),
                    device: match(windows_phone, ua) || match(windows_tablet, ua)
                };
                this.other = {
                    blackberry: match(other_blackberry, ua),
                    blackberry10: match(other_blackberry_10, ua),
                    opera: match(other_opera, ua),
                    firefox: match(other_firefox, ua),
                    chrome: match(other_chrome, ua),
                    device: match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
                };
                this.seven_inch = match(seven_inch, ua);
                this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

                // excludes 'other' devices and ipods, targeting touchscreen phones
                this.phone = this.apple.phone || this.android.phone || this.windows.phone;

                // excludes 7 inch devices, classifying as phone or tablet is left to the user
                this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

                if (typeof window === 'undefined') {
                    return this;
                }
            };

            var instantiate = function () {
                var IM = new IsMobileClass();
                IM.Class = IsMobileClass;
                return IM;
            };

            mobileDetection = instantiate();
            return mobileDetection;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecRenderer', odecRenderer);

    /* @ngInject */
    function odecRenderer($compile) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controllerAs: 'odecRenderer',
            link: link,
            restrict: 'A',
            controller:odecRendererController,
            scope: {
                odecRendererConfig:'=',
                odecRendererDisabled:'<'
            }
        };
        return directive;
        
        function link(scope, element, _attrs) {
            var vm = scope.odecRenderer,
                htmlTemplate;

            if (vm.odecRendererDisabledInstanceName) {
                vm.eventName = vm.odecRendererDisabledInstanceName + ':' +  vm.odecRendererConfig.eventName;
            } else {
                vm.eventName = vm.odecRendererConfig.eventName;
            }
            
            if (vm.odecRendererConfig.type === 'select2') {
                htmlTemplate = '<div odec-select2 odec-select2-data="odecRenderer.odecRendererConfig.datos" odec-select2-placeholder="{{odecRenderer.odecRendererConfig.label|translate}}" odec-select2-selection="odecRenderer.odecRendererConfig.selectedNode" odec-select2-event="odecRenderer.odecRendererConfig.eventId" odec-select-2-config-extra="odecRenderer.odecRendererConfig.config" odec-select2-allow-clear="odecRenderer.odecRendererConfig.allowClear" odec-select2-disabled="odecRenderer.odecRendererDisabled"></div>';
            } else if (vm.odecRendererConfig.type === 'label') {
                htmlTemplate = '<span class="label label-success">{{odecRenderer.odecRendererConfig.selectedNode}}</span>';                
            }else if (vm.odecRendererConfig.type === 'multiple') {
                htmlTemplate = '<div odec-select2-multiple="true" odec-select2-disabled="odecRenderer.odecRendererConfig.disabled" odec-select2 odec-select2-data="odecRenderer.odecRendererConfig.datos" odec-select2-placeholder="{{odecRenderer.odecRendererConfig.label|translate}}" odec-select2-selection="odecRenderer.odecRendererConfig.selectedNode" odec-select2-event="odecRenderer.eventName" odec-select-2-config-extra="odecRenderer.odecRendererConfig.config" odec-select2-allow-clear="odecRenderer.odecRendererConfig.allowClear" odec-select2-disabled="odecRenderer.odecRendererDisabled" odec-select2-max-selections="odecRenderer.odecRendererConfig.maxSelections"></div>';
            }
            element.replaceWith($compile(htmlTemplate)(scope));
            
        }
    }

    /* @ngInject */
    function odecRendererController() {

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecPanel', odecPanel);

    /* @ngInject */
    function odecPanel() {
        /**
         * Component used to render panels, this is the container
         * 
         * @example
         * <odec-panel>
         *     <odec-panel-header
         *         odec-panel-header-config="interviewlist.panel.config">
         *     </odec-panel-header>
         *     <odec-panel-body>
         *         <odec-panel-body-bar
         *             odec-panel-body-bar-search-text="interviewlist.expandable.searchText"
         *             odec-panel-body-bar-search-placeholder="interviewlist.expandable.placeholder">
         *         </odec-panel-body-bar>
         *         <div class="content padding--1">
         *             <table id="interviewListTable" class="table table-stripped table-bordered"
         *                 odec-datatable
         *                 odec-datatable-column-defs="interviewlist.table.columnsDef"
         *                 odec-datatable-data="interviewlist.table.data"
         *                 odec-datatable-columns="interviewlist.table.columns"
         *                 odec-datatable-sort="interviewlist.table.order"
         *                 odec-datatable-search-text="interviewlist.expandable.searchText"
         *                 odec-datatable-allow-row-click="true"></table>
         *         </div>
         *     </odec-panel-body>
         * </odec-panel>
         */
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanel.html',
            bindToController: true,
            controller: odecPanelController,
            controllerAs: 'odecPanel',
            link: link,
            restrict: 'EA',
            transclude: true,
            scope: {
            }
        };
        return directive;

        function link(scope, element, _attrs) {
            scope.$on('$destroy',function() {
                element.remove();
            });
        }
    }
    /* @ngInject */
    function odecPanelController($scope) {
        var vm = this;
        vm.isCollapsed = false;
        vm.collapse = collapse;
        vm.close = close;


        /** private methods */
        function collapse() {
            vm.isCollapsed = !vm.isCollapsed;
        }


        function close() {
            $scope.$destroy();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecNoticePopup', odecNoticePopup);

    /* @ngInject */
    function odecNoticePopup() {
        var directive = {
            bindToController: true,
            controller: odecNoticePopupController,
            templateUrl: 'app/components/odecNoticePopup/odecNoticePopup.html',
            controllerAs: 'noticeCtrl',
            restrict: 'EA',
            scope: {}
        };
        return directive;
    }

    /* @ngInject */
    function odecNoticePopupController() {
        var vm = this;

        vm.visible = true;
        vm.close = close;

        /** private methods */
        function close() {
            vm.visible = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecNoDataDisplay', odecNoDataDisplay);

    /* @ngInject */
    function odecNoDataDisplay() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecNoDataDisplayController,
            templateUrl: 'app/components/odecNoDataDisplay/odecNoDataDisplay.html',
            controllerAs: 'displayCtrl',
            link: link,
            restrict: 'EA',
            scope: {
                isError: '<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecNoDataDisplayController () {
        var NO_DATA_MESSAGE = 'NO_DATA';
        var ERROR_MESSAGE = 'ERROR_NO_DATA';

        var vm = this;

        // Error display
        vm.message = vm.isError ? 
        { key: ERROR_MESSAGE, icon: 'icon-close2' } :
        { key: NO_DATA_MESSAGE, icon: 'icon-error_outline' };
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecModal', odecModal);

    /* @ngInject */
    function odecModal() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odeModalController,
            templateUrl: 'app/components/odecModal/odecModal.html',
            controllerAs: 'modalCtrl',
            transclude: true,
            link: link,
            restrict: 'EA',
            scope: {
                headerTitle: '@',
                bodyMessage: '@',
                eventId: '@',
                emitData: '<', //Data to send when the event is emited
                showData: '<' //Data to show besides the 'bodyMessage' (format: [{key: '', value: ''}, ...])
            }
        };
        return directive;
        
        function link(scope, element, _attrs) {
            element.on('click', scope.modalCtrl.openModal);
        }
    }
    /* @ngInject */
    function odeModalController ($scope, $uibModal) {
        var vm = this;
        //Modal instance
        var modalInstance;
        
        vm.openModal = openModal; //Open 
        vm.closeModal = closeModal; //Close
        vm.accept = accept; //Accept

        /**
         * Open the modal when click the button
         */
        function openModal(){
            modalInstance = $uibModal.open({
                templateUrl: 'odecModal.html',
                scope: $scope
            });
        }

        /**
         * Close de modal
         */
        function closeModal(){
            modalInstance.dismiss('cancel');
        }

        /**
         * When accept is clicked
         */
        function accept(){
            //Close modal
            vm.closeModal();
            //Emit
            var eventString = 'modal:accept';
            if(angular.isDefined(vm.eventId)){
                eventString += ':' + vm.eventId;
            }
            $scope.$emit(eventString, vm.emitData);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLoadingButton', odecLoadingButton);

    function odecLoadingButton() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecLoadingButton/odecLoadingButton.html',
            bindToController: true,
            controller: odecLoadingButtonController,
            controllerAs: 'odecLoadingButton',
            link: link,
            restrict: 'EA',
            transclude:true,
            replace:true,
            scope: {
                odecLoadingButtonLoading:'='
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecLoadingButtonController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLegend', odecLegend);

    odecLegend.$inject = [];
    function odecLegend() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/odecLegend/odecLegend.html',
            bindToController: true,
            controller: odecLegendController,
            controllerAs: 'odecLegend',
            link: link,
            restrict: 'EA',
            scope: {
                odecLeftLegend:'<',
                odecRightLegend:'<',
                odecLegendHideSignification:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {

        }
    }
    /* @ngInject */
    function odecLegendController (configurationLoaderService) {
        var vm = this;

        vm.odecRightLegend = vm.odecRightLegend || 'GENERAL_LEGEND';
        vm.hideSignification = angular.isDefined(vm.odecLegendHideSignification) && vm.odecLegendHideSignification ? true : false;

        vm.legend = {
            colorsSignification: {
              up: _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'U' }).result('color').value(),
              down: _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'D' }).result('color').value(),
              default: _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'DF' }).result('color').value()
            }
          };
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecLanguageSelector', odecLanguageSelector);

  function odecLanguageSelector() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/odecLanguageSelector/odecLanguageSelector.html',
      bindToController: true,
      controller: odecLanguageSelectorController,
      controllerAs: 'odecLanguageSelector',
      link: link,
      restrict: 'EA',
      transclude: true,
      replace: true,
      scope: {
        odecLanguageList: '=',
        odecLanguageSelected: '=',
        odecLanguageOnChange: '&'
      }
    };
    return directive;

    function link(scope, _element, _attrs) {
      var vm = scope.odecLanguageSelector;
      // inicializamos con los que nos pasa al componente desde fuera
      vm.languageSelector.language.selected = vm.odecLanguageSelected;
      vm.languageSelector.language.list = vm.odecLanguageList;
    }
  }
  /* @ngInject */
  function odecLanguageSelectorController() {
    var vm = this;

    var enumStatus = [{
        label: 'HOME_SELECT_COUNTRY'
      }, {
        label: 'HOME_SELECT_LANGUAGE'
      }],
      statusSelected = 0,
      lastSelected = null;

    vm.languageSelector = {
      status: enumStatus[statusSelected],
      countrySelectionChange: countrySelectionChange,
      isLoading: false,
      language: {
        selected: null,
        list: []
      },
      filteredLanguageList: [],
      languageSelectionChange: languageSelectionChange,
      returnCountrySelection: returnCountrySelection
    };


    function countrySelectionChange($event, country) {
      statusSelected++;
      lastSelected = vm.languageSelector.language.selected;
      vm.languageSelector.language.selected = {
        country: country.country,
        image: country.image,
        lang: '',
        code: ''
      };

      if (country.languages.length === 1) {
        vm.languageSelector.language.selected.lang = country.languages[0].lang;
        vm.languageSelector.language.selected.code = country.languages[0].code;
        vm.languageSelector.isLoading = true;

        vm.odecLanguageSelected = country.languages[0].code;

        vm.odecLanguageOnChange({
          selection: vm.languageSelector.language.selected
        });
      } else {
        vm.languageSelector.filteredLanguageList = country.languages;
        vm.languageSelector.status = enumStatus[statusSelected];

        vm.odecLanguageSelected = null;

        $event.stopPropagation();
      }

    }

    function languageSelectionChange(language) {
      statusSelected--;
      vm.languageSelector.language.selected.lang = language.lang;
      vm.languageSelector.language.selected.code = language.code;
      vm.languageSelector.filteredLanguageList = [];
      vm.languageSelector.status = enumStatus[statusSelected];
      lastSelected = null;
      vm.languageSelector.isLoading = true;

      vm.odecLanguageSelected = language.code;

      vm.odecLanguageOnChange({
        selection: vm.languageSelector.language.selected
      });
    }

    function returnCountrySelection() {
      statusSelected--;
      vm.languageSelector.language.selected = lastSelected;
      vm.languageSelector.status = enumStatus[statusSelected];
    }
  }


})();
/*global Highcharts */
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecHighcharts', odecHighcharts);

    odecHighcharts.$inject = ['$timeout'];

    function odecHighcharts($timeout) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecHighchartsController,
            controllerAs: 'odecHighcharts',
            link: link,
            restrict: 'EA',
            scope: {
                odecHighchartsConfig: '<',
                odecHighchartsData: '<',
                odecHighchartsCategories: '<',
                odecHighchartsInstance: '=',
                odecHighchartsOnClick: '&'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecHighcharts;
            var chart,
                dataWatcher,
                TIMEOUT_REFLOW = 300;


            dataWatcher = scope.$watch(function() {
                return vm.odecHighchartsData;
            }, init);

            scope.$on('$destroy', function() {
                dataWatcher();
            });



            // private methods
            function init(newData) {
                // in case the data is null exit
                if (!newData) {
                    return;
                }

                var opciones = vm.odecHighchartsConfig;

                // add data
                opciones.series = vm.odecHighchartsData && vm.odecHighchartsData.length > 0 ?
                    vm.odecHighchartsData :
                    vm.odecHighchartsConfig.series;

                // add categories
                opciones.xAxis = opciones.xAxis || {};
                opciones.xAxis.categories = vm.odecHighchartsCategories && vm.odecHighchartsCategories.length > 0 ?
                    vm.odecHighchartsCategories :
                    vm.odecHighchartsConfig.categories;

                // get id for chart from parent element
                opciones.chart = opciones.chart || {};
                opciones.chart.renderTo = element.attr('id');

                // set events                            
                if (angular.isDefined(attrs.odecHighchartsOnClick)) {
                    opciones.plotOptions = opciones.plotOptions || {};
                    opciones.plotOptions.series = opciones.plotOptions.series || {};
                    opciones.plotOptions.series.point = opciones.plotOptions.series.point || {};
                    opciones.plotOptions.series.point.events = {
                        click: angular.isDefined(attrs.odecHighchartsOnClick) && onClick
                    };
                }

                // fix responsive bug: need that container has own width and highcharts-container
                // to be width:100%
                element.attr('style','display:block;width:100%');
                //console.log('Creating chart:' + element.attr('id') + ' -> width: ' + element.width());
                chart = new Highcharts.Chart(opciones);
                reflow();

            }

            function reflow() {
                $timeout(function() {
                    chart.reflow();
                }, TIMEOUT_REFLOW);
            }

            function onClick(event) {
                vm.odecHighchartsOnClick({event:event});
            }
        }
    }
    /* @ngInject */
    function odecHighchartsController() {
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('odecFilter', odecFilter);

    /** @ngInject */
    function odecFilter($rootScope, filterService, errorHandlerService,$log) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecFilter/odecFilter.html',
            bindToController: true,
            controller: odecFilterController,
            controllerAs: 'odecFilter',
            link: link,
            restrict: 'EA',
            scope: {
                odecFilterData: '<',
                hideFilterBar: '<',
                preApplyFilter:'<'
            }
        };
        return directive;

        function link(scope, _element, _attrs) {
            var vm = scope.odecFilter;
            var watcherUpdate, watcherAsyncFirst, treeWatchersOnChange, openWatcher,watcherDoUpdate;
            var eventList;

            vm.displayer;

            /** listeners */

            // watch for filter updates            
            watcherDoUpdate = $rootScope.$on('filter:do:update', function() {
                // allow to do filter update from outside the component without clicking the button
                // do it without emiting apply or it loops
                return vm.applyFilter(false);
            });
            watcherUpdate = $rootScope.$on('filter:update', updateFilter);
            openWatcher = $rootScope.$on('filter:open', function(_event,value){
                vm.opened = value;
            });
            watcherAsyncFirst = scope.$watch('odecFilter.odecFilterData', watchFilter);

            scope.$on('$destroy', function () {
                destroyAllWatchers();
                watcherUpdate();
                watcherAsyncFirst();
                openWatcher();
                watcherDoUpdate();
            });

            function destroyAllWatchers() {
                $log.warn('destroying watcher', treeWatchersOnChange && treeWatchersOnChange.length);

                _.each(treeWatchersOnChange, function (item) {
                    item();
                });
            }

            function getEventList(filterData) {
                return _.chain(filterData)
                    .map('data')
                    .flatten()
                    .map(function (item) {
                        return {
                            type: item.type,
                            eventName: item.eventName
                        };
                    })
                    .uniqBy('eventName')
                    .value();
            }

            function createDataWatchers(eventList) {

                return _.chain(eventList).map(function (item) {
                    //console.warn('register Watchers', item.eventId);
                    var dataWatcher =  $rootScope.$on(item.type + ':' + item.eventName, function (event, object) {
                        setLoading(true);
                        var eventObject = object;
                        var objectValue = (object && object.element && object.element.value) || (object && object.id);
                        // if we detect the object has the multiple option enabled
                        if (item.type === 'multiple') {
                            var selection =  _.chain(vm.displayer).flatMap('selection').filter({ 'eventName': item.eventName }).value(),
                                selectionIds = [].concat(_.chain(selection).find({ 'eventName': item.eventName }).result('id').value() || []),
                                ids;
                            // When removing...
                            if (object.events.removing) {
                                ids = _.without(selectionIds, objectValue);
                            // When adding...
                            } else {
                                // ID´s as an array
                                if (!alreadyExists(objectValue, selectionIds)) { 
                                    ids = selectionIds.concat(objectValue);
                                }
                            
                            }
                            eventObject = _.extend({}, eventObject, { id: ids });
                        } else if (object.events.removing) {
                            //In case of removing, it is necessary to remove from the previous node selected.
                            var networkObject = _.chain(scope.odecFilter.odecFilterData).flatMap('selection').filter({ 'eventId': item.eventId }).value(),
                                indexSelected = _.chain(networkObject).findIndex({ id: object.id }).value(),
                                previousObject;

                            if (indexSelected > 0) {
                                previousObject = networkObject[indexSelected - 1];
                                eventObject = _.extend({}, eventObject, previousObject);
                            } else {
                                eventObject = _.extend({}, eventObject, { id: null });
                            }



                        }
                        filterService.onChangeCallback.apply(this, Array.prototype.concat(event, eventObject, item.eventName))
                            .then(function () { })
                            .catch(errorHandlerService.callbackError)
                            .finally(function () {
                                setLoading(false);
                            });
                    });
                    return dataWatcher;
                })
                    .value();

            }

            /**
             * Given a new id check whether already
             * exists in our selectedNode
             * 
             * @param {any} id new selected value
             * @param {any} selectedNode string of selected values (separated by commas)
             */
            function alreadyExists(id, selectedNode) {
                // If selectedNode is null means that there is any element selected
                if (!selectedNode) { return false; }
                return selectedNode.indexOf(id) > -1;
            }

            function updateFilter(_event, data) {
                //console.warn('update');

                // in case input was null that means it was synchronous and
                // must update pills with data requested
                // if (data.data) {
                //     vm.pillsCollection = angular.copy(vm.createPills(data.data));
                // }

                setLoading(true);

                var newEventList = getEventList(data.data);
                var newEvents = _.difference(_.map(newEventList, 'eventId'), _.map(eventList, 'eventId'));
                var newEventObjs;

                if (newEvents.length > 0) {
                    newEventObjs = _.filter(newEventList, function (item) {
                        return _.some(newEvents, function (el) { return el === item.eventId; });
                    });

                    treeWatchersOnChange.concat(createDataWatchers(newEventObjs));
                    eventList = eventList.concat(newEventObjs);
                } else if (newEventList.length < eventList.length) {
                    destroyAllWatchers();
                    treeWatchersOnChange = createDataWatchers(newEventList);
                }


                vm.displayer = data.data;
                setLoading(false);
            }

            function watchFilter(newValue) {
                //console.warn('watch');
                if (newValue) {
                    // que events form filter response
                    eventList = getEventList(newValue);

                    // destroy all watchers before registering
                    if (treeWatchersOnChange && treeWatchersOnChange.length > 0) {
                        destroyAllWatchers();
                    }

                    // create watchers for events
                    treeWatchersOnChange = createDataWatchers(eventList);


                    // in case input was null that means it was synchronous and
                    // must update pills with data requested
                    setLoading(true);
                    if (!vm.pillsCollection) {
                        vm.pillsCollection = angular.copy(vm.createPills(newValue));
                    }

                    vm.displayer = newValue;
                    setLoading(false);
                }
            }

            function setLoading(blnValue) {
                vm.loading = blnValue;
            }

        }
    }

    /* @ngInject */
    function odecFilterController($scope, $rootScope, contextVariableService) {
        var vm = this;

        vm.opened = false;
        vm.open = toggleFilterView;
        vm.applyFilter = applyFilter;
        vm.createPills = createPills;
        vm.loading = false;

        /** private methods */

        // toggle filter openness. can pass the value as optional, without parameter is a toggle.
        function toggleFilterView(value) {
            vm.opened = value;
            $rootScope.$emit('filter:open', value);
        }

        function applyFilter(forceEmit) {
            if(vm.preApplyFilter && _.isFunction(vm.preApplyFilter)){
                if(vm.preApplyFilter.bind(null, vm.displayer).apply()){
                    // if undefined, the default is to emit
                    if (angular.isUndefined(forceEmit)) {
                        forceEmit = true;
                    }
                    if (forceEmit) {
                        $scope.$emit('filter:apply', { filter: vm.displayer });
                    }            
                    // on apply create pills
                    vm.pillsCollection = angular.copy(createPills(vm.displayer));
                    toggleFilterView(false);
                }
            }
            else{
                // if undefined, the default is to emit
                if (angular.isUndefined(forceEmit)) {
                    forceEmit = true;
                }

                if (forceEmit) {
                    $scope.$emit('filter:apply', { filter: vm.displayer });
                }            
                // on apply create pills
                vm.pillsCollection = angular.copy(createPills(vm.displayer));
                toggleFilterView(false);
            }
        }

        function createPills(data) {
            return _.chain(data)
                .filter(function(group) {
                    return !group.hide;
                })
                .map('filterInfo')
                .flatten()
                .filter(function (item) {
                    return item;
                })
                .map(function (item) {
                    return {
                        label: item.viewLabel,
                        value: item.text
                    };
                })
                .value();
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecDrawSvg', odecDrawSvg);

    odecDrawSvg.$inject = ['d3', 'uuid','$rootScope'];

    function odecDrawSvg(d3, uuid, $rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecDrawSvgController,
            controllerAs: 'odecDrawSvg',
            link: link,
            restrict: 'EA',
            scope: {
                url:'<',
                image: '<',
                typeImage: '<',
                typeView: '<'
            }
        };
        return directive;

        function link(scope, element, _attrs) {
            var vm = scope.odecDrawSvg;
            vm.uuid = uuid.v4();
            var _uuid = 'odec-draw-svg-'+uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var repaintListener = $rootScope.$on('window.resize', function(){
                var elementSvg = d3.select('#' + d3.select(element).node().attr('id')).node();
                var sizeElemement = elementSvg.getBoundingClientRect(); 
                var svgUpdated = '#' + d3.select(element).node().attr('id') + ' svg';
                d3.select(svgUpdated)
                    .attr('width', sizeElemement && sizeElemement.width)
                    .attr('height', sizeElemement && sizeElemement.height);
            });
  
            //Watchers
            var dataWatcher = scope.$watch(function () {
                return vm;
            }, init);
    
            scope.$on('$destroy', function () {
                repaintListener();
                dataWatcher();
            });

            function init() {
                d3.xml(vm.url+vm.typeView+'/'+vm.image+'.'+vm.typeImage).mimeType("image/svg+xml").get(function (error, xml) {
                    var elementRemove = d3.select('#' + element.attr('id'));
                    elementRemove.select("svg").remove();

                    if (error) throw error;

                    var map = d3.select(xml.documentElement);
                    var svg = d3.select('#' + element.attr('id')).node();
                    if (!svg) {
                        return;
                    }

                    //svg.append(map.node());
                    svg.appendChild(map.node());
                    svg.innerHTML = svg.innerHTML.replace(/\s+/g," ").replace(/(<style.*?<\/style>)/g, "").replace(/(<title.*?<\/title>)/g, "");
                    
                    var sizeSvg = {
                         width: svg.offsetWidth,
                         height: svg.offsetHeight
                    };
                    
                    d3.select('#' + element.attr('id')+ ' svg')
                        .attr('width', sizeSvg.width)
                        .attr('height', sizeSvg.height);
                        //.attr('viewBox', '0 0 ' + sizeSvg.width + ' ' + sizeSvg.height)
                        //.attr('preserveAspectRatio','xMidYMid meet')
                        //.attr('transform','translate('+sizeSvg.width/2+','+sizeSvg.height/2+')');

                    /*d3.select('.svg-'+vm.uuid+ ' svg path')
                        .attr('transform','translate('+sizeSvg.width/4+',0)');*/
                });
            }
        }
    }
    /* @ngInject */
    function odecDrawSvgController() {
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecDrawMaps', odecDrawMaps);

  odecDrawMaps.$inject = ['d3', 'odecD3Service'];

  function odecDrawMaps(d3, odecD3Service) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/odecDrawMaps/odecDrawMaps.html',
      bindToController: true,
      controller: odecDrawMapsController,
      controllerAs: 'odecDrawMaps',
      link: link,
      restrict: 'EA',
      scope: {
        countrySelected: '<',
        fnClick: '<'
      }
    };
    return directive;

    function link(scope, _element, _attrs) {

      var vm = scope.odecDrawMaps;
      var animation = true,
        durationMap = 300,
        duration = 1500,
        durationHover = 300;

      var colorPaths = '#BCC2DD';
      var strokeMap = '#616ea9';
      init();

      function init() {
        drawMap();
      }

      function drawMap() {
        var elementRemove = d3.select('.world-map');
        elementRemove.select('svg').remove();

        d3.xml("assets/images/map.svg").mimeType("image/svg+xml").get(function (error, xml) {
          if (error) throw error;

          var map = d3.select(xml.documentElement);
          prepareMapBefore(map);
          var svg = d3.select('.world-map').node();
          if (!svg) {
            return;
          }

          svg.appendChild(map.node());

          var sizeMap = {
            width: svg.offsetWidth,
            height: svg.offsetHeight
          };

          d3.select('svg')
            .attr('width', sizeMap.width)
            .attr('height', sizeMap.height);
        });
      }

      function applyAction(group) {
        group
          .attr('cursor', 'pointer')
          .on('click', function () {
            var isoGroup = d3.select(this).attr('id');
            var isoCountryArray = isoGroup && isoGroup.split('-');
            var isoCountry = isoCountryArray && isoCountryArray[1];
            vm.fnClick(isoCountry);
          })
          .on('mouseenter', function () {
            var isoGroup = d3.select(this).attr('id');
            d3.select('#' + isoGroup + ' path')
              .transition()
              .duration(durationHover)
              .attr('opacity', 0.75);

            d3.select('#' + isoGroup + ' .pin')
              .transition()
              .duration(durationHover)
              .attr('opacity', 0.75);

          })
          .on('mouseleave', function () {
            var isoGroup = d3.select(this).attr('id');
            d3.select('#' + isoGroup + ' path')
              .transition()
              .duration(durationHover)
              .attr('opacity', 1);

            d3.select('#' + isoGroup + ' .pin')
              .transition()
              .duration(durationHover)
              .attr('opacity', 1);
          });

      }

      // function hideAllPins(_map) {
      //   _map.selectAll('.pin')
      //     .each(function (_d) {
      //       d3.select(this)
      //         .attr('opacity', 0);
      //     });
      // }

      function animationCountry(_groupCountrySelected, index) {
        _groupCountrySelected
          .select('path')
          .attr('fill', 'transparent')
          .transition()
          .duration(durationHover / 4)
          .delay(function () {
            return (durationHover / 5) * index;
          })
          .attr('fill', colorPaths)
          .on('end', function () {
            applyAction(_groupCountrySelected);
          });
      }

      function prepareMapBefore(_map) {
        _map
          .selectAll('.pin')
          .attr('opacity', 0);

        _map.selectAll('path')
          .attr('opacity', 1)
          .each(function (_d, i) {
            var linePath = d3.select(this);

            d3.select(this)
              .attr('fill', 'white')
              .attr('stroke', strokeMap)
              .attr('stroke-width', '0.5px')
              .transition()
              .delay(function () {
                return animation ? i : 0;
              })
              .ease(d3.easeExp)
              .duration(animation ? duration : 0);


            odecD3Service.animatePath(linePath, durationMap)
              .on('end', function () {
                _map
                  .selectAll('.pin')
                  .transition()
                  .duration(durationHover / 2)
                  .delay(function (_d, index) {
                    return (durationHover / 3) * index;
                  })
                  .attr('opacity', 1);

                _.each(vm.countrySelected, function (country, index) {
                  var groupCountrySelected = _map.select('#g-' + country);
                  animationCountry(groupCountrySelected, index);
                });
              });
          });
      }
    }
  }
  /* @ngInject */
  function odecDrawMapsController() {
  }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecDatatable', odecDatatable);

    /** @ngInject */
    function odecDatatable() {
        var directive = {
            restrict: 'EA',
            scope: {
                odecDatatableData: '=',
                odecDatatableColumns: '=',
                odecDatatableColumnDefs: '=',
                odecDatatableSort: '=',
                odecDatatableLanguageUrl: '@',
                odecDatatableSearchText:'=',
                odecDatatableAllowRowClick:'<',
                odecDatatableAllowCellClick:'<',
                odecDatatableTableState: '<',
                odecDatatableNotDestroy: '<'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el,attr) {
            var options,
                tabla,
                id,
                event,
                saveState;
            
            id = attr.id;

            if (id) {
                event = 'datatables:' + id + ':';
            } else {
                event = 'datatables:';
            }
            
            /** private methods */

            // datatables initialization, prepares config and calls plugin
            function init(newData) {
                if (tabla && !scope.odecDatatableNotDestroy) {
                    destroy();
                }

                // only initiate if newData is not null
                if (!newData || !newData.length > 0) {return;}

                options = {};

                // set i18
                options.language = {
                    url: scope.odecDatatableLanguageUrl
                };

                // set data rows only if is defined
                if (angular.isDefined(scope.odecDatatableData)) {
                    options.data = scope.odecDatatableData;
                }

                // set data columns only if defined
                if (angular.isDefined(scope.odecDatatableColumns)) {
                    options.columns = scope.odecDatatableColumns;
                }

                // set column defs only if defined
                if (angular.isDefined(scope.odecDatatableColumnDefs)) {
                    options.columnDefs = scope.odecDatatableColumnDefs;
                }

                // if passed some sorting use it else will order by default using first column
                if (angular.isDefined(scope.odecDatatableSort)) {
                    options.aaSorting = scope.odecDatatableSort;
                } else {
                    options.aaSorting = [];
                }

                //Table state (columns sorting, search, pagination, ...)
                saveState = angular.isDefined(scope.odecDatatableTableState);

                // destroy table each time is update otherwise won't update
                options.destroy = true;

                // processing overlay during process
                options.bProcessing = true;

                // defer drawing, this avoids freezing when to much rows
                options.bDeferRender = true;

                // hide length change combo
                options.bLengthChange = false;

                // type of paging is simple numbers
                options.pagingType = 'simple_numbers';

                // in case the table don't fit x-space there will be a scrollbar
                options.sScrollX = true;

                //Saving the table state?
                options.stateSave = saveState;

                /**
                 * We emit the current table state
                 * 
                 * !! This will be call only if 'stateSave' value is true.
                 */
                options.stateSaveCallback = function (_settings, data) {
                    scope.$emit('datatables:saveState', data);
                };

                /**
                 * Return the previous saved state
                 * 
                 * !! This will be call only if 'stateSave' value is true.
                 */
                options.stateLoadCallback = function (_settings) {
                    return scope.odecDatatableTableState;
                };


                if (options.data && options.data.length > 0) {
                    // inititalize datatables just in case there is data
                    tabla = angular.element(el).DataTable(options);
                }

                if (scope.odecDatatableAllowCellClick) {
                    tabla.off( 'click' ).on( 'click', 'td', function () {
                        var cell = tabla.cell(this);
                        var index = tabla.cell(this).index();
                        scope.$emit(event + 'cell',{cell:cell, index:index});
                    });
                }
                
                if (scope.odecDatatableAllowRowClick) {
                    tabla.on( 'click', 'td', function () {
                        var row = tabla.row(this).data();
                        scope.$emit(event + 'row',{row:row});
                    });
                }
            }

            // metod on destroy
            function destroy() {
                if (tabla) {
                    tabla.destroy();
                    angular.element(el).empty();
                }
            }

            // method used to externalize search
            function searchGlobal(newData, oldData) {
                if (newData !== oldData) {
                    tabla.search(
                        newData,
                        false, //Regex
                        false //Smart search
                    ).draw();
                }
            }

            /** listeners */

            // watch change on data input
            var datawatch = scope.$watch('odecDatatableData', init);

            // watch change on search input
            var seachTextWatch = scope.$watch('odecDatatableSearchText', searchGlobal);

            // on destroy listener
            scope.$on('$destroy', function() {
                destroy();
                datawatch();
                seachTextWatch();
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3BubbleLanding', odecD3BubbleLanding);

    odecD3BubbleLanding.$inject = ['uuid', '$rootScope', 'd3', 'odecD3Service', '$filter'];
    function odecD3BubbleLanding(uuid, $rootScope, d3, odecD3Service, $filter) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecD3BubbleLandingController,
            controllerAs: 'odecD3BubbleLanding',
            link: link,
            restrict: 'EA',
            scope: {
                textBubble: '<',
                iconBubble: '<',
                indexBubble: '<',
                fnBubble: '<',
                paramsUrlBubble:'<',
                propsBubble: '<',
                isModal:'<',
                isHistoric:'<',
                isGroup: '<',
                groupSource: '<'
            }
        };
        return directive;

        function link(scope, element, _attrs) {
            var vm = scope.odecD3BubbleLanding;
            var _uuid = 'odec-d3-bubble-landing-' + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));


            /**Animations */
            var interval = 50;
            var delay = 50;
            var duration = 500;

            var margin = {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0
            };
            var radiousCircle = 0;
            var vw = element.innerWidth();
            var vh = element.innerHeight();
            var width = vw - margin.left - margin.right;
            var height = vh - margin.top - margin.bottom;

            var repaintListener = $rootScope.$on('window.resize', update);

            //Watchers
            var dataWatcher = scope.$watch(function () {
                return vm;
            }, update);

            scope.$on('$destroy', function () {
                repaintListener();
                dataWatcher();
            });

            function update() {
                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove();

                var bubbleLanding = d3.select('#' + element.attr('id'));

                vw = element.innerWidth();
                vh = element.innerHeight();
                width = vw - margin.left - margin.right;
                height = vh - margin.top - margin.bottom;

                // Calcular radio basado en maxBubbles si está definido
                if (vm.propsBubble && vm.propsBubble.maxBubbles) {
                    // Usar el viewport como referencia para garantizar uniformidad entre vistas
                    // El radio se basa SOLO en el ancho para que todas las burbujas sean iguales
                    var containerWidth = window.innerWidth * 0.95;
                    var bubbleWidth = containerWidth / vm.propsBubble.maxBubbles;
                    // Limitar también por la altura de una fila (~21% del viewport para 4 filas + títulos)
                    var maxRowHeight = window.innerHeight * 0.22;
                    radiousCircle = Math.min(bubbleWidth, maxRowHeight) * 0.85;
                } else if (vm.propsBubble && vm.propsBubble.radius) {
                    radiousCircle = vm.propsBubble.radius;
                } else {
                    radiousCircle = height * .9;
                }

                // SVG con padding para que la sombra no se corte
                var shadowPadding = 20;
                var svgSize = radiousCircle + shadowPadding;

                var svg = bubbleLanding.append("svg")
                    .attr('width', svgSize)
                    .attr('height', svgSize)
                    .attr('viewBox', '0 0 ' + svgSize + ' ' + svgSize)
                    .attr('preserveAspectRatio', 'xMidYMid meet')
                    .attr('class', "odec-d3-bubble-landing");

                appendShadowFilterSvg(svg);


                var groupCircle = svg
                    .append('g')
                    .attr('cursor', 'pointer')
                    .on("mouseover", function () {
                        d3.select(this).select('circle')
                            .transition()
                            .duration(150)
                            .attr('r', radiousCircle / 1.92)
                            .attr('opacity',0.75)
                            .attr('stroke-width', 2);
                    })
                    .on("mouseout", function () {
                        d3.select(this).select('circle')
                            .transition()
                            .duration(50)
                            .attr('r', radiousCircle / 2)
                            .attr('opacity',1)
                            .attr('stroke-width', 1);
                    })
                    .on('click', function () {
                        if(vm.isModal || vm.isGroup){
                            $rootScope.$emit('bubbleLandingClicked', vm);
                        }
                        else{
                            if(angular.isFunction(vm.fnBubble)){
                                return vm.fnBubble(vm.paramsUrlBubble);
                            }
                            return;
                        }
                    })
                    .attr('opacity', 0)
                    ;

                groupCircle
                    .append('circle')
                    .attr("filter", "url(#drop-shadow)")
                    .attr('r', radiousCircle / 2)
                    .attr('cx', svgSize / 2)
                    .attr('cy', svgSize / 2)
                    .attr('fill', (vm.propsBubble && vm.propsBubble.backgroundBubble) || 'white')
                    .attr("opacity", 1);

                groupCircle
                    .append('image')
                    .attr("xlink:href", "assets/images/landing-icons/" + vm.iconBubble + ".svg")
                    .attr('width', radiousCircle / 4)
                    .attr('height', radiousCircle / 4)
                    .attr('x', svgSize / 2 - radiousCircle / 8)
                    .attr('y', svgSize / 2 - radiousCircle / 4)
                    .attr("opacity", 1);


                var fontSize = odecD3Service.resizeText(70, svgSize);
                groupCircle
                    .append('text')
                    .attr('x', svgSize / 2)
                    .attr('y', svgSize / 2 + radiousCircle * 0.1)
                    .attr('font-weight', 700)
                    .attr('text-anchor', 'middle')
                    .attr('fill', (vm.propsBubble && vm.propsBubble.colorBubble) || 'black')
                    .text($filter('translationWithPrefix')(vm.textBubble))
                    .each(function () {
                        d3.select(this)
                            .call(odecD3Service.wrapText, radiousCircle * 0.75, "middle", fontSize, 3);
                    })
                    .attr("opacity", 1);

                groupCircle
                    .attr('opacity', 0)
                    .transition()
                    .delay(function () {
                        return vm.indexBubble * interval + delay;
                    })
                    .duration(duration)
                    .attr('opacity', 1);
            }

            function appendShadowFilterSvg(svg) {
                var defs = svg.append("defs");
                var filter = defs.append("filter")
                    .attr("id", "drop-shadow")
                    .attr("x", "-50%")
                    .attr("y", "-50%")
                    .attr("width", "200%")
                    .attr("height", "200%");

                // SourceAlpha refers to opacity of graphic that this filter will be applied to
                // convolve that with a Gaussian with standard deviation 3 and store result
                // in blur
                filter.append("feGaussianBlur")
                    .attr("in", "SourceAlpha")
                    .attr("stdDeviation", 3)
                    .attr("result", "blur");

                // translate output of Gaussian blur to the right and downwards with 2px
                // store result in offsetBlur
                filter.append("feOffset")
                    .attr("in", "blur")
                    .attr("dx", 2)
                    .attr("dy", 4)
                    .attr("result", "offsetBlur");
                // overlay original SourceGraphic over translated blurred opacity by using
                // feMerge filter. Order of specifying inputs is important!
                var feMerge = filter.append("feMerge");
                feMerge.append("feMergeNode")
                    .attr("in", "offsetBlur");
                feMerge.append("feMergeNode")
                    .attr("in", "SourceGraphic");
            }
        }
    }
    /* @ngInject */
    function odecD3BubbleLandingController() {

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecCoverModule', odecCoverModule);

    odecCoverModule.$inject = [];
    function odecCoverModule() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/odecCoverModule/odecCoverModule.html',
            bindToController: true,
            controller: odecCoverModuleController,
            controllerAs: 'odecCoverModule',
            link: link,
            restrict: 'EA',
            scope: {
                coverText:'<',
                coverIcon:'<',
                coverFilter:'<'
            }
        };
        return directive;
        
        function link(_scope, _element, _attrs) {
        }
    }
    /* @ngInject */
    function odecCoverModuleController (filterHelperService) {
        var vm  = this;

        vm.getInfoSelected = getInfoSelected;

        function getInfoSelected(name){
            return filterHelperService.getFilterElementSelected(vm.coverFilter, name, 'text');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecButtonExpandable', odecButtonExpandable);

    //odecButtonExpandable.$inject = ['dependency1'];
    function odecButtonExpandable() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecButtonExpandable/odecButtonExpandable.html',
            bindToController: true,
            controller: odecButtonExpandableController,
            controllerAs: 'odecButtonExpandable',
            link: link,
            restrict: 'EA',
            transclude:true,
            scope: {
                odecButtonExpandableOpened:'=?',
                odecButtonExpandableClosable:'<?'
            }
        };
        return directive;
        
        function link(scope, _element, _attrs) {
            var vm = scope.odecButtonExpandable;
            vm.odecButtonExpandableOpened = angular.isUndefined(vm.odecButtonExpandableOpened)? false:vm.odecButtonExpandableOpened; 
            vm.odecButtonExpandableClosable = angular.isUndefined(vm.odecButtonExpandableClosable)? true:vm.odecButtonExpandableClosable;
        }
    }
    /* @ngInject */
    function odecButtonExpandableController () {
        var vm = this;
        vm.toggleOpen = toggleOpen;

        /** private methods */
        function toggleOpen() {
            
            if (!vm.odecButtonExpandableClosable) {
                return;
            }

            vm.odecButtonExpandableOpened = !vm.odecButtonExpandableOpened;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecCopyToClipboard', odecCopyToClipboard);

    /** @ngInject */
    function odecCopyToClipboard(toastr, $document, $filter) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            templateUrl: 'app/components/odecCopyToClipboard/odecCopyToClipboard.html',
            controller: odecCopyToClipboardController,
            controllerAs: 'odecCopyToClipboard',
            link: link,
            restrict: 'EA',
            scope: {   
                odecCopyToClipboardData: '<',
                odecCopyToClipboardFormatFn: '<'
            }
        };
        return directive;
        
        function link(scope, _element, _attrs) {
            var vm = scope.odecCopyToClipboard;
            vm.copyToClipboard = copyToClipboard;
            vm.copyText = $filter('translationWithPrefix')('COPY_DATA');

            function copyToClipboard() {
                var formattedData = vm.odecCopyToClipboardFormatFn(vm.odecCopyToClipboardData);
                var el = $document[0].createElement('textarea');  // Create a <textarea> element
                el.value = formattedData;   
                el.textContent = formattedData;                              // Set its value to the string that you want copied
                el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
                el.style.position = 'absolute';
                el.style.left = '-9999px';                      // Move outside the screen to make it invisible
                $document[0].body.appendChild(el);                  // Append the <textarea> element to the HTML document
                var selected = $document[0].getSelection().rangeCount > 0 ? $document[0].getSelection().getRangeAt(0) : false;     // Store selection if found or mark as false to know no selection existed before
                el.select();                                    // Select the <textarea> content
                $document[0].execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
                $document[0].body.removeChild(el);                  // Remove the <textarea> element
                if (selected) {                                 // If a selection existed before copying
                    $document[0].getSelection().removeAllRanges();    // Unselect everything on the HTML document
                    $document[0].getSelection().addRange(selected);   // Restore the original selection
                }
                toastr.success($filter('translationWithPrefix')('COPIED_DATA_SUCCESFULLY'));
            }            
        }
    }
    
    /** @ngInject */
    function odecCopyToClipboardController () {
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecBreadcrumb', odecBreadcrumb);

    /* @ngInject */
    function odecBreadcrumb() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecBreadcrumb/odecBreadcrumb.html',
            bindToController: true,
            controller: odecBreadcrumbController,
            controllerAs: 'odecBreadcrumb',
            link: link,
            restrict: 'EA',
            scope: {}
        };

        return directive;

        function link(scope, _element, _attrs, ctrl) {
            var vm = scope.odecBreadcrumb;
            vm.odecBreadcrumb = ctrl;
        }
    }
    /* @ngInject */
    function odecBreadcrumbController($rootScope, $scope, $state) {
        var vm = this;
        var listener;
        vm.breadcrumbActive = {};

        vm.breadcrumbActive = $state.current.breadcrumb;
        vm.breadcrumbParams = $state.params;

        listener = $rootScope.$on('breadcrumb:toState', function (_events, args) {
            vm.breadcrumbActive = args.toState.breadcrumb;
        });

        $scope.$on('$destroy', function () {
            listener();
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('numberCounter', numberCounter);

    numberCounter.$inject = ['d3'];
    function numberCounter(d3) {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;
        
        function link(_scope, element, attrs) {
            var formatDecimal = d3.format(".0f");
            var animation =  attrs && attrs.animated === 'true' ? true : false;
            var duration = 1800;
            if(!_.isNaN(parseInt(attrs.cellvalue)) && (parseInt(attrs.cellvalue) > 0)){
                d3.select(element && element[0])
                    .text(0)
                    .transition()
                    .duration(animation ? duration : 0)
                    .tween('text', function () {
                        var number = attrs && attrs.cellvalue / 100;
                        var that = d3.select(element[0]),
                            i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
                        return function (t) {
                            that.text(formatDecimal(i(t)));
                        };
                    })
                    .style('color', attrs.colorcell)
                    .on('end', function(){
                        if(attrs.showPercent){
                            d3.select(this)
                                .append('tspan')
                                .text('%')
                                .attr('opacity', 0)
                                .attr('y', -5)
                                .transition()
                                .attr('opacity', 1);
                        }
                        
                    });
                    
                    
            }
            else{
                d3.select(element && element[0])
                    .text('');
            }
            
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLayoutUi', odecLayoutUi);

    //odecLayoutUi.$inject = ['dependency1'];
    function odecLayoutUi() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/layoutUi.html',
            bindToController: true,
            controller: odecLayoutUiController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            transclude:true,
            replace:true,
            scope: {
                opened:'='                
            }
        };
        return directive;
        
        function link() {           

        }
    }
     /* @ngInject */
    function odecLayoutUiController () {
        
    }    
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('odecD3Service', odecD3Service);

  odecD3Service.$inject = ['d3'];

  function odecD3Service(d3) {
    var service = {
      wrapText: wrapText,
      ellipsis: ellipsis,
      resizeText: resizeText,
      animatePath:animatePath,
      getScaleColor:getScaleColor,
      rounded_rect:rounded_rect,
      rightRoundedRect:rightRoundedRect,
      leftRoundedRect:leftRoundedRect
    };

    return service;

    //for ellipsis text
    function ellipsis(width) {
      var widthBlackBox = angular.isDefined(width) && width > 0 ? width : 150;
      var self = d3.select(this),
        textLength = self.node().getComputedTextLength(),
        text = self.text();
      while (textLength > (widthBlackBox - 25) && text.length > 0) {
        text = text.slice(0, -1);
        self.text(text + '...');
        textLength = self.node().getComputedTextLength();
      }
    }

    // for wrapping labels
    function wrapText(text, width, textAnchor, fontSize, maxLines) {
      maxLines = maxLines || 2;
      textAnchor = textAnchor ? textAnchor : "start";
      /*Wrapping text*/
      text.each(function () {
        var text = d3.select(this)
          .attr("text-anchor", textAnchor)
          .attr('font-size', fontSize || 8),
          words = text.text().split(/\s+/).reverse(),
          word = words.pop(),
          line = [],
          lineNumber = 0,
          lineHeight = 1, // ems
          x = text.attr('x'),
          y = text.attr('y'),
          dy = 0, //parseFloat(text.attr('dy')),
          tspan = text.text(null)
          .append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dy', dy + 'em');
        while (word) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width && line.length > 1) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            tspan = text.append('tspan')
              .attr('x', x)
              .attr('y', y)

              //.attr('font-weight', 'bold')
              .attr('dy', ++lineNumber * lineHeight + dy + 'em')
              .text(word);
          }
          word = words.pop();
        }
      });
      /**Ellisis text */
      text.each(function () {
        var tspanAll = _.chain(d3.select(this).selectAll('tspan')._groups[0]).value();

        d3.select(this)
          .selectAll('tspan')
          .remove();

        d3.select(this)
          .selectAll('tspan')
          .data(tspanAll)
          .enter()
          .append('tspan')
          .attr('x', function (d) {
            return d && d.attributes && d.attributes.x && d.attributes.x.value || 0;
          })
          .attr('y', function (d) {
            return d && d.attributes && d.attributes.y && d.attributes.y.value || 0;
          })
          .attr('dy', function (d) {
            return d && d.attributes && d.attributes.dy && d.attributes.dy.value || 0;
          })
          .text(function (d, i) {
            if (i === (maxLines - 1)) {
              var text = d3.select(this).text(d.textContent);
              if (width >= (text.node().getBoundingClientRect().width) && tspanAll.length <= maxLines){
                return d.textContent;
              }
              else{
                return d.textContent.slice(0, (d.textContent.length - 3)) + '...';
              } 
            }
            else{
              if(i < (maxLines - 1)){
                return d.textContent;
              }
            }
          });
      });
    }

    function resizeText(value, width) {
      return value / 100 * (width * 0.007) + "rem";
    }

    function animatePath(path, time){
      // Total lenght to animate
      var totalLength = d3.max(path.nodes(), function(d) { return d.getTotalLength(); });
      return path
          .attr('stroke-dasharray', totalLength + ' ' + totalLength)
          .attr('stroke-dashoffset', totalLength)
          .transition()
              .duration(time || 2000)
              .attr('stroke-dashoffset', 0);
    }

    function getScaleColor(initStars, endStars){
      return d3.scaleQuantize()
        .range(['#901819','#98291a','#a0371b','#a8441b','#b0501b','#b75c1b','#bf681b','#c7741a','#ce7f19','#d68b18','#de9716','#e5a214','#ecae10','#f4ba0b','#fbc604','#f7c806','#e8c111','#daba17','#cbb31c','#bcac1f','#ada522','#9f9e25','#909727','#819028','#738929','#64812a','#547a2b','#44732c','#336c2c','#1d652c'])     
        .domain([initStars, endStars]);
    }

    //Round all corners paths
    function rounded_rect(x, y, w, h, r, tl, tr, bl, br) {
      var retval;
      retval  = "M" + (x + r) + "," + y;
      retval += "h" + (w - 2*r);
      if (tr) { retval += "a" + r + "," + r + " 0 0 1 " + r + "," + r; }
      else { retval += "h" + r; retval += "v" + r; }
      retval += "v" + (h - 2*r);
      if (br) { retval += "a" + r + "," + r + " 0 0 1 " + -r + "," + r; }
      else { retval += "v" + r; retval += "h" + -r; }
      retval += "h" + (2*r - w);
      if (bl) { retval += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r; }
      else { retval += "h" + -r; retval += "v" + -r; }
      retval += "v" + (2*r - h);
      if (tl) { retval += "a" + r + "," + r + " 0 0 1 " + r + "," + -r; }
      else { retval += "v" + -r; retval += "h" + r; }
      retval += "z";
      return retval;
    }

    //Round right corners paths
    function rightRoundedRect(x, y, width, height, radius) {
      return "M" + x + "," + y
           + "h" + (width - radius)
           + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius
           + "v" + (height - 2 * radius)
           + "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + radius
           + "h" + (radius - width)
           + "z";
    }

    //Round left corners paths
    function leftRoundedRect(x, y, width, height, radius) {
      return "M" + (x + radius) + "," + y
           + "h" + (width - radius)
           + "v" + height
           + "h" + (radius - width)
           + "a" + radius + "," + radius + " 0 0 1 " + (-radius) + "," + (-radius)
           + "v" + (2 * radius - height)
           + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + (-radius)
           + "z";
    } 
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout9Service', layout9Service);

  layout9Service.$inject = ['$http', 'filterHelperService', '$q', '$filter', 'stateManagerService', '$stateParams', 'configurationLoaderService'];
  function layout9Service($http, filterHelperService, $q, $filter, stateManagerService, $stateParams, configurationLoaderService) {
    var service = {
      getW1: getW1,
      getCategories:getCategories,
      getConfigChart: getConfigChart,
      getChartData: getChartData
    };

    return service;

    function getW1() {
      return getWidgetImages('PUIG-25');
    }

    function getWidgetImages(dataSource, grouping){
      var brand = filterHelperService.getPropertySelected('brand');
      var metric = filterHelperService.getPropertySelected('metric');
      var market = filterHelperService.getPropertySelected('market');
      var filterArray = [];

      _.each(brand, function(item){
        var brand = _.replace(item,market,'');
        filterArray.push('base'+metric+brand);
        filterArray.push(metric+brand);
      });

      var filterLayout = stateManagerService.getState('filterLayout');
      var elementsF16All = _.chain(filterLayout).find({ 'name': 'F28' }).result('content').find({ 'id': filterHelperService.getPropertySelected('year') }).result('children').value();
      var indexPeriodSelected = _.findIndex(elementsF16All, { 'id': filterHelperService.getPropertySelected('period') });
      //Periodos hacia atras máximos
      var fixedPeriods = 24;
      var elementsF16Next = [].concat(_.chain(elementsF16All).slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods).map('id').value());

      var filters = {
        F16: elementsF16Next,
        '#GROUP1':[
          {FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country'))},
          {CRITERIA: [filterHelperService.getPropertySelected('criteria')]}
        ]
      };

      var newFilter = {};
      newFilter[metric] = filterArray;
      filters['F29I'] = [newFilter];
      

      return getData(dataSource, '', filters, grouping);
    }

    function getCategories(data){
      return _.chain(data).map(function(item){
        return $filter('uppercase')(item && item.text);
      }).value();
    }

    function getChartData(data) {
      var colorSignification = _.chain(configurationLoaderService.getConfig()).result('colors').value();
      return _.chain(data)
        .map(function (item, _index) {
          return {
            animation: $stateParams && $stateParams.web === 'true' ? true : false,
            data: _.map(item.values, function (itemValues, index) {
              var x = {
                y: '',
                dataLabels: {
                  color: _.chain(colorSignification).find({ 'type': item && item.types[index]}).result('color').value()
                }
              };
              x.y = itemValues;
              return x;
            }),
            name: $filter('uppercase')(item && item.text),
            marker: {
              symbol: 'circle',
              fillColor: 'white',
              lineColor: null,
              lineWidth: 2
            },
            visible: true
          };
        })
        .value();
    }

    function getConfigChart(max, min) {
      return {
        chart: {
          style: {
            fontFamily: 'Montserrat'
          },
          renderTo: null,
          type: 'line',
          marginTop:50,
          marginRight: 50/*,
                events: {
                    load: adjustLegend,
                    redraw: adjustLegend
                }*/
        },
        colors: _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'countryColors' }).result('color').map('value').value(),
        title: {
          text: ''
        },
        subtitle: {
          text: null
        },
        xAxis: {
          labels: {
            formatter: function () {
              return this.value;
            }
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          gridLineWidth: 1,
          lineWidth: 0,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3
        },
        yAxis: [{
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          //lineWidth:1,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          showEmpty: true
          //tickInterval: range
        },
        {
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dot',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          //lineWidth:1,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          opposite: true,
          showEmpty: true
          //tickInterval: range
        }],
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                // position odd show label... 
                /*if(this.point.series.index % 2 === 0){
                    if (this.point.index % 2 === 0) {
                        return this.y.toFixed(fixedPrecision);
                    }
                }
                else{
                    if (this.point.index % 2 !== 0) {
                        return this.y.toFixed(fixedPrecision);
                    }
                }*/
                return this && this.y && this.y.toFixed(0);
              },
              style:{
                fontWeight:'bold',
                textOutline: "0px contrast"
              }
            },
            enableMouseTracking: true
          },
          column: {
            events: { //Bloquear evento click sobre la serie de la columna. En este caso es la de COUNTRY.
              legendItemClick: function () {
                return false;
              }
            }
          },
          series: {
            lineWidth: 1,
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 3
            },
            states: {
              inactive: {
                opacity: 1
              }
            }
          }
        },
        legend: {
          enabled: true,
          symbolWidth: 40
        },
        tooltip: {
          enabled: true,
          shared: true,
          useHTML: true,
          backgroundColor:'white',
          crosshairs: true,
          formatter: function () {
            var divTitle = '<div class="bold--700 text-center">'+this.x+'</div>';
            var divBrands = '<div class="">';
            _.each(this.points, function(item){
              var brandTooltip = '<p class="" style="color:'+(item && item.point && item.point.color)+'"><i class="icon-size-sm icon-circle-thin bold--700 margin-right--0_5 margin-left--0_5"></i>'+$filter('uppercase')(item && item.series && item.series.name)+':'+(item && item.y && item.y.toFixed(0))+'</p>';
              divBrands += brandTooltip;
            });
            divBrands += '</div>';
            return divTitle+divBrands;
          }
        },
        series: [],
        credits:{
          enabled:false
        }
      };
    }

    // function hexToRGB(hex, alpha) {
    //   var r = parseInt(hex && hex.slice(1, 3), 16),
    //     g = parseInt(hex && hex.slice(3, 5), 16),
    //     b = parseInt(hex && hex.slice(5, 7), 16);

    //   if (alpha) {
    //     return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    //   } else {
    //     return "rgb(" + r + ", " + g + ", " + b + ")";
    //   }
    // }

    function getData(dataSource, marketSelected, filters){
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        //method: 'GET',
        //url: './data/evolution.json',
        data: {
          datasource: dataSource,
          query: dataSource+marketSelected,
          parameters: {
            $country$: filterHelperService.getPropertySelected('country')
          },
          filters: filters,
          transform: {
            template: 'Signification',
            parameters: {
              groupOn: 'Columns'
            }
          }
        }
      })
      .then(function(data){
        var output = {
          categories:[],
          series:[]
        };
        _.each(data && data.data, function(item){
          var newItem = {
            id:'',
            text:'',
            values:[],
            types:[]
          };
          var dataItem = item && item.values && _.first(item.values);
          newItem.id = dataItem && dataItem.id;
          newItem.text = dataItem && dataItem.text;
          newItem.values = _.map(dataItem && dataItem.values, 'value');
          newItem.types = _.map(dataItem && dataItem.values, 'type');

          var dates = _.map(dataItem && dataItem.values, function(date){
            return {
              id:date && date.id,
              text:date && date.text
            };
          });
          output.categories = [].concat(output.categories, dates);
          output.series.push(newItem);
        }); 
        output.categories = _.uniqBy(output.categories, 'id');
        output.series = filterSeriesWithoutValues(output.series);
        return output;
      })
      .catch(function(){
        return $q.reject([]);
      });
    }

    function filterSeriesWithoutValues(series){
      return _.chain(series).filter(function (serie) {
        if (_.some(serie.values, Number)) {
          return serie;
        }
      }).value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout9', {
                url: '/brandMetricsAcrossBrands?web&jobId',
                breadcrumb: { icon: 'icon-layout-9', label: 'MAIN_HOME_LAYOUT9' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout9/layout9.html',
                        controller: 'Layout9Controller',
                        controllerAs: 'layout9'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout9')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout9 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService','filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    market: reportParams.market,
                    brand: reportParams.brand,
                    criteria: reportParams.criteria,
                    metric: reportParams.metric
                };
                return mainService.getFilterModule('layout9', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout9', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout9Controller', Layout9Controller);

  /** @ngInject */
  function Layout9Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout9Service, uuid, errorHandlerService, filterHelperService) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter: preApplyFilter
    };

    vm.view = {
      loading: false,
      hasData: true,
      chart: {
        id: uuid.v4(),
        categories: [],
        data: [],
        config: {}
      },
      images:{
        data:[],
        typeView:'T',
        typeImages:[]
      }
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: []
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('EVER_BOUGHT_IB')+'</span>. '+$filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('DESIRABILITY_IB')+'</span>. '+$filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('LOVE_IB')+'</span>. '+$filter('translationWithPrefix')('LOVE_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('UNIQUENESS_IB')+'</span>. '+$filter('translationWithPrefix')('UNIQUENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('ADVOCACY_IB')+'</span>. '+$filter('translationWithPrefix')('ADVOCACY_INFO_TEXT_IB')+'</p>'+
        '</div>'+

        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('TOTAL_TBCA_IB')+'</span>. '+$filter('translationWithPrefix')('TOTAL_TBCA_INFO_TEXT_IB')+'</p>'+
        '</div>'+

        '<div>'
      ;

    vm.serviceView = layout9Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      vm.view.images.typeView = filterHelperService.getPropertySelected('market');
      vm.view.images.typeImages = _.map(filterHelperService.getPropertySelected('brand'), function(item){
        var brandImage = item.slice(-2);
        return brandImage === '01' || brandImage === '00'  ? 'svg' : 'png';
      });

      //vm.view.images.type = filterHelperService.getPropertySelected('market') === 'T' ? 'svg' : 'png';
      vm.view.images.data = _.chain(filterHelperService.getPropertySelected('brand')).map(function(item){
        return item && item.replace(vm.view.images.typeView, '');
      }).value();

      layout9Service.getW1()
        .then(function (data) {
          vm.view.chart.data = layout9Service.getChartData(data && data.series);
          vm.view.chart.categories = layout9Service.getCategories(data && data.categories);
          var min = _.chain(vm.view.chart.data).flatMap('data').map('y').min().value();
          var max = _.chain(vm.view.chart.data).flatMap('data').map('y').max().value();
          vm.view.chart.config = layout9Service.getConfigChart(max > 90 ? 100 : max * 1.1, min * 0.95);
          vm.view.hasData = true;
          vm.copyXls.copyToXlsData = vm.view.chart;
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function preApplyFilter(filter) {
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si tengo seleccionado en el filtro de red un COUNTRY.
       */
      var brandFilter = {
        numberSelected: _.chain(filter).find({ 'id': 'brand' }).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({ 'id': 'brand' }).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({ 'id': 'brand' }).result('data').first().result('minSelections').value()
      };

      //El filtro brands no cumple con el numero minimo de selecciones
      if (!checkRange(brandFilter.numberSelected, brandFilter.min, brandFilter.max)) {
        errorHandlerService.callbackWarning.call({ text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_BRANDS_L7') });
        return false;
      }

      return true;
    }

    function checkRange(value, min, max) {
      return value >= min && value <= max ? true : false;
    }

    function copyToXlsFn(data) {
      var columnHeaders = [].concat("", _.chain(data).result('categories').map(function(item){
        return $filter('lowercase')(item);
      }).value());

      var rowData = [columnHeaders];

      _.each(_.chain(data).result('data').value(), function (item) {
        rowData.push([].concat(item.name, _.chain(item.data).map(function(item){
          return item && item.y && $filter('round')(item.y,0);
        }).value()));
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');

    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout8Service', layout8Service);

    layout8Service.$inject = ['$http', 'filterHelperService', '$q'];
    function layout8Service($http, filterHelperService, $q) {
        var service = {
            getW1: getW1,
            getW2: getW2,
            getW3: getW3
        };

        return service;

        function getW1() {
            return $q.all([getWidget('PUIG-23', 'Columns'), getTotalECPrevious('PUIG-23MUES'), getTotalECCurrent('PUIG-23MUES')]);
        }

        function getW2() {
            return $q.all([getWidgetImages('PUIG-24', 'Columns'), getTotalBrandImages('PUIG-24MUES', 'Columns')]);
        }

        function getW3() {
            return $q.all([getWidget('PUIG-22', 'Columns'), getTotal('PUIG-22MUES')]);
        }

        function getTotal(dataSource) {
            var brand = filterHelperService.getPropertySelected('brand');
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f23 = {};
            f23[parentBrand] = brand;

            var filters = {
                F16: filterHelperService.getPropertySelected('period'),
                F23: [f23],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getDataCompact(dataSource, 'AP', filters)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getTotalBrandImages(dataSource, grouping) {
            var countrySelected = filterHelperService.getPropertySelected('country');

            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f20I = 'IM' + countrySelected + brandSelected + parentBrand;

            var filters = {
                F16: filterHelperService.getPropertySelected('period'),
                F20I: [f20I],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, 'AP', filters, grouping)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getWidgetImages(dataSource, grouping) {
            var countrySelected = filterHelperService.getPropertySelected('country');

            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f20I = 'IM' + countrySelected + brandSelected + parentBrand;

            var filters = {
                F16SIG: filterHelperService.getPropertySelected('period'),
                F20I: [f20I],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, '', filters, grouping);
        }

        function getWidget(dataSource, grouping) {
            var marketSelected = filterHelperService.getPropertySelected('market');

            var brand = filterHelperService.getPropertySelected('brand');
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f23 = {};
            f23[parentBrand] = brand;

            var filters = {
                F16SIG: filterHelperService.getPropertySelected('period'),
                F23: [f23],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, marketSelected, filters, grouping);
        }

        function getData(dataSource, marketSelected, filters, grouping) {
            if (filters && filters.F16SIG) {
                filters.F16SIG = filters.F16SIG.sort();
            }
            if (filters && filters.F16) {
                filters.F16 = filters.F16.sort();
            }
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters,
                    transform: {
                        template: 'Signification',
                        parameters: {
                            groupOn: grouping
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }

        function getDataCompact(dataSource, marketSelected, filters) {
            if (filters && filters.F16SIG) {
                filters.F16SIG = filters.F16SIG.sort();
            }
            if (filters && filters.F16) {
                filters.F16 = filters.F16.sort();
            }
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters,
                    transform: {
                        template: "Compact",
                        parameters: {
                            itemsBy: "Rows",
                            filterExpression: "$.[?(@.id =~ /^BASE|TOTAL(.*)$/)]"
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }

        function getTotalECCurrent(dataSource) {
            var market = filterHelperService.getPropertySelected('market');
            var brand, filters;
            if (market === 'T') {
                brand = filterHelperService.getPropertySelected('brand');
                var brandSelected = brand && brand.substr(1);
                var f20I = [
                    { "ADVOF": ["baseADVOF" + brandSelected] },
                    { "ADVOM": ["baseADVOM" + brandSelected] }
                ];

                filters = {
                    F16: [_.chain(filterHelperService.getPropertySelected('period')).sort().last().value()],
                    F20I: f20I,
                    '#GROUP1': [
                        { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                        { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                    ]
                };

                return getDataT(filters)
                    .catch(function () {
                        return $q.when('-');
                    });
            }
            else {
                brand = filterHelperService.getPropertySelected('brand');
                var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
                var f23 = {};
                f23[parentBrand] = brand;

                filters = {
                    F16: [].concat(_.chain(filterHelperService.getPropertySelected('period')).sort().last().value()),
                    F23: [f23],
                    '#GROUP1': [
                        { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                        { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                    ]
                };

                return getData(dataSource, '', filters)
                    .catch(function () {
                        return $q.when('-');
                    });
            }
        }

        function getTotalECPrevious(dataSource) {
            var market = filterHelperService.getPropertySelected('market');
            var brand, filters;
            if (market === 'T') {
                brand = filterHelperService.getPropertySelected('brand');
                var brandSelected = brand && brand.substr(1);
                var f20I = [
                    { "ADVOF": ["baseADVOF" + brandSelected] },
                    { "ADVOM": ["baseADVOM" + brandSelected] }
                ];

                filters = {
                    F16: [_.chain(filterHelperService.getPropertySelected('period')).sort().first().value()],
                    F20I: f20I,
                    '#GROUP1': [
                        { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                        { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                    ]
                };

                return getDataT(filters)
                    .catch(function () {
                        return $q.when('-');
                    });
            }
            else {
                brand = filterHelperService.getPropertySelected('brand');
                var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
                var f23 = {};
                f23[parentBrand] = brand;

                filters = {
                    F16: [].concat(_.chain(filterHelperService.getPropertySelected('period')).sort().first().value()),
                    F23: [f23],
                    '#GROUP1': [
                        { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                        { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                    ]
                };

                return getData(dataSource, '', filters)
                    .catch(function () {
                        return $q.when('-');
                    });
            }
        }

        function getDataT(filters) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: 'PUIG-24MUES',
                    query: 'PUIG-23MUESTOTAL',
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout8', {
                url: '/brandOverviewAcrossPeriods?web&jobId',
                breadcrumb: { icon: 'icon-layout-8', label: 'MAIN_HOME_LAYOUT8' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout8/layout8.html',
                        controller: 'Layout8Controller',
                        controllerAs: 'layout8'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout8')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout8 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    market: reportParams.market,
                    brand: reportParams.brand,
                    criteria: reportParams.criteria
                };
                return mainService.getFilterModule('layout8', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout8', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout8Controller', Layout8Controller);

  /** @ngInject */
  function Layout8Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout8Service, errorHandlerService) {
    var vm = this;
    var listeners;

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter:preApplyFilter
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.serviceView = layout8Service;

    vm.statusWidgets = {
      allLoaded: false,
      widgets: [
        {
          id: 'emotionalConnectionL8',
          value: false
        },
        {
          id: 'brandImageL8',
          value: false
        },
        {
          id: 'purchaseFunnelL8',
          value: false
        }
      ]
    };

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
      destroyListenerCombo();
    });


    function init(args) {
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      createListenersCombo();
    }

    function updateStateWidget(_event, nameWidget) {
      var indexWidget = _.chain(vm.statusWidgets.widgets).findIndex({ 'id': nameWidget }).value();
      vm.statusWidgets.widgets[indexWidget].value = true;
      checkAllWidgetsLoaded();
    }

    function checkAllWidgetsLoaded() {
      var isAllLoaded = _.chain(vm.statusWidgets.widgets).every({ 'value': true }).value();
      if (isAllLoaded) {
        $rootScope.$emit('printReport', true);
      }
    }

    function createListenersCombo() {
      listeners = _.chain(vm.statusWidgets.widgets).map(function (item) {
        var widgetListener = $rootScope.$on(item.id + 'Loaded', updateStateWidget);
        return widgetListener;
      }).value();
    }

    function destroyListenerCombo() {
      _.each(listeners, function (item) {
        item();
      });
    }

    function preApplyFilter(filter){
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si tengo seleccionado en el filtro de red un COUNTRY.
       */
      var periodFilter = {
        numberSelected: _.chain(filter).find({'id':'period'}).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({'id':'period'}).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({'id':'period'}).result('data').first().result('minSelections').value()
      };

      //El filtro periods
      if(!checkRange(periodFilter.numberSelected, periodFilter.min, periodFilter.max)){
        errorHandlerService.callbackWarning.call({text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_PERIODS_L8')});
        return false;
      }

      return true;
    }

    function checkRange(value, min, max){
      return value >= min && value <=max ? true: false;
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout7Service', layout7Service);

    layout7Service.$inject = ['$http', 'filterHelperService', '$q'];
    function layout7Service($http, filterHelperService, $q) {
        var service = {
            getW1: getW1,
            getW2: getW2,
            getW3: getW3
        };

        return service;

        function getW1() {
            return $q.all([getWidget('PUIG-22', 'Columns'), getTotal('PUIG-22MUES')]);

        }

        function getW2() {
            return $q.all([getWidget('PUIG-23', 'Columns'), getTotalEC('PUIG-23MUES')]);
        }

        function getW3() {
            return $q.all([getWidgetImages('PUIG-24', 'Rows'), getTotalBrandImages('PUIG-24MUES', 'Columns')]);
        }

        function getTotal(dataSource) {
            var brand = filterHelperService.getPropertySelected('brand');
            var parentBrand = _.chain(brand).map(function (item) {
                return item.charAt(0) && item.charAt(0).toUpperCase();
            }).uniq().value();
            var f23 = {};
            f23[parentBrand] = brand;

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F23: [f23],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getDataCompact(dataSource, 'AP', filters)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getTotalEC(dataSource) {
            var market = filterHelperService.getPropertySelected('market');
            var brand, filters;
            if (market === 'T') {
                brand = filterHelperService.getPropertySelected('brand');
                var brands = _.chain(brand).map(function (item) {
                    return item && item.substr(1);
                }).value();

                filters = {
                    F16: [filterHelperService.getPropertySelected('period')],
                    F20I: [
                        { "ADVOF": _.map(brands, function (item) { return 'baseADVOF' + item; }) },
                        { "ADVOM": _.map(brands, function (item) { return 'baseADVOM' + item; }) }
                    ],
                    '#GROUP1': [
                        { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                        { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                    ]
                };

                return getDataT(filters, brands && brands.length)
                    .catch(function () {
                        return $q.when('-');
                    });
            }
            else {
                brand = filterHelperService.getPropertySelected('brand');
                var parentBrand = _.chain(brand).map(function (item) {
                    return item.charAt(0) && item.charAt(0).toUpperCase();
                }).uniq().value();
                var f23 = {};
                f23[parentBrand] = brand;

                filters = {
                    F16: [filterHelperService.getPropertySelected('period')],
                    F23: [f23],
                    '#GROUP1': [
                        { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                        { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                    ]
                };

                return getData(dataSource, '', filters, 'Columns')
                    .catch(function () {
                        return $q.when('-');
                    });
            }
        }

        function getTotalBrandImages(dataSource, grouping) {
            var countrySelected = filterHelperService.getPropertySelected('country');

            var brand = filterHelperService.getPropertySelected('brand');
            var images = filterHelperService.getPropertySelected('image');
            var f20I = [];
            _.each(brand, function (item) {
                var brandSelected = item && item.substr(1);
                var parentBrand = item.charAt(0) && item.charAt(0).toUpperCase();
                f20I = f20I.concat('IM' + countrySelected + brandSelected + parentBrand);
            });

            f20I = _.reduce(f20I, function (aggr, item, index) {
                var newFilter = [];
                var obj = {};
                _.each(images, function (imaItem) {
                    newFilter.push('base' + imaItem + brand[index]);
                    newFilter.push(imaItem + brand[index]);
                });
                obj[item] = newFilter;
                aggr.push(obj);
                return aggr;
            }, []);

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F20I: f20I,
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, 'AB' + brand.length, filters, grouping)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getWidgetImages(dataSource, grouping) {
            var countrySelected = filterHelperService.getPropertySelected('country');

            var brand = filterHelperService.getPropertySelected('brand');
            var images = filterHelperService.getPropertySelected('image');
            var f20I = [];
            _.each(brand, function (item) {
                var brandSelected = item && item.substr(1);
                var parentBrand = item.charAt(0) && item.charAt(0).toUpperCase();
                f20I = f20I.concat('IM' + countrySelected + brandSelected + parentBrand);
            });

            f20I = _.reduce(f20I, function (aggr, item, index) {
                var newFilter = [];
                var obj = {};
                _.each(images, function (imaItem) {
                    newFilter.push('base' + imaItem + brand[index]);
                    newFilter.push(imaItem + brand[index]);
                });
                obj[item] = newFilter;
                aggr.push(obj);
                return aggr;
            }, []);

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F20I: f20I,
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, '_' + brand.length + 'MAR', filters, grouping);
        }

        function getWidget(dataSource, grouping) {
            var marketSelected = filterHelperService.getPropertySelected('market');

            var brand = filterHelperService.getPropertySelected('brand');
            var parentBrand = _.chain(brand).map(function (item) {
                return item.charAt(0) && item.charAt(0).toUpperCase();
            }).uniq().value();
            var f23 = {};
            f23[parentBrand] = brand;

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F23: [f23],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, marketSelected, filters, grouping);
        }

        function getData(dataSource, marketSelected, filters, grouping) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters,
                    transform: {
                        template: 'Signification',
                        parameters: {
                            groupOn: grouping
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }

        function getDataCompact(dataSource, marketSelected, filters) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters,
                    transform: {
                        template: "Compact",
                        parameters: {
                            itemsBy: "Rows",
                            filterExpression: "$.[?(@.id =~ /^BASE|TOTAL(.*)$/)]"
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }

        function getDataT(filters, numberBrands) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: 'PUIG-24MUES',
                    query: 'PUIG-23MUESTOTAL' + numberBrands,
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout7', {
                url: '/brandOverviewAcrossBrands?web&jobId',
                breadcrumb: { icon: 'icon-layout-7', label: 'MAIN_HOME_LAYOUT7' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout7/layout7.html',
                        controller: 'Layout7Controller',
                        controllerAs: 'layout7'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams:getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout7')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout7 is not enabled');
            }
            return $q.resolve();
        }

            function getReportParams(mainService, $stateParams, $state) {
                return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
            }
    
            getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
            function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
                if (reportParams) {
                    var newContext = {
                        country: reportParams.country,
                        year: reportParams.year,
                        period: reportParams.period,
                        market: reportParams.market,
                        brand: reportParams.brand,
                        criteria: reportParams.criteria
                    };
                    return mainService.getFilterModule('layout7', newContext, filterService, true, filterViewConfigurationService);
                }
                return mainService.getFilterModule('layout7', newContext, filterService, false, filterViewConfigurationService);
            }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout7Controller', Layout7Controller);

  /** @ngInject */
  function Layout7Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout7Service, errorHandlerService) {
    var vm = this;
    var listeners;

    vm.filter = {
      data: [],
      applied:false,
      preApplyFilter:preApplyFilter
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.serviceView = layout7Service;

    vm.statusWidgets = {
      allLoaded: false,
      widgets: [
        {
          id: 'emotionalConnectionL7',
          value: false
        },
        {
          id: 'brandImageL7',
          value: false
        },
        {
          id: 'purchaseFunnelL7',
          value: false
        }
      ]
    };

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
      destroyListenerCombo();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      createListenersCombo();
    }

    function preApplyFilter(filter){
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si tengo seleccionado en el filtro de red un COUNTRY.
       */
      var brandFilter = {
        numberSelected: _.chain(filter).find({'id':'brand'}).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({'id':'brand'}).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({'id':'brand'}).result('data').first().result('minSelections').value()
      };

      var brandImageFilter = {
        numberSelected: _.chain(filter).find({'id':'image'}).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({'id':'image'}).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({'id':'image'}).result('data').first().result('minSelections').value()
      };

      //El filtro brands y brandImage no cumplen con el numero minimo de selecciones
      if(!checkRange(brandFilter.numberSelected, brandFilter.min, brandFilter.max) && !checkRange(brandImageFilter.numberSelected, brandFilter.min, brandFilter.max)){
        errorHandlerService.callbackWarning.call({text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_BRANDS_AND_BRAND_IMAGE_L7')});
        return false;
      }

      //El filtro brands no cumple con el numero minimo de selecciones
      if(checkRange(brandFilter.numberSelected, brandFilter.min, brandFilter.max) && !checkRange(brandImageFilter.numberSelected, brandFilter.min, brandFilter.max)){
        errorHandlerService.callbackWarning.call({text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_BRANDS_L7')});
        return false;
      }
      
       //El filtro brandImage no cumple con el numero minimo de selecciones
      if(!checkRange(brandFilter.numberSelected, brandFilter.min, brandFilter.max) && checkRange(brandImageFilter.numberSelected, brandFilter.min, brandFilter.max)){
        errorHandlerService.callbackWarning.call({text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_BRAND_IMAGE_L7')});
        return false;
      }

      return true;
    }

    function checkRange(value, min, max){
      return value >= min && value <=max ? true: false;
    }

    function updateStateWidget(_event, nameWidget) {
      var indexWidget = _.chain(vm.statusWidgets.widgets).findIndex({ 'id': nameWidget }).value();
      vm.statusWidgets.widgets[indexWidget].value = true;
      checkAllWidgetsLoaded();
    }

    function checkAllWidgetsLoaded() {
      var isAllLoaded = _.chain(vm.statusWidgets.widgets).every({ 'value': true }).value();
      if (isAllLoaded) {
        $rootScope.$emit('printReport', true);
      }
    }

    function createListenersCombo() {
      listeners = _.chain(vm.statusWidgets.widgets).map(function (item) {
        var widgetListener = $rootScope.$on(item.id + 'Loaded', updateStateWidget);
        return widgetListener;
      }).value();
    }

    function destroyListenerCombo() {
      _.each(listeners, function (item) {
        item();
      });
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout6Service', layout6Service);

    layout6Service.$inject = ['$http', 'filterHelperService', '$q'];
    function layout6Service($http, filterHelperService, $q) {
        var service = {
            getW1: getW1,
            getW2: getW2,
            getW3: getW3
        };

        return service;

        function getW1() {
            var market = filterHelperService.getPropertySelected('market');
            if (market === 'T') {
                return $q.all([getWidget('PUIG-23', 'Columns'), getTotalT('PUIG-23MUES', 'Columns')]);
            }
            else {
                return $q.all([getWidget('PUIG-23', 'Columns'), getTotal('PUIG-23MUES', 'Columns')]);
            }

        }

        function getW2() {
            return $q.all([getWidgetImages('PUIG-24', 'Columns'), getTotalBrandImages('PUIG-24MUES', 'Columns')]);
        }

        function getW3() {
            return $q.all([getWidget('PUIG-22', 'Columns'), getTotal('PUIG-22MUES', 'Columns')]);
        }

        function getTotalT() {
            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var f20I = [
                { "ADVOF": ["baseADVOF" + brandSelected] },
                { "ADVOM": ["baseADVOM" + brandSelected] }
            ];

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F20I: f20I,
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getDataT(filters)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getTotal(dataSource, grouping) {
            var brand = filterHelperService.getPropertySelected('brand');
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f23 = {};
            f23[parentBrand] = brand;

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F23: [f23],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, '', filters, grouping)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getTotalBrandImages(dataSource, grouping) {
            var countrySelected = filterHelperService.getPropertySelected('country');

            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f20I = 'IM' + countrySelected + brandSelected + parentBrand;

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F20I: [f20I],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, '', filters, grouping)
                .catch(function () {
                    return $q.when('-');
                });
        }

        function getWidgetImages(dataSource, grouping) {
            var countrySelected = filterHelperService.getPropertySelected('country');

            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f20I = 'IM' + countrySelected + brandSelected + parentBrand;

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F20I: [f20I],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, '', filters, grouping);
        }

        function getWidget(dataSource, grouping) {
            var marketSelected = filterHelperService.getPropertySelected('market');

            var brand = filterHelperService.getPropertySelected('brand');
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var f23 = {};
            f23[parentBrand] = brand;

            var filters = {
                F16: [filterHelperService.getPropertySelected('period')],
                F23: [f23],
                '#GROUP1': [
                    { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };

            return getData(dataSource, marketSelected, filters, grouping);
        }

        function getData(dataSource, marketSelected, filters, grouping) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters,
                    transform: {
                        template: 'Signification',
                        parameters: {
                            groupOn: grouping
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }

        function getDataT(filters) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: 'PUIG-24MUES',
                    query: 'PUIG-23MUESTOTAL',
                    parameters: {
                        $country$: filterHelperService.getPropertySelected('country')
                    },
                    filters: filters
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout6', {
                url: '/brandOverview?web&jobId',
                breadcrumb: { icon: 'icon-layout-6', label: 'MAIN_HOME_LAYOUT6' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout6/layout6.html',
                        controller: 'Layout6Controller',
                        controllerAs: 'layout6'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout6')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout6 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    market: reportParams.market,
                    brand: reportParams.brand,
                    criteria: reportParams.criteria
                };
                return mainService.getFilterModule('layout6', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout6', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout6Controller', Layout6Controller);

  /** @ngInject */
  function Layout6Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout6Service) {
    var vm = this;
    var listeners;

    vm.filter = {
      data: [],
      applied: false
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.serviceView = layout6Service;

    vm.statusWidgets = {
      allLoaded: false,
      widgets: [
        {
          id: 'emotionalConnectionL6',
          value: false
        },
        {
          id: 'brandImageL6',
          value: false
        },
        {
          id: 'purchaseFunnelL6',
          value: false
        }
      ]
    };

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
      destroyListenerCombo();
    });


    function init(args) {
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      createListenersCombo();
    }

    function updateStateWidget(_event, nameWidget) {
      var indexWidget = _.chain(vm.statusWidgets.widgets).findIndex({ 'id': nameWidget }).value();
      vm.statusWidgets.widgets[indexWidget].value = true;
      checkAllWidgetsLoaded();
    }

    function checkAllWidgetsLoaded() {
      var isAllLoaded = _.chain(vm.statusWidgets.widgets).every({ 'value': true }).value();
      if (isAllLoaded) {
        $rootScope.$emit('printReport', true);
      }
    }

    function createListenersCombo() {
      listeners = _.chain(vm.statusWidgets.widgets).map(function (item) {
        var widgetListener = $rootScope.$on(item.id + 'Loaded', updateStateWidget);
        return widgetListener;
      }).value();
    }

    function destroyListenerCombo() {
      _.each(listeners, function (item) {
        item();
      });
    }
  }
})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .factory('layout17Service', layout17Service);
  
    layout17Service.$inject = ['$http', 'filterHelperService', '$q', '$filter', 'stateManagerService', '$stateParams', 'configurationLoaderService', 'd3','odecD3Service'];
    function layout17Service($http, filterHelperService, $q, $filter, stateManagerService, $stateParams, configurationLoaderService, d3, odecD3Service) {
      var filterLayout;
      var service = {
        getW1: getW1,
        getCategories:getCategories,
        getConfigChart: getConfigChart,
        getChartData: getChartData,
        getLegend:getLegend,
        getTooltip:getTooltip,
        getEventsToLegend: getEventsToLegend
      };
  
      return service;
  
      function getW1(query) {
        filterLayout = stateManagerService.getState('filterLayout');
        return $q.all([getAudience(query, 'PUIG-30NEW'), getTooltip('PUIG-27')]);
      }
  
      function getTooltip(dataSource){
        var filters = getFiltersTooltip();
  
        return $http({
          method: 'POST',
          url: './api/crosstab-engine-extract',
          data: {
            datasource: dataSource,
            query: dataSource,
            parameters: {
              $country$: filterHelperService.getPropertySelected('country')
            },
            filters: filters,
            transform: {
              template: "FlattenText",
              parameters: {
                flattenBy: "Columns"
              }
            }
          }
        })
        .then(function(data){
          return data && data.data;
        })
        .catch(function(_error){
          return $q.when([]);
        });
      }
  
      function getFiltersTooltip(){
        var campaign = filterHelperService.getPropertySelected('campaigns');
        var country = filterHelperService.getPropertySelected('country');
  
        var elementsF31XAll = _.chain(filterLayout).find({ 'name': 'F31X' }).result('content').find({ 'id': 'M' }).result('children').flatMap('children').value();
        var indexPeriodSelected = _.findIndex(elementsF31XAll, { 'id': filterHelperService.getPropertySelected('period') });
        //Periodos hacia atras máximos
        var fixedPeriods = 24;
        var elementsF31XNext = [].concat(_.chain(elementsF31XAll).slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods).map('id').value());
        var filterEti = {};
        filterEti[(campaign && campaign.replace('T',''))+country] = [];
  
        var filters = {
          F31X: _.reverse(elementsF31XNext),
          FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')),
          FILTRO_ETI: [filterEti]
        };
  
        return filters;
      }
  
      function getAudience(query, dataSource){
        var campaign = filterHelperService.getPropertySelected('campaigns');
        var criteria = filterHelperService.getPropertySelected('criteria');
        // var filterRecogMedia = _.chain(filterLayout).find({'name':'FRECOGMEDIA'}).result('content').value();
        var typeMedia = filterHelperService.getPropertySelected('typeMedia');
        var typeMediaSelected = getMedia(typeMedia);
        var elementsF31XAll = _.chain(filterLayout).find({ 'name': 'F31X' }).result('content').find({ 'id': 'M' }).result('children').flatMap('children').value();
        var indexPeriodSelected = _.findIndex(elementsF31XAll, { 'id': filterHelperService.getPropertySelected('period') });
        //Periodos hacia atras máximos
        var fixedPeriods = 24;
        var elementsF31XNext = [].concat(_.chain(elementsF31XAll).slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods).map('id').value());
  
        var filters = {
          F31X: _.reverse(elementsF31XNext),
          '#GROUP1':[
            {FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country'))},
            { CRITERIA: [criteria]}
          ]
        };
  
        //FMEDIOCAMPAÑA
        filters['FMEDIOCAMPANYA'] = _.chain(typeMediaSelected)
                                      .map(function(item){
                                        var media = item && item.text && item.text.split(':');
                                        var mediaSelected = {};
                                        mediaSelected[media && media[0]] = [campaign];
                                        return mediaSelected;
                                      })
                                    .value();
  
        // Agrupar periodos por año natural (ej: "M2503" → "25")
        var periodsByYear = _.groupBy(filters.F31X, function(periodId) {
          return periodId.substring(1, 3);
        });

        var requests = _.map(periodsByYear, function(periods, year) {
          var yearFilters = angular.copy(filters);
          yearFilters.F31X = periods;
          return getData(query, dataSource, yearFilters, year);
        });

        return $q.all(requests).then(function(results) {
          return mergeResults(results);
        });
      }
  
      function getLegend() {
        var typeMedia = filterHelperService.getPropertySelected('typeMedia');
        var typeMediaSelected = getMedia(typeMedia);
        // var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
        var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
        
        // norma será un array de objetos, uno por cada conjunto de resultados (combinación de parámetros)
        var norma = [];
        
        if (_.isArray(filterNorma) && filterNorma.length > 0) {
          // Por cada resultItem (combinación de parámetros: country, year, target)
          _.each(filterNorma, function(resultItem) {
            var normaMap = {};
            
            // Añadimos los parámetros al map para referencia
            if (resultItem.parameters) {
              var filterCountry = _.chain(filterLayout).find({ 'name': 'F5' }).result('content').value();

              


              var countryFound = _.find(filterCountry, { 'id': resultItem.parameters.$country$ });
              normaMap.country = countryFound && countryFound.text;
              var filterTarget = _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
              var targetFound = _.find(filterTarget, { 'id': resultItem.parameters.$target$ });
              normaMap.target = targetFound && targetFound.text;
       
              //Rellenar año '25'., '24', '23' para tener 2025,
              normaMap.year ='20' + resultItem.parameters.$year$;
            }
            
            // Por cada tipo de media seleccionado, buscamos su norma en este resultItem
            _.each(typeMediaSelected, function (item) {
              var values = item && item.text && item.text.split(':');
              var variableSet = resultItem.variables || resultItem;             
              
              //Las nuevas normas tienen el prefijo NORMA_
              var found = _.find(variableSet, { 'name': 'NORMA_' + values[0] });
              //Las antiguas normas tienen el prefijo NORMA
              if (found === undefined) {
                found = _.find(variableSet, { 'name': 'NORMA' + values[0] });
              }

              if (found) {
                normaMap[values[1]] = found.value;
              }
            });
            
            norma.push(normaMap);
          });
        }
  
        return norma;
      }
  
      function getCategories(data){
        return _.chain(data).value();
      }
  
      function getChartData(data) {
        var colorSeries = getColorsSeries();
        var colorSignification = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignification' }).result('color').value();
        var bgSignification = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignification' }).result('color').value();
        return _.chain(data)
          .map(function (item, _index) {
            var filterLayout = stateManagerService.getState('filterLayout');
            var metricsAvail = _.chain(filterLayout).find({ 'name': 'F29' }).result('content').find({ 'id': filterHelperService.getPropertySelected('market') }).result('children').value();
            var nameMetric = item && item.id && item.id.substring(0, item.id.length - 4);
            var metricFound = _.chain(metricsAvail).find({ 'id': nameMetric }).value() ? _.chain(metricsAvail).find({ 'id': nameMetric }).result('text').value() : null;
            return {
              id: item && item.id,
              animation: $stateParams && $stateParams.web === 'true' ? true : false,
              color: _.chain(colorSeries).find({ 'id': item && item.id }).result('value').value(),
              lineWidth: item && item.id === 'RECOG01' ? 3 : 2,
              data: _.map(item.values, function (itemValues, index) {
                var x = {
                  y: '',
                  dataLabels: {
                    color: item && item.id === 'RECOG01' ? _.chain(colorSignification).find({ 'id': item && item.types[index] }).result('value').value() : '-'
                  }
                };
                x.y = itemValues;
                return x;
              }),
              dataLabels:{
                formatter:function(){
                  var index = this && this.point && this.point.index;
                  var typesPrev = _.chain(item && item.typesPrev).get(index).value();
                  var color = _.chain(bgSignification).find({ 'id': typesPrev }).result('value').value();
                  if(typesPrev === '-' || typesPrev === ''){
                    return this && this.y && this.y.toFixed(0);
                  }
                  else{
                    if(typesPrev === 'U'){
                      return this && this.y && this.y.toFixed(0) + ' <i class="icon-caret-up icon-size-lg signification-icon" style="color:' + color +'"></i>';
                    }else{
                      return this && this.y && this.y.toFixed(0) + ' <i class="icon-caret-down icon-size-lg signification-icon" style="color:'+color+'"></i>';
                    }
                  }
                  
                }
              },
              name: metricFound ? $filter('uppercase')(metricFound) : $filter('uppercase')(item && item.text),
              marker: {
                symbol: 'circle',
                fillColor: 'white',
                lineColor: null,
                lineWidth: 2
              },
              visible: true
            };
          })
          .value();
      }
  
      function formatLabelsPlotBands(){

        var chart = this;
        var xAxis = chart && chart.xAxis && chart.xAxis[0];
        var xAxisBands = _.filter(xAxis.plotLinesAndBands, function(item){
          if ( typeof (item && item.id) !== 'undefined')
          {
            return item;
          }
        });
        var allText = d3.selectAll('.highcharts-plot-band-label').nodes();
        _.each(angular.copy(xAxisBands), function (item, index) {
          var widthPlotBand = d3.select('.' + (item && item.id)).node().getBBox().width;
          
          var textNode = d3.select(allText[index]);
          var auxNode = angular.copy(textNode);
          var posXNode = auxNode.attr('x');
          var posYNode = auxNode.attr('y');
          var textNodeValue = angular.copy(item && item.options && item.options.label && item.options.label.text);
          var fillColor = item && item.options && item.options.color === '#C4C6C8' || item && item.options && item.options.color === '#E6E7E7' ? 'black' : 'white';
          textNode.selectAll('tspan').remove();
          textNode
              .text(textNodeValue)
              .attr('x', posXNode)
              .attr('y', posYNode)
              .style('fill', fillColor)
              .call(odecD3Service.wrapText, widthPlotBand * .75, "middle", 10, 4); 
        });
      }
  
      function getConfigChart(tooltips, categories, max, min) {
        var maxChartY = max > 90 ? max : max + 10;
        return {
          chart: {
            renderTo: null,
            type: 'spline',
            style: {
              fontFamily: 'Montserrat'
            },
            marginTop:50,
            marginRight: 50,
                  events: {
                    load: formatLabelsPlotBands,
                    redraw: formatLabelsPlotBands
                  }
          },
          title: {
            text: ''
          },
          subtitle: {
            text: null
          },
          xAxis: {
            labels: {
              formatter: function () {
                return this.value && this.value.text && this.value.text.toUpperCase();
              }
            },
            // tickWidth: 1,
            // tickColor: 'rgba(232, 232, 232, 1)',
            lineWidth:1,
            lineColor: 'rgba(232, 232, 232, 1)',
            plotBands: getEventsToPlotBands(_.map(categories, 'id')),
            plotLines: getPlotLines(_.map(categories, 'id'))
          },
          yAxis: {
            min: min,
            max: maxChartY,
            title: {
              text: null,
              align: 'high'
            },
            gridLineWidth: 0,
            lineWidth:1,
            lineColor: 'rgba(232, 232, 232, 1)',
            plotBands:[
                  {
                    from: plotBandsY(_.map(categories, 'id'), maxChartY, min), 
                    to: 0,
                    color: 'white'
                  }
              ],
              tickInterval: 10
          },
          plotOptions: {
            spline: {
              dataLabels: {
                useHTML: true,
                enabled: true,
                style: {
                  fontWeight: 'bold',
                  textOutline: "0px contrast"
                }
              },
              enableMouseTracking: true
            },
            series: {
              lineWidth: 1,
              marker: {
                enabled: true,
                symbol: 'circle',
                radius: 3
              },
              states: {
                inactive: {
                  opacity: 1
                }
              }
            }
          },
          legend: {
            enabled: true,
            symbolWidth: 40,
            align: 'center',
            verticalAlign: 'top',
            floating: true,
            x: 0,
            y: 0
          },
          tooltip: {
            enabled: true,
            shared: true,
            useHTML: true,
            backgroundColor: 'white',
            crosshairs: false,
            padding: 0,
            borderWidth: 0,
            shadow: false,
            formatter: function () {
              
              var nameCampaign = _.chain(filterLayout).find({ 'name': 'F30X' }).result('content').find({ 'id': filterHelperService.getPropertySelected('campaigns')}).result('text').split('-').get(0).value();
              var idCampaign = _.chain(filterLayout).find({ 'name': 'F30X' }).result('content').find({ 'id': filterHelperService.getPropertySelected('campaigns') }).result('id').replace('T','').value();
              var monthSel = this.x && this.x.id;
              var campaignChange = _.chain(tooltips).find(function(item){
                if(_.includes(item && item.id && item.id,idCampaign)){
                  return item;
                }
              }).result('values')
                .find(function (item) {
                  if (_.includes(item && item.id && item.id,monthSel)) { return item; }
                }).result('values').reduce().value();
            
              if(campaignChange){
                nameCampaign = campaignChange;
              }
              var divTitle = '<div class="bold--700 text-center">' + nameCampaign+'</div>';
              var divBrands = '<div class="margin-top--0_5">';
              _.each(this.points, function(item){
                var brandTooltip = '<p class="" style="color:'+(item && item.point && item.point.color)+'"><i class="icon-size-sm icon-circle-thin bold--700 margin-right--0_5 margin-left--0_5"></i>'+$filter('uppercase')(item && item.series && item.series.name)+': '+(item && item.y && item.y.toFixed(0))+'</p>';
                divBrands += brandTooltip;
              });
              divBrands += '</div>';
              return divTitle+divBrands;
            }
          },
          series: [],
          credits:{
            enabled:false
          }
        };
      }
  
      function getData(query, dataSource, filters, year){
        return $http({
          method: 'POST',
          url: './api/crosstab-engine-extract',
          data: {
            datasource: dataSource,
            query: query,
            parameters: {
              $country$: filterHelperService.getPropertySelected('country'),
              $target$: filterHelperService.getPropertySelected('criteria'),
              $year$: year
            },
            filters: filters,
            transform: {
              template: 'Signification',
              parameters: {
                groupOn: 'Rows'
              }
            }
          }
        })
        .then(function(data){
          var output = {
            categories: [],
            series: []
          };
          var filterLayout = stateManagerService.getState('filterLayout');
          var campaign = filterHelperService.getPropertySelected('campaigns');
  
          var typeMedia = filterHelperService.getPropertySelected('typeMedia');
          var filterRecogMedia = _.chain(filterLayout).find({'name': typeMedia}).result('content').map(function(item){
            var vars = item && item.text && item.text.split(':');
            item.idMedia = vars && vars[0];
            return item;
          }).value();
  
          var valuesMetrics = _.chain(data && data.data).value();
          _.each(valuesMetrics, function (item) {
            var newItem = {
              id: '',
              text: '',
              values: [],
              types: [],
              typesPrev:[]
            };
  
            var findMedia = _.chain(filterRecogMedia).find({'idMedia':item && item.id}).value();
            var dataItem = item;
            newItem.id = dataItem && dataItem.id;
            var text = dataItem && dataItem.text && dataItem.text.split('*');
            newItem.text = text && text[0] && text[0].replace('RECOGNITION','');
            newItem.values = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia)+campaign }).result('values').map(function(item){
              return item && item.value > 0 ? item.value : null;
            }).value();
            newItem.types = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia) + campaign }).result('values').map(function(item){return item && item.type && item.type[0];}).value();
            newItem.typesPrev = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia) + campaign }).result('values').map(function (item) { return item && item.type && item.type[1]; }).value();
            var dates = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia) + campaign }).result('values').map(function(item){
              return {
                'id':item && item.id,
                'text':item && item.text
              };
            }).value();
            output.categories = [].concat(output.categories, dates);
            output.series.push(newItem);
          });
  
          output.categories = _.uniqBy(output.categories, 'id');
          output.series = output.series;
          return output;
        })
        .catch(function(){
          return $q.reject([]);
        });
      }
  
      function mergeResults(results) {
        var validResults = _.filter(results, function(r) { return r && r.categories && r.categories.length > 0; });
        if (validResults.length === 0) return { categories: [], series: [] };
        if (validResults.length === 1) return validResults[0];

        var merged = { categories: [], series: [] };

        _.each(validResults, function(result) {
          merged.categories = merged.categories.concat(result.categories);
        });

        var seriesIds = _.map(validResults[0].series, 'id');
        _.each(seriesIds, function(seriesId, idx) {
          var mergedSeries = {
            id: seriesId,
            text: validResults[0].series[idx].text,
            values: [],
            types: [],
            typesPrev: []
          };
          _.each(validResults, function(result) {
            var s = _.find(result.series, { id: seriesId });
            if (s) {
              mergedSeries.values = mergedSeries.values.concat(s.values);
              mergedSeries.types = mergedSeries.types.concat(s.types);
              mergedSeries.typesPrev = mergedSeries.typesPrev.concat(s.typesPrev);
            }
          });
          merged.series.push(mergedSeries);
        });

        return merged;
      }

      function getColorsSeries() {
        return _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'campaignRecognition' }).result('color').value();
      }

      /**
       * Events to show
       */
      function getEventsToShow(categories) {
        var filterEvents = _.chain(filterLayout).find({ 'name':'F34X'}).result('content').value();
        var eventsToShow = [];
        eventsToShow = _.map(filterEvents, function(event, _index){
          var newEvent = {
            id:null,
            text:'',
            size:0,
            showingMonths:[],
            pos:0,
            isGradient:false,
            gradient:'',
            color: null,
            type:null
          };
          var valuesEvent = event && event.text && event.text.split('%%');
          var yearEvent = valuesEvent && valuesEvent[1] && valuesEvent[1].split('-');
          var textEvent = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColors' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('text').value();
          newEvent.id = event.id;
          newEvent.text = $filter('translationWithPrefix')(textEvent)+ ' \''+ yearEvent[yearEvent.length -1];
          newEvent.type = valuesEvent && valuesEvent[0];
          newEvent.gradient = valuesEvent && valuesEvent[2];
          newEvent.isGradient = valuesEvent && angular.isDefined(valuesEvent[2]) ? true : false;
          _.each(event && event.children, function(childEvent){
            var foundChild = _.chain(categories).includes(childEvent && childEvent.id).value();
            if(foundChild){
              newEvent.size ++;
              newEvent.showingMonths.push(childEvent);
            }
          });
          newEvent.color = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColors' }).result('color').find({ 'id': valuesEvent && valuesEvent[0]}).result('value').value();
          newEvent.pos = _.indexOf(categories, _.chain(newEvent.showingMonths).orderBy('id').first().result('id').value());
          return newEvent;
        });
  
        //Filter events to show
        return eventsToShow = _.filter(eventsToShow, function(item){return item.pos >= 0;});
      }
  
      function getEventsToPlotBands(categories) {
        var events = getEventsToShow(categories);
        
        if (hasGradients(events) > 0){
          //Return collection plotbands with gradients
          return getGradients(events);
        }
        else{
          return getPlotBandsDefault(events);
        }
      }
  
      function hasGradients(eventsToShow){
        return _.chain(eventsToShow).filter('gradient').groupBy('gradient').size().value();
      }
  
      function getGradients(eventsToShow){
        var plotBandsNoGradientsEvents = _.filter(eventsToShow, ['isGradient', false]);
        var plotBandsNoGradients = getPlotBandsDefault(plotBandsNoGradientsEvents);
        
        var gradients = _.groupBy(_.filter(eventsToShow, 'gradient'), 'gradient');
  
        var newGrads = _.map(gradients, function(newGrad){
          newGrad  = _.orderBy(newGrad, ['pos', 'id'], ['asc', 'asc']);
          var firstEvent = _.chain(newGrad).first().value();
          var lastEvent = _.chain(newGrad).last().value();
          var maxSize = _.chain(newGrad).map('size').max().value();
  
          return {
            id: firstEvent.gradient,
            className: firstEvent.gradient,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, firstEvent && firstEvent.color],
                [1, lastEvent && lastEvent.color]
              ]
            },
            from: firstEvent && firstEvent.pos - 0.5,
            to: firstEvent && firstEvent.pos - 0.5 + maxSize,
            label: {
              text: newGrad && newGrad.length > 1 ? (firstEvent && firstEvent.text) + ' / ' + (lastEvent && lastEvent.text) : firstEvent && firstEvent.text,
              align: 'center'
            }
          };
        });
        return [].concat(plotBandsNoGradients, newGrads);
      }
  
      function getPlotBandsDefault(eventsToShow){
        return _.chain(eventsToShow).reduce(function (aggr, event) {
          aggr.push({
            id: event.id,
            className: event.id,
            color: event.color,
            from: event.pos - 0.5,
            to: event.pos + event.size - 0.5,
            label: {
              text: event.text,
              align: 'center'
            }
          });
          return aggr;
        }, []).value();
      }

      function getPlotLines(categories){
        var events = getEventsToShow(categories);
        return _.chain(events).reduce(function (aggr, event) {
          aggr.push({
            color: 'rgba(232, 232, 232, 1)', // Color value
            dashStyle: 'solid', // Style of the plot line. Default to solid
            value: event.pos + event.size - 0.5, // Value of where the line will appear
            width: 1,// Width of the line,
            zIndex: 5    
          });
          return aggr;
        }, []).value();
      }
  
      function getEventsToLegend(){
        var filterEvents = _.chain(filterLayout).find({ 'name': 'F34X' }).result('content').value();
        var eventsToShow = [];
        eventsToShow = _.map(filterEvents, function (event, _index) {
          var valuesEvent = event && event.text && event.text.split('%%');
          var newEvent = {
            text: '',
            color: null,
            type:'',
            order:null
          };
          
          newEvent.text = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColors' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('text').value();
          newEvent.type = valuesEvent && valuesEvent[0];
          newEvent.color = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColors' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('value').value();
          newEvent.order = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColors' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('order').value();
          return newEvent;
        });
  
        return _.orderBy(_.uniqBy(eventsToShow, 'type'), 'order');
      }

      function getMedia(typeMedia) {
        return _.chain(filterLayout).find({'name': typeMedia}).result('content').value();
      }

      function plotBandsY(categories, max, min) {
        var ticksInterval;
        var events = getEventsToShow(categories);
        var roundMax = Math.floor( max / 10 ) * 10 + 10;
        var interval = roundMax - min;
        
        if (hasGradients(events) > 0){
          ticksInterval =  Math.floor( interval / 10 ) * 10 + 15;
          return roundMax - (ticksInterval / 10);
        }
        else {
          if ( max === 100 ){
            return max - 7;
          }
          ticksInterval =  Math.floor( interval / 10 ) * 10 + 10;
          return roundMax - (ticksInterval / 10);
        }
      }
    }
  })();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout17', {
                url: '/recognitionEvolution?web&jobId',
                breadcrumb: { icon: 'icon-layout-13', label: 'MAIN_HOME_LAYOUT17' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout17/layout17.html',
                        controller: 'Layout17Controller',
                        controllerAs: 'layout17'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout17')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout17 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService','filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    campaigns: reportParams.campaigns,
                    criteria: reportParams.criteria,
                    typeMedia: reportParams.typeMedia
                };
                return mainService.getFilterModule('layout17', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout17', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
    'use strict';
  
    angular
      .module('app')
      .controller('Layout17Controller', Layout17Controller);
  
    /** @ngInject */
    function Layout17Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout17Service, uuid, configurationLoaderService, filterHelperService, contextVariableService) {
      var vm = this;
  
      vm.filter = {
        data: [],
        applied: false
      };
  
      vm.view = {
        loading: false,
        hasData: true,
        chart: {
          id: uuid.v4(),
          categories: [],
          data: [],
          config: {}
        }
      };
  
      vm.legend = {
        data:[],
        events:[],
        typeLegend:''
      };

      var query = {
        FRECOTOTAL: 'PUIG-30TOT',
        FRECOVIDEO: 'PUIG-30VID',
        FRECOVISUAL: 'PUIG-30VIS'
      };
  
      vm.isWeb = $stateParams && $stateParams.web === 'true';
  
      vm.cover = {
        icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
        text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
      };
  
      vm.copyXls = {
        copyToXlsFn: copyToXlsFn,
        copyToXlsData: []
      };
  
      vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">'+
          '<span class="no-margin text-left font-weight_bold">'+($filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE'))+'</span>'+    
      '<div class="item-info margin-top--0_5">'+
          '<span class="no-margin text-left font-weight_bold">'+$filter('uppercase')($filter('translationWithPrefix')('GROUP_VIDEO'))+'</span>'+
      '</div>'+
      '<div class="item-info">'+
          '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('CORE_VIDEO')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_CORE_VIDEO')+'</p>'+
      '</div>'+
      '<div class="item-info">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_LINEAR_TV')+'</strong>'+
          '<ul><li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_LINEAR_TRAD')+'</li></ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_DIGITAL_TV')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_PAID')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_SMART')+'</li>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_CATCHUP')+'</li>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_STREAM')+'</li>'+          
          '</ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_OUTDOOR')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TRAIN')+'</li>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TAXI')+'</li>'+          
          '</ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN_YOUTUBE')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN')+'</li>'+                       
          '</ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_OTHER')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL')+'</li>'+      
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_CINEMA')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_RADIO')+'</li>'+                       
          '</ul>'+          
      '</div>'+

      '<div class="item-info">'+
          '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('SOCIAL_VIDEOS')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_SOCIAL_VIDEOS')+'</p>'+
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
          '<span class="no-margin text-left font-weight_bold"> '+$filter('uppercase')($filter('translationWithPrefix')('GROUP_VISUAL'))+'</span>'+
      '</div>'+
      '<div class="item-info">'+
          '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('OFFLINE_ONLINE')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_OFFLINE_ONLINE')+'</p>'+
      '</div>'+
      '<div class="item-info">'+
          '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('SOCIAL_VISUAL')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_SOCIAL_VISUAL')+'</p>'+
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
        '<strong>'+$filter('translationWithPrefix')('GROUP_PRINT')+'</strong>'+
        '<ul>'+
          '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_PRINT_CONVPRESS')+'</li>'+            
          '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL')+'</li>'+                       
        '</ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
        '<strong>'+$filter('translationWithPrefix')('GROUP_SHOP')+'</strong>'+
        '<ul>'+
          '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING')+'</li>'+            
          '<li>'+$filter('translationWithPrefix')('GROUP_SHOP')+'</li>'+   
          '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_SHOP_RETAIL')+'</li>'+              
        '</ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
        '<strong>'+$filter('translationWithPrefix')('GROUP_OUTDOOR')+'</strong>'+
        '<ul>'+
          '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_TRANSPORT')+'</li>'+            
          '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_STREET')+'</li>'+            
        '</ul>'+          
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
        '<strong>'+$filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS')+'</strong>'+
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
        '<strong>'+$filter('translationWithPrefix')('GROUP_BRAND_WEBSITES')+'</strong>'+
      '</div>'+
      '<div class="item-info margin-top--0_5">'+
          '<p class="no-margin text-left">'+$filter('translationWithPrefix')('BEST_DATA_MEDIA_EVENT')+'</p>'+
      '</div>'+    
      '<div>'
    ;
  
      vm.serviceView = layout17Service;
  
      init();
  
      /** listeners */
      var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
        vm.filter.applied = { value: true };
        init(args && args.filter);
      });
  
      $scope.$on('$destroy', function () {
        filterApply();
      });
  
      ////////////////
  
      function init(args) {
        $rootScope.$emit('printReport', false);
        if (!args) {
          vm.filter.applied = false;
        }
        vm.filter.data = args || filterData;
        vm.view.hasData = false;
        vm.view.loading = true;
  
        var contextOptions = { 'allTargets': false, 'filterPeriodInfo':{ 'id': 'period', 'nameFilter': 'F31X', 'fixedPeriods': 24 } };
        var contextMap = {
            period: filterHelperService.getFilterElementSelected(vm.filter.data, 'period'),
            country: filterHelperService.getFilterElementSelected(vm.filter.data, 'country'),
            year: filterHelperService.getFilterElementSelected(vm.filter.data, 'year'),
            criteria: filterHelperService.getFilterElementSelected(vm.filter.data, 'criteria')
        };

        contextVariableService.getFilter.call(contextMap, 'contextVariables', contextOptions).then(function() {
            vm.legend = getStylesLegend(vm.legend);
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');
            vm.legend.typeLegend = typeMedia;
            layout17Service.getW1(query[typeMedia])
              .then(function (data) {
                var tooltipEvents = data && data[1];
                data = data && data[0];
                vm.view.chart.data = layout17Service.getChartData(data && data.series);
                vm.view.chart.categories = _.chain(layout17Service.getCategories(data && data.categories, 'text')).map(function(i){return $filter('uppercase')(i);}).value();
                var min =  _.chain(vm.view.chart.data).flatMap('data').map('y').min().value();
                var max = _.chain(vm.view.chart.data).flatMap('data').map('y').max().value();
                vm.view.hasData = isNaN(min) && isNaN(max) ? false : true;
                vm.view.chart.config = layout17Service.getConfigChart(tooltipEvents,layout17Service.getCategories(data && data.categories, 'id'), max > 90 ? 100 : max*1.1, min*0.95);
                vm.copyXls.copyToXlsData = vm.view.chart;
                vm.legend.data = layout17Service.getLegend();
                vm.legend.events = layout17Service.getEventsToLegend(layout17Service.getCategories(data && data.categories, 'id'));
              })
              .catch(function () {
                vm.view.hasData = false;
              })
              .finally(function () {
                vm.view.loading = false;
                $rootScope.$emit('printReport', true);
              });
        });
      }
  
      function copyToXlsFn(data) {
        var columnHeaders = [].concat("", _.chain(data).result('categories').map(function(item){
          return $filter('lowercase')(item && item.text);
        }).value());
  
        var rowData = [columnHeaders];
  
        _.each(_.chain(data).result('data').value(), function (item) {
          rowData.push([].concat(item.name, _.chain(item.data).map(function (item) {
            return item && item.y && $filter('round')(item.y,0);
          }).value()));
        });
  
        var rows = _.map(rowData, function (i) {
          return i.join('\t');
        });
        return rows.join('\n');
      }
  
      function getStylesLegend(legend){
        var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundChartSignification' }).result('color').value();
        var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignification' }).result('color').value();
  
        return _.extend({},legend, {
          c1: _.chain(colors).find({ 'id': 'U' }).result('value').value(),
          c2: _.chain(colors).find({ 'id': 'D' }).result('value').value(),
          bg1: _.chain(backgroundColors).find({ 'id': 'U' }).result('value').value(),
          bg2: _.chain(backgroundColors).find({ 'id': 'D' }).result('value').value()
        });
      }
    }
  })();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout16Service', layout16Service);

  layout16Service.$inject = ['$http', 'filterHelperService', '$q', 'stateManagerService','configurationLoaderService'];
  function layout16Service($http, filterHelperService, $q, stateManagerService, configurationLoaderService) {
    var filterLayout = {};
    var extraInfo = {};
    var service = {
      getW1: getW1,
      getCategories: getCategories,
      getLegend: getLegend
    };

    return service;

    function getW1(query) {
      extraInfo = {};
      filterLayout = stateManagerService.getState('filterLayout');
      var queries = prepareQueries(query, 'PUIG-29NEW');
      return getQueries(queries, extraInfo);
    }

    function getLegend(){
      var typeMedia = filterHelperService.getPropertySelected('typeMedia');
      var typeMediaSelected = getMedia(typeMedia);
      // var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
      
      // norma será un array de objetos, uno por cada conjunto de resultados (combinación de parámetros)
      var norma = [];
      
      if (_.isArray(filterNorma) && filterNorma.length > 0) {
        // Por cada resultItem (combinación de parámetros: country, year, target)
        _.each(filterNorma, function(resultItem) {
          var normaMap = {
            typeLegend: typeMedia,
            typeMedia: typeMedia,
            default: {},
            prestige: {}
          };
          
          // Añadimos los parámetros al map para referencia
          if (resultItem.parameters) {
            var filterCountry = _.chain(filterLayout).find({ 'name': 'F5' }).result('content').value();
            var countryFound = _.find(filterCountry, { 'id': resultItem.parameters.$country$ });
            normaMap.country = countryFound && countryFound.text;
            
            var filterTarget = _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
            var targetFound = _.find(filterTarget, { 'id': resultItem.parameters.$target$ });
            normaMap.target = targetFound && targetFound.text;
            
            // Rellenar año '25', '24', '23' para tener 2025
            normaMap.year = '20' + resultItem.parameters.$year$;
          }
          
          // Por cada tipo de media seleccionado, buscamos su norma en este resultItem
          _.each(typeMediaSelected, function(item){
            var values = item && item.text && item.text.split(':');
            var variableSet = resultItem.variables || resultItem;
            
            //Las nuevas normas tienen el prefijo NORMA_
            var valueNorma = _.find(variableSet, {'name':'NORMA_'+values[0]});
            //Las antiguas normas tienen el prefijo NORMA
            if (valueNorma === undefined) {
              valueNorma = _.find(variableSet, { 'name': 'NORMA' + values[0] });
            }

            //Las nuevas normas de prestigio tienen el prefijo PRESTIGE
            var valuePrestige = _.find(variableSet, {'name':'PRESTIGE'+values[0]});
            //Las antiguas normas de prestigio tienen el prefijo NORMA_PRESTIGE
            if (valuePrestige === undefined) {
              valuePrestige = _.find(variableSet, { 'name': 'NORMA_PRESTIGE' + values[0] });
            }
            
            normaMap.default[values[1]] = valueNorma && valueNorma.value;
            normaMap.prestige[values[1]] = valuePrestige && valuePrestige.value;
          });
          
          norma.push(normaMap);
        });
      }
      
      return norma;
    }
   

    function prepareQueries(query, datasource){
      var criteria = _.chain(filterLayout).find({'name':'CRITERIA'}).result('content').value();
      var tags = _.chain(filterLayout).find({'name':'CRITERIA'}).result('tags').value();
      var datasources = [];
      if (tags && tags.length > 0) {
        tags.forEach(function(tag) {
          var tagPassed = JSON.parse(tag);
          if (tagPassed.id === 'DATASOURCES') {
            datasources = tagPassed.datasources;
          }
        });
      }
      
      var campaigns = filterHelperService.getPropertySelected('campaigns');
      var typeEvent = filterHelperService.getPropertySelected('typeEvent');
      var typeMedia = filterHelperService.getPropertySelected('typeMedia');
      var typeMediaSelected = getMedia(typeMedia);
      // var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var events = _.orderBy(filterHelperService.getPropertySelected('events'));
      var filterEventsMonths = _.chain(filterLayout).find({ 'name': 'F34X' }).result('content').value();
      var transformEventsMonths = [];
      if (typeEvent === 'E') {
        _.each(events, function (item) {
          var monthsEvent = _.chain(filterEventsMonths).find({ 'id': item }).result('children').map('id').value();
          transformEventsMonths = [].concat(transformEventsMonths, monthsEvent);
        });
      }
      extraInfo = {
        events: events,
        typeEvent: typeEvent,
        eventMonth: filterEventsMonths,
        typeMedia: typeMedia
      };
      return _.map(criteria, function(item){
        var finalDatasource = _.find(datasources, function(datasource) {
          return _.includes(datasource.id, _.get(item, 'id'));
        }) || {};
        return getGroup(query, finalDatasource.datasource || datasource, item && item.id, transformEventsMonths, events, typeEvent, typeMedia, typeMediaSelected, campaigns);
      });
    }

    function getGroup(query, datasource, criteriaSelected, transformEventsMonths, events, typeEvent, typeMedia, typeMediaSelected, campaigns){
      /**Preparing filters */
      var filters = {
        F31X: typeEvent === 'E' ? _.orderBy(_.uniq(transformEventsMonths)) : events ,
        '#GROUP1': [
          { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
          { CRITERIA: [criteriaSelected] }
        ]
      };

      /* PUIGK-286: Add TOTAL to typeMediaSelected in order to get same data order for all data views */
      if ((typeEvent === 'E' || typeEvent === 'M') && typeMedia !== 'FRECOTOTAL') { query += typeEvent; }      
      var typeMediaBoolean = (typeEvent === 'M') ? typeMediaSelected :
        _.uniqBy([_.first(getMedia('FRECOTOTAL'))].concat(typeMediaSelected), 'text');
      /* /PUIGK-286 */

      filters['FMEDIOCAMPANYA'] = _.chain(typeMediaBoolean)
        .map(function (item) {
          var media = item && item.text && item.text.split(':');
          var mediaSelected = {};
          mediaSelected[media && media[0]] = [campaigns];
          return mediaSelected;
        })
        .value();
      
      var country = filterHelperService.getPropertySelected('country');
      var signification = buildSignification(typeMediaBoolean, filters.F31X, criteriaSelected, country);
      
      return getData(query, datasource, filters, signification);
    }

    function buildSignification(typeMediaBoolean, f31xValues, criteriaSelected, country) {
      var parameters = {};
      
      _.each(typeMediaBoolean, function(item) {
        var media = item && item.text && item.text.split(':');
        var recogCode = media && media[0];
        
        _.each(f31xValues, function(monthEvent) {
          var year = monthEvent && monthEvent.substring(1, 3);
          var key = recogCode + ':' + monthEvent;
          parameters[key] = [criteriaSelected, country, year];
        });
      });
      
      return {
        fields: ["$target$", "$country$", "$year$"],
        parameters: parameters
      };
    }

    function getData(query, datasource, filters, signification){
      return {
        datasource: datasource,
        query: query,
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: filters,
        signification: signification,
        transform: {
          "template": "Vector"
        }
      };
    }

    function getQueries(queries, extraInfo){
      return $http({
        method: 'POST',
        url: './api/extract-batch',
        data: {
          "queries": queries,
          "transform": {
            "template": "Join"
          }
        },
        transformResponse: $http.defaults.transformResponse.concat([transformData.bind(null, extraInfo)])
      })
      .then(function (data) {
        return data && data.data;
      })
      .catch(function () {
        return $q.when(null);
      });
    }

    function transformData(extraInfo, data){
      if ((extraInfo && extraInfo.typeEvent === 'M')){
        return transformToMonths(data, extraInfo);
      }
      else{
        return transformToEvents(data, extraInfo);
      }
    }

    function transformToEvents(data, extraInfo){
      var monthsEvents = getMonthsEvents(extraInfo);
      var monthsSelected = [];
      return _.chain(data)
      .map(function(rowGroups, indexRow){
        var cellRow = [];
        _.each(rowGroups, function(group, indexGroup){
            _.each(monthsEvents, function (months, indexEvents) {
              /**First group, TOTAL - First line TOTALS */
              var monthsGroupCollection;
              if (indexGroup === 0 && indexRow === 0) {
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var filteredMonthsFromEvent = _.filter(monthsGroupCollection, function(monthsGroup){
                  if (_.includes(months.months, 'M'+monthsGroup.ColumnCategory)) {
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    // Si no es TOTAL(RECOG01), no tiene significación country
                    monthsGroup.color = monthsGroup.rowVariable === 'RECOG01' ? monthsGroup.values[1] : "";
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup;
                  }
                });

                var monthSelected = _.chain(filteredMonthsFromEvent).maxBy('value').value();
                if(monthSelected){
                  monthsSelected.push('M' + (monthSelected && monthSelected.ColumnCategory));
                }
                else{
                  monthsSelected.push('');
                }
                if (extraInfo.typeMedia === 'FRECOTOTAL') {
                  cellRow = [].concat(cellRow, {
                    value: monthSelected && monthSelected.value,
                    color: getSignification('c', monthSelected && monthSelected.color),
                    background: getSignification('bg', monthSelected && monthSelected.background)
                  });
                }
              }
              else{
                if (extraInfo.typeMedia !== 'FRECOTOTAL' && indexGroup === 0) { return; }
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var monthFromEventFound = _.find(monthsGroupCollection, function (monthsGroup) {
                  if (('M' + monthsGroup.ColumnCategory) === monthsSelected[indexEvents]) {
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    // Si no es TOTAL(RECOG01), no tiene significación country
                    monthsGroup.color = monthsGroup.rowVariable === 'RECOG01' ? monthsGroup.values[1] : "";
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup;
                  }
                });

                cellRow = [].concat(cellRow, {
                  value: monthFromEventFound && monthFromEventFound.value,
                  color: getSignification('c', monthFromEventFound && monthFromEventFound.color),
                  background: getSignification('bg', monthFromEventFound && monthFromEventFound.background)
                });
              }
            });
        });
        return cellRow;
      }).value();
    }

    function transformToMonths(data, extraInfo) {
      return _.chain(data)
        .map(function (rowGroups, _indexRow) {
          var cellRow = [];
          _.each(rowGroups, function (group, _indexGroup) {
            _.each(extraInfo && extraInfo.events, function(monthSel){
              var groupMonths = _.chain(_.reduce(group)).value();
              var monthFound = _.chain(groupMonths).find({'ColumnCategory': monthSel && monthSel.replace('M','')}).value();
              if(monthFound){
                monthFound.values = angular.copy(monthFound.value);
                monthFound.value = monthFound.values[0];
                // monthFound.color = monthFound.values[1];
                // Si no es TOTAL(RECOG01), no tiene significación country
                monthFound.color = monthFound.rowVariable === 'RECOG01' ? monthFound.values[1] : "";
                monthFound.background = monthFound.values[2];

                cellRow = [].concat(cellRow, {
                  value: monthFound && monthFound.value,
                  color: getSignification('c', monthFound && monthFound.color),
                  background: getSignification('bg', monthFound && monthFound.background)
                });
              }
              else{
                cellRow = [].concat(cellRow, {
                  value: null,
                  color: '',
                  background: ''
                });
              }
            });
          });
          return cellRow;
        }).value();
    }

    function getMonthsEvents(extraInfo){
      return _.chain(extraInfo && extraInfo.events).map(function (item) {
        var monthEvents = {
          id: '',
          months: []
        };
        var months = _.chain(extraInfo && extraInfo.eventMonth).find({ 'id': item }).result('children').map('id').value();
        monthEvents.id = item;
        monthEvents.months = months;
        return monthEvents;
      })
      .value();
    }

    function getSignification(typeColor, signification) {
      var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTable' }).result('color').value();
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTable' }).result('color').value();
      if (typeColor === 'c') {
        return _.chain(colors).find({ 'id': signification }).result('value').value();
      }
      else {
        return _.chain(backgroundColors).find({ 'id': signification }).result('value').value();
      }
    }

    function getCategories(){
      return _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
    }

    function getMedia(typeMedia) {
      return _.chain(filterLayout).find({'name': typeMedia}).result('content').value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout16', {
                url: '/recognitionByMediaAndTarget?web&jobId',
                breadcrumb: { icon: 'icon-layout-12', label: 'MAIN_HOME_LAYOUT16' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout16/layout16.html',
                        controller: 'Layout16Controller',
                        controllerAs: 'layout16'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout16')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout16 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams','transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    campaigns: reportParams && reportParams.campaigns,
                    events: reportParams && reportParams.events,
                    typeEvent: reportParams && reportParams.typeEvent,
                    typeMedia: reportParams && reportParams.typeMedia
                };
                return mainService.getFilterModule('layout16', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout16', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout16Controller', Layout16Controller);

  /** @ngInject */
  function Layout16Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout16Service, errorHandlerService, filterHelperService, contextVariableService) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter: preApplyFilter
    };

    vm.view = {
      loading: false,
      hasData: true
    };

    vm.dataTable = {
      columnHeaders:[],
      rowHeaders:[],
      data:[],
      legendData:[],
      events:[],
      typeMedia:''
    };
    
    var query = {
      FRECOTOTAL: 'PUIG-29TOT',
      FRECOVIDEO: 'PUIG-29VID',
      FRECOVISUAL: 'PUIG-29VIS',
      FRECOVIDEOX: 'PUIG-29VID_REDES',
      FRECOVISUAX: 'PUIG-29VIS_REDES'
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true' ? true : false;   
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: {}
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
        '<div class="item-info">'+
            '<span class="no-margin text-left font-weight_bold">'+($filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE'))+'</span>'+    
        '<div class="item-info margin-top--0_5">'+
            '<span class="no-margin text-left font-weight_bold">'+$filter('uppercase')($filter('translationWithPrefix')('GROUP_VIDEO'))+'</span>'+
        '</div>'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('CORE_VIDEO')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_CORE_VIDEO')+'</p>'+
        '</div>'+
        '<div class="item-info">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_LINEAR_TV')+'</strong>'+
            '<ul><li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_LINEAR_TRAD')+'</li></ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_DIGITAL_TV')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_PAID')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_SMART')+'</li>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_CATCHUP')+'</li>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_STREAM')+'</li>'+          
            '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_OUTDOOR')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TRAIN')+'</li>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TAXI')+'</li>'+          
            '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN_YOUTUBE')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN')+'</li>'+                       
            '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_OTHER')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL')+'</li>'+      
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_CINEMA')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_RADIO')+'</li>'+                       
            '</ul>'+          
        '</div>'+

        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('SOCIAL_VIDEOS')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_SOCIAL_VIDEOS')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<span class="no-margin text-left font-weight_bold"> '+$filter('uppercase')($filter('translationWithPrefix')('GROUP_VISUAL'))+'</span>'+
        '</div>'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('OFFLINE_ONLINE')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_OFFLINE_ONLINE')+'</p>'+
        '</div>'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('SOCIAL_VISUAL')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_SOCIAL_VISUAL')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_PRINT')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_PRINT_CONVPRESS')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL')+'</li>'+                       
          '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_SHOP')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('GROUP_SHOP')+'</li>'+   
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_SHOP_RETAIL')+'</li>'+              
          '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_OUTDOOR')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_TRANSPORT')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_STREET')+'</li>'+            
          '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS')+'</strong>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_BRAND_WEBSITES')+'</strong>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left">'+$filter('translationWithPrefix')('BEST_DATA_MEDIA_EVENT')+'</p>'+
        '</div>'+    
        '<div>'
      ;

    vm.serviceView = layout16Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;
      
      var contextOptions = { 'allTargets': true, 'filterPeriodInfo':{ 'id': 'events', 'nameFilter': 'F31X'} };
      var contextMap = {
          events: filterHelperService.getFilterElementSelected(vm.filter.data, 'events'),
          country: filterHelperService.getFilterElementSelected(vm.filter.data, 'country'),
          typeEvent: filterHelperService.getFilterElementSelected(vm.filter.data, 'typeEvent')
      };

      contextVariableService.getFilter.call(contextMap, 'contextVariables', contextOptions).then(function() {
        var typeMedia = filterHelperService.getPropertySelected('typeMedia');
        

        layout16Service.getW1(query[typeMedia])
          .then(function (data) {
            vm.view.hasData = true;     
                          /*Prepare data to table **/

            vm.dataTable.rowHeaders = layout16Service.getCategories();
            vm.dataTable.events = getEventsOrdered(vm.filter.data, filterHelperService.getFilterElementSelected(vm.filter && vm.filter.data, 'events'));
            vm.dataTable.legend = layout16Service.getLegend();          
            vm.dataTable.columnHeaders = setColumnHeaders(typeMedia, vm.dataTable.legend);
            vm.dataTable.data = data;          
            /**Xls clipboard */
            vm.copyXls.copyToXlsData = {
              rowHeaders: vm.dataTable.rowHeaders,
              columnHeaders: vm.dataTable.columnHeaders,
              data: vm.dataTable.data,
              events: vm.dataTable.events
            };
          })
          .catch(function () {
            vm.view.hasData = false;
          })
          .finally(function () {
            vm.view.loading = false;
            $rootScope.$emit('printReport', true);
          });
      });
    }

    function preApplyFilter(filter) {
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si tengo seleccionado en el filtro de red un COUNTRY.
       */
      var eventFilter = {
        numberSelected: _.chain(filter).find({ 'id': 'events' }).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({ 'id': 'events' }).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({ 'id': 'events' }).result('data').first().result('minSelections').value()
      };

      //El filtro brands no cumple con el numero minimo de selecciones
      if (!checkRange(eventFilter.numberSelected, eventFilter.min, eventFilter.max)) {
        errorHandlerService.callbackWarning.call({ text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_EVENTS_L18') });
        return false;
      }

      return true;
    }

    function checkRange(value, min, max) {
      return value >= min && value <= max ? true : false;
    }

    function copyToXlsFn(data) {
      var groupCampaigns = [""];
      var allEvents = [""];
      var allRows = [];

      _.each(data && data.columnHeaders, function(group){
        _.each(data && data.events, function (event, index) {
          groupCampaigns = [].concat(groupCampaigns, index === 0 ? $filter('translationWithPrefix')(group && group.text) : '');
          allEvents = [].concat(allEvents, event && event.text);
        });
      });

      _.each(data && data.rowHeaders, function (rows, indexRow) {
        var titleRow = rows && rows.text;
        var dataRow = _.chain(data && data.data && data.data[indexRow]).map(function(cell){return $filter('round')((cell && cell.value), 0);}).value();
        allRows.push([].concat(titleRow, dataRow));
      });

      var rowData = [groupCampaigns, allEvents];
      
      _.each(allRows,function(row){
        rowData.push(row);
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }

    function setColumnHeaders(media, normaLegend){
      // Si normaLegend es un array, usamos el primer elemento para los headers
      var legend = _.isArray(normaLegend) && normaLegend.length > 0 ? normaLegend[0] : normaLegend;
    
      switch ( media ){
        case 'FRECOTOTAL':
          return [
            { id: 'total', key: 'T', logo: '', text: 'GROUP_CAMPAIGN', legendNorma: legend.default && legend.default.T, legendPrestige: legend.prestige && legend.prestige.T },
            { id: 'video', key: 'VID', logo: '', text: 'GROUP_VIDEO', legendNorma: legend.default && legend.default.VID, legendPrestige: legend.prestige && legend.prestige.VID},
            { id: 'visual', key: 'VIS', logo: '', text: 'GROUP_VISUAL', legendNorma: legend.default && legend.default.VIS, legendPrestige: legend.prestige && legend.prestige.VIS}
          ];
        case 'FRECOVIDEO':       
          return [
            { id: 'video', key: 'VID', logo: '', text: 'GROUP_VIDEO', legendNorma: legend.default && legend.default.VID, legendPrestige: legend.prestige && legend.prestige.VID },
            { id: 'linear_tv', key: 'LIN', logo: '', text: 'GROUP_LINEAR_TV', legendNorma: legend.default && legend.default.LIN, legendPrestige: legend.prestige && legend.prestige.LIN },
            { id: 'digital_tv', key: 'DIG', logo: '', text: 'GROUP_DIGITAL_TV', legendNorma: legend.default && legend.default.DIG, legendPrestige: legend.prestige && legend.prestige.DIG },
            { id: 'outdoor', key: 'OUD', logo: '', text: 'GROUP_OUTDOOR', legendNorma: legend.default && legend.default.OUD, legendPrestige: legend.prestige && legend.prestige.OUD },
            { id: 'social_networks', key: 'SOC', logo: '', text: 'GROUP_SOCIAL_NETWORKS', legendNorma: legend.default && legend.default.SOC, legendPrestige: legend.prestige && legend.prestige.SOC },
            { id: 'ohter', key: 'OTH', logo: '', text: 'GROUP_OTHER', legendNorma: legend.default && legend.default.OTH, legendPrestige: legend.prestige && legend.prestige.OTH }
          ];
        case 'FRECOVISUAL':       
          return [
            { id: 'visual', key: 'VIS',  logo: '', text: 'GROUP_VISUAL', legendNorma: legend.default && legend.default.VIS, legendPrestige: legend.prestige && legend.prestige.VIS },
            { id: 'print', key: 'PRI', logo: '', text: 'GROUP_PRINT', legendNorma: legend.default && legend.default.PRI, legendPrestige: legend.prestige && legend.prestige.PRI },
            { id: 'shop', key: 'SHO', logo: '', text: 'GROUP_SHOP', legendNorma: legend.default && legend.default.SHO, legendPrestige: legend.prestige && legend.prestige.SHO },
            { id: 'outdoor', key: 'OUV', logo: '', text: 'GROUP_OUTDOOR', legendNorma: legend.default && legend.default.OUV, legendPrestige: legend.prestige && legend.prestige.OUV },
            { id: 'social_networks', key: 'SOV', logo: '', text: 'GROUP_SOCIAL_NETWORKS', legendNorma: legend.default && legend.default.SOV, legendPrestige: legend.prestige && legend.prestige.SOV },
            { id: 'brand_websites', key: 'BRA', logo: '', text: 'GROUP_BRAND_WEBSITES', legendNorma: legend.default && legend.default.BRA, legendPrestige: legend.prestige && legend.prestige.BRA }
          ];
        case 'FRECOVIDEOX':
          return [
            { id: 'video', key: 'VID', logo: '', text: 'GROUP_VIDEO', legendNorma: legend.default && legend.default.VID, legendPrestige: legend.prestige && legend.prestige.VID },
            { id: 'facebook', key: 'DFA', logo: '', text: 'GROUP_FACEBOOK', legendNorma: legend.default && legend.default.LIN, legendPrestige: legend.prestige && legend.prestige.DFA },
            { id: 'instagram', key: 'DIN', logo: '', text: 'GROUP_INSTAGRAM', legendNorma: legend.default && legend.default.DIG, legendPrestige: legend.prestige && legend.prestige.DIN },
            { id: 'tiktok', key: 'DTK', logo: '', text: 'GROUP_TIKTOK', legendNorma: legend.default && legend.default.OUD, legendPrestige: legend.prestige && legend.prestige.DTK },
            { id: 'snapchat', key: 'DSN', logo: '', text: 'GROUP_SNAPCHAT', legendNorma: legend.default && legend.default.SOC, legendPrestige: legend.prestige && legend.prestige.DSN },
            { id: 'twich', key: 'DTW', logo: '', text: 'GROUP_TWITCH', legendNorma: legend.default && legend.default.SOC, legendPrestige: legend.prestige && legend.prestige.DTW },
            { id: 'pinterest', key: 'DPI', logo: '', text: 'GROUP_PINTEREST', legendNorma: legend.default && legend.default.OTH, legendPrestige: legend.prestige && legend.prestige.DPI },
            { id: 'twitter', key: 'TWD', logo: '', text: 'GROUP_TWITTER', legendNorma: legend.default && legend.default.TWD, legendPrestige: legend.prestige && legend.prestige.TWD },
            { id: 'other', key: 'DOT', logo: '', text: 'GROUP_OTHER', legendNorma: legend.default && legend.default.OTH, legendPrestige: legend.prestige && legend.prestige.DOT }
          ];
        case 'FRECOVISUAX':
          return [
            { id: 'visual', key: 'VIS', logo: '', text: 'GROUP_VISUAL', legendNorma: legend.default && legend.default.VIS, legendPrestige: legend.prestige && legend.prestige.VIS },
            { id: 'facebook', key: 'SFA', logo: '', text: 'GROUP_FACEBOOK', legendNorma: legend.default && legend.default.LIN, legendPrestige: legend.prestige && legend.prestige.SFA },
            { id: 'instagram', key: 'SIN', logo: '', text: 'GROUP_INSTAGRAM', legendNorma: legend.default && legend.default.DIG, legendPrestige: legend.prestige && legend.prestige.SIN },
            { id: 'tiktok', key: 'STK', logo: '', text: 'GROUP_TIKTOK', legendNorma: legend.default && legend.default.OUD, legendPrestige: legend.prestige && legend.prestige.STK },
            { id: 'snapchat', key: 'SSN', logo: '', text: 'GROUP_SNAPCHAT', legendNorma: legend.default && legend.default.SOC, legendPrestige: legend.prestige && legend.prestige.SSN },
            { id: 'twich', key: 'STW', logo: '', text: 'GROUP_TWITCH', legendNorma: legend.default && legend.default.SOC, legendPrestige: legend.prestige && legend.prestige.STW },
            { id: 'pinterest', key: 'SPI', logo: '', text: 'GROUP_PINTEREST', legendNorma: legend.default && legend.default.OTH, legendPrestige: legend.prestige && legend.prestige.SPI },
            { id: 'twitter', key: 'TWS', logo: '', text: 'GROUP_TWITTER', legendNorma: legend.default && legend.default.TWD, legendPrestige: legend.prestige && legend.prestige.TWS },
            { id: 'other', key: 'SOT', logo: '', text: 'GROUP_OTHER', legendNorma: legend.default && legend.default.OTH, legendPrestige: legend.prestige && legend.prestige.SOT }
          ];
      }
    }

    function getEventsOrdered(filter, selection){
      return _.chain(filter).find({ 'id': 'events' }).result('data')
            .find({ 'name': 'events' }).result('datos').flatMap('children')
            .filter(function (item) { return _.includes(selection, item.id); }).orderBy('id').value();
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout15Service', layout15Service);

  layout15Service.$inject = ['$http', 'filterHelperService', '$q', 'stateManagerService','configurationLoaderService'];
  function layout15Service($http, filterHelperService, $q, stateManagerService, configurationLoaderService) {
    var filterLayout = {};
    var extraInfo = {};
    var service = {
      getW1: getW1,
      getCategories: getCategories,
      getLegend: getLegend
    };

    return service;

    function getW1(query) {
      extraInfo = {};
      filterLayout = stateManagerService.getState('filterLayout');
      var queries = prepareQueries(query, 'PUIG-29NEW-2');
      return getQueries(queries, [transformData.bind(null, extraInfo)]);
    }

    function getLegend(){
      var typeMedia = filterHelperService.getPropertySelected('typeMedia');
      var typeMediaSelected = getMedia(typeMedia);
      var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
      
      var norma = [];
      
      if (_.isArray(filterNorma) && filterNorma.length > 0) {
        _.each(filterNorma, function(resultItem) {
          var normaMap = {
            default: {},
            prestige: {}
          };
          
          if (resultItem.parameters) {
            var filterCountry = _.chain(filterLayout).find({ 'name': 'F5' }).result('content').value();
            var countryFound = _.find(filterCountry, { 'id': resultItem.parameters.$country$ });
            normaMap.country = countryFound && countryFound.text;
            var filterTarget = _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
            var targetFound = _.find(filterTarget, { 'id': resultItem.parameters.$target$ });
            normaMap.target = targetFound && targetFound.text;
            normaMap.year = '20' + resultItem.parameters.$year$;
          }
          
          _.each(typeMediaSelected, function (item) {
            var values = item && item.text && item.text.split(':');
            var variableSet = resultItem.variables || resultItem;
            //Las nuevas normas tienen el prefijo NORMA_
            var foundNorma = _.find(variableSet, { 'name': 'NORMA_' + values[0] });
            //Las antiguas normas tienen el prefijo NORMA
            if (foundNorma === undefined) {
              foundNorma = _.find(variableSet, { 'name': 'NORMA' + values[0] });
            }
            //Las nuevas normas de prestigio tienen el prefijo PRESTIGE
            var foundPrestige = _.find(variableSet, { 'name': 'PRESTIGE' + values[0] });
            //Las antiguas normas de prestigio tienen el prefijo NORMA_PRESTIGE
            if (foundPrestige === undefined) {
              foundPrestige = _.find(variableSet, { 'name': 'NORMA_PRESTIGE' + values[0] });
            }
            
            if (foundNorma) {
              normaMap.default[values[1]] = foundNorma.value;
            }
            if (foundPrestige) {
              normaMap.prestige[values[1]] = foundPrestige.value;
            }
          });
          
          norma.push(normaMap);
        });
      }

      return norma;
    }

    function prepareQueries(query, datasource){
      var campaigns = _.chain(filterLayout).find({ 'name': 'F30X' }).result('content').map('id').value();
      // var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var typeMedia = filterHelperService.getPropertySelected('typeMedia');
      var typeMediaSelected = getMedia(typeMedia);
      var event = filterHelperService.getPropertySelected('period');
      var filterEventsMonths = _.chain(filterLayout).find({ 'name': 'F34X' }).result('content').value();
      var transformEventsMonths = [];
      
      
      var monthsEvent = _.chain(filterEventsMonths).find({ 'id': event }).result('children').map('id').value();
      transformEventsMonths = [].concat(transformEventsMonths, monthsEvent);
      
      extraInfo = {
        campaigns:campaigns,
        events: [event],
        eventMonth: filterEventsMonths
      };

      return _.map(campaigns, function(item){
        return getGroup(query, datasource, item, transformEventsMonths, typeMediaSelected);
      });
    }

    function getGroup(query, dataSource, campaign,  transformEventsMonths, typeMediaSelected){
      /**Preparing filters */
      var filters = {
        F31X: _.orderBy(_.uniq(transformEventsMonths)) ,
        '#GROUP1': [
          { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
          { CRITERIA: [filterHelperService.getPropertySelected('criteria')]}
        ]
      };
      filters['FMEDIOCAMPANYA'] = _.chain(typeMediaSelected)
        .map(function (item) {
          var media = item && item.text && item.text.split(':');
          var mediaSelected = {};
          mediaSelected[media && media[0]] = [campaign];
          return mediaSelected;
        })
        .value();

      return getData(query, dataSource, filters);
    }

    function getData(query, dataSource, filters){
      return {
        datasource: dataSource,
        query: query,
        parameters: {
          $country$: filterHelperService.getPropertySelected('country'),
          $year$: filterHelperService.getPropertySelected('year').substring(4),
          $target$: filterHelperService.getPropertySelected('criteria')
        },
        filters: filters,
        transform: {
          "template": "Vector"
        }
      };
    }

    function getQueries(queries, transformFn){
      return $http({
        method: 'POST',
        url: './api/extract-batch',
        data: {
          "queries": queries,
          "transform": {
            "template": "Join"
          }
        },
        transformResponse: transformFn ? $http.defaults.transformResponse.concat(transformFn) : null
      })
      .then(function (data) {
        return data && data.data;
      })
      .catch(function () {
        return $q.when(null);
      });
    }

    function transformData(extraInfo, data){
      return transformToEvents(data, extraInfo);
    }

    function transformToEvents(data, _extraInfo){    
      return _.chain(data)
      .map(function(rowGroups, _indexRow){  
        var cellRow = [];
        _.each(rowGroups, function(group, _indexGroup){
              /**First group, TOTAL - First line TOTALS */
              var monthsGroupCollection;
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var filteredMonthsFromEvent = _.map(monthsGroupCollection, function(monthsGroup){
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    // Si no es TOTAL(RECOG01), no tiene significación country
                    monthsGroup.color = monthsGroup.rowVariable === 'RECOG01' ? monthsGroup.values[1] : "";
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup; 
                });

                var monthSelected = _.chain(filteredMonthsFromEvent).maxBy('value').value();
                
                cellRow = [].concat(cellRow, {
                  value: monthSelected && monthSelected.value,
                  color: getSignification('c', monthSelected && monthSelected.color),
                  background: getSignification('bg', monthSelected && monthSelected.background)
                });
        });
        return cellRow;
      }).value();
    }

    function getSignification(typeColor, signification) {
      var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTable' }).result('color').value();
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTable' }).result('color').value();
      if (typeColor === 'c') {
        return _.chain(colors).find({ 'id': signification }).result('value').value();
      }
      else {
        return _.chain(backgroundColors).find({ 'id': signification }).result('value').value();
      }
    }

    function getCategories(){
      return _.chain(filterLayout).find({ 'name': 'F30X' }).result('content').map(function(item){
        var splitedText = item && item.text && item.text.split('-');
        item.text = splitedText[0];
        return item;
      }).value();
    }

    function getMedia(typeMedia) {
      return _.chain(filterLayout).find({'name': typeMedia}).result('content').value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout15', {
                url: '/recognitionByMedia?web&jobId',
                breadcrumb: { icon: 'icon-layout-11', label: 'MAIN_HOME_LAYOUT15' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout15/layout15.html',
                        controller: 'Layout15Controller',
                        controllerAs: 'layout15'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout15')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout15 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams','transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams && reportParams.year,
                    period: reportParams && reportParams.period,
                    typeMedia: reportParams && reportParams.typeMedia
                };
                return mainService.getFilterModule('layout15', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout15', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout15Controller', Layout15Controller);

  /** @ngInject */
  function Layout15Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout15Service, filterHelperService, contextVariableService) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false
    };

    vm.view = {
      loading: false,
      hasData: true
    };

    vm.dataTable = {
      columnHeaders:[],
      rowHeaders:[],
      data:[],
      legendData:[],
      events:[]
    };

    var query = {
      FRECOTOTAL: 'PUIG-29TOT',
      FRECOVIDEO: 'PUIG-29VID',
      FRECOVISUAL: 'PUIG-29VIS'
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true' ? true : false;

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: {}
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
        '<div class="item-info">'+
            '<span class="no-margin text-left font-weight_bold">'+($filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE'))+'</span>'+    
        '<div class="item-info margin-top--0_5">'+
            '<span class="no-margin text-left font-weight_bold">'+$filter('uppercase')($filter('translationWithPrefix')('GROUP_VIDEO'))+'</span>'+
        '</div>'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('CORE_VIDEO')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_CORE_VIDEO')+'</p>'+
        '</div>'+
        '<div class="item-info">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_LINEAR_TV')+'</strong>'+
            '<ul><li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_LINEAR_TRAD')+'</li></ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_DIGITAL_TV')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_PAID')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_SMART')+'</li>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_CATCHUP')+'</li>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_STREAM')+'</li>'+          
            '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_OUTDOOR')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TRAIN')+'</li>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TAXI')+'</li>'+          
            '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN_YOUTUBE')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN')+'</li>'+                       
            '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<strong>'+$filter('translationWithPrefix')('GROUP_OTHER')+'</strong>'+
            '<ul>'+
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL')+'</li>'+      
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_CINEMA')+'</li>'+            
              '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_RADIO')+'</li>'+                       
            '</ul>'+          
        '</div>'+

        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('SOCIAL_VIDEOS')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_SOCIAL_VIDEOS')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<span class="no-margin text-left font-weight_bold"> '+$filter('uppercase')($filter('translationWithPrefix')('GROUP_VISUAL'))+'</span>'+
        '</div>'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('OFFLINE_ONLINE')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_OFFLINE_ONLINE')+'</p>'+
        '</div>'+
        '<div class="item-info">'+
            '<p class="no-margin text-left"><strong>'+$filter('translationWithPrefix')('SOCIAL_VISUAL')+'</strong>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_SOCIAL_VISUAL')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_PRINT')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_PRINT_CONVPRESS')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL')+'</li>'+                       
          '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_SHOP')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('GROUP_SHOP')+'</li>'+   
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_SHOP_RETAIL')+'</li>'+              
          '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_OUTDOOR')+'</strong>'+
          '<ul>'+
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_TRANSPORT')+'</li>'+            
            '<li>'+$filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_STREET')+'</li>'+            
          '</ul>'+          
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS')+'</strong>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
          '<strong>'+$filter('translationWithPrefix')('GROUP_BRAND_WEBSITES')+'</strong>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left">'+$filter('translationWithPrefix')('BEST_DATA_MEDIA_EVENT')+'</p>'+
        '</div>'+    
        '<div>'
      ;

    vm.serviceView = layout15Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      var contextOptions = { 'allTargets': false, 'filterPeriodInfo':{ 'id': 'period', 'nameFilter': 'F32X'} };
      var contextMap = {
          period: filterHelperService.getFilterElementSelected(vm.filter.data, 'period'),
          country: filterHelperService.getFilterElementSelected(vm.filter.data, 'country'),
          criteria: filterHelperService.getFilterElementSelected(vm.filter.data, 'criteria')
      };

      contextVariableService.getFilter.call(contextMap, 'contextVariables', contextOptions).then(function() {
          var typeMedia = filterHelperService.getPropertySelected('typeMedia');
          
          layout15Service.getW1(query[typeMedia])
            .then(function (data) {          
              vm.view.hasData = true;          
              /*Prepare data to table **/
              vm.dataTable.rowHeaders = layout15Service.getCategories();
              var legendNormas = layout15Service.getLegend();
              vm.dataTable.legend = {
                typeLegend: typeMedia,
                typeMedia: typeMedia,
                normas: legendNormas
              };
              vm.dataTable.events = vm.filter.data.find(function(item) { return item.id === 'year'; });
              vm.dataTable.columnHeaders = setColumnHeaders(typeMedia, legendNormas[0]);
              vm.dataTable.data = data;
          
              var order = orderTable(0, vm.dataTable.rowHeaders, vm.dataTable.data);
              vm.dataTable.rowHeaders = _.chain(order).map('cat').value();
              vm.dataTable.data = _.chain(order).map('collection').value();
    
              if(order && order.length > 0){
                vm.dataTable.rowHeaders = _.chain(order).map('cat').value();
                vm.dataTable.data = _.chain(order).map('collection').value();
              }
              else{
                vm.view.hasData = false;
              }
              
    
              /**Xls clipboard */
              vm.copyXls.copyToXlsData = {
                rowHeaders: vm.dataTable.rowHeaders,
                columnHeaders: vm.dataTable.columnHeaders,
                data: vm.dataTable.data
              };
            })
            .catch(function () {
              vm.view.hasData = false;
            })
            .finally(function () {
              vm.view.loading = false;
              $rootScope.$emit('printReport', true);
            });
      });
    }

    function copyToXlsFn(data) {
      var groupCampaigns = [""];
      var allRows = [];

      _.each(data && data.columnHeaders, function(group){
          groupCampaigns = [].concat(groupCampaigns, $filter('translationWithPrefix')(group && group.text));
      });

      _.each(data && data.rowHeaders, function (rows, indexRow) {
        var titleRow = rows && rows.text;
        var dataRow = _.chain(data && data.data && data.data[indexRow]).map(function(cell){return $filter('round')((cell && cell.value), 0);}).value();
        allRows.push([].concat(titleRow, dataRow));
      });

      var rowData = [groupCampaigns];
      
      _.each(allRows,function(row){
        rowData.push(row);
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }

    function setColumnHeaders(media, normaLegend){
   
      switch ( media ){
        case 'FRECOTOTAL':
          return [
            { id: 'total', logo: '', text: 'GROUP_CAMPAIGN', legendNorma: normaLegend.default && normaLegend.default.T, legendPrestige: normaLegend.prestige && normaLegend.prestige.T },
            { id: 'video', logo: '', text: 'GROUP_VIDEO', legendNorma: normaLegend.default && normaLegend.default.VID, legendPrestige: normaLegend.prestige && normaLegend.prestige.VID},
            { id: 'visual', logo: '', text: 'GROUP_VISUAL', legendNorma: normaLegend.default && normaLegend.default.VIS, legendPrestige: normaLegend.prestige && normaLegend.prestige.VIS}
          ];
        case 'FRECOVIDEO':
          return [
            { id: 'video', logo: '', text: 'GROUP_VIDEO', legendNorma: normaLegend.default && normaLegend.default.VID, legendPrestige: normaLegend.prestige && normaLegend.prestige.VID },
            { id: 'linear_tv', logo: '', text: 'GROUP_LINEAR_TV', legendNorma: normaLegend.default && normaLegend.default.LIN, legendPrestige: normaLegend.prestige && normaLegend.prestige.LIN },
            { id: 'digital_tv', logo: '', text: 'GROUP_DIGITAL_TV', legendNorma: normaLegend.default && normaLegend.default.DIG, legendPrestige: normaLegend.prestige && normaLegend.prestige.DIG },
            { id: 'outdoor', logo: '', text: 'GROUP_OUTDOOR', legendNorma: normaLegend.default && normaLegend.default.OUD, legendPrestige: normaLegend.prestige && normaLegend.prestige.OUD },
            { id: 'social_networks', logo: '', text: 'GROUP_SOCIAL_NETWORKS', legendNorma: normaLegend.default && normaLegend.default.SOC, legendPrestige: normaLegend.prestige && normaLegend.prestige.SOC },
            { id: 'ohter', logo: '', text: 'GROUP_OTHER', legendNorma: normaLegend.default && normaLegend.default.OTH, legendPrestige: normaLegend.prestige && normaLegend.prestige.OTH }
          ];
        case 'FRECOVISUAL':
          return [
            { id: 'visual', logo: '', text: 'GROUP_VISUAL', legendNorma: normaLegend.default && normaLegend.default.VIS, legendPrestige: normaLegend.prestige && normaLegend.prestige.VIS },
            { id: 'print', logo: '', text: 'GROUP_PRINT', legendNorma: normaLegend.default && normaLegend.default.PRI, legendPrestige: normaLegend.prestige && normaLegend.prestige.PRI },
            { id: 'shop', logo: '', text: 'GROUP_SHOP', legendNorma: normaLegend.default && normaLegend.default.SHO, legendPrestige: normaLegend.prestige && normaLegend.prestige.SHO },
            { id: 'outdoor', logo: '', text: 'GROUP_OUTDOOR', legendNorma: normaLegend.default && normaLegend.default.OUV, legendPrestige: normaLegend.prestige && normaLegend.prestige.OUV },
            { id: 'social_networks', logo: '', text: 'GROUP_SOCIAL_NETWORKS', legendNorma: normaLegend.default && normaLegend.default.SOV, legendPrestige: normaLegend.prestige && normaLegend.prestige.SOV },
            { id: 'brand_websites', logo: '', text: 'GROUP_BRAND_WEBSITES', legendNorma: normaLegend.default && normaLegend.default.BRA, legendPrestige: normaLegend.prestige && normaLegend.prestige.BRA }
          ];
      }
    }

    function orderTable(indexColumn, categories, data){
      return _.chain(categories)
        .map(function(cat, index){
          var newOrder = {
            cat: '',
            indexValue: null,
            collection: []
          };
          newOrder.cat = cat ;
          newOrder.indexValue = _.chain(data[index][indexColumn]).result('value').value();
          newOrder.collection = data[index];
          return newOrder;
        })
        .filter(function(item){
          return item && item.indexValue && parseInt(item.indexValue) > 0;
        })
        .orderBy(['indexValue'],['desc'])
      .value();

    }   
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout14Service', layout14Service);

  layout14Service.$inject = ['$http', 'filterHelperService', '$q', 'stateManagerService','configurationLoaderService'];
  function layout14Service($http, filterHelperService, $q, stateManagerService, configurationLoaderService) {
    var filterLayout = {};
    var extraInfo = {};
    var service = {
      getW1: getW1,
      getCategories: getCategories,
      getLegend: getLegend
    };

    return service;

    function getW1() {
      extraInfo = {};
      filterLayout = stateManagerService.getState('filterLayout');
      var queries = prepareQueries('PUIG-29');
      return getQueries(queries, [transformData.bind(null, extraInfo)]);
    }

    function getLegend(){
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
      var norma = {
        default:{},
        prestige:{}
      };
      _.each(filterRecogMedia, function(item){
        var values = item && item.text && item.text.split(':');
        var valueNorma = _.chain(filterNorma).find({'name':'NORMA'+values[0]}).result('value').value();
        var valuePrestige = _.chain(filterNorma).find({ 'name': 'NORMA_PRESTIGE' + values[0] }).result('value').value();
        norma.default[values[1]] = valueNorma;
        norma.prestige[values[1]] = valuePrestige;
      });
      return norma;
    }

    function prepareQueries(query){
      var campaigns = _.chain(filterLayout).find({ 'name': 'F30' }).result('content').map('id').value();
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var event = filterHelperService.getPropertySelected('period');
      var filterEventsMonths = _.chain(filterLayout).find({ 'name': 'F34' }).result('content').value();
      var transformEventsMonths = [];
      
      
      var monthsEvent = _.chain(filterEventsMonths).find({ 'id': event }).result('children').map('id').value();
      transformEventsMonths = [].concat(transformEventsMonths, monthsEvent);
      
      extraInfo = {
        campaigns:campaigns,
        events: [event],
        eventMonth: filterEventsMonths
      };

      return _.map(campaigns, function(item){
        return getGroup(query, item, transformEventsMonths, filterRecogMedia);
      });
    }

    function getGroup(dataSource, campaign,  transformEventsMonths, filterRecogMedia){
      /**Preparing filters */
      var filters = {
        F31: _.orderBy(_.uniq(transformEventsMonths)) ,
        '#GROUP1': [
          { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) }
        ]
      };
      filters['FMEDIOCAMPANYA'] = _.chain(filterRecogMedia)
        .map(function (item) {
          var media = item && item.text && item.text.split(':');
          var mediaSelected = {};
          mediaSelected[media && media[0]] = [campaign];
          return mediaSelected;
        })
        .value();

      return getData(dataSource, filters);
    }

    function getData(dataSource, filters){
      return {
        datasource: dataSource,
        query: dataSource,
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: filters,
        transform: {
          "template": "Vector"
        }
      };
    }

    function getQueries(queries, transformFn){
      return $http({
        method: 'POST',
        url: './api/extract-batch',
        data: {
          "queries": queries,
          "transform": {
            "template": "Join"
          }
        },
        transformResponse: transformFn ? $http.defaults.transformResponse.concat(transformFn) : null
      })
      .then(function (data) {
        return data && data.data;
      })
      .catch(function () {
        return $q.when(null);
      });
    }

    function transformData(extraInfo, data){
      return transformToEvents(data, extraInfo);
    }

    function transformToEvents(data, _extraInfo){    
      return _.chain(data)
      .map(function(rowGroups, _indexRow){  
        var cellRow = [];
        _.each(rowGroups, function(group, _indexGroup){
              /**First group, TOTAL - First line TOTALS */
              var monthsGroupCollection;
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var filteredMonthsFromEvent = _.map(monthsGroupCollection, function(monthsGroup){
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    monthsGroup.color = monthsGroup.values[1];
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup; 
                });

                var monthSelected = _.chain(filteredMonthsFromEvent).maxBy('value').value();
                
                cellRow = [].concat(cellRow, {
                  value: monthSelected && monthSelected.value,
                  color: getSignification('c', monthSelected && monthSelected.color),
                  background: getSignification('bg', monthSelected && monthSelected.background)
                });
        });
        return cellRow;
      }).value();
    }

    function getSignification(typeColor, signification) {
      var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTable' }).result('color').value();
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTable' }).result('color').value();
      if (typeColor === 'c') {
        return _.chain(colors).find({ 'id': signification }).result('value').value();
      }
      else {
        return _.chain(backgroundColors).find({ 'id': signification }).result('value').value();
      }
    }

    function getCategories(){
      return _.chain(filterLayout).find({ 'name': 'F30' }).result('content').map(function(item){
        var splitedText = item && item.text && item.text.split('-');
        item.text = splitedText[0];
        return item;
      }).value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout14', {
                url: '/recognitionByMedia?web&jobId',
                breadcrumb: { icon: 'icon-layout-14', label: 'MAIN_HOME_LAYOUT14' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout14/layout14.html',
                        controller: 'Layout14Controller',
                        controllerAs: 'layout14'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout14')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout14 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams','transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams && reportParams.year,
                    period: reportParams && reportParams.period
                };
                return mainService.getFilterModule('layout14', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout14', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout14Controller', Layout14Controller);

  /** @ngInject */
  function Layout14Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout14Service) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false
    };

    vm.view = {
      loading: false,
      hasData: true
    };

    vm.dataTable = {
      columnHeaders:[],
      rowHeaders:[],
      data:[],
      legendData:[]
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true' ? true : false;

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: {}
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">'+
            '<p class="no-margin text-left"> '+$filter('translationWithPrefix')('ADVERTS_TV_PRINT_OUTDOOR_INTERNET')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left">'+$filter('translationWithPrefix')('BEST_DATA_MEDIA_EVENT')+'</p>'+
        '</div>'+
        '<div>'
      ;

    vm.serviceView = layout14Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      layout14Service.getW1()
        .then(function (data) {
          vm.view.hasData = true;
          
          /*Prepare data to table **/
          vm.dataTable.rowHeaders = layout14Service.getCategories();
          vm.dataTable.columnHeaders = setColumnHeaders(data);
          vm.dataTable.legend = layout14Service.getLegend();
          vm.dataTable.data = data;
      
          var order = orderTable(0, vm.dataTable.rowHeaders, vm.dataTable.data);
          vm.dataTable.rowHeaders = _.chain(order).map('cat').value();
          vm.dataTable.data = _.chain(order).map('collection').value();

          if(order && order.length > 0){
            vm.dataTable.rowHeaders = _.chain(order).map('cat').value();
            vm.dataTable.data = _.chain(order).map('collection').value();
          }
          else{
            vm.view.hasData = false;
          }
          

          /**Xls clipboard */
          vm.copyXls.copyToXlsData = {
            rowHeaders: vm.dataTable.rowHeaders,
            columnHeaders: vm.dataTable.columnHeaders,
            data: vm.dataTable.data
          };
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function copyToXlsFn(data) {
      var groupCampaigns = [""];
      var allRows = [];

      _.each(data && data.columnHeaders, function(group){
          groupCampaigns = [].concat(groupCampaigns, $filter('translationWithPrefix')(group && group.text));
      });

      _.each(data && data.rowHeaders, function (rows, indexRow) {
        var titleRow = rows && rows.text;
        var dataRow = _.chain(data && data.data && data.data[indexRow]).map(function(cell){return $filter('round')((cell && cell.value), 0);}).value();
        allRows.push([].concat(titleRow, dataRow));
      });

      var rowData = [groupCampaigns];
      
      _.each(allRows,function(row){
        rowData.push(row);
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }

    function setColumnHeaders(){
      return [
        { 'id': 'total', logo: 'c_campaign.svg', text: 'GROUP_CAMPAIGN' },
        { 'id': 'tv', logo: 'c_tv.svg', text: 'GROUP_TV' },
        { 'id': 'print', logo: 'c_print.svg', text: 'GROUP_PRINT' },
        { 'id': 'outdoor', logo: 'c_outdoor.svg', text: 'GROUP_OUTDOOR' },
        { 'id': 'digital', logo: 'c_digital.svg', text: 'GROUP_DIGITAL' }
      ];
    }

    function orderTable(indexColumn, categories, data){
      return _.chain(categories)
        .map(function(cat, index){
          var newOrder = {
            cat: '',
            indexValue: null,
            collection: []
          };
          newOrder.cat = cat ;
          newOrder.indexValue = _.chain(data[index][indexColumn]).result('value').value();
          newOrder.collection = data[index];
          return newOrder;
        })
        .filter(function(item){
          return item && item.indexValue && parseInt(item.indexValue) > 0;
        })
        .orderBy(['indexValue'],['desc'])
      .value();

    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout12Service', layout12Service);

  layout12Service.$inject = ['$http', 'filterHelperService', '$q', 'stateManagerService','configurationLoaderService'];
  function layout12Service($http, filterHelperService, $q, stateManagerService, configurationLoaderService) {
    var filterLayout = {};
    var extraInfo = {};
    var service = {
      getW1: getW1,
      getCategories: getCategories,
      getLegend: getLegend
    };

    return service;

    function getW1() {
      extraInfo = {};
      filterLayout = stateManagerService.getState('filterLayout');
      var queries = prepareQueries('PUIG-29');
      return getQueries(queries, extraInfo);
    }

    function getLegend(){
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
      var norma = {
        default:{},
        prestige:{}
      };
      _.each(filterRecogMedia, function(item){
        var values = item && item.text && item.text.split(':');
        var valueNorma = _.chain(filterNorma).find({'name':'NORMA'+values[0]}).result('value').value();
        var valuePrestige = _.chain(filterNorma).find({ 'name': 'NORMA_PRESTIGE' + values[0] }).result('value').value();
        norma.default[values[1]] = valueNorma;
        norma.prestige[values[1]] = valuePrestige;
      });
      return norma;
    }

    function prepareQueries(query){
      var criteria = _.chain(filterLayout).find({'name':'CRITERIA'}).result('content').value();
      var campaigns = filterHelperService.getPropertySelected('campaigns');
      var typeEvent = filterHelperService.getPropertySelected('typeEvent');
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var events = _.orderBy(filterHelperService.getPropertySelected('events'));
      var filterEventsMonths = _.chain(filterLayout).find({ 'name': 'F34' }).result('content').value();
      var transformEventsMonths = [];
      if (typeEvent === 'E') {
        _.each(events, function (item) {
          var monthsEvent = _.chain(filterEventsMonths).find({ 'id': item }).result('children').map('id').value();
          transformEventsMonths = [].concat(transformEventsMonths, monthsEvent);
        });
      }
      extraInfo = {
        events: events,
        typeEvent: typeEvent,
        eventMonth: filterEventsMonths
      };
      return _.map(criteria, function(item){
        return getGroup(query, item && item.id, transformEventsMonths, events, typeEvent, filterRecogMedia, campaigns);
      });
    }

    function getGroup(dataSource, criteriaSelected, transformEventsMonths, events, typeEvent, filterRecogMedia, campaigns){
      /**Preparing filters */
      var filters = {
        F31: typeEvent === 'E' ? _.orderBy(_.uniq(transformEventsMonths)) : events ,
        '#GROUP1': [
          { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) },
          { CRITERIA: [criteriaSelected] }
        ]
      };
      filters['FMEDIOCAMPANYA'] = _.chain(filterRecogMedia)
        .map(function (item) {
          var media = item && item.text && item.text.split(':');
          var mediaSelected = {};
          mediaSelected[media && media[0]] = [campaigns];
          return mediaSelected;
        })
        .value();

      return getData(dataSource, filters);
    }

    function getData(dataSource, filters){
      return {
        datasource: dataSource,
        query: dataSource,
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: filters,
        transform: {
          "template": "Vector"
        }
      };
    }

    function getQueries(queries, extraInfo){
      return $http({
        method: 'POST',
        url: './api/extract-batch',
        data: {
          "queries": queries,
          "transform": {
            "template": "Join"
          }
        },
        transformResponse: $http.defaults.transformResponse.concat([transformData.bind(null, extraInfo)])
      })
      .then(function (data) {
        return data && data.data;
      })
      .catch(function () {
        return $q.when(null);
      });
    }

    function transformData(extraInfo, data){
      if ((extraInfo && extraInfo.typeEvent === 'M')){
        return transformToMonths(data, extraInfo);
      }
      else{
        return transformToEvents(data, extraInfo);
      }
    }

    function transformToEvents(data, extraInfo){    
      var monthsEvents = getMonthsEvents(extraInfo);
      var monthsSelected = [];
      return _.chain(data)
      .map(function(rowGroups, indexRow){  
        var cellRow = [];
        _.each(rowGroups, function(group, indexGroup){
            _.each(monthsEvents, function (months, indexEvents) {
              /**First group, TOTAL - First line TOTALS */
              var monthsGroupCollection;
              if (indexGroup === 0 && indexRow === 0) {
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var filteredMonthsFromEvent = _.filter(monthsGroupCollection, function(monthsGroup){
                  if (_.includes(months.months, 'M'+monthsGroup.ColumnCategory)) { 
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    monthsGroup.color = monthsGroup.values[1];
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup; 
                  }
                });

                var monthSelected = _.chain(filteredMonthsFromEvent).maxBy('value').value();
                if(monthSelected){
                  monthsSelected.push('M' + (monthSelected && monthSelected.ColumnCategory));
                }
                else{
                  monthsSelected.push('');
                }
                cellRow = [].concat(cellRow, {
                  value: monthSelected && monthSelected.value,
                  color: getSignification('c', monthSelected && monthSelected.color),
                  background: getSignification('bg', monthSelected && monthSelected.background)
                });
              }
              else{
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var monthFromEventFound = _.find(monthsGroupCollection, function (monthsGroup) {
                  if (('M' + monthsGroup.ColumnCategory) === monthsSelected[indexEvents]) {
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    monthsGroup.color = monthsGroup.values[1];
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup;
                  }
                });

                cellRow = [].concat(cellRow, {
                  value: monthFromEventFound && monthFromEventFound.value,
                  color: getSignification('c', monthFromEventFound && monthFromEventFound.color),
                  background: getSignification('bg', monthFromEventFound && monthFromEventFound.background)
                });
              }
            });
        });
        return cellRow;
      }).value();
    }

    function transformToMonths(data, extraInfo) {
      return _.chain(data)
        .map(function (rowGroups, _indexRow) {
          var cellRow = [];
          _.each(rowGroups, function (group, _indexGroup) {
            _.each(extraInfo && extraInfo.events, function(monthSel){
              var groupMonths = _.chain(_.reduce(group)).value();
              var monthFound = _.chain(groupMonths).find({'ColumnCategory': monthSel && monthSel.replace('M','')}).value();
              if(monthFound){
                monthFound.values = angular.copy(monthFound.value);
                monthFound.value = monthFound.values[0];
                monthFound.color = monthFound.values[1];
                monthFound.background = monthFound.values[2];

                cellRow = [].concat(cellRow, {
                  value: monthFound && monthFound.value,
                  color: getSignification('c', monthFound && monthFound.color),
                  background: getSignification('bg', monthFound && monthFound.background)
                });
              }
              else{
                cellRow = [].concat(cellRow, {
                  value: null,
                  color: '',
                  background: ''
                });
              }
            });
          });
          return cellRow;
        }).value();
    }

    function getMonthsEvents(extraInfo){
      return _.chain(extraInfo && extraInfo.events).map(function (item) {
        var monthEvents = {
          id: '',
          months: []
        };
        var months = _.chain(extraInfo && extraInfo.eventMonth).find({ 'id': item }).result('children').map('id').value();
        monthEvents.id = item;
        monthEvents.months = months;
        return monthEvents;
      })
      .value();
    }

    function getSignification(typeColor, signification) {
      var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTableHistoric' }).result('color').value();
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTableHistoric' }).result('color').value();
      if (typeColor === 'c') {
        return _.chain(colors).find({ 'id': signification }).result('value').value();
      }
      else {
        return _.chain(backgroundColors).find({ 'id': signification }).result('value').value();
      }
    }

    function getCategories(){
      return _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout12', {
                url: '/recognitionByMediaAndTargetHistoric?web&jobId',
                breadcrumb: { icon: 'icon-layout-12', label: 'MAIN_HOME_LAYOUT12' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout12/layout12.html',
                        controller: 'Layout12Controller',
                        controllerAs: 'layout12'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout12')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout12 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams','transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    campaigns: reportParams && reportParams.campaigns,
                    events: reportParams && reportParams.events,
                    typeEvent: reportParams && reportParams.typeEvent
                };
                return mainService.getFilterModule('layout12', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout12', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout12Controller', Layout12Controller);

  /** @ngInject */
  function Layout12Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout12Service, errorHandlerService, filterHelperService) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter: preApplyFilter
    };

    vm.view = {
      loading: false,
      hasData: true
    };

    vm.dataTable = {
      columnHeaders:[],
      rowHeaders:[],
      data:[],
      legendData:[],
      events:[]
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true' ? true : false;

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: {}
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">'+
            '<p class="no-margin text-left"> '+$filter('translationWithPrefix')('ADVERTS_TV_PRINT_OUTDOOR_INTERNET')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left">'+$filter('translationWithPrefix')('BEST_DATA_CAMPAIGN_EVENT')+'</p>'+
        '</div>'+
        '<div>'
      ;

    vm.serviceView = layout12Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      layout12Service.getW1()
        .then(function (data) {
          vm.view.hasData = true;
          
          /*Prepare data to table **/
          vm.dataTable.rowHeaders = layout12Service.getCategories();
          vm.dataTable.columnHeaders = setColumnHeaders(data);
          vm.dataTable.events = getEventsOrdered(vm.filter.data, filterHelperService.getFilterElementSelected(vm.filter && vm.filter.data, 'events'));
          vm.dataTable.legend = layout12Service.getLegend();
          vm.dataTable.data = data;
          
          /**Xls clipboard */
          vm.copyXls.copyToXlsData = {
            rowHeaders: vm.dataTable.rowHeaders,
            columnHeaders: vm.dataTable.columnHeaders,
            data: vm.dataTable.data,
            events: vm.dataTable.events
          };
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function preApplyFilter(filter) {
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si tengo seleccionado en el filtro de red un COUNTRY.
       */
      var eventFilter = {
        numberSelected: _.chain(filter).find({ 'id': 'events' }).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({ 'id': 'events' }).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({ 'id': 'events' }).result('data').first().result('minSelections').value()
      };

      //El filtro brands no cumple con el numero minimo de selecciones
      if (!checkRange(eventFilter.numberSelected, eventFilter.min, eventFilter.max)) {
        errorHandlerService.callbackWarning.call({ text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_EVENTS_L18') });
        return false;
      }

      return true;
    }

    function checkRange(value, min, max) {
      return value >= min && value <= max ? true : false;
    }

    function copyToXlsFn(data) {
      var groupCampaigns = [""];
      var allEvents = [""];
      var allRows = [];

      _.each(data && data.columnHeaders, function(group){
        _.each(data && data.events, function (event, index) {
          groupCampaigns = [].concat(groupCampaigns, index === 0 ? $filter('translationWithPrefix')(group && group.text) : '');
          allEvents = [].concat(allEvents, event && event.text);
        });
      });

      _.each(data && data.rowHeaders, function (rows, indexRow) {
        var titleRow = rows && rows.text;
        var dataRow = _.chain(data && data.data && data.data[indexRow]).map(function(cell){return $filter('round')((cell && cell.value), 0);}).value();
        allRows.push([].concat(titleRow, dataRow));
      });

      var rowData = [groupCampaigns, allEvents];
      
      _.each(allRows,function(row){
        rowData.push(row);
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }

    function setColumnHeaders(){
      return [
        { 'id': 'total', logo: 'c_campaign.svg', text: 'GROUP_CAMPAIGN' },
        { 'id': 'tv', logo: 'c_tv.svg', text: 'GROUP_TV' },
        { 'id': 'print', logo: 'c_print.svg', text: 'GROUP_PRINT' },
        { 'id': 'outdoor', logo: 'c_outdoor.svg', text: 'GROUP_OUTDOOR' },
        { 'id': 'digital', logo: 'c_digital.svg', text: 'GROUP_DIGITAL' }
      ];
    }

    function getEventsOrdered(filter, selection){
      return _.chain(filter).find({ 'id': 'events' }).result('data')
            .find({ 'name': 'events' }).result('datos').flatMap('children')
            .filter(function (item) { return _.includes(selection, item.id); }).orderBy('id').value();
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout13Service', layout13Service);

  layout13Service.$inject = ['$http', 'filterHelperService', '$q', '$filter', 'stateManagerService', '$stateParams', 'configurationLoaderService', 'd3','odecD3Service'];
  function layout13Service($http, filterHelperService, $q, $filter, stateManagerService, $stateParams, configurationLoaderService, d3, odecD3Service) {
    var filterLayout;
    var service = {
      getW1: getW1,
      getCategories:getCategories,
      getConfigChart: getConfigChart,
      getChartData: getChartData,
      getLegend:getLegend,
      getTooltip:getTooltip,
      getEventsToLegend: getEventsToLegend
    };

    return service;

    function getW1() {
      filterLayout = stateManagerService.getState('filterLayout');
      return $q.all([getAudience('PUIG-30'), getTooltip('PUIG-27')]);
    }

    function getTooltip(dataSource){
      var filters = getFiltersTooltip();

      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: {
          datasource: dataSource,
          query: dataSource,
          parameters: {
            $country$: filterHelperService.getPropertySelected('country')
          },
          filters: filters,
          transform: {
            template: "FlattenText",
            parameters: {
              flattenBy: "Columns"
            }
          }
        }
      })
      .then(function(data){
        return data && data.data;
      })
      .catch(function(_error){
        return $q.when([]);
      });
    }

    function getFiltersTooltip(){
      var campaign = filterHelperService.getPropertySelected('campaigns');
      var country = filterHelperService.getPropertySelected('country');

      var elementsF31All = _.chain(filterLayout).find({ 'name': 'F31' }).result('content').find({ 'id': 'M' }).result('children').flatMap('children').value();
      var indexPeriodSelected = _.findIndex(elementsF31All, { 'id': filterHelperService.getPropertySelected('period') });
      //Periodos hacia atras máximos
      var fixedPeriods = 24;
      var elementsF31Next = [].concat(_.chain(elementsF31All).slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods).map('id').value());
      var filterEti = {};
      filterEti[(campaign && campaign.replace('T',''))+country] = [];

      var filters = {
        F31: _.reverse(elementsF31Next),
        FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')),
        FILTRO_ETI: [filterEti]
      };

      return filters;
    }

    function getAudience(dataSource){
      var campaign = filterHelperService.getPropertySelected('campaigns');
      var criteria = filterHelperService.getPropertySelected('criteria');
      var filterRecogMedia = _.chain(filterLayout).find({'name':'FRECOGMEDIA'}).result('content').value();
      var elementsF31All = _.chain(filterLayout).find({ 'name': 'F31' }).result('content').find({ 'id': 'M' }).result('children').flatMap('children').value();
      var indexPeriodSelected = _.findIndex(elementsF31All, { 'id': filterHelperService.getPropertySelected('period') });
      //Periodos hacia atras máximos
      var fixedPeriods = 24;
      var elementsF31Next = [].concat(_.chain(elementsF31All).slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods).map('id').value());

      var filters = {
        F31: _.reverse(elementsF31Next),
        '#GROUP1':[
          {FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country'))},
          { CRITERIA: [criteria]}
        ]
      };

      //FMEDIOCAMPAÑA
      filters['FMEDIOCAMPANYA'] = _.chain(filterRecogMedia)
                                    .map(function(item){
                                      var media = item && item.text && item.text.split(':');
                                      var mediaSelected = {};
                                      mediaSelected[media && media[0]] = [campaign];
                                      return mediaSelected;
                                    })
                                  .value();

      return getData(dataSource, filters);
    }

    function getLegend() {
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
      var norma = {
      };
      _.each(filterRecogMedia, function (item) {
        var values = item && item.text && item.text.split(':');
        var valueNorma = _.chain(filterNorma).find({ 'name': 'NORMA' + values[0] }).result('value').value();
        norma[values[1]] = valueNorma;
      });

      return norma;
    }

    function getCategories(data){
      return _.chain(data).value();
    }

    function getChartData(data) {
      var colorSeries = getColorsSeries();
      var colorSignification = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignificationHistoric' }).result('color').value();
      var bgSignification = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundChartSignificationHistoric' }).result('color').value();
      return _.chain(data)
        .map(function (item, _index) {
          var filterLayout = stateManagerService.getState('filterLayout');
          var metricsAvail = _.chain(filterLayout).find({ 'name': 'F29' }).result('content').find({ 'id': filterHelperService.getPropertySelected('market') }).result('children').value();
          var nameMetric = item && item.id && item.id.substring(0, item.id.length - 4);
          var metricFound = _.chain(metricsAvail).find({ 'id': nameMetric }).value() ? _.chain(metricsAvail).find({ 'id': nameMetric }).result('text').value() : null;
          return {
            id: item && item.id,
            animation: $stateParams && $stateParams.web === 'true' ? true : false,
            color: _.chain(colorSeries).find({ 'id': item && item.id }).result('value').value(),
            lineWidth: item && item.id === 'RECOG99' ? 3 : 2,
            data: _.map(item.values, function (itemValues, index) {
              var x = {
                y: '',
                dataLabels: {
                  color: _.chain(colorSignification).find({ 'id': item && item.types[index] }).result('value').value()
                }
              };
              x.y = itemValues;
              return x;
            }),
            dataLabels:{
              formatter:function(){
                var index = this && this.point && this.point.index;
                var typesPrev = _.chain(item && item.typesPrev).get(index).value();
                var color = _.chain(bgSignification).find({ 'id': typesPrev }).result('value').value();
                if(typesPrev === '-' || typesPrev === ''){
                  return this && this.y && this.y.toFixed(0);
                }
                else{
                  if(typesPrev === 'U'){
                    return this && this.y && this.y.toFixed(0) + ' <i class="icon-caret-up icon-size-lg signification-icon" style="color:' + color +'"></i>';
                  }else{
                    return this && this.y && this.y.toFixed(0) + ' <i class="icon-caret-down icon-size-lg signification-icon" style="color:'+color+'"></i>';
                  }
                }
                
              }
            },
            name: metricFound ? $filter('uppercase')(metricFound) : $filter('uppercase')(item && item.text),
            marker: {
              symbol: 'circle',
              fillColor: 'white',
              lineColor: null,
              lineWidth: 2
            },
            visible: true
          };
        })
        .value();
    }

    function formatLabelsPlotBands(){
      var chart = this;
      var xAxis = chart && chart.xAxis && chart.xAxis[0];
      var allText = d3.selectAll('.highcharts-plot-band-label').nodes();
      _.each(angular.copy(xAxis.plotLinesAndBands), function (item, index) {
        var widthPlotBand = d3.select('.' + (item && item.id)).node().getBBox().width;
        
        var textNode = d3.select(allText[index]);
        var auxNode = angular.copy(textNode);
        var posXNode = auxNode.attr('x');
        var posYNode = auxNode.attr('y');
        var textNodeValue = angular.copy(item && item.options && item.options.label && item.options.label.text);

        textNode.selectAll('tspan').remove();

        //textNodeValue = textNodeValue.replace('-', ' ').replace('\'',' \'');

        // if(widthPlotBand < 50){
        //   textNode
        //     .text(textNodeValue)
        //     .attr('x', posXNode)
        //     .attr('y', posYNode)
        //     //.attr('font-size', 10)
        //     .call(odecD3Service.ellipsis.bind(textNode.node(), widthPlotBand*.8));
        // }
        // else{
          textNode
            .text(textNodeValue)
            .attr('x', posXNode)
            .attr('y', posYNode)
            .call(odecD3Service.wrapText, widthPlotBand * .75, "middle", 10, 4);
        //}
        
      });
    }

    function getConfigChart(tooltips,categories,max, min) {
      return {
        chart: {
          renderTo: null,
          type: 'spline',
          style: {
            fontFamily: 'Montserrat'
          },
          marginTop:50,
          marginRight: 50,
                events: {
                  load: formatLabelsPlotBands,
                  redraw: formatLabelsPlotBands
                }
        },
        title: {
          text: ''
        },
        subtitle: {
          text: null
        },
        xAxis: {
          labels: {
            formatter: function () {
              return this.value && this.value.text && this.value.text.toUpperCase();
            }
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          gridLineWidth: 1,
          lineWidth: 0,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          plotBands: getEventsToPlotBands(_.map(categories, 'id'))
        },
        yAxis: [{
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          //lineWidth:1,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          showEmpty: true
          //tickInterval: range
        },
        {
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dot',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          //lineWidth:1,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          opposite: true,
          showEmpty: true
          //tickInterval: range
        }],
        plotOptions: {
          spline: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              style: {
                fontWeight: 'bold',
                textOutline: "0px contrast"
              }
            },
            enableMouseTracking: true
          },
          series: {
            lineWidth: 1,
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 3
            },
            states: {
              inactive: {
                opacity: 1
              }
            }
          }
        },
        legend: {
          enabled: true,
          symbolWidth: 40,
          align: 'center',
          verticalAlign: 'top',
          floating: true,
          x: 0,
          y: 0
        },
        tooltip: {
          enabled: true,
          shared: true,
          useHTML: true,
          backgroundColor: 'white',
          crosshairs: false,
          padding: 0,
          borderWidth: 0,
          shadow: false,
          formatter: function () {
            
            var nameCampaign = _.chain(filterLayout).find({ 'name': 'F30' }).result('content').find({ 'id': filterHelperService.getPropertySelected('campaigns')}).result('text').split('-').get(0).value();
            var idCampaign = _.chain(filterLayout).find({ 'name': 'F30' }).result('content').find({ 'id': filterHelperService.getPropertySelected('campaigns') }).result('id').replace('T','').value();
            var monthSel = this.x && this.x.id;
            var campaignChange = _.chain(tooltips).find(function(item){
              if(_.includes(item && item.id && item.id,idCampaign)){
                return item;
              }
            }).result('values')
              .find(function (item) {
                if (_.includes(item && item.id && item.id,monthSel)) { return item; }
              }).result('values').reduce().value();
          
            if(campaignChange){
              nameCampaign = campaignChange;
            }
            var divTitle = '<div class="bold--700 text-center">' + nameCampaign+'</div>';
            var divBrands = '<div class="margin-top--0_5">';
            _.each(this.points, function(item){
              var brandTooltip = '<p class="" style="color:'+(item && item.point && item.point.color)+'"><i class="icon-size-sm icon-circle-thin bold--700 margin-right--0_5 margin-left--0_5"></i>'+$filter('uppercase')(item && item.series && item.series.name)+': '+(item && item.y && item.y.toFixed(0))+'</p>';
              divBrands += brandTooltip;
            });
            divBrands += '</div>';
            return divTitle+divBrands;
          }
        },
        series: [],
        credits:{
          enabled:false
        }
      };
    }

    function getData(dataSource, filters){
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: {
          datasource: dataSource,
          query: dataSource,
          parameters: {
            $country$: filterHelperService.getPropertySelected('country')
          },
          filters: filters,
          transform: {
            template: 'Signification',
            parameters: {
              groupOn: 'Rows'
            }
          }
        }
      })
      .then(function(data){
        var output = {
          categories: [],
          series: []
        };
        var filterLayout = stateManagerService.getState('filterLayout');
        var campaign = filterHelperService.getPropertySelected('campaigns');

        var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').map(function(item){
          var vars = item && item.text && item.text.split(':');
          item.idMedia = vars && vars[0];
          return item;
        }).value();

        var valuesMetrics = _.chain(data && data.data).value();
        _.each(valuesMetrics, function (item) {
          var newItem = {
            id: '',
            text: '',
            values: [],
            types: [],
            typesPrev:[]
          };

          var findMedia = _.chain(filterRecogMedia).find({'idMedia':item && item.id}).value();
          var dataItem = item;
          newItem.id = dataItem && dataItem.id;
          var text = dataItem && dataItem.text && dataItem.text.split('*');
          newItem.text = text && text[0] && text[0].replace('RECOGNITION','');
          newItem.values = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia)+campaign }).result('values').map(function(item){
            return item && item.value > 0 ? item.value : null;
          }).value();
          newItem.types = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia) + campaign }).result('values').map(function(item){return item && item.type && item.type[0];}).value();
          newItem.typesPrev = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia) + campaign }).result('values').map(function (item) { return item && item.type && item.type[1]; }).value();
          var dates = _.chain(item).result('values').find({ 'id': (findMedia && findMedia.idMedia) + campaign }).result('values').map(function(item){
            return {
              'id':item && item.id,
              'text':item && item.text
            };
          }).value();
          output.categories = [].concat(output.categories, dates);
          output.series.push(newItem);
        });

        output.categories = _.uniqBy(output.categories, 'id');
        output.series = output.series;
        return output;
      })
      .catch(function(){
        return $q.reject([]);
      });
    }

    function getColorsSeries() {
      return _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'campaignRecognitionHistoric' }).result('color').value();
    }

    function getEventsToPlotBands(categories) {
      var filterEvents = _.chain(filterLayout).find({ 'name':'F34'}).result('content').value();
      var eventsToShow = [];
      eventsToShow = _.map(filterEvents, function(event, _index){
        var newEvent = {
          id:null,
          text:'',
          size:0,
          showingMonths:[],
          pos:0,
          isGradient:false,
          gradient:'',
          color: null,
          type:null
        };
        var valuesEvent = event && event.text && event.text.split('%%');
        var yearEvent = valuesEvent && valuesEvent[1] && valuesEvent[1].split('-');
        var textEvent = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColorsHistoric' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('text').value();
        newEvent.id = event.id;
        newEvent.text = $filter('translationWithPrefix')(textEvent)+ ' \''+ yearEvent[yearEvent.length -1];
        newEvent.type = valuesEvent && valuesEvent[0];
        newEvent.gradient = valuesEvent && valuesEvent[2];
        newEvent.isGradient = valuesEvent && angular.isDefined(valuesEvent[2]) ? true : false;
        _.each(event && event.children, function(childEvent){
          var foundChild = _.chain(categories).includes(childEvent && childEvent.id).value();
          if(foundChild){
            newEvent.size ++;
            newEvent.showingMonths.push(childEvent);
          }
        });
        newEvent.color = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColorsHistoric' }).result('color').find({ 'id': valuesEvent && valuesEvent[0]}).result('value').value();
        newEvent.pos = _.indexOf(categories, _.chain(newEvent.showingMonths).orderBy('id').first().result('id').value());
        return newEvent;
      });

      //Filter events to show
      eventsToShow = _.filter(eventsToShow, function(item){return item.pos >= 0;});
      if (hasGradients(eventsToShow) > 0){
        //Return collection plotbands with gradients
        return getGradients(eventsToShow);
      }
      else{
        return getPlotBandsDefault(eventsToShow);
      }
    }

    function hasGradients(eventsToShow){
      return _.chain(eventsToShow).filter('gradient').groupBy('gradient').size().value();
    }

    function getGradients(eventsToShow){
      var plotBandsNoGradientsEvents = _.filter(eventsToShow, ['isGradient', false]);
      var plotBandsNoGradients = getPlotBandsDefault(plotBandsNoGradientsEvents);
      
      var gradients = _.groupBy(_.filter(eventsToShow, 'gradient'), 'gradient');

      var newGrads = _.map(gradients, function(newGrad){
        newGrad  = _.orderBy(newGrad, ['pos', 'id'], ['asc', 'asc']);
        var firstEvent = _.chain(newGrad).first().value();
        var lastEvent = _.chain(newGrad).last().value();
        var maxSize = _.chain(newGrad).map('size').max().value();

        return {
          id: firstEvent.gradient,
          className: firstEvent.gradient,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, firstEvent && firstEvent.color],
              [1, lastEvent && lastEvent.color]
            ]
          },
          from: firstEvent && firstEvent.pos - 0.5,
          to: firstEvent && firstEvent.pos - 0.5 + maxSize,
          label: {
            text: newGrad && newGrad.length > 1 ? (firstEvent && firstEvent.text) + ' / ' + (lastEvent && lastEvent.text) : firstEvent && firstEvent.text,
            align: 'center'
          }
        };
      });
      return [].concat(plotBandsNoGradients, newGrads);
    }

    function getPlotBandsDefault(eventsToShow){
      return _.chain(eventsToShow).reduce(function (aggr, event) {
        aggr.push({
          id: event.id,
          className: event.id,
          color: event && event.color,
          from: event.pos - 0.5,
          to: event.pos + event.size - 0.5,
          label: {
            text: event.text,
            align: 'center'
          }
        });
        return aggr;
      }, []).value();
    }

    function getEventsToLegend(){
      var filterEvents = _.chain(filterLayout).find({ 'name': 'F34' }).result('content').value();
      var eventsToShow = [];
      eventsToShow = _.map(filterEvents, function (event, _index) {
        var valuesEvent = event && event.text && event.text.split('%%');
        var newEvent = {
          text: '',
          color: null,
          type:'',
          order:null
        };
        
        newEvent.text = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColorsHistoric' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('text').value();
        newEvent.type = valuesEvent && valuesEvent[0];
        newEvent.color = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColorsHistoric' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('value').value();
        newEvent.order = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'eventsColorsHistoric' }).result('color').find({ 'id': valuesEvent && valuesEvent[0] }).result('order').value();
        return newEvent;
      });

      return _.orderBy(_.uniqBy(eventsToShow, 'type'), 'order');
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout13', {
                url: '/recognitionEvolutionHistoric?web&jobId',
                breadcrumb: { icon: 'icon-layout-13', label: 'MAIN_HOME_LAYOUT13' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout13/layout13.html',
                        controller: 'Layout13Controller',
                        controllerAs: 'layout13'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout13')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout13 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService','filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    campaigns: reportParams.campaigns,
                    criteria: reportParams.criteria
                };
                return mainService.getFilterModule('layout13', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout13', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout13Controller', Layout13Controller);

  /** @ngInject */
  function Layout13Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout13Service, uuid, configurationLoaderService) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false
    };

    vm.view = {
      loading: false,
      hasData: true,
      chart: {
        id: uuid.v4(),
        categories: [],
        data: [],
        config: {}
      }
    };

    vm.legend = {
      data:[],
      events:[]
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: []
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">' +
      '<p class="no-margin text-left"> ' + $filter('translationWithPrefix')('ADVERTS_TV_PRINT_OUTDOOR_INTERNET') + '</p>' +
      '</div>'
      ;

    vm.serviceView = layout13Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      vm.legend = getStylesLegend(vm.legend);
      layout13Service.getW1()
        .then(function (data) {
          var tooltipEvents = data && data[1];
          data = data && data[0];
          vm.view.chart.data = layout13Service.getChartData(data && data.series);
          vm.view.chart.categories = _.chain(layout13Service.getCategories(data && data.categories, 'text')).map(function(i){return $filter('uppercase')(i);}).value();
          var min =  _.chain(vm.view.chart.data).flatMap('data').map('y').min().value();
          var max = _.chain(vm.view.chart.data).flatMap('data').map('y').max().value();
          vm.view.chart.config = layout13Service.getConfigChart(tooltipEvents,layout13Service.getCategories(data && data.categories, 'id'), max > 90 ? 100 : max*1.1, min*0.95);
          vm.view.hasData = true;
          vm.copyXls.copyToXlsData = vm.view.chart;
          vm.legend.data = layout13Service.getLegend();
          vm.legend.events = layout13Service.getEventsToLegend(layout13Service.getCategories(data && data.categories, 'id'));
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function copyToXlsFn(data) {
      var columnHeaders = [].concat("", _.chain(data).result('categories').map(function(item){
        return $filter('lowercase')(item && item.text);
      }).value());

      var rowData = [columnHeaders];

      _.each(_.chain(data).result('data').value(), function (item) {
        rowData.push([].concat(item.name, _.chain(item.data).map(function (item) {
          return item && item.y && $filter('round')(item.y,0);
        }).value()));
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }

    function getStylesLegend(legend){
      var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundChartSignificationHistoric' }).result('color').value();
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignificationHistoric' }).result('color').value();

      return _.extend({},legend, {
        c1: _.chain(colors).find({ 'id': 'U' }).result('value').value(),
        c2: _.chain(colors).find({ 'id': 'D' }).result('value').value(),
        bg1: _.chain(backgroundColors).find({ 'id': 'U' }).result('value').value(),
        bg2: _.chain(backgroundColors).find({ 'id': 'D' }).result('value').value()
      });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout11Service', layout11Service);

  layout11Service.$inject = ['$http', 'filterHelperService', '$q', 'stateManagerService','configurationLoaderService'];
  function layout11Service($http, filterHelperService, $q, stateManagerService, configurationLoaderService) {
    var filterLayout = {};
    var extraInfo = {};
    var service = {
      getW1: getW1,
      getCategories: getCategories,
      getLegend: getLegend
    };

    return service;

    function getW1() {
      extraInfo = {};
      filterLayout = stateManagerService.getState('filterLayout');
      var queries = prepareQueries('PUIG-29');
      return getQueries(queries, [transformData.bind(null, extraInfo)]);
    }

    function getLegend(){
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();
      var norma = {
        default:{},
        prestige:{}
      };
      _.each(filterRecogMedia, function(item){
        var values = item && item.text && item.text.split(':');
        var valueNorma = _.chain(filterNorma).find({'name':'NORMA'+values[0]}).result('value').value();
        var valuePrestige = _.chain(filterNorma).find({ 'name': 'NORMA_PRESTIGE' + values[0] }).result('value').value();
        norma.default[values[1]] = valueNorma;
        norma.prestige[values[1]] = valuePrestige;
      });
      return norma;
    }

    function prepareQueries(query){
      var campaigns = _.chain(filterLayout).find({ 'name': 'F30' }).result('content').map('id').value();
      var filterRecogMedia = _.chain(filterLayout).find({ 'name': 'FRECOGMEDIA' }).result('content').value();
      var event = filterHelperService.getPropertySelected('period');
      var filterEventsMonths = _.chain(filterLayout).find({ 'name': 'F34' }).result('content').value();
      var transformEventsMonths = [];
      
      
      var monthsEvent = _.chain(filterEventsMonths).find({ 'id': event }).result('children').map('id').value();
      transformEventsMonths = [].concat(transformEventsMonths, monthsEvent);
      
      extraInfo = {
        campaigns:campaigns,
        events: [event],
        eventMonth: filterEventsMonths
      };

      return _.map(campaigns, function(item){
        return getGroup(query, item, transformEventsMonths, filterRecogMedia);
      });
    }

    function getGroup(dataSource, campaign,  transformEventsMonths, filterRecogMedia){
      /**Preparing filters */
      var filters = {
        F31: _.orderBy(_.uniq(transformEventsMonths)) ,
        '#GROUP1': [
          { FILTRO_PAIS: _.concat([], filterHelperService.getPropertySelected('country')) }
        ]
      };
      filters['FMEDIOCAMPANYA'] = _.chain(filterRecogMedia)
        .map(function (item) {
          var media = item && item.text && item.text.split(':');
          var mediaSelected = {};
          mediaSelected[media && media[0]] = [campaign];
          return mediaSelected;
        })
        .value();

      return getData(dataSource, filters);
    }

    function getData(dataSource, filters){
      return {
        datasource: dataSource,
        query: dataSource,
        parameters: {
          $country$: filterHelperService.getPropertySelected('country')
        },
        filters: filters,
        transform: {
          "template": "Vector"
        }
      };
    }

    function getQueries(queries, transformFn){
      return $http({
        method: 'POST',
        url: './api/extract-batch',
        data: {
          "queries": queries,
          "transform": {
            "template": "Join"
          }
        },
        transformResponse: transformFn ? $http.defaults.transformResponse.concat(transformFn) : null
      })
      .then(function (data) {
        return data && data.data;
      })
      .catch(function () {
        return $q.when(null);
      });
    }

    function transformData(extraInfo, data){
      return transformToEvents(data, extraInfo);
    }

    function transformToEvents(data, _extraInfo){    
      return _.chain(data)
      .map(function(rowGroups, _indexRow){  
        var cellRow = [];
        _.each(rowGroups, function(group, _indexGroup){
              /**First group, TOTAL - First line TOTALS */
              var monthsGroupCollection;
                monthsGroupCollection = _.reduce(group);
                /**Select the month with value is max */
                var filteredMonthsFromEvent = _.map(monthsGroupCollection, function(monthsGroup){
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    monthsGroup.color = monthsGroup.values[1];
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup; 
                });

                var monthSelected = _.chain(filteredMonthsFromEvent).maxBy('value').value();
                
                cellRow = [].concat(cellRow, {
                  value: monthSelected && monthSelected.value,
                  color: getSignification('c', monthSelected && monthSelected.color),
                  background: getSignification('bg', monthSelected && monthSelected.background)
                });
        });
        return cellRow;
      }).value();
    }

    function getSignification(typeColor, signification) {
      var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTableHistoric' }).result('color').value();
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTableHistoric' }).result('color').value();
      if (typeColor === 'c') {
        return _.chain(colors).find({ 'id': signification }).result('value').value();
      }
      else {
        return _.chain(backgroundColors).find({ 'id': signification }).result('value').value();
      }
    }

    function getCategories(){
      return _.chain(filterLayout).find({ 'name': 'F30' }).result('content').map(function(item){
        var splitedText = item && item.text && item.text.split('-');
        item.text = splitedText[0];
        return item;
      }).value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout11', {
                url: '/recognitionByMediaHistoric?web&jobId',
                breadcrumb: { icon: 'icon-layout-11', label: 'MAIN_HOME_LAYOUT11' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout11/layout11.html',
                        controller: 'Layout11Controller',
                        controllerAs: 'layout11'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout11')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout11 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams','transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams && reportParams.year,
                    period: reportParams && reportParams.period
                };
                return mainService.getFilterModule('layout11', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout11', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout11Controller', Layout11Controller);

  /** @ngInject */
  function Layout11Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout11Service) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false
    };

    vm.view = {
      loading: false,
      hasData: true
    };

    vm.dataTable = {
      columnHeaders:[],
      rowHeaders:[],
      data:[],
      legendData:[]
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true' ? true : false;

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: {}
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">'+
            '<p class="no-margin text-left"> '+$filter('translationWithPrefix')('ADVERTS_TV_PRINT_OUTDOOR_INTERNET')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left">'+$filter('translationWithPrefix')('BEST_DATA_MEDIA_EVENT')+'</p>'+
        '</div>'+
        '<div>'
      ;

    vm.serviceView = layout11Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      layout11Service.getW1()
        .then(function (data) {
          vm.view.hasData = true;
          
          /*Prepare data to table **/
          vm.dataTable.rowHeaders = layout11Service.getCategories();
          vm.dataTable.columnHeaders = setColumnHeaders(data);
          vm.dataTable.legend = layout11Service.getLegend();
          vm.dataTable.data = data;
      
          var order = orderTable(0, vm.dataTable.rowHeaders, vm.dataTable.data);
          vm.dataTable.rowHeaders = _.chain(order).map('cat').value();
          vm.dataTable.data = _.chain(order).map('collection').value();

          if(order && order.length > 0){
            vm.dataTable.rowHeaders = _.chain(order).map('cat').value();
            vm.dataTable.data = _.chain(order).map('collection').value();
          }
          else{
            vm.view.hasData = false;
          }
          

          /**Xls clipboard */
          vm.copyXls.copyToXlsData = {
            rowHeaders: vm.dataTable.rowHeaders,
            columnHeaders: vm.dataTable.columnHeaders,
            data: vm.dataTable.data
          };
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function copyToXlsFn(data) {
      var groupCampaigns = [""];
      var allRows = [];

      _.each(data && data.columnHeaders, function(group){
          groupCampaigns = [].concat(groupCampaigns, $filter('translationWithPrefix')(group && group.text));
      });

      _.each(data && data.rowHeaders, function (rows, indexRow) {
        var titleRow = rows && rows.text;
        var dataRow = _.chain(data && data.data && data.data[indexRow]).map(function(cell){return $filter('round')((cell && cell.value), 0);}).value();
        allRows.push([].concat(titleRow, dataRow));
      });

      var rowData = [groupCampaigns];
      
      _.each(allRows,function(row){
        rowData.push(row);
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }

    function setColumnHeaders(){
      return [
        { 'id': 'total', logo: 'c_campaign.svg', text: 'GROUP_CAMPAIGN' },
        { 'id': 'tv', logo: 'c_tv.svg', text: 'GROUP_TV' },
        { 'id': 'print', logo: 'c_print.svg', text: 'GROUP_PRINT' },
        { 'id': 'outdoor', logo: 'c_outdoor.svg', text: 'GROUP_OUTDOOR' },
        { 'id': 'digital', logo: 'c_digital.svg', text: 'GROUP_DIGITAL' }
      ];
    }

    function orderTable(indexColumn, categories, data){
      return _.chain(categories)
        .map(function(cat, index){
          var newOrder = {
            cat: '',
            indexValue: null,
            collection: []
          };
          newOrder.cat = cat ;
          newOrder.indexValue = _.chain(data[index][indexColumn]).result('value').value();
          newOrder.collection = data[index];
          return newOrder;
        })
        .filter(function(item){
          return item && item.indexValue && parseInt(item.indexValue) > 0;
        })
        .orderBy(['indexValue'],['desc'])
      .value();

    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout10Service', layout10Service);

  layout10Service.$inject = ['$http', 'filterHelperService', '$q', '$filter', 'stateManagerService', '$stateParams','configurationLoaderService'];
  function layout10Service($http, filterHelperService, $q, $filter, stateManagerService, $stateParams, configurationLoaderService) {
    var service = {
      getW1: getW1,
      getCategories:getCategories,
      getConfigChart: getConfigChart,
      getChartData: getChartData
    };

    return service;

    function getW1() {
      return getWidgetImages('PUIG-26');
    }

    function getWidgetImages(dataSource, grouping){
      var brand = filterHelperService.getPropertySelected('brand');
      var metric = filterHelperService.getPropertySelected('metric');
      var market = filterHelperService.getPropertySelected('market');
      

      var filterLayout = stateManagerService.getState('filterLayout');
      var elementsF16All = _.chain(filterLayout).find({ 'name': 'F28' }).result('content').find({ 'id': filterHelperService.getPropertySelected('year') }).result('children').value();
      var indexPeriodSelected = _.findIndex(elementsF16All, { 'id': filterHelperService.getPropertySelected('period') });
      //Periodos hacia atras máximos
      var fixedPeriods = 24;
      var elementsF16Next = [].concat(_.chain(elementsF16All).slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods).map('id').value());

      var filters = {
        F16: elementsF16Next,
        '#GROUP1':[
          {FILTRO_PAIS: _.concat([],filterHelperService.getPropertySelected('country'))},
          {CRITERIA: [filterHelperService.getPropertySelected('criteria')]}
        ]
      };

      var newFilter = [];
      
      _.each(metric, function(item){
        var filterF20I = {};
        var filterArray = [];
        brand = _.replace(brand, market, '');
        filterArray.push('base' + item + brand);
        filterArray.push(item + brand);
        filterF20I[item] = filterArray;
        newFilter.push(filterF20I);    
      });

      filters['F20I'] = newFilter;
      return getData(dataSource, '_'+(metric && metric.length) + 'ME', filters, grouping);
    }

    function getCategories(data){
      return _.chain(data).map(function(item){
        return $filter('uppercase')(item && item.text);
      }).value();
    }

    function getChartData(data) {
      var colorSignification = _.chain(configurationLoaderService.getConfig()).result('colors').value();
      return _.chain(data)
        .map(function (item, _index) {
          var filterLayout = stateManagerService.getState('filterLayout');
          var metricsAvail = _.chain(filterLayout).find({ 'name': 'F29' }).result('content').find({ 'id': filterHelperService.getPropertySelected('market') }).result('children').value();
          var nameMetric = item && item.id && item.id.substring(0, item.id.length - 4);
          var metricFound = _.chain(metricsAvail).find({ 'id': nameMetric }).value() ? _.chain(metricsAvail).find({ 'id': nameMetric }).result('text').value() : null;

          return {
            animation: $stateParams && $stateParams.web === 'true' ? true : false,
            data: _.map(item.values, function (itemValues, index) {
              var x = {
                y: '',
                dataLabels: {
                  color: _.chain(colorSignification).find({ 'type': item && item.types[index] }).result('color').value()
                }
              };
              x.y = itemValues;
              return x;
            }),
            name: metricFound ? $filter('uppercase')(metricFound) : $filter('uppercase')(item && item.text),
            marker: {
              symbol: 'circle',
              fillColor: 'white',
              lineColor: null,
              lineWidth: 2
            },
            visible: true
          };
        })
        .value();
    }

    function getConfigChart(max, min) {
      return {
        chart: {
          style: {
            fontFamily: 'Montserrat'
          },
          renderTo: null,
          type: 'line',
          marginTop:50,
          marginRight: 50/*,
                events: {
                    load: adjustLegend,
                    redraw: adjustLegend
                }*/
        },
        colors: _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'countryColors' }).result('color').map('value').value(),
        title: {
          text: ''
        },
        subtitle: {
          text: null
        },
        xAxis: {
          labels: {
            formatter: function () {
              return this.value;
            }
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          gridLineWidth: 1,
          lineWidth: 0,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3
        },
        yAxis: [{
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          //lineWidth:1,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          showEmpty: true
          //tickInterval: range
        },
        {
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dot',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          //lineWidth:1,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          opposite: true,
          showEmpty: true
          //tickInterval: range
        }],
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                // position odd show label... 
                /*if(this.point.series.index % 2 === 0){
                    if (this.point.index % 2 === 0) {
                        return this.y.toFixed(fixedPrecision);
                    }
                }
                else{
                    if (this.point.index % 2 !== 0) {
                        return this.y.toFixed(fixedPrecision);
                    }
                }*/
                return this && this.y && this.y.toFixed(0);
              },
              style: {
                fontWeight: 'bold',
                textOutline: "0px contrast"
              }
            },
            enableMouseTracking: true
          },
          column: {
            events: { //Bloquear evento click sobre la serie de la columna. En este caso es la de COUNTRY.
              legendItemClick: function () {
                return false;
              }
            }
          },
          series: {
            lineWidth: 1,
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 3
            },
            states: {
              inactive: {
                opacity: 1
              }
            }
          }
        },
        legend: {
          enabled: true,
          symbolWidth: 40
        },
        tooltip: {
          enabled: true,
          shared: true,
          useHTML: true,
          backgroundColor:'white',
          crosshairs: true,
          formatter: function () {
            var divTitle = '<div class="bold--700 text-center">'+this.x+'</div>';
            var divBrands = '<div class="">';
            _.each(this.points, function(item){
              var brandTooltip = '<p class="" style="color:'+(item && item.point && item.point.color)+'"><i class="icon-size-sm icon-circle-thin bold--700 margin-right--0_5 margin-left--0_5"></i>'+$filter('uppercase')(item && item.series && item.series.name)+':'+(item && item.y && item.y.toFixed(0))+'</p>';
              divBrands += brandTooltip;
            });
            divBrands += '</div>';
            return divTitle+divBrands;
          }
        },
        series: [],
        credits:{
          enabled:false
        }
      };
    }

    // function hexToRGB(hex, alpha) {
    //   var r = parseInt(hex && hex.slice(1, 3), 16),
    //     g = parseInt(hex && hex.slice(3, 5), 16),
    //     b = parseInt(hex && hex.slice(5, 7), 16);

    //   if (alpha) {
    //     return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    //   } else {
    //     return "rgb(" + r + ", " + g + ", " + b + ")";
    //   }
    // }

    function getData(dataSource, marketSelected, filters){
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        //method: 'GET',
        //url: './data/evolution.json',
        data: {
          datasource: dataSource,
          query: dataSource+marketSelected,
          parameters: {
            $country$: filterHelperService.getPropertySelected('country')
          },
          filters: filters,
          transform: {
            template: 'Signification',
            parameters: {
              groupOn: 'Columns'
            }
          }
        }
      })
      .then(function(data){
        var output = {
          categories: [],
          series: []
        };

        var valuesMetrics = _.chain(data && data.data).first().result('values').value();
        _.each(valuesMetrics, function (item) {
          var newItem = {
            id: '',
            text: '',
            values: [],
            types: []
          };
          var dataItem = item;
          newItem.id = dataItem && dataItem.id;
          newItem.text = dataItem && dataItem.text;
          newItem.values = _.map(dataItem && dataItem.values, 'value');
          newItem.types = _.map(dataItem && dataItem.values, 'type');

          var dates = _.map(dataItem && dataItem.values, function (date) {
            return {
              id: date && date.id,
              text: date && date.text
            };
          });
          output.categories = [].concat(output.categories, dates);
          output.series.push(newItem);
        });

        output.categories = _.uniqBy(output.categories, 'id');
        output.series = filterSeriesWithoutValues(output.series);
        return output;
      })
      .catch(function(){
        return $q.reject([]);
      });
    }

    function filterSeriesWithoutValues(series) {
      return _.chain(series).filter(function (serie) {
        if (_.some(serie.values, Number)) {
          return serie;
        }
      }).value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout10', {
                url: '/brandMetricsAcrossMetrics?web&jobId',
                breadcrumb: { icon: 'icon-layout-10', label: 'MAIN_HOME_LAYOUT10' },
                views: {
                    content: {
                        templateUrl: 'app/detailOverview/layout10/layout10.html',
                        controller: 'Layout10Controller',
                        controllerAs: 'layout10'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout10')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout10 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService','filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    market: reportParams.market,
                    brand: reportParams.brand,
                    criteria: reportParams.criteria,
                    metric: reportParams.metric
                };
                return mainService.getFilterModule('layout10', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout10', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout10Controller', Layout10Controller);

  /** @ngInject */
  function Layout10Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout10Service, uuid, errorHandlerService, filterHelperService) {
    var vm = this;

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter: preApplyFilter
    };

    vm.view = {
      loading: false,
      hasData: true,
      chart: {
        id: uuid.v4(),
        categories: [],
        data: [],
        config: {}
      },
      images:{
        data: [],
        typeView: 'T',
        typeImages: []
      }
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: []
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB')+'</span>. '+$filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('EVER_BOUGHT_IB')+'</span>. '+$filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('CONSIDERATION_IB')+'</span>. '+$filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('AWARENESS_IB')+'</span>. '+$filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('DESIRABILITY_IB')+'</span>. '+$filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('LOVE_IB')+'</span>. '+$filter('translationWithPrefix')('LOVE_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('UNIQUENESS_IB')+'</span>. '+$filter('translationWithPrefix')('UNIQUENESS_INFO_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('ADVOCACY_IB')+'</span>. '+$filter('translationWithPrefix')('ADVOCACY_INFO_TEXT_IB')+'</p>'+
        '</div>'+

        '<div class="item-info margin-top--0_5">'+
            '<p class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('TOTAL_TBCA_IB')+'</span>. '+$filter('translationWithPrefix')('TOTAL_TBCA_INFO_TEXT_IB')+'</p>'+
        '</div>'+

        '<div>'
      ;

    vm.serviceView = layout10Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      vm.view.images.typeView = filterHelperService.getPropertySelected('market');
      
      var images = [filterHelperService.getPropertySelected('brand')];
      vm.view.images.typeImages = _.map(images, function (item) {
        var brandImage = item.slice(-2);
        return brandImage === '01' || brandImage === '00' ? 'svg' : 'png';
      });
      vm.view.images.type = filterHelperService.getPropertySelected('market') === 'T' ? 'svg' : 'png';
      vm.view.images.data = _.chain(images).map(function(item){
        return item && item.replace(vm.view.images.typeView, '');
      }).value();

      layout10Service.getW1()
        .then(function (data) {
          vm.view.chart.data = layout10Service.getChartData(data && data.series);
          vm.view.chart.categories = layout10Service.getCategories(data && data.categories);
          var min =  _.chain(vm.view.chart.data).flatMap('data').map('y').min().value();
          var max = _.chain(vm.view.chart.data).flatMap('data').map('y').max().value();
          vm.view.chart.config = layout10Service.getConfigChart(max > 90 ? 100 : max*1.1, min*0.95);
          vm.view.hasData = true;
          vm.copyXls.copyToXlsData = vm.view.chart;
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function preApplyFilter(filter) {
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si tengo seleccionado en el filtro de red un COUNTRY.
       */
      var metricFilter = {
        numberSelected: _.chain(filter).find({ 'id': 'metric' }).result('data').first().result('selectedNode').size().value(),
        max: _.chain(filter).find({ 'id': 'metric' }).result('data').first().result('maxSelections').value(),
        min: _.chain(filter).find({ 'id': 'metric' }).result('data').first().result('minSelections').value()
      };

      //El filtro brands no cumple con el numero minimo de selecciones
      if (!checkRange(metricFilter.numberSelected, metricFilter.min, metricFilter.max)) {
        errorHandlerService.callbackWarning.call({ text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_METRICS_L10') });
        return false;
      }

      return true;
    }

    function checkRange(value, min, max) {
      return value >= min && value <= max ? true : false;
    }

    function copyToXlsFn(data) {
      var columnHeaders = [].concat("", _.chain(data).result('categories').map(function(item){
        return $filter('lowercase')(item);
      }).value());

      var rowData = [columnHeaders];

      _.each(_.chain(data).result('data').value(), function (item) {
        rowData.push([].concat(item.name, _.chain(item.data).map(function (item) {
          return item && item.y && $filter('round')(item.y,0);
        }).value()));
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');

    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout24Service', layout24Service);

    layout24Service.$inject = ['$http', 'filterHelperService', '$q', '$filter', 'stateManagerService', '$stateParams', 'configurationLoaderService'];
    function layout24Service($http, filterHelperService, $q, $filter, stateManagerService, $stateParams, configurationLoaderService) {
        var filterLayout;
        var selectedPeriod;
        var service = {
            getW1: getW1,
            getCategories: getCategories,
            getConfigChart: getConfigChart,
            getChartData: getChartData,
            getLegend: getLegend,
            getMediaColumns: getMediaColumns
        };

        return service;

        /**
         * Obtiene datos para multi-country evolution chart.
         * Hace una llamada crosstab-engine-extract por país (misma estructura que layout17)
         * cambiando $country$ y FILTRO_PAIS por cada país.
         */
        function getW1(query, countryNames, selectedBrand, period) {
            filterLayout = stateManagerService.getState('filterLayout');
            selectedPeriod = period;

            var countries = filterHelperService.getPropertySelected('country');
            var countriesArray = _.isArray(countries) ? countries : [countries];

            // Una petición getAudience por cada país (cada una con catch propio para no bloquear el resto)
            var audienceRequests = _.map(countriesArray, function (country) {
                return getAudience(query, 'PUIG-30NEW', country, selectedBrand)
                    .catch(function () {
                        return { categories: [], series: [] };
                    });
            });

            return $q.all(audienceRequests).then(function (allCountryData) {
                var processedCountries = _.map(allCountryData, function (countryData, index) {
                    return {
                        countryCode: countriesArray[index],
                        countryName: countryNames[index] && countryNames[index].name || countriesArray[index],
                        data: countryData
                    };
                });

                return {
                    processedCountries: processedCountries
                };
            });
        }

        /**
         * Petición crosstab-engine-extract para un país concreto.
         * Misma estructura que layout17.getAudience pero parametrizada por país y marca.
         */
        function getAudience(query, dataSource, country, selectedBrand) {
            var criteria = filterHelperService.getPropertySelected('criteria');
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');

            var fullPeriods = getFullPeriods(selectedPeriod, 24);

            // Agrupar periodos por año natural (ej: {id: "M2503"} → "25")
            var periodsByYear = _.groupBy(fullPeriods, function(p) {
                return p.id.substring(1, 3);
            });

            var requests = _.map(periodsByYear, function(periodsForYear, year) {
                var periodIds = _.map(periodsForYear, 'id');
                var filters = {
                    FWAVE4: periodIds,
                    '#GROUP1': [
                        { FILTRO_PAIS: [country] },
                        { CRITERIA: [criteria] }
                    ],
                    FMEDIOCAMPANYA: buildFmediocampanya(typeMedia, selectedBrand)
                };
                return getData(query, dataSource, filters, country, periodsForYear, year);
            });

            return $q.all(requests).then(function(results) {
                return mergeResults(results);
            });
        }

        /**
         * Llamada HTTP a crosstab-engine-extract (idéntica a layout17.getData)
         */
        function getData(query, dataSource, filters, country, fullPeriods, year) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: query,
                    parameters: {
                        $country$: country,
                        $target$: filterHelperService.getPropertySelected('criteria'),
                        $year$: year
                    },
                    filters: filters,
                    transform: {
                        template: 'Signification',
                        parameters: {
                            groupOn: 'Rows'
                        }
                    }
                }
            })
            .then(function (data) {
                var output = {
                    categories: [],
                    series: []
                };

                var typeMedia = filterHelperService.getPropertySelected('typeMedia');
                var filterRecogMedia = _.map(getMedia(typeMedia), function (item) {
                    var vars = item && item.text && item.text.split(':');
                    item.idMedia = vars && vars[0];
                    return item;
                });

                var valuesMetrics = _.chain(data && data.data).value();
                _.each(valuesMetrics, function (item) {
                    var newItem = {
                        id: '',
                        text: '',
                        values: [],
                        types: [],
                        typesPrev: []
                    };

                    var findMedia = _.chain(filterRecogMedia).find({ 'idMedia': item && item.id }).value();
                    newItem.id = item && item.id;
                    var text = item && item.text && item.text.split('*');
                    newItem.text = text && text[0] && text[0].replace('RECOGNITION', '').trim();
                    // Para Video/Visual Social Networks, quitar prefijo VIDEO/VISUAL de los hijos
                    if (typeMedia === 'FRECOVIDEOX' || typeMedia === 'FRECOVISUAX') {
                        var stripped = newItem.text.replace(/^VIDEO[:\s]+/i, '').replace(/^VISUAL[:\s]+/i, '');
                        if (stripped.length > 0) {
                            newItem.text = stripped;
                        }
                    }

                    // Buscar valores usando la marca (en layout17 se usa campaign)
                    var mediaKey = findMedia && findMedia.idMedia;
                    var matchingValues = _.chain(item).result('values').find(function (v) {
                        return v && v.id && v.id.indexOf(mediaKey) === 0;
                    }).value();

                    newItem.values = _.chain(matchingValues).result('values').map(function (val) {
                        return val && val.value > 0 ? val.value : null;
                    }).value();
                    newItem.types = _.chain(matchingValues).result('values').map(function (val) { return val && val.type && val.type[0]; }).value();
                    newItem.typesPrev = _.chain(matchingValues).result('values').map(function (val) { return val && val.type && val.type[1]; }).value();

                    var dates = _.chain(matchingValues).result('values').map(function (val) {
                        return {
                            'id': val && val.id,
                            'text': val && val.text
                        };
                    }).value();
                    output.categories = [].concat(output.categories, dates);
                    output.series.push(newItem);
                });

                output.categories = _.uniqBy(output.categories, 'id');

                // Rellenar todos los periodos (aunque no haya datos)
                var existingCategoryMap = _.keyBy(output.categories, 'id');
                var fullPeriodIds = _.map(fullPeriods, 'id');

                var fullCategories = _.map(fullPeriods, function (period) {
                    return existingCategoryMap[period.id] || { id: period.id, text: period.text };
                });

                _.each(output.series, function (seriesItem) {
                    var valuesByPeriod = {};
                    var typesByPeriod = {};
                    var typesPrevByPeriod = {};

                    _.each(output.categories, function (cat, idx) {
                        valuesByPeriod[cat.id] = seriesItem.values[idx];
                        typesByPeriod[cat.id] = seriesItem.types[idx];
                        typesPrevByPeriod[cat.id] = seriesItem.typesPrev[idx];
                    });

                    seriesItem.values = _.map(fullPeriodIds, function (periodId) {
                        return valuesByPeriod.hasOwnProperty(periodId) ? valuesByPeriod[periodId] : null;
                    });
                    seriesItem.types = _.map(fullPeriodIds, function (periodId) {
                        return typesByPeriod.hasOwnProperty(periodId) ? typesByPeriod[periodId] : '-';
                    });
                    seriesItem.typesPrev = _.map(fullPeriodIds, function (periodId) {
                        return typesPrevByPeriod.hasOwnProperty(periodId) ? typesPrevByPeriod[periodId] : '-';
                    });
                });

                output.categories = fullCategories;
                return output;
            })
            .catch(function () {
                return { categories: [], series: [] };
            });
        }

        function mergeResults(results) {
            var validResults = _.filter(results, function(r) { return r && r.categories && r.categories.length > 0; });
            if (validResults.length === 0) return { categories: [], series: [] };
            if (validResults.length === 1) return validResults[0];

            var merged = { categories: [], series: [] };

            _.each(validResults, function(result) {
                merged.categories = merged.categories.concat(result.categories);
            });

            var seriesIds = _.map(validResults[0].series, 'id');
            _.each(seriesIds, function(seriesId, idx) {
                var mergedSeries = {
                    id: seriesId,
                    text: validResults[0].series[idx].text,
                    values: [],
                    types: [],
                    typesPrev: []
                };
                _.each(validResults, function(result) {
                    var s = _.find(result.series, { id: seriesId });
                    if (s) {
                        mergedSeries.values = mergedSeries.values.concat(s.values);
                        mergedSeries.types = mergedSeries.types.concat(s.types);
                        mergedSeries.typesPrev = mergedSeries.typesPrev.concat(s.typesPrev);
                    }
                });
                merged.series.push(mergedSeries);
            });

            return merged;
        }

        // --- Funciones de chart config (patrón layout17) ---

        function getCategories(data, field) {
            if (field) {
                return _.chain(data).map(field).value();
            }
            return _.chain(data).value();
        }

        /**
         * Transforma las series de un país a formato Highcharts.
         * Misma lógica que layout17.getChartData pero añadiendo el nombre del país a cada serie.
         */
        function getChartData(data, countryName, countryIndex) {
            var countryColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'countryColors' }).result('color').map('value').value();
            var dashStyles = ['Solid', 'Dash', 'ShortDot', 'DashDot', 'LongDash', 'Dot'];
            var countryColor = countryColors[countryIndex % countryColors.length];
            var colorSignification = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignification' }).result('color').value();
            var bgSignification = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignification' }).result('color').value();

            return _.chain(data)
                .map(function (item, metricIndex) {
                    var seriesName = countryName + ' - ' + $filter('uppercase')(item && item.text);

                    return {
                        id: item && item.id,
                        animation: $stateParams && $stateParams.web === 'true' ? true : false,
                        color: countryColor,
                        dashStyle: dashStyles[metricIndex % dashStyles.length],
                        lineWidth: metricIndex === 0 ? 3 : 2,
                        data: _.map(item.values, function (itemValues, index) {
                            var x = {
                                y: '',
                                dataLabels: {
                                    color: item && item.id === 'RECOG01' ? _.chain(colorSignification).find({ 'id': item && item.types[index] }).result('value').value() : '-'
                                }
                            };
                            x.y = itemValues;
                            return x;
                        }),
                        dataLabels: {
                            formatter: function () {
                                var index = this && this.point && this.point.index;
                                var typesPrev = _.chain(item && item.typesPrev).get(index).value();
                                var color = _.chain(bgSignification).find({ 'id': typesPrev }).result('value').value();
                                if (typesPrev === '-' || typesPrev === '') {
                                    return this && this.y && this.y.toFixed(0);
                                }
                                else {
                                    if (typesPrev === 'U') {
                                        return this && this.y && this.y.toFixed(0) + ' <i class="icon-caret-up icon-size-lg signification-icon" style="color:' + color + '"></i>';
                                    } else {
                                        return this && this.y && this.y.toFixed(0) + ' <i class="icon-caret-down icon-size-lg signification-icon" style="color:' + color + '"></i>';
                                    }
                                }
                            }
                        },
                        name: seriesName,
                        marker: {
                            symbol: 'circle',
                            fillColor: 'white',
                            lineColor: null,
                            lineWidth: 2
                        },
                        visible: metricIndex === 0
                    };
                })
                .value();
        }

        function getConfigChart(max, min) {
            var maxChartY = max > 90 ? max : max + 10;
            return {
                chart: {
                    renderTo: null,
                    type: 'spline',
                    style: {
                        fontFamily: 'Montserrat'
                    },
                    marginTop: 10,
                    marginRight: 50
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: null
                },
                xAxis: {
                    labels: {
                        step: 1,
                        rotation: -45,
                        formatter: function () {
                            return this.value && this.value.text && this.value.text.toUpperCase();
                        }
                    },
                    tickInterval: 1,
                    lineWidth: 1,
                    lineColor: 'rgba(232, 232, 232, 1)',
                    gridLineWidth: 1,
                    gridLineColor: 'rgba(232, 232, 232, 1)'
                },
                yAxis: {
                    min: min,
                    max: maxChartY,
                    title: {
                        text: null,
                        align: 'high'
                    },
                    gridLineWidth: 0,
                    lineWidth: 1,
                    lineColor: 'rgba(232, 232, 232, 1)',
                    tickInterval: 10
                },
                plotOptions: {
                    spline: {
                        dataLabels: {
                            useHTML: true,
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                textOutline: "0px contrast"
                            }
                        },
                        enableMouseTracking: true
                    },
                    series: {
                        lineWidth: 1,
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 3
                        },
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    enabled: true,
                    shared: true,
                    useHTML: true,
                    backgroundColor: 'white',
                    crosshairs: false,
                    padding: 0,
                    borderWidth: 0,
                    shadow: false,
                    formatter: function () {
                        // TODO: Adaptar tooltip para multi-country
                        var divTitle = '<div class="bold--700 text-center">' + (this.x && this.x.text) + '</div>';
                        var divBrands = '<div class="margin-top--0_5">';
                        _.each(this.points, function (item) {
                            var brandTooltip = '<p style="color:' + (item && item.point && item.point.color) + '"><i class="icon-size-sm icon-circle-thin bold--700 margin-right--0_5 margin-left--0_5"></i>' + $filter('uppercase')(item && item.series && item.series.name) + ': ' + (item && item.y && item.y.toFixed(0)) + '</p>';
                            divBrands += brandTooltip;
                        });
                        divBrands += '</div>';
                        return divTitle + divBrands;
                    }
                },
                series: [],
                credits: {
                    enabled: false
                }
            };
        }

        // --- Funciones de legend (patrón layout17 + layout23) ---

        function getLegend() {
            filterLayout = stateManagerService.getState('filterLayout');
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');
            var typeMediaSelected = getMedia(typeMedia);
            var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();

            var norma = [];

            if (_.isArray(filterNorma) && filterNorma.length > 0) {
                _.each(filterNorma, function (resultItem) {
                    var normaMap = {
                        default: {},
                        prestige: {}
                    };

                    if (resultItem.parameters) {
                        var filterCountry = _.chain(filterLayout).find({ 'name': 'F5' }).result('content').value();
                        var countryFound = _.find(filterCountry, { 'id': resultItem.parameters.$country$ });
                        normaMap.country = countryFound && countryFound.text;
                        var filterTarget = _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
                        var targetFound = _.find(filterTarget, { 'id': resultItem.parameters.$target$ });
                        normaMap.target = targetFound && targetFound.text;
                        normaMap.year = '20' + resultItem.parameters.$year$;
                    }

                    _.each(typeMediaSelected, function (item) {
                        var values = item && item.text && item.text.split(':');
                        var variableSet = resultItem.variables || resultItem;
                        var foundNorma = _.find(variableSet, { 'name': 'NORMA_' + values[0] });
                        if (foundNorma === undefined) {
                            foundNorma = _.find(variableSet, { 'name': 'NORMA' + values[0] });
                        }
                        var foundPrestige = _.find(variableSet, { 'name': 'PRESTIGE' + values[0] });
                        if (foundPrestige === undefined) {
                            foundPrestige = _.find(variableSet, { 'name': 'NORMA_PRESTIGE' + values[0] });
                        }

                        if (foundNorma) {
                            normaMap.default[values[1]] = foundNorma.value;
                        }
                        if (foundPrestige) {
                            normaMap.prestige[values[1]] = foundPrestige.value;
                        }
                    });

                    norma.push(normaMap);
                });
            }

            return norma;
        }

        function getMediaColumns() {
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');
            var typeMediaSelected = getMedia(typeMedia);
            var textMap = {
                'T': 'GROUP_CAMPAIGN',
                'VID': 'GROUP_VIDEO',
                'VIS': 'GROUP_VISUAL',
                'LIN': 'GROUP_LINEAR_TV',
                'DIG': 'GROUP_DIGITAL_TV',
                'OUD': 'GROUP_OUTDOOR',
                'SOC': 'GROUP_SOCIAL_NETWORKS',
                'OTH': 'GROUP_OTHER',
                'PRI': 'GROUP_PRINT',
                'SHO': 'GROUP_SHOP',
                'OUV': 'GROUP_OUTDOOR',
                'SOV': 'GROUP_SOCIAL_NETWORKS',
                'BRA': 'GROUP_BRAND_WEBSITES',
                'VSN': 'GROUP_VIDEO',
                'VISN': 'GROUP_VISUAL',
                'FB': 'GROUP_FACEBOOK',
                'IG': 'GROUP_INSTAGRAM',
                'TK': 'GROUP_TIKTOK',
                'SC': 'GROUP_SNAPCHAT',
                'TW': 'GROUP_TWITCH',
                'PI': 'GROUP_PINTEREST',
                'XTW': 'GROUP_TWITTER'
            };
            return _.map(typeMediaSelected, function (item) {
                var values = item && item.text && item.text.split(':');
                var key = values && values[1];
                return {
                    key: key,
                    text: textMap[key] || key
                };
            });
        }

        // --- Funciones auxiliares ---

        function getEvolutionMonths(period, numMonths) {
            if (!period || period.length < 5) { return []; }
            var prefix = period.charAt(0);
            var year = parseInt(period.substring(1, 3));
            var month = parseInt(period.substring(3, 5));
            var months = [];
            for (var i = numMonths - 1; i >= 0; i--) {
                var m = month - i;
                var y = year;
                while (m <= 0) { m += 12; y--; }
                months.push(prefix + y.toString().padStart(2, '0') + m.toString().padStart(2, '0'));
            }
            return months;
        }

        function buildFmediocampanya(typeMedia, brandValue) {
            var fmediaFilter = _.chain(filterLayout).find({ 'name': 'FMEDIOnewX' }).result('content').value();
            var recogIds = [];

            switch (typeMedia) {
                case 'FRECOTOTAL':
                    recogIds = ['RECOG01', 'RECOG11', 'RECOG18'];
                    break;
                case 'FRECOVIDEO':
                    var videoItem = _.find(fmediaFilter, { 'id': 'RECOG11' });
                    recogIds = ['RECOG11'];
                    if (videoItem && videoItem.children) {
                        recogIds = recogIds.concat(_.map(videoItem.children, 'id'));
                    }
                    break;
                case 'FRECOVISUAL':
                    var visualItem = _.find(fmediaFilter, { 'id': 'RECOG18' });
                    recogIds = ['RECOG18'];
                    if (visualItem && visualItem.children) {
                        recogIds = recogIds.concat(_.map(visualItem.children, 'id'));
                    }
                    break;
                case 'FRECOVIDEOX':
                    var videoSNItem = _.find(fmediaFilter, { 'id': 'RECOG11X' });
                    recogIds = ['RECOG11X'];
                    if (videoSNItem && videoSNItem.children) {
                        recogIds = recogIds.concat(_.map(videoSNItem.children, 'id'));
                    }
                    break;
                case 'FRECOVISUAX':
                    var visualSNItem = _.find(fmediaFilter, { 'id': 'RECOG18X' });
                    recogIds = ['RECOG18X'];
                    if (visualSNItem && visualSNItem.children) {
                        recogIds = recogIds.concat(_.map(visualSNItem.children, 'id'));
                    }
                    break;
                default:
                    recogIds = ['RECOG01', 'RECOG11', 'RECOG18'];
            }

            return _.map(recogIds, function (recogId) {
                var mediaSelected = {};
                mediaSelected[recogId.replace(/X$/, '')] = [brandValue];
                return mediaSelected;
            });
        }

        function getFullPeriods(period, numPeriods) {
            var prefix = period.charAt(0);
            var filterContent = _.chain(filterLayout).find({ 'name': 'FWAVE4' }).result('content').value();
            var allPeriods = null;

            if (filterContent) {
                // Intentar buscar por prefijo (ej: id 'M' para periodos mensuales)
                var groupNode = _.find(filterContent, { 'id': prefix });

                if (groupNode && groupNode.children) {
                    if (groupNode.children[0] && groupNode.children[0].children) {
                        allPeriods = _.chain(groupNode.children).flatMap('children').value();
                    } else {
                        allPeriods = groupNode.children;
                    }
                } else {
                    // FWAVE4: grupos por año (A2025, A2024...) con meses como hijos
                    allPeriods = _.chain(filterContent).flatMap('children').value();
                }
            }

            if (!allPeriods || allPeriods.length === 0) {
                return _.map(getEvolutionMonths(period, numPeriods), function (id) {
                    return { id: id, text: id };
                });
            }

            var indexPeriodSelected = _.findIndex(allPeriods, { 'id': period });
            if (indexPeriodSelected === -1) {
                return _.map(getEvolutionMonths(period, numPeriods), function (id) {
                    return { id: id, text: id };
                });
            }

            var selected = allPeriods.slice(indexPeriodSelected, indexPeriodSelected + numPeriods);
            selected.reverse();
            return selected;
        }

        function getMedia(typeMedia) {
            switch (typeMedia) {
                case 'FRECOTOTAL':
                    return [
                        { id: 'RECOG01', text: 'RECOG01:T' },
                        { id: 'RECOG11', text: 'RECOG11:VID' },
                        { id: 'RECOG18', text: 'RECOG18:VIS' }
                    ];
                case 'FRECOVIDEO':
                    return [
                        { id: 'RECOG11', text: 'RECOG11:VID' },
                        { id: 'RECOG12', text: 'RECOG12:LIN' },
                        { id: 'RECOG13', text: 'RECOG13:DIG' },
                        { id: 'RECOG14', text: 'RECOG14:OUD' },
                        { id: 'RECOG15', text: 'RECOG15:SOC' },
                        { id: 'RECOG25', text: 'RECOG25:OTH' }
                    ];
                case 'FRECOVISUAL':
                    return [
                        { id: 'RECOG18', text: 'RECOG18:VIS' },
                        { id: 'RECOG19', text: 'RECOG19:PRI' },
                        { id: 'RECOG20', text: 'RECOG20:SHO' },
                        { id: 'RECOG21', text: 'RECOG21:OUV' },
                        { id: 'RECOG22', text: 'RECOG22:SOV' },
                        { id: 'RECOG23', text: 'RECOG23:BRA' }
                    ];
                case 'FRECOVIDEOX':
                    return [
                        { id: 'RECOG11', text: 'RECOG11:VSN' },
                        { id: 'RECOG37', text: 'RECOG37:FB' },
                        { id: 'RECOG38', text: 'RECOG38:IG' },
                        { id: 'RECOG39', text: 'RECOG39:TK' },
                        { id: 'RECOG40', text: 'RECOG40:SC' },
                        { id: 'RECOG41', text: 'RECOG41:TW' },
                        { id: 'RECOG42', text: 'RECOG42:PI' },
                        { id: 'RECOG44', text: 'RECOG44:XTW' },
                        { id: 'RECOG43', text: 'RECOG43:OTH' }
                    ];
                case 'FRECOVISUAX':
                    return [
                        { id: 'RECOG18', text: 'RECOG18:VISN' },
                        { id: 'RECOG30', text: 'RECOG30:FB' },
                        { id: 'RECOG31', text: 'RECOG31:IG' },
                        { id: 'RECOG32', text: 'RECOG32:TK' },
                        { id: 'RECOG33', text: 'RECOG33:SC' },
                        { id: 'RECOG34', text: 'RECOG34:TW' },
                        { id: 'RECOG35', text: 'RECOG35:PI' },
                        { id: 'RECOG45', text: 'RECOG45:XTW' },
                        { id: 'RECOG36', text: 'RECOG36:OTH' }
                    ];
                default:
                    return _.chain(filterLayout).find({ 'name': typeMedia }).result('content').value();
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout24', {
                url: '/recognitionEvolutionAcrossCountries?web&jobId',
                breadcrumb: { icon: 'icon-layout-13', label: 'MAIN_HOME_LAYOUT24' },
                views: {
                    content: {
                        templateUrl: 'app/crossCountry/layout24/layout24.html',
                        controller: 'Layout24Controller',
                        controllerAs: 'layout24'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout24')) {
                $state.go('main');
                return $q.reject('Module layout24 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams', 'transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams && reportParams.year,
                    period: reportParams && reportParams.period,
                    campaigns: reportParams && reportParams.campaigns,
                    criteria: reportParams && reportParams.criteria,
                    typeMedia: reportParams && reportParams.typeMedia,
                    brand: reportParams && reportParams.brand
                };
                return mainService.getFilterModule('layout24', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout24', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('Layout24Controller', Layout24Controller);

    /** @ngInject */
    function Layout24Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, $q, layout24Service, uuid, configurationLoaderService, filterHelperService, contextVariableService, errorHandlerService, $uibModal) {
        var vm = this;

        vm.filter = {
            data: [],
            applied: false,
            preApplyFilter: preApplyFilter
        };

        vm.view = {
            loading: false,
            hasData: true,
            chart: {
                id: uuid.v4(),
                categories: [],
                data: [],
                config: {}
            }
        };

        vm.legend = {
            data: [],
            events: [],
            typeLegend: ''
        };

        // TODO: Definir los datasources correctos para cross-country evolution
        var query = {
            FRECOTOTAL: 'PUIG-30TOT',
            FRECOVIDEO: 'PUIG-30VID',
            FRECOVISUAL: 'PUIG-30VIS',
            FRECOVIDEOX: 'PUIG-30VID_REDESM',
            FRECOVISUAX: 'PUIG-30VIS_REDESM'
        };

        vm.isWeb = $stateParams && $stateParams.web === 'true';

        vm.cover = {
            icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
            text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
        };

        vm.copyXls = {
            copyToXlsFn: copyToXlsFn,
            copyToXlsData: []
        };

        // TODO: Reutilizar o adaptar el infoText del layout17/23
        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
            '<div class="item-info">' +
            '<span class="no-margin text-left">Select on the individual channels per country you want to visualize.</span>' +
            '</div>' +
            '</div>';

        vm.serviceView = layout24Service;

        vm.getNormaValue = function (norma, column, type) {
            if (!norma || !column) return '';
            var key = column.key || column.id;
            if (type === 'norma') {
                return norma.default && norma.default[key];
            }
            return norma.prestige && norma.prestige[key];
        };

        vm.notLastMedia = function (index) {
            return vm.legend.mediaColumns && index < vm.legend.mediaColumns.length - 1;
        };

        vm.openLegendModal = function () {
            $uibModal.open({
                templateUrl: 'legendModalLayout24.html',
                controller: function ($uibModalInstance, legendData) {
                    var modalVm = this;
                    modalVm.legend = legendData;
                    modalVm.getNormaValue = vm.getNormaValue;
                    modalVm.notLastMedia = vm.notLastMedia;
                    modalVm.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    legendData: function () {
                        return vm.legend;
                    }
                }
            });
        };

        vm.toggleSeries = function (seriesIndex, legendItem) {
            legendItem.visible = !legendItem.visible;
            var charts = window.Highcharts && window.Highcharts.charts;
            if (charts) {
                for (var i = charts.length - 1; i >= 0; i--) {
                    if (charts[i] && charts[i].renderTo && charts[i].renderTo.id === vm.view.chart.id) {
                        var series = charts[i].series[seriesIndex];
                        if (series) {
                            series.setVisible(legendItem.visible, true);
                        }
                        break;
                    }
                }
            }
        };

        init();

        /** listeners */
        var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
            vm.filter.applied = { value: true };
            init(args && args.filter);
        });

        $scope.$on('$destroy', function () {
            filterApply();
        });

        ////////////////

        function init(args) {
            $rootScope.$emit('printReport', false);
            if (!args) {
                vm.filter.applied = false;
            }
            vm.filter.data = args || filterData;
            vm.view.hasData = false;
            vm.view.loading = true;

            vm.legend = getStylesLegend(vm.legend);
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');
            vm.legend.typeLegend = typeMedia;

            var countryNames = getCountryNamesFromFilter();
            var selectedBrand = getBrandFromFilter();
            var selectedPeriod = filterHelperService.getFilterElementSelected(vm.filter.data, 'period');

            // 1. Obtener datos del gráfico primero para tener las categorías (eje X)
            layout24Service.getW1(query[typeMedia], countryNames, selectedBrand, selectedPeriod)
                .then(function (data) {
                    var processedCountries = data && data.processedCountries;

                    var allSeries = [];
                    var categories = [];

                    _.each(processedCountries, function (countryItem, countryIndex) {
                        var countryData = countryItem.data;
                        if (countryData && countryData.series && countryData.series.length > 0) {
                            var countrySeries = layout24Service.getChartData(countryData.series, countryItem.countryName, countryIndex);
                            allSeries = allSeries.concat(countrySeries);
                        }
                        if (countryData && countryData.categories && countryData.categories.length > 0 && categories.length === 0) {
                            categories = countryData.categories;
                        }
                    });

                    vm.view.chart.data = allSeries;

                    // Construir leyenda custom agrupada por columnas de país
                    var legendGroups = [];
                    var seriesIdx = 0;
                    var dashStyles = ['Solid', 'Dash', 'ShortDot', 'DashDot', 'LongDash', 'Dot'];

                    // Recoger nombres de métricas de referencia del primer país con series
                    var referenceMetricNames = [];
                    _.each(processedCountries, function (countryItem) {
                        if (referenceMetricNames.length === 0 && countryItem.data && countryItem.data.series && countryItem.data.series.length > 0) {
                            referenceMetricNames = _.map(countryItem.data.series, function (s) {
                                return $filter('uppercase')(s && s.text);
                            });
                        }
                    });

                    _.each(processedCountries, function (countryItem) {
                        var countryData = countryItem.data;
                        var countryHasSeries = countryData && countryData.series && countryData.series.length > 0;

                        // Comprobar si el país tiene valores reales (no todo nulos/ceros)
                        var countryHasRealData = false;
                        if (countryHasSeries) {
                            var countrySeriesSlice = allSeries.slice(seriesIdx, seriesIdx + countryData.series.length);
                            countryHasRealData = _.some(countrySeriesSlice, function (s) {
                                return _.some(s.data, function (d) { return d && d.y !== null && d.y !== '' && d.y !== undefined; });
                            });
                        }

                        var group = {
                            countryName: countryItem.countryName,
                            hasData: countryHasRealData,
                            series: []
                        };

                        if (countryHasSeries) {
                            _.each(countryData.series, function (_seriesItem, metricIdx) {
                                var seriesInfo = allSeries[seriesIdx];
                                if (seriesInfo) {
                                    var nameParts = seriesInfo.name.split(' - ');
                                    group.series.push({
                                        name: nameParts.length > 1 ? nameParts[1] : seriesInfo.name,
                                        color: seriesInfo.color,
                                        lineWidth: metricIdx === 0 ? 3 : 2,
                                        dashArray: getDashArray(dashStyles[metricIdx % dashStyles.length]),
                                        seriesIndex: seriesIdx,
                                        visible: metricIdx === 0
                                    });
                                }
                                seriesIdx++;
                            });
                        } else if (referenceMetricNames.length > 0) {
                            _.each(referenceMetricNames, function (refName, metricIdx) {
                                group.series.push({
                                    name: refName,
                                    color: '#ccc',
                                    lineWidth: metricIdx === 0 ? 3 : 2,
                                    dashArray: getDashArray(dashStyles[metricIdx % dashStyles.length]),
                                    seriesIndex: -1,
                                    visible: true
                                });
                            });
                        }

                        legendGroups.push(group);
                    });
                    vm.view.chart.legendGroups = legendGroups;
                    vm.view.chart.categories = layout24Service.getCategories(categories);

                    var min = _.chain(vm.view.chart.data).flatMap('data').map('y').min().value();
                    var max = _.chain(vm.view.chart.data).flatMap('data').map('y').max().value();
                    vm.view.hasData = isNaN(min) && isNaN(max) ? false : true;
                    vm.view.chart.config = layout24Service.getConfigChart(max > 90 ? 100 : max * 1.1, min * 0.95);
                    vm.copyXls.copyToXlsData = vm.view.chart;

                    // 2. Usar las categorías del eje X para extraer los años
                    var categoryIds = _.map(categories, 'id');
                    var contextOptions = { 'allTargets': false, 'filterPeriodInfo': { 'id': 'period', 'nameFilter': 'FWAVE4' } };
                    var contextMap = {
                        period: categoryIds,
                        country: filterHelperService.getPropertySelected('country'),
                        criteria: filterHelperService.getFilterElementSelected(vm.filter.data, 'criteria')
                    };

                    // 3. Llamar a contextVariableService con los periodos del eje X
                    return contextVariableService.getFilter.call(contextMap, 'contextVariables', contextOptions)
                        .then(function () {
                            // 4. Ahora obtener las normas (SYSTEM::REQUESTVARIABLES ya tiene todos los años)
                            vm.legend.normas = layout24Service.getLegend();
                            vm.legend.mediaColumns = layout24Service.getMediaColumns();
                            vm.legend.data = vm.legend.normas;
                            vm.legend.normasByCountry = _.chain(vm.legend.normas)
                                .groupBy('country')
                                .map(function (normas, country) {
                                    return { country: country, normas: _.orderBy(normas, 'year', 'desc') };
                                })
                                .value();
                        })
                        .catch(function () {
                            // Si falla contextVariableService, el gráfico se mantiene sin normas
                        });
                })
                .catch(function () {
                    vm.view.hasData = false;
                })
                .finally(function () {
                    vm.view.loading = false;
                    $rootScope.$emit('printReport', true);
                });
        }

        // --- Funciones multi-country (patrón layout23) ---

        function getCountryNamesFromFilter() {
            var selectedCountries = filterHelperService.getPropertySelected('country');
            if (!_.isArray(selectedCountries)) {
                selectedCountries = [selectedCountries];
            }

            var countryFilter = _.find(vm.filter.data, { 'id': 'country' });
            var countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].content;

            if (!countryContent) {
                countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].datos;
            }

            var countryMap = {};
            if (countryContent && _.isArray(countryContent)) {
                countryMap = _.chain(countryContent)
                    .keyBy('id')
                    .mapValues('text')
                    .value();
            }

            return _.map(selectedCountries, function (countryCode) {
                return {
                    code: countryCode,
                    name: countryMap[countryCode] || countryCode
                };
            });
        }

        function getBrandFromFilter() {
            var brandsFilter = _.find(vm.filter.data, { 'id': 'brands' });
            if (brandsFilter && brandsFilter.data && brandsFilter.data[0]) {
                var filterData = brandsFilter.data[0];
                var selectedNode = filterData.selectedNode;
                if (selectedNode && typeof selectedNode === 'string') {
                    return selectedNode;
                }
                if (_.isArray(selectedNode) && selectedNode.length > 0) {
                    return selectedNode[selectedNode.length - 1];
                }
            }
            return null;
        }

        function preApplyFilter(filter) {
            var countryFilter = {
                numberSelected: _.chain(filter)
                    .find({ 'id': 'country' })
                    .result('data')
                    .first()
                    .result('selectedNode')
                    .size()
                    .value(),
                max: 8,
                min: 1
            };

            if (!checkRange(countryFilter.numberSelected, countryFilter.min, countryFilter.max)) {
                var message = countryFilter.numberSelected < countryFilter.min
                    ? $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_COUNTRIES_L22')
                    : $filter('translationWithPrefix')('NO_MAXIMUM_SELECTIONS_COUNTRIES_L22');
                errorHandlerService.callbackWarning.call({ text: message });
                return false;
            }

            return true;
        }

        function checkRange(value, min, max) {
            return value >= min && value <= max;
        }

        function getDashArray(dashStyle) {
            switch (dashStyle) {
                case 'Dash': return '8,4';
                case 'ShortDot': return '2,4';
                case 'DashDot': return '8,4,2,4';
                case 'LongDash': return '12,4';
                case 'Dot': return '2,4';
                default: return 'none';
            }
        }

        // --- Funciones chart (patrón layout17) ---

        function copyToXlsFn(data) {
            var columnHeaders = [].concat("", _.chain(data).result('categories').map(function (item) {
                return $filter('lowercase')(item && item.text);
            }).value());

            var rowData = [columnHeaders];

            _.each(_.chain(data).result('data').value(), function (item) {
                rowData.push([].concat(item.name, _.chain(item.data).map(function (item) {
                    return item && item.y && $filter('round')(item.y, 0);
                }).value()));
            });

            var rows = _.map(rowData, function (i) {
                return i.join('\t');
            });
            return rows.join('\n');
        }

        function getStylesLegend(legend) {
            var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundChartSignification' }).result('color').value();
            var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsChartSignification' }).result('color').value();

            return _.extend({}, legend, {
                c1: _.chain(colors).find({ 'id': 'U' }).result('value').value(),
                c2: _.chain(colors).find({ 'id': 'D' }).result('value').value(),
                bg1: _.chain(backgroundColors).find({ 'id': 'U' }).result('value').value(),
                bg2: _.chain(backgroundColors).find({ 'id': 'D' }).result('value').value()
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout23Service', layout23Service);

    layout23Service.$inject = ['$http', 'filterHelperService', 'stateManagerService', 'configurationLoaderService'];
    function layout23Service($http, filterHelperService, stateManagerService, configurationLoaderService) {
        var filterLayout = {};
        var service = {
            getW1: getW1,
            getCategories: getCategories,
            getLegend: getLegend
        };

        return service;

        function getW1(query, countryNames, selectedBrand) {
            filterLayout = stateManagerService.getState('filterLayout');

            var countries = filterHelperService.getPropertySelected('country');
            var countriesArray = _.isArray(countries) ? countries : [countries];

            // Construir queries para todos los países
            var queries = buildQueriesForCountries(query, countriesArray, selectedBrand);

            console.log('Layout23 - Enviando petición:', { query: query, queries: queries, countriesArray: countriesArray });

            return $http({
                method: 'POST',
                url: './api/extract-batch',
                data: {
                    "queries": queries,
                    "transform": {
                        "template": "Join"
                    }
                }
            })
            .then(function(response) {
                return processResponse(response.data, countriesArray, countryNames, selectedBrand);
            })
            .catch(function(error) {
                console.error('Error en petición layout23:', error);
                return {
                    categories: [],
                    countryCodes: countriesArray,
                    data: []
                };
            });
        }

        function buildQueriesForCountries(query, countriesArray, selectedBrand) {
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');
            var criteria = filterHelperService.getPropertySelected('criteria');

            // Obtener periodo seleccionado y calcular este mes + mes anterior
            var period = filterHelperService.getPropertySelected('period');

            // Extraer el año del periodo (ej: "M2511" -> "25", "T2501" -> "25")
            var year = period ? period.substring(1, 3) : '25';

            // Usar la marca seleccionada pasada desde el controller
            var brandValue = selectedBrand || null;

            // Construir FMEDIOCAMPANYA basado en el typeMedia seleccionado
            // Obtener los RECOGs correspondientes de FMEDIOnewX
            var fmediocampanya = buildFmediocampanya(typeMedia, brandValue);

            // Crear una query por cada país
            return _.map(countriesArray, function(country) {
                return {
                    datasource: 'PUIG-29NEW-2',
                    query: query,
                    parameters: {
                        '$country$': country,
                        '$year$': year,
                        '$target$': criteria
                    },
                    filters: {
                        'FWAVE4': [period],
                        '#GROUP1': [
                            {
                                'FILTRO_PAIS': [country]
                            },
                            {
                                'CRITERIA': [criteria]
                            }
                        ],
                        'FMEDIOCAMPANYA': fmediocampanya
                    },
                    transform: {
                        template: 'Vector'
                    }
                };
            });
        }

        function processResponse(data, countriesArray, countryNames, selectedBrand) {
            // Crear mapa de códigos a nombres
            var countryMap = {};
            if (countryNames && _.isArray(countryNames)) {
                countryMap = _.keyBy(countryNames, 'code');
            }

            // Obtener la información de la marca seleccionada
            var allBrands = _.chain(filterLayout).find({ 'name': 'FCAMPA' }).result('content').value();
            var brandInfo = _.find(allBrands, { 'id': selectedBrand });
            var brandText = brandInfo ? brandInfo.text.split('-')[0].trim() : selectedBrand;

            // Nueva estructura: países como filas, métricas como columnas
            var newData = {
                brandName: brandText,
                brandId: selectedBrand,
                // rowHeaders son los países
                rowHeaders: _.map(countriesArray, function(countryCode) {
                    var countryInfo = countryMap[countryCode];
                    return {
                        id: countryCode,
                        text: countryInfo && countryInfo.name ? countryInfo.name : countryCode
                    };
                }),
                // data es un array donde cada elemento es una fila (país) con sus celdas (métricas)
                data: []
            };

            // data es un array con los resultados de cada país
            if (!data || !_.isArray(data) || data.length === 0) {
                return newData;
            }

            // Iterar sobre los resultados de cada país (cada país es una fila)
            _.forEach(data, function(countryResult) {
                // countryResult contiene todos los grupos de media (RECOG01, RECOG11, RECOG18)
                if (countryResult && _.isArray(countryResult)) {
                    // Cada fila es un array de celdas (métricas)
                    newData.data.push(transformRowData(countryResult));
                } else {
                    newData.data.push([]);
                }
            });

            return newData;
        }

        function transformRowData(rowData) {
            var cells = [];

            _.each(rowData, function(group) {
                var monthsGroupCollection = _.reduce(group);
                var filteredMonthsFromEvent = _.map(monthsGroupCollection, function(monthsGroup) {
                    monthsGroup.values = angular.copy(monthsGroup.value);
                    monthsGroup.value = monthsGroup.values[0];
                    monthsGroup.color = monthsGroup.rowVariable === 'RECOG01' ? monthsGroup.values[1] : "";
                    monthsGroup.background = monthsGroup.values[2];
                    return monthsGroup;
                });

                var monthSelected = _.chain(filteredMonthsFromEvent).maxBy('value').value();

                cells.push({
                    value: monthSelected && monthSelected.value,
                    color: getSignification('c', monthSelected && monthSelected.color),
                    background: getSignification('bg', monthSelected && monthSelected.background)
                });
            });

            return cells;
        }

        function getSignification(typeColor, signification) {
            var backgroundColors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'backgroundTable' }).result('color').value();
            var colors = _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'colorsTable' }).result('color').value();
            if (typeColor === 'c') {
                return _.chain(colors).find({ 'id': signification }).result('value').value();
            }
            else {
                return _.chain(backgroundColors).find({ 'id': signification }).result('value').value();
            }
        }

        function getLegend() {
            var typeMedia = filterHelperService.getPropertySelected('typeMedia');
            var typeMediaSelected = getMedia(typeMedia);
            var filterNorma = _.chain(filterLayout).find({ 'name': 'SYSTEM::REQUESTVARIABLES' }).result('content').value();

            var norma = [];

            if (_.isArray(filterNorma) && filterNorma.length > 0) {
                _.each(filterNorma, function(resultItem) {
                    var normaMap = {
                        default: {},
                        prestige: {}
                    };

                    if (resultItem.parameters) {
                        var filterCountry = _.chain(filterLayout).find({ 'name': 'F5' }).result('content').value();
                        var countryFound = _.find(filterCountry, { 'id': resultItem.parameters.$country$ });
                        normaMap.country = countryFound && countryFound.text;
                        var filterTarget = _.chain(filterLayout).find({ 'name': 'CRITERIA' }).result('content').value();
                        var targetFound = _.find(filterTarget, { 'id': resultItem.parameters.$target$ });
                        normaMap.target = targetFound && targetFound.text;
                        normaMap.year = '20' + resultItem.parameters.$year$;
                    }

                    _.each(typeMediaSelected, function(item) {
                        var values = item && item.text && item.text.split(':');
                        var variableSet = resultItem.variables || resultItem;
                        var foundNorma = _.find(variableSet, { 'name': 'NORMA_' + values[0] });
                        if (foundNorma === undefined) {
                            foundNorma = _.find(variableSet, { 'name': 'NORMA' + values[0] });
                        }
                        var foundPrestige = _.find(variableSet, { 'name': 'PRESTIGE' + values[0] });
                        if (foundPrestige === undefined) {
                            foundPrestige = _.find(variableSet, { 'name': 'NORMA_PRESTIGE' + values[0] });
                        }

                        if (foundNorma) {
                            normaMap.default[values[1]] = foundNorma.value;
                        }
                        if (foundPrestige) {
                            normaMap.prestige[values[1]] = foundPrestige.value;
                        }
                    });

                    norma.push(normaMap);
                });
            }

            return norma;
        }

        function getCategories(selectedBrand) {
            // Obtener la información completa de las marcas desde FCAMPA
            var allBrands = _.chain(filterLayout).find({ 'name': 'FCAMPA' }).result('content').value();

            // Si se pasa selectedBrand, filtrar solo esa marca
            if (selectedBrand) {
                var brandInfo = _.find(allBrands, { 'id': selectedBrand });
                if (brandInfo) {
                    var splitedText = brandInfo.text && brandInfo.text.split('-');
                    return [{
                        id: brandInfo.id,
                        text: splitedText ? splitedText[0].trim() : brandInfo.text
                    }];
                }
                return [];
            }

            // Fallback: intentar obtener del filterHelper
            var brands = filterHelperService.getPropertySelected('brands');
            var brandsArray = _.isArray(brands) ? brands : [brands];

            return _.chain(allBrands)
                .filter(function(item) {
                    return _.includes(brandsArray, item.id);
                })
                .map(function(item) {
                    var splitedText = item && item.text && item.text.split('-');
                    return {
                        id: item.id,
                        text: splitedText ? splitedText[0].trim() : item.text
                    };
                })
                .value();
        }

        function getMedia(typeMedia) {
            // Usar datos dinámicos del filterLayout (como layout16) para que
            // los códigos RECOG siempre coincidan con los del servidor
            var dynamicMedia = _.chain(filterLayout).find({ 'name': typeMedia }).result('content').value();
            if (dynamicMedia && dynamicMedia.length > 0) {
                return dynamicMedia;
            }

            // Fallback a definiciones hardcodeadas si no hay datos dinámicos
            switch (typeMedia) {
                case 'FRECOTOTAL':
                    return [
                        { id: 'RECOG01', text: 'RECOG01:T' },
                        { id: 'RECOG11', text: 'RECOG11:VID' },
                        { id: 'RECOG18', text: 'RECOG18:VIS' }
                    ];
                case 'FRECOVIDEO':
                    return [
                        { id: 'RECOG11', text: 'RECOG11:VID' },
                        { id: 'RECOG12', text: 'RECOG12:LIN' },
                        { id: 'RECOG13', text: 'RECOG13:DIG' },
                        { id: 'RECOG14', text: 'RECOG14:OUD' },
                        { id: 'RECOG15', text: 'RECOG15:SOC' },
                        { id: 'RECOG25', text: 'RECOG25:OTH' }
                    ];
                case 'FRECOVISUAL':
                    return [
                        { id: 'RECOG18', text: 'RECOG18:VIS' },
                        { id: 'RECOG19', text: 'RECOG19:PRI' },
                        { id: 'RECOG20', text: 'RECOG20:SHO' },
                        { id: 'RECOG21', text: 'RECOG21:OUV' },
                        { id: 'RECOG22', text: 'RECOG22:SOV' },
                        { id: 'RECOG23', text: 'RECOG23:BRA' }
                    ];
                case 'FRECOVIDEOX':
                    // Video Social Networks: RECOG11 (Video parent) + hijos (RECOG37-44)
                    return [
                        { id: 'RECOG11', text: 'RECOG11:VID' },
                        { id: 'RECOG37', text: 'RECOG37:FB' },
                        { id: 'RECOG38', text: 'RECOG38:IG' },
                        { id: 'RECOG39', text: 'RECOG39:TK' },
                        { id: 'RECOG40', text: 'RECOG40:SC' },
                        { id: 'RECOG41', text: 'RECOG41:TW' },
                        { id: 'RECOG42', text: 'RECOG42:PI' },
                        { id: 'RECOG44', text: 'RECOG44:XTW' },
                        { id: 'RECOG43', text: 'RECOG43:OTH' }
                    ];
                case 'FRECOVISUAX':
                    // Visual Social Networks: RECOG18 (Visual parent) + hijos (RECOG30-36, RECOG45)
                    return [
                        { id: 'RECOG18', text: 'RECOG18:VIS' },
                        { id: 'RECOG30', text: 'RECOG30:FB' },
                        { id: 'RECOG31', text: 'RECOG31:IG' },
                        { id: 'RECOG32', text: 'RECOG32:TK' },
                        { id: 'RECOG33', text: 'RECOG33:SC' },
                        { id: 'RECOG34', text: 'RECOG34:TW' },
                        { id: 'RECOG35', text: 'RECOG35:PI' },
                        { id: 'RECOG45', text: 'RECOG45:XTW' },
                        { id: 'RECOG36', text: 'RECOG36:OTH' }
                    ];
                default:
                    return _.chain(filterLayout).find({ 'name': typeMedia }).result('content').value();
            }
        }

        function buildFmediocampanya(typeMedia, brandValue) {
            // Obtener el filtro FMEDIOnewX
            var fmediaFilter = _.chain(filterLayout).find({ 'name': 'FMEDIOnewX' }).result('content').value();
            var recogIds = [];

            switch (typeMedia) {
                case 'FRECOTOTAL':
                    // Total: RECOG01 (Total), RECOG11 (Video), RECOG18 (Visual)
                    recogIds = ['RECOG01', 'RECOG11', 'RECOG18'];
                    break;
                case 'FRECOVIDEO':
                    // Video: RECOG11 + sus hijos
                    var videoItem = _.find(fmediaFilter, { 'id': 'RECOG11' });
                    recogIds = ['RECOG11'];
                    if (videoItem && videoItem.children) {
                        recogIds = recogIds.concat(_.map(videoItem.children, 'id'));
                    }
                    break;
                case 'FRECOVISUAL':
                    // Visual: RECOG18 + sus hijos
                    var visualItem = _.find(fmediaFilter, { 'id': 'RECOG18' });
                    recogIds = ['RECOG18'];
                    if (visualItem && visualItem.children) {
                        recogIds = recogIds.concat(_.map(visualItem.children, 'id'));
                    }
                    break;
                case 'FRECOVIDEOX':
                    // Video Social Networks: RECOG11X + sus hijos
                    var videoSNItem = _.find(fmediaFilter, { 'id': 'RECOG11X' });
                    recogIds = ['RECOG11X'];
                    if (videoSNItem && videoSNItem.children) {
                        recogIds = recogIds.concat(_.map(videoSNItem.children, 'id'));
                    }
                    break;
                case 'FRECOVISUAX':
                    // Visual Social Networks: RECOG18X + sus hijos
                    var visualSNItem = _.find(fmediaFilter, { 'id': 'RECOG18X' });
                    recogIds = ['RECOG18X'];
                    if (visualSNItem && visualSNItem.children) {
                        recogIds = recogIds.concat(_.map(visualSNItem.children, 'id'));
                    }
                    break;
                default:
                    recogIds = ['RECOG01', 'RECOG11', 'RECOG18'];
            }

            // Construir el array de FMEDIOCAMPANYA (quitar sufijo X de las claves)
            return _.map(recogIds, function(recogId) {
                var mediaSelected = {};
                mediaSelected[recogId.replace(/X$/, '')] = [brandValue];
                return mediaSelected;
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout23', {
                url: '/recognitionByMediaAcrossCountries?web&jobId',
                breadcrumb: { icon: 'icon-layout-11', label: 'MAIN_HOME_LAYOUT23' },
                views: {
                    content: {
                        templateUrl: 'app/crossCountry/layout23/layout23.html',
                        controller: 'Layout23Controller',
                        controllerAs: 'layout23'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout23')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout23 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams', 'transition'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams, _transition) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams && reportParams.year,
                    period: reportParams && reportParams.period,
                    typeMedia: reportParams && reportParams.typeMedia,
                    brand: reportParams && reportParams.brand,
                    criteria: reportParams && reportParams.criteria
                };
                return mainService.getFilterModule('layout23', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout23', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('Layout23Controller', Layout23Controller);

    /** @ngInject */
    function Layout23Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout23Service, filterHelperService, contextVariableService, errorHandlerService) {
        var vm = this;

        vm.filter = {
            data: [],
            applied: false,
            preApplyFilter: preApplyFilter
        };

        vm.view = {
            loading: false,
            hasData: true
        };

        vm.dataTable = {
            brandName: '',
            columnHeaders: [],
            rowHeaders: [],
            data: [],
            legendData: [],
            events: []
        };

        var query = {
            FRECOTOTAL: 'PUIG-29TOT',
            FRECOVIDEO: 'PUIG-29VID',
            FRECOVISUAL: 'PUIG-29VIS',
            FRECOVIDEOX: 'PUIG-29VID_REDESM',
            FRECOVISUAX: 'PUIG-29VIS_REDESM'
        };

        vm.isWeb = $stateParams && $stateParams.web === 'true' ? true : false;

        vm.cover = {
            icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
            text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
        };

        vm.copyXls = {
            copyToXlsFn: copyToXlsFn,
            copyToXlsData: {}
        };

        vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
            '<div class="item-info">' +
            '<span class="no-margin text-left font-weight_bold">' + ($filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE')) + '</span>' +
            '<div class="item-info margin-top--0_5">' +
            '<span class="no-margin text-left font-weight_bold">' + $filter('uppercase')($filter('translationWithPrefix')('GROUP_VIDEO')) + '</span>' +
            '</div>' +
            '<div class="item-info">' +
            '<p class="no-margin text-left"><strong>' + $filter('translationWithPrefix')('CORE_VIDEO') + '</strong>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_CORE_VIDEO') + '</p>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_LINEAR_TV') + '</strong>' +
            '<ul><li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_LINEAR_TRAD') + '</li></ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_DIGITAL_TV') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_PAID') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_SMART') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_CATCHUP') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_NON_LINEAR_STREAM') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_OUTDOOR') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TRAIN') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_BUS_TAXI') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN_YOUTUBE') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_SN') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_OTHER') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_CINEMA') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_RADIO') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info">' +
            '<p class="no-margin text-left"><strong>' + $filter('translationWithPrefix')('SOCIAL_VIDEOS') + '</strong>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_SOCIAL_VIDEOS') + '</p>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<span class="no-margin text-left font-weight_bold"> ' + $filter('uppercase')($filter('translationWithPrefix')('GROUP_VISUAL')) + '</span>' +
            '</div>' +
            '<div class="item-info">' +
            '<p class="no-margin text-left"><strong>' + $filter('translationWithPrefix')('OFFLINE_ONLINE') + '</strong>' + $filter('translationWithPrefix')('ADVERTS_VISUAL_OFFLINE_ONLINE') + '</p>' +
            '</div>' +
            '<div class="item-info">' +
            '<p class="no-margin text-left"><strong>' + $filter('translationWithPrefix')('SOCIAL_VISUAL') + '</strong>' + $filter('translationWithPrefix')('ADVERTS_VISUAL_SOCIAL_VISUAL') + '</p>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_PRINT') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_PRINT_CONVPRESS') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OTHER_DIGITAL') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_SHOP') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VIDEO_NEW_MEDIA_STRUCTURE_OUTDOOR_SHOPPING') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('GROUP_SHOP') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_SHOP_RETAIL') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_OUTDOOR') + '</strong>' +
            '<ul>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_TRANSPORT') + '</li>' +
            '<li>' + $filter('translationWithPrefix')('ADVERTS_VISUAL_NEW_MEDIA_STRUCTURE_OUTDOOR_STREET') + '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_SOCIAL_NETWORKS') + '</strong>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<strong>' + $filter('translationWithPrefix')('GROUP_BRAND_WEBSITES') + '</strong>' +
            '</div>' +
            '<div class="item-info margin-top--0_5">' +
            '<p class="no-margin text-left">' + $filter('translationWithPrefix')('BEST_DATA_MEDIA_EVENT') + '</p>' +
            '</div>' +
            '<div>';

        vm.serviceView = layout23Service;

        init();

        /** listeners */
        var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
            vm.filter.applied = { value: true };
            init(args && args.filter);
        });

        $scope.$on('$destroy', function () {
            filterApply();
        });

        function init(args) {
            $rootScope.$emit('printReport', false);
            if (!args) {
                vm.filter.applied = false;
            }
            vm.filter.data = args || filterData;
            vm.view.hasData = false;
            vm.view.loading = true;

            var contextOptions = { 'allTargets': false, 'filterPeriodInfo': { 'id': 'period', 'nameFilter': 'FWAVE4' } };
            var contextMap = {
                period: filterHelperService.getFilterElementSelected(vm.filter.data, 'period'),
                country: filterHelperService.getPropertySelected('country'),
                criteria: filterHelperService.getFilterElementSelected(vm.filter.data, 'criteria')
            };

            contextVariableService.getFilter.call(contextMap, 'contextVariables', contextOptions).then(function () {
                var typeMedia = filterHelperService.getPropertySelected('typeMedia');
                var countryNames = getCountryNamesFromFilter();
                var selectedBrand = getBrandFromFilter();

                layout23Service.getW1(query[typeMedia], countryNames, selectedBrand)
                    .then(function (data) {
                        vm.view.hasData = true;

                        // Configurar datos para la tabla
                        // Nueva estructura: países como filas, métricas como columnas
                        vm.dataTable.brandName = data.brandName || '';
                        vm.dataTable.rowHeaders = data.rowHeaders || []; // Países

                        // Obtener normas y estructurar legendData con typeLegend
                        var legendNormas = layout23Service.getLegend();
                        var period = filterHelperService.getPropertySelected('period');
                        var periodYear = period ? parseInt(period.substring(1, 3)) : 25;
                        vm.dataTable.legend = {
                            typeLegend: typeMedia,
                            typeMedia: typeMedia,
                            normas: legendNormas,
                            periodYear: periodYear
                        };

                        vm.dataTable.events = vm.filter.data.find(function (item) { return item.id === 'year'; });
                        vm.dataTable.columnHeaders = setColumnHeaders(typeMedia, legendNormas[0] || {});
                        vm.dataTable.data = data.data || []; // Array de arrays (cada fila es un país)

                        // Filtrar filas (países) que tengan al menos un valor > 0
                        var processedData = filterRowsWithData(vm.dataTable.rowHeaders, vm.dataTable.data);

                        if (processedData && processedData.length > 0) {
                            vm.dataTable.rowHeaders = _.map(processedData, 'rowHeader');
                            vm.dataTable.data = _.map(processedData, 'rowData');
                        } else {
                            vm.view.hasData = false;
                        }

                        // Datos para clipboard
                        vm.copyXls.copyToXlsData = {
                            brandName: vm.dataTable.brandName,
                            rowHeaders: vm.dataTable.rowHeaders,
                            columnHeaders: vm.dataTable.columnHeaders,
                            data: vm.dataTable.data
                        };
                    })
                    .catch(function () {
                        vm.view.hasData = false;
                    })
                    .finally(function () {
                        vm.view.loading = false;
                        $rootScope.$emit('printReport', true);
                    });
            });
        }

        function getCountryNamesFromFilter() {
            var selectedCountries = filterHelperService.getPropertySelected('country');
            if (!_.isArray(selectedCountries)) {
                selectedCountries = [selectedCountries];
            }

            var countryFilter = _.find(vm.filter.data, { 'id': 'country' });
            var countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].content;

            if (!countryContent) {
                countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].datos;
            }

            var countryMap = {};
            if (countryContent && _.isArray(countryContent)) {
                countryMap = _.chain(countryContent)
                    .keyBy('id')
                    .mapValues('text')
                    .value();
            }

            return _.map(selectedCountries, function (countryCode) {
                return {
                    code: countryCode,
                    name: countryMap[countryCode] || countryCode
                };
            });
        }

        function getBrandFromFilter() {
            // Obtener la marca seleccionada del filtro
            var brandsFilter = _.find(vm.filter.data, { 'id': 'brands' });
            if (brandsFilter && brandsFilter.data && brandsFilter.data[0]) {
                var filterData = brandsFilter.data[0];
                var selectedNode = filterData.selectedNode;
                // selectedNode es directamente el string del ID (ej: "T0001")
                if (selectedNode && typeof selectedNode === 'string') {
                    return selectedNode;
                }
                // Si es un array, devolver el último elemento
                if (_.isArray(selectedNode) && selectedNode.length > 0) {
                    return selectedNode[selectedNode.length - 1];
                }
            }
            return null;
        }

        function filterRowsWithData(rowHeaders, data) {
            // Filtrar filas (países) que tengan al menos un valor > 0
            return _.chain(rowHeaders)
                .map(function (rowHeader, index) {
                    var rowData = data[index];
                    return {
                        rowHeader: rowHeader,
                        rowData: rowData
                    };
                })
                .filter(function (item) {
                    // Filtrar filas que tengan al menos una celda con valor > 0
                    if (!item.rowData || !_.isArray(item.rowData)) return false;
                    return _.some(item.rowData, function (cell) {
                        return cell && cell.value && parseInt(cell.value) > 0;
                    });
                })
                .value();
        }

        function copyToXlsFn(data) {
            var allRows = [];

            // Título: nombre de la marca
            allRows.push([data && data.brandName]);

            // Cabeceras: vacío + métricas
            var headerRow = [""];
            _.each(data && data.columnHeaders, function (header) {
                headerRow.push($filter('translationWithPrefix')(header && header.text));
            });
            allRows.push(headerRow);

            // Filas de datos: país + valores de métricas
            _.each(data && data.rowHeaders, function (rowHeader, indexRow) {
                var titleRow = rowHeader && rowHeader.text;
                var dataRow = [titleRow];

                var rowData = data && data.data && data.data[indexRow];
                if (rowData && _.isArray(rowData)) {
                    _.each(rowData, function (cell) {
                        dataRow.push($filter('round')((cell && cell.value), 0));
                    });
                }

                allRows.push(dataRow);
            });

            var rows = _.map(allRows, function (i) {
                return i.join('\t');
            });
            return rows.join('\n');
        }

        function setColumnHeaders(media, normaLegend) {
            normaLegend = normaLegend || { default: {}, prestige: {} };

            switch (media) {
                case 'FRECOTOTAL':
                    return [
                        { id: 'total', key: 'T', logo: '', text: 'GROUP_CAMPAIGN', legendNorma: normaLegend.default && normaLegend.default.T, legendPrestige: normaLegend.prestige && normaLegend.prestige.T },
                        { id: 'video', key: 'VID', logo: '', text: 'GROUP_VIDEO', legendNorma: normaLegend.default && normaLegend.default.VID, legendPrestige: normaLegend.prestige && normaLegend.prestige.VID },
                        { id: 'visual', key: 'VIS', logo: '', text: 'GROUP_VISUAL', legendNorma: normaLegend.default && normaLegend.default.VIS, legendPrestige: normaLegend.prestige && normaLegend.prestige.VIS }
                    ];
                case 'FRECOVIDEO':
                    return [
                        { id: 'video', key: 'VID', logo: '', text: 'GROUP_VIDEO', legendNorma: normaLegend.default && normaLegend.default.VID, legendPrestige: normaLegend.prestige && normaLegend.prestige.VID },
                        { id: 'linear_tv', key: 'LIN', logo: '', text: 'GROUP_LINEAR_TV', legendNorma: normaLegend.default && normaLegend.default.LIN, legendPrestige: normaLegend.prestige && normaLegend.prestige.LIN },
                        { id: 'digital_tv', key: 'DIG', logo: '', text: 'GROUP_DIGITAL_TV', legendNorma: normaLegend.default && normaLegend.default.DIG, legendPrestige: normaLegend.prestige && normaLegend.prestige.DIG },
                        { id: 'outdoor', key: 'OUD', logo: '', text: 'GROUP_OUTDOOR', legendNorma: normaLegend.default && normaLegend.default.OUD, legendPrestige: normaLegend.prestige && normaLegend.prestige.OUD },
                        { id: 'social_networks', key: 'SOC', logo: '', text: 'GROUP_SOCIAL_NETWORKS', legendNorma: normaLegend.default && normaLegend.default.SOC, legendPrestige: normaLegend.prestige && normaLegend.prestige.SOC },
                        { id: 'other', key: 'OTH', logo: '', text: 'GROUP_OTHER', legendNorma: normaLegend.default && normaLegend.default.OTH, legendPrestige: normaLegend.prestige && normaLegend.prestige.OTH }
                    ];
                case 'FRECOVISUAL':
                    return [
                        { id: 'visual', key: 'VIS', logo: '', text: 'GROUP_VISUAL', legendNorma: normaLegend.default && normaLegend.default.VIS, legendPrestige: normaLegend.prestige && normaLegend.prestige.VIS },
                        { id: 'print', key: 'PRI', logo: '', text: 'GROUP_PRINT', legendNorma: normaLegend.default && normaLegend.default.PRI, legendPrestige: normaLegend.prestige && normaLegend.prestige.PRI },
                        { id: 'shop', key: 'SHO', logo: '', text: 'GROUP_SHOP', legendNorma: normaLegend.default && normaLegend.default.SHO, legendPrestige: normaLegend.prestige && normaLegend.prestige.SHO },
                        { id: 'outdoor', key: 'OUV', logo: '', text: 'GROUP_OUTDOOR', legendNorma: normaLegend.default && normaLegend.default.OUV, legendPrestige: normaLegend.prestige && normaLegend.prestige.OUV },
                        { id: 'social_networks', key: 'SOV', logo: '', text: 'GROUP_SOCIAL_NETWORKS', legendNorma: normaLegend.default && normaLegend.default.SOV, legendPrestige: normaLegend.prestige && normaLegend.prestige.SOV },
                        { id: 'brand_websites', key: 'BRA', logo: '', text: 'GROUP_BRAND_WEBSITES', legendNorma: normaLegend.default && normaLegend.default.BRA, legendPrestige: normaLegend.prestige && normaLegend.prestige.BRA }
                    ];
                case 'FRECOVIDEOX':
                    return [
                        { id: 'video_sn', key: 'VID', logo: '', text: 'GROUP_VIDEO', legendNorma: normaLegend.default && normaLegend.default.VID, legendPrestige: normaLegend.prestige && normaLegend.prestige.VID },
                        { id: 'facebook', key: 'FB', logo: '', text: 'GROUP_FACEBOOK', legendNorma: normaLegend.default && normaLegend.default.FB, legendPrestige: normaLegend.prestige && normaLegend.prestige.FB },
                        { id: 'instagram', key: 'IG', logo: '', text: 'GROUP_INSTAGRAM', legendNorma: normaLegend.default && normaLegend.default.IG, legendPrestige: normaLegend.prestige && normaLegend.prestige.IG },
                        { id: 'tiktok', key: 'TK', logo: '', text: 'GROUP_TIKTOK', legendNorma: normaLegend.default && normaLegend.default.TK, legendPrestige: normaLegend.prestige && normaLegend.prestige.TK },
                        { id: 'snapchat', key: 'SC', logo: '', text: 'GROUP_SNAPCHAT', legendNorma: normaLegend.default && normaLegend.default.SC, legendPrestige: normaLegend.prestige && normaLegend.prestige.SC },
                        { id: 'twitch', key: 'TW', logo: '', text: 'GROUP_TWITCH', legendNorma: normaLegend.default && normaLegend.default.TW, legendPrestige: normaLegend.prestige && normaLegend.prestige.TW },
                        { id: 'pinterest', key: 'PI', logo: '', text: 'GROUP_PINTEREST', legendNorma: normaLegend.default && normaLegend.default.PI, legendPrestige: normaLegend.prestige && normaLegend.prestige.PI },
                        { id: 'twitter', key: 'XTW', logo: '', text: 'GROUP_TWITTER', legendNorma: normaLegend.default && normaLegend.default.XTW, legendPrestige: normaLegend.prestige && normaLegend.prestige.XTW },
                        { id: 'other', key: 'OTH', logo: '', text: 'GROUP_OTHER', legendNorma: normaLegend.default && normaLegend.default.OTH, legendPrestige: normaLegend.prestige && normaLegend.prestige.OTH }
                    ];
                case 'FRECOVISUAX':
                    return [
                        { id: 'visual_sn', key: 'VIS', logo: '', text: 'GROUP_VISUAL', legendNorma: normaLegend.default && normaLegend.default.VIS, legendPrestige: normaLegend.prestige && normaLegend.prestige.VIS },
                        { id: 'facebook', key: 'FB', logo: '', text: 'GROUP_FACEBOOK', legendNorma: normaLegend.default && normaLegend.default.FB, legendPrestige: normaLegend.prestige && normaLegend.prestige.FB },
                        { id: 'instagram', key: 'IG', logo: '', text: 'GROUP_INSTAGRAM', legendNorma: normaLegend.default && normaLegend.default.IG, legendPrestige: normaLegend.prestige && normaLegend.prestige.IG },
                        { id: 'tiktok', key: 'TK', logo: '', text: 'GROUP_TIKTOK', legendNorma: normaLegend.default && normaLegend.default.TK, legendPrestige: normaLegend.prestige && normaLegend.prestige.TK },
                        { id: 'snapchat', key: 'SC', logo: '', text: 'GROUP_SNAPCHAT', legendNorma: normaLegend.default && normaLegend.default.SC, legendPrestige: normaLegend.prestige && normaLegend.prestige.SC },
                        { id: 'twitch', key: 'TW', logo: '', text: 'GROUP_TWITCH', legendNorma: normaLegend.default && normaLegend.default.TW, legendPrestige: normaLegend.prestige && normaLegend.prestige.TW },
                        { id: 'pinterest', key: 'PI', logo: '', text: 'GROUP_PINTEREST', legendNorma: normaLegend.default && normaLegend.default.PI, legendPrestige: normaLegend.prestige && normaLegend.prestige.PI },
                        { id: 'twitter', key: 'XTW', logo: '', text: 'GROUP_TWITTER', legendNorma: normaLegend.default && normaLegend.default.XTW, legendPrestige: normaLegend.prestige && normaLegend.prestige.XTW },
                        { id: 'other', key: 'OTH', logo: '', text: 'GROUP_OTHER', legendNorma: normaLegend.default && normaLegend.default.OTH, legendPrestige: normaLegend.prestige && normaLegend.prestige.OTH }
                    ];
            }
        }

        function preApplyFilter(filter) {
            // Validar que haya entre 1 y 8 países seleccionados
            var countryFilter = {
                numberSelected: _.chain(filter)
                    .find({ 'id': 'country' })
                    .result('data')
                    .first()
                    .result('selectedNode')
                    .size()
                    .value(),
                max: 8,
                min: 1
            };

            if (!checkRange(countryFilter.numberSelected, countryFilter.min, countryFilter.max)) {
                var message = countryFilter.numberSelected < countryFilter.min
                    ? $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_COUNTRIES_L22')
                    : $filter('translationWithPrefix')('NO_MAXIMUM_SELECTIONS_COUNTRIES_L22');
                errorHandlerService.callbackWarning.call({ text: message });
                return false;
            }

            return true;
        }

        function checkRange(value, min, max) {
            return value >= min && value <= max;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout22Service', layout22Service);

    layout22Service.$inject = ['$http', 'filterHelperService', '$q'];
    function layout22Service($http, filterHelperService, $q) {
        var service = {
            getW1: getW1
        };

        return service;

        function getW1(countryNames) {
            var countries = filterHelperService.getPropertySelected('country');
            var countriesArray = _.isArray(countries) ? countries : [countries];
            
            // Crear promesas para datos principales y sample
            var dataPromises = _.map(countriesArray, function(country) {
                return getDataForCountry(country);
            });
            
            var samplePromises = _.map(countriesArray, function(country) {
                return getSampleForCountry(country);
            });

            // Esperar a que todas las peticiones terminen
            return $q.all([
                $q.all(dataPromises),
                $q.all(samplePromises)
            ])
            .then(function(allResults) {
                var dataResults = allResults[0];
                var sampleResults = allResults[1];
                return mergeCountryData(dataResults, sampleResults, countriesArray, countryNames);
            });
        }

        function getDataForCountry(country) {
            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var period = filterHelperService.getPropertySelected('period');
            var criteria = filterHelperService.getPropertySelected('criteria');
            
            var f20I = 'IM' + country + brandSelected + parentBrand;

            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: "PUIG-24",
                    query: "PUIG-24",
                    parameters: {
                        $country$: country
                    },
                    filters: {
                        FWAVEI: [period],
                        F20I: [f20I],
                        '#GROUP1': [
                            {
                                FILTRO_PAIS: [country]
                            },
                            {
                                CRITERIA: [criteria]
                            }
                        ]
                    },
                    transform: {
                        template: 'Signification',
                        parameters: {
                            groupOn: 'Columns'
                        }
                    }
                }
            })
            .then(function(response) {
                console.log('Respuesta para país ' + country + ':', response.data);
                return {
                    country: country,
                    data: response && response.data
                };
            })
            .catch(function(error) {
                console.error('Error en petición para país ' + country + ':', error);
                return {
                    country: country,
                    data: null
                };
            });
        }

        function getSampleForCountry(country) {
            var brand = filterHelperService.getPropertySelected('brand');
            var brandSelected = brand && brand.substr(1);
            var parentBrand = brand && brand.charAt(0) && brand.charAt(0).toUpperCase();
            var period = filterHelperService.getPropertySelected('period');
            var criteria = filterHelperService.getPropertySelected('criteria');
            
            var f20I = 'IM' + country + brandSelected + parentBrand;

            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: "PUIG-24MUES",
                    query: "PUIG-24MUES",
                    parameters: {
                        $country$: country
                    },
                    filters: {
                        FWAVEI: [period],
                        F20I: [f20I],
                        '#GROUP1': [
                            {
                                FILTRO_PAIS: [country]
                            },
                            {
                                CRITERIA: [criteria]
                            }
                        ]
                    },
                    transform: {
                        template: "Compact",
                        parameters: {
                            itemsBy: "Rows",
                            filterExpression: "$.[?(@.id =~ /^BASE|TOTAL(.*)$/)]"
                        }
                    }
                }
            })
            .then(function(response) {
                console.log('Sample para país ' + country + ':', response.data);
                
                // CORRECCIÓN: Manejar diferentes formatos de respuesta
                var sampleValue = null;
                
                // Si la respuesta es un string directamente (como "138")
                if (_.isString(response.data)) {
                    sampleValue = response.data;
                }
                // Si es un número directamente
                else if (_.isNumber(response.data)) {
                    sampleValue = response.data;
                }
                // Si es un array con estructura compleja (formato antiguo)
                else if (_.isArray(response.data) && response.data.length > 0) {
                    if (response.data[0].values && 
                        response.data[0].values.length > 0 &&
                        response.data[0].values[0].value !== undefined) {
                        sampleValue = response.data[0].values[0].value;
                    }
                }
                // Si es un objeto con propiedad 'value'
                else if (_.isObject(response.data) && response.data.value !== undefined) {
                    sampleValue = response.data.value;
                }
                
                console.log('Sample extraído para ' + country + ':', sampleValue);
                
                // Convertir "0" string o 0 número a null para que se muestre como guión
                if (sampleValue === "0" || sampleValue === 0) {
                    sampleValue = null;
                }
                
                return {
                    country: country,
                    sample: sampleValue
                };
            })
            .catch(function(error) {
                console.error('Error obteniendo sample para país ' + country + ':', error);
                return {
                    country: country,
                    sample: null
                };
            });
        }

        function mergeCountryData(dataResults, sampleResults, countriesArray, countryNames) {
            // Crear mapa de códigos a nombres
            var countryMap = {};
            if (countryNames && _.isArray(countryNames)) {
                countryMap = _.keyBy(countryNames, 'code');
            }
            
            // Crear mapa de samples por país
            var sampleMap = _.keyBy(sampleResults, 'country');
            
            var newData = {
                // Convertir códigos de país a nombres completos
                categories: _.map(countriesArray, function(countryCode) {
                    var countryInfo = countryMap[countryCode];
                    return countryInfo && countryInfo.name ? countryInfo.name : countryCode;
                }),
                samples: _.map(countriesArray, function(countryCode) {
                    var sampleInfo = sampleMap[countryCode];
                    return sampleInfo ? sampleInfo.sample : null;
                }),
                data: []
            };

            var firstValidResult = _.find(dataResults, function(r) { 
                return r.data && r.data.length > 0; 
            });
            
            if (!firstValidResult || !firstValidResult.data) {
                console.warn('No hay datos válidos en ningún país');
                return newData;
            }

            _.forEach(firstValidResult.data, function(groupItem) {
                var imageAttribute = groupItem.values && groupItem.values[0];
                
                if (!imageAttribute) return;

                var newRow = {
                    id: imageAttribute.id,
                    text: imageAttribute.text ? imageAttribute.text.replace(/%%/g, '').trim() : '',
                    typeImg: 'svg',
                    values: []
                };

                _.forEach(dataResults, function(result, index) {
                    var countryData = result.data;
                    var countryInfo = countryMap[result.country];
                    var displayName = countryInfo && countryInfo.name ? countryInfo.name : result.country;
                    
                    var valueObj = {
                        text: displayName,
                        type: '',
                        value: null,
                        hasMark: false
                    };

                    if (countryData && countryData.length > 0) {
                        var matchingGroup = _.find(countryData, function(group) {
                            return group.values && 
                                   group.values[0] && 
                                   group.values[0].id === imageAttribute.id;
                        });

                        if (matchingGroup && 
                            matchingGroup.values && 
                            matchingGroup.values[0] && 
                            matchingGroup.values[0].values &&
                            matchingGroup.values[0].values[0]) {
                            
                            var dataValue = matchingGroup.values[0].values[0];
                            var groupText = matchingGroup.group || '';
                            
                            valueObj = {
                                text: displayName,
                                type: dataValue.type || '',
                                // Convertir 0 en null para que se muestre como guion
                                value: dataValue.value === 0 ? null : dataValue.value,
                                hasMark: groupText.indexOf('%%') > -1
                            };
                        }
                    }

                    newRow.values.push(valueObj);
                });

                newData.data.push(newRow);
            });

            // Verificar para cada país si todos sus valores son null
            // y en ese caso, poner el sample como null
            _.forEach(countriesArray, function(countryCode, countryIndex) {
                var allValuesNull = _.every(newData.data, function(row) {
                    return row.values[countryIndex] && row.values[countryIndex].value === null;
                });

                if (allValuesNull) {
                    newData.samples[countryIndex] = null;
                }
            });

            console.log('Datos mergeados con samples (estructura Layout 22):', newData);
            return newData;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout22', {
                url: '/brandImageAcrossCountries?web&jobId',
                breadcrumb: { icon: 'icon-layout-4', label: 'MAIN_HOME_LAYOUT22' },
                views: {
                    content: {
                        templateUrl: 'app/crossCountry/layout22/layout22.html',
                        controller: 'Layout22Controller',
                        controllerAs: 'layout22'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout22')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout22 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            if (reportParams) {
                var newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    market: reportParams.market,
                    brand: reportParams.brand,
                    criteria: reportParams.criteria
                };
                return mainService.getFilterModule('layout22', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout22', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout22Controller', Layout22Controller);

  /** @ngInject */
  function Layout22Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout22Service, filterHelperService, errorHandlerService) {
    var vm = this;
    var listeners;

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter: preApplyFilter
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.serviceView = {
      getW1: function() {
        // Obtener nombres de países del filtro
        var countryNames = getCountryNamesFromFilter();
        // Pasar los nombres al servicio
        return layout22Service.getW1(countryNames);
      }
    };
    
    vm.typeView = 'countries';
    vm.typeContent = 'brandImages';

    vm.statusWidgets = {
      allLoaded: false,
      widgets: [
        {
          id: 'brandImageL22',
          value: false
        }
      ]
    };

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
      destroyListenerCombo();
    });


    function init(args) {
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      createListenersCombo();
    }

    function getCountryNamesFromFilter() {
      // Obtener países seleccionados
      var selectedCountries = filterHelperService.getPropertySelected('country');
      if (!_.isArray(selectedCountries)) {
        selectedCountries = [selectedCountries];
      }
      
      // Buscar el filtro de países en filterData
      var countryFilter = _.find(vm.filter.data, { 'id': 'country' });
      var countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].content;
      
      // Si no existe 'content', intentar con 'datos'
      if (!countryContent) {
        countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].datos;
      }
      
      // Crear mapa de países: {FR: 'FRANCE', ES: 'SPAIN', ...}
      var countryMap = {};
      if (countryContent && _.isArray(countryContent)) {
        countryMap = _.chain(countryContent)
          .keyBy('id')
          .mapValues('text')
          .value();
      }
      
      // Crear array con códigos y nombres
      return _.map(selectedCountries, function(countryCode) {
        return {
          code: countryCode,
          name: countryMap[countryCode] || countryCode
        };
      });
    }

    function updateStateWidget(_event, nameWidget) {
      var indexWidget = _.chain(vm.statusWidgets.widgets).findIndex({ 'id': nameWidget }).value();
      vm.statusWidgets.widgets[indexWidget].value = true;
      checkAllWidgetsLoaded();
    }

    function checkAllWidgetsLoaded() {
      var isAllLoaded = _.chain(vm.statusWidgets.widgets).every({ 'value': true }).value();
      if (isAllLoaded) {
        $rootScope.$emit('printReport', true);
      }
    }

    function createListenersCombo() {
      listeners = _.chain(vm.statusWidgets.widgets).map(function (item) {
        var widgetListener = $rootScope.$on(item.id + 'Loaded', updateStateWidget);
        return widgetListener;
      }).value();
    }

    function destroyListenerCombo() {
      _.each(listeners, function (item) {
        item();
      });
    }

    function preApplyFilter(filter) {
      /**
       * Validación previa a la aplicación del filtro.
       * Comprobamos que haya entre 1 y 8 países seleccionados
       */
      
      // Validar países
      var countryFilter = {
        numberSelected: _.chain(filter)
          .find({ 'id': 'country' })
          .result('data')
          .first()
          .result('selectedNode')
          .size()
          .value(),
        max: 8,
        min: 1
      };

      if (!checkRange(countryFilter.numberSelected, countryFilter.min, countryFilter.max)) {
        var message = countryFilter.numberSelected < countryFilter.min 
          ? $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_COUNTRIES_L22')
          : $filter('translationWithPrefix')('NO_MAXIMUM_SELECTIONS_COUNTRIES_L22');
        errorHandlerService.callbackWarning.call({ text: message });
        return false;
      }

      return true;
    }

    function checkRange(value, min, max) {
      return value >= min && value <= max ? true : false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('layout21Service', layout21Service);

  layout21Service.$inject = ['$http', 'filterHelperService', '$q', '$filter', 'stateManagerService', '$stateParams', 'configurationLoaderService'];
  function layout21Service($http, filterHelperService, $q, $filter, stateManagerService, $stateParams, configurationLoaderService) {

    // ========== CONFIGURACIÓN LAYOUT21 ==========
    var LAYOUT21_CONFIG = {
      dataSource: 'PUIG-25',
      fixedPeriods: {
        M: 24,  // Mensual: 24 meses
        T: 24,   // Trimestral: 8 trimestres
        S: 24,   // Semestral: 4 semestres
        A: 24   // Anual: 10 años
      },
      chart: {
        marginTop: 50,
        marginRight: 50,
        lineWidth: 1,
        markerRadius: 3,
        symbolWidth: 40
      }
    };
    // ============================================

    var service = {
      getW1: getW1,
      getCategories: getCategories,
      getConfigChart: getConfigChart,
      getChartData: getChartData
    };

    return service;

    function getW1() {
      return getWidgetDataMultiCountry(LAYOUT21_CONFIG.dataSource);
    }

    /**
     * Función para obtener datos de múltiples países para una marca
     */
  function getWidgetDataMultiCountry(dataSource) {
      var countries = filterHelperService.getPropertySelected('country');
      var metric = filterHelperService.getPropertySelected('metric');
      var market = filterHelperService.getPropertySelected('market');
      var brand = filterHelperService.getPropertySelected('brand');
      var criteria = filterHelperService.getPropertySelected('criteria');
      var granularity = filterHelperService.getPropertySelected('granularity') || 'M';
      
      if (!_.isArray(countries)) {
          countries = [countries];
      }
      
      var brandCode = _.isArray(brand) ? _.first(brand) : brand;
      var cleanBrand = _.replace(brandCode, market, '');
      
      var filterArray = ['base' + metric + cleanBrand, metric + cleanBrand];

      var filterLayout = stateManagerService.getState('filterLayout');
      var fwaveContent = _.chain(filterLayout)
          .find({ 'name': 'FWAVE2' })
          .result('content')
          .value();

      // Buscar el grupo que corresponde a la granularidad seleccionada (M, T, S, A)
      var selectedGroup = _.find(fwaveContent, { 'id': granularity });
      var allPeriods = selectedGroup && selectedGroup.children || [];
      
      var selectedPeriod = filterHelperService.getPropertySelected('period');
      var indexPeriodSelected = _.findIndex(allPeriods, { 'id': selectedPeriod });
      
      if (indexPeriodSelected === -1) {
          indexPeriodSelected = 0;
      }
      
      var fixedPeriods = LAYOUT21_CONFIG.fixedPeriods[granularity] || 24;
      var elementsWaveNext = _.chain(allPeriods)
          .slice(indexPeriodSelected, indexPeriodSelected + fixedPeriods)
          .map('id')
          .value();

      var newFilter = {};
      newFilter[metric] = filterArray;

      // Envolver cada promesa para que siempre se resuelva, incluso si hay error
      var promises = _.map(countries, function(country) {
          var filters = {
              FWAVE: elementsWaveNext,
              '#GROUP1': [
                  { FILTRO_PAIS: [country] },
                  { CRITERIA: [criteria] }
              ],
              F29I: [newFilter]
          };

          // Manejar el error individualmente y devolver null en lugar de rechazar
          return getData(dataSource, '', filters, country)
              .catch(function(error) {
                  console.warn('Error obteniendo datos para país ' + country + ':', error);
                  return null; // Devolver null en lugar de rechazar
              });
      });

      return $q.all(promises).then(function(results) {
          var output = {
              categories: [],
              series: []
          };

          // Primero, recolectar todas las categorías únicas de todos los países
          var allCategories = [];
          _.each(results, function(result) {
              if (result && result.categories && result.categories.length > 0) {
                  allCategories = allCategories.concat(result.categories);
              }
          });

          // Deduplicar y ordenar categorías por id
          output.categories = _.chain(allCategories)
              .uniqBy('id')
              .sortBy('id')
              .value();

          // Crear un mapa de id de categoría a índice
          var categoryIndexMap = {};
          _.each(output.categories, function(cat, idx) {
              categoryIndexMap[cat.id] = idx;
          });

          _.each(results, function(result, index) {
              // Saltar resultados null (países que fallaron)
              if (!result || !result.series || result.series.length === 0) {
                  return;
              }

              var serie = _.first(result.series);
              if (serie) {
                  // Crear arrays de valores y tipos alineados con las categorías globales
                  var alignedValues = new Array(output.categories.length).fill(null);
                  var alignedTypes = new Array(output.categories.length).fill('');

                  // Mapear valores usando las categorías del resultado
                  _.each(result.categories, function(cat, catIndex) {
                      var globalIndex = categoryIndexMap[cat.id];
                      if (globalIndex !== undefined && catIndex < serie.values.length) {
                          alignedValues[globalIndex] = serie.values[catIndex];
                          alignedTypes[globalIndex] = serie.types[catIndex];
                      }
                  });

                  serie.values = alignedValues;
                  serie.types = alignedTypes;
                  serie.text = countries[index];
                  serie.countryCode = countries[index];
                  output.series.push(serie);
              }
          });

          // Solo rechazar si NO hay ningún dato válido
          if (output.series.length === 0) {
              return $q.reject('No data available for any country');
          }

          return output;
      });
  }

    function getCategories(data) {
      return _.chain(data)
        .map(function(item) {
          return $filter('uppercase')(item && item.text);
        })
        .value();
    }

    function getChartData(data, countryNames) {
      var colorSignification = _.chain(configurationLoaderService.getConfig())
        .result('colors')
        .value();
      
      // Si no hay countryNames, crear un mapa vacío
      var countryMap = {};
      if (countryNames && _.isArray(countryNames)) {
        countryMap = _.keyBy(countryNames, 'code');
      }
      
      return _.chain(data)
        .map(function (item, _index) {
          // Buscar el nombre completo del país
          var countryInfo = countryMap[item.countryCode];
          var displayName = countryInfo && countryInfo.name ? countryInfo.name : item.text;
          
          return {
            animation: $stateParams && $stateParams.web === 'true' ? true : false,
            data: _.map(item.values, function (itemValues, index) {
              var x = {
                y: '',
                dataLabels: {
                  color: _.chain(colorSignification)
                    .find({ 'type': item && item.types[index] })
                    .result('color')
                    .value()
                }
              };
              x.y = itemValues;
              return x;
            }),
            name: displayName, // Ya no usar uppercase aquí, lo haremos después
            countryCode: item.countryCode,
            marker: {
              symbol: 'circle',
              fillColor: 'white',
              lineColor: null,
              lineWidth: 2
            },
            visible: true
          };
        })
        .value();
    }

    function getConfigChart(max, min) {
      return {
        chart: {
          style: {
            fontFamily: 'Montserrat'
          },
          renderTo: null,
          type: 'line',
          marginTop: LAYOUT21_CONFIG.chart.marginTop,
          marginRight: LAYOUT21_CONFIG.chart.marginRight
        },
        colors: _.chain(configurationLoaderService.getConfig()).result('colors').find({ 'type': 'countryColors' }).result('color').map('value').value(),
        title: {
          text: ''
        },
        subtitle: {
          text: null
        },
        xAxis: {
          labels: {
            formatter: function () {
              return this.value;
            }
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          gridLineWidth: 1,
          lineWidth: 0,
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3
        },
        yAxis: [{
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dash',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          showEmpty: true
        },
        {
          min: min,
          max: max,
          title: {
            text: null,
            align: 'high'
          },
          gridLineDashStyle: 'dot',
          gridLineColor: 'rgba(232, 232, 232, 1)',
          lineColor: 'rgba(232, 232, 232, 1)',
          tickColor: 'rgba(232, 232, 232, 1)',
          tickWidth: 1,
          tickLength: 3,
          opposite: true,
          showEmpty: true
        }],
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                // Mostrar guion si el valor es null, undefined o 0
                if (this.y === null || this.y === undefined || this.y === 0) {
                  return '-';
                }
                return this.y.toFixed(0);
              },
              style: {
                fontWeight: 'bold',
                textOutline: "0px contrast"
              }
            },
            enableMouseTracking: true
          },
          column: {
            events: {
              legendItemClick: function () {
                return false;
              }
            }
          },
          series: {
            lineWidth: LAYOUT21_CONFIG.chart.lineWidth,
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: LAYOUT21_CONFIG.chart.markerRadius
            },
            states: {
              inactive: {
                opacity: 1
              }
            }
          }
        },
        legend: {
          enabled: true,
          symbolWidth: LAYOUT21_CONFIG.chart.symbolWidth
        },
        tooltip: {
          enabled: true,
          shared: true,
          useHTML: true,
          backgroundColor: 'white',
          crosshairs: true,
          formatter: function () {
            var divTitle = '<div class="bold--700 text-center">' + this.x + '</div>';
            var divCountries = '<div class="">';
            _.each(this.points, function(item) {
              // Mostrar guion si el valor es null, undefined o 0
              var displayValue = (item.y === null || item.y === undefined || item.y === 0) ? '-' : item.y.toFixed(0);
              var countryTooltip = '<p class="" style="color:' + (item && item.point && item.point.color) + '"><i class="icon-size-sm icon-circle-thin bold--700 margin-right--0_5 margin-left--0_5"></i>' + $filter('uppercase')(item && item.series && item.series.name) + ':' + displayValue + '</p>';
              divCountries += countryTooltip;
            });
            divCountries += '</div>';
            return divTitle + divCountries;
          }
        },
        series: [],
        credits: {
          enabled: false
        }
      };
    }

    /**
     * Función getData para realizar peticiones HTTP individuales por país
     */
    function getData(dataSource, marketSelected, filters, countryCode) {
      return $http({
        method: 'POST',
        url: './api/crosstab-engine-extract',
        data: {
          datasource: dataSource,
          query: dataSource + marketSelected,
          parameters: {
            $country$: countryCode
          },
          filters: filters,
          transform: {
            template: 'Signification',
            parameters: {
              groupOn: 'Columns'
            }
          }
        }
      })
      .then(function(data) {
        var output = {
          categories: [],
          series: []
        };
        
        _.each(data && data.data, function(item) {
          var newItem = {
            id: '',
            text: '',
            values: [],
            types: []
          };

          var dataItem = item && item.values && _.first(item.values);
          newItem.id = dataItem && dataItem.id;
          newItem.text = dataItem && dataItem.text;
          // Convertir 0 en null para que se muestre como guion
          newItem.values = _.map(dataItem && dataItem.values, function(val) {
            return val.value === 0 ? null : val.value;
          });
          newItem.types = _.map(dataItem && dataItem.values, 'type');

          var dates = _.map(dataItem && dataItem.values, function(date) {
            return {
              id: date && date.id,
              text: date && date.text
            };
          });
          
          output.categories = [].concat(output.categories, dates);
          output.series.push(newItem);
        }); 
        
        output.categories = _.uniqBy(output.categories, 'id');
        output.series = filterSeriesWithoutValues(output.series);
        return output;
      })
      .catch(function(error) {
                console.error('Error obteniendo datos para país ' + countryCode + ':', error);
                return null;
            });
    }

    function filterSeriesWithoutValues(series) {
      return _.chain(series)
        .filter(function (serie) {
          if (_.some(serie.values, Number)) {
            return serie;
          }
        })
        .value();
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout21', {
                url: '/brandMetricsAcrossCountries?web&jobId',
                breadcrumb: { icon: 'icon-layout-9', label: 'MAIN_HOME_LAYOUT21' },
                views: {
                    content: {
                        templateUrl: 'app/crossCountry/layout21/layout21.html',
                        controller: 'Layout21Controller',
                        controllerAs: 'layout21'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams: getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout21')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout21 is not enabled');
            }
            return $q.resolve();
        }

        getReportParams.$inject = ['mainService', '$stateParams', '$state'];
        function getReportParams(mainService, $stateParams, $state) {
            return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
        }

        getFilter.$inject = ['mainService','filterService', 'filterViewConfigurationService', 'reportParams'];
        function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
            var newContext;
            if (reportParams) {
                newContext = {
                    country: reportParams.country,
                    year: reportParams.year,
                    period: reportParams.period,
                    market: reportParams.market,
                    brand: reportParams.brand,
                    criteria: reportParams.criteria,
                    metric: reportParams.metric
                };
                return mainService.getFilterModule('layout21', newContext, filterService, true, filterViewConfigurationService);
            }
            return mainService.getFilterModule('layout21', newContext, filterService, false, filterViewConfigurationService);
        }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout21Controller', Layout21Controller);

  /** @ngInject */
  function Layout21Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout21Service, uuid, errorHandlerService, filterHelperService) {
    var vm = this;

    // ========== CONFIGURACIÓN LAYOUT21 ==========
    var LAYOUT21_VALIDATION = {
      minCountries: 1,
      maxCountries: 8
    };
    var LAYOUT21_CHART_SCALE = {
      threshold: 90,
      maxMultiplier: 1.1,
      minMultiplier: 0.95
    };
    // ============================================

    vm.filter = {
      data: [],
      applied: false,
      preApplyFilter: preApplyFilter
    };

    vm.view = {
      loading: false,
      hasData: true,
      chart: {
        id: uuid.v4(),
        categories: [],
        data: [],
        config: {}
      },
      images: {
        data: [],
        typeView: 'country',
        typeImages: []
      }
    };

    vm.isWeb = $stateParams && $stateParams.web === 'true';

    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.copyXls = {
      copyToXlsFn: copyToXlsFn,
      copyToXlsData: []
    };

    vm.infoText = '<div class="padding--0_5 info-button display__flex flex-direction-column">' +
      '<div class="item-info">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('BOUGTH_LAST_YEAR_IB') + '</span>. ' + $filter('translationWithPrefix')('BOUGTH_LAST_YEAR_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('EVER_BOUGHT_IB') + '</span>. ' + $filter('translationWithPrefix')('EVER_BOUGHT_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('CONSIDERATION_IB') + '</span>. ' + $filter('translationWithPrefix')('CONSIDERATION_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('AWARENESS_IB') + '</span>. ' + $filter('translationWithPrefix')('AWARENESS_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('DESIRABILITY_IB') + '</span>. ' + $filter('translationWithPrefix')('DESIRABILITY_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('LOVE_IB') + '</span>. ' + $filter('translationWithPrefix')('LOVE_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('UNIQUENESS_IB') + '</span>. ' + $filter('translationWithPrefix')('UNIQUENESS_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('ADVOCACY_IB') + '</span>. ' + $filter('translationWithPrefix')('ADVOCACY_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '<div class="item-info margin-top--0_5">' +
      '<p class="no-margin text-left"><span class="bold--700">' + $filter('translationWithPrefix')('TOTAL_TBCA_IB') + '</span>. ' + $filter('translationWithPrefix')('TOTAL_TBCA_INFO_TEXT_IB') + '</p>' +
      '</div>' +
      '</div>';

    vm.serviceView = layout21Service;

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function (_event, args) {
      vm.filter.applied = { value: true };
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
    });

    ////////////////

    function init(args) {
      $rootScope.$emit('printReport', false);
      if (!args) {
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      vm.view.hasData = false;
      vm.view.loading = true;

      // Obtener la marca seleccionada
      var selectedBrand = filterHelperService.getPropertySelected('brand');
      var market = filterHelperService.getPropertySelected('market');
      
      // Procesar la marca para obtener el código limpio
      var brandCode = _.isArray(selectedBrand) ? _.first(selectedBrand) : selectedBrand;
      var cleanBrand = _.replace(brandCode, market, '');
      
      // Configurar la imagen de la marca
      vm.view.images.typeView = market;
      vm.view.images.data = [cleanBrand];

      var brandImage = cleanBrand.slice(-2);
      vm.view.images.typeImages = [brandImage === '01' || brandImage === '00' ? 'svg' : 'png'];

      // --- OBTENER NOMBRES COMPLETOS DE PAÍSES ---
      var selectedCountries = filterHelperService.getPropertySelected('country');
      if (!_.isArray(selectedCountries)) {
        selectedCountries = [selectedCountries];
      }
      
      // Buscar el filtro de países en filterData
      var countryFilter = _.find(vm.filter.data, { 'id': 'country' });
      var countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].content;
      
      // Si no existe 'content', intentar con 'datos'
      if (!countryContent) {
        countryContent = countryFilter && countryFilter.data && countryFilter.data[0] && countryFilter.data[0].datos;
      }
      
      // Crear mapa de países: {FR: 'FRANCE', ES: 'SPAIN', ...}
      var countryMap = {};
      if (countryContent && _.isArray(countryContent)) {
        countryMap = _.chain(countryContent)
          .keyBy('id')
          .mapValues('text')
          .value();
      }
      
      // Crear array con códigos y nombres para pasarlo al servicio
      vm.view.countryNames = _.map(selectedCountries, function(countryCode) {
        return {
          code: countryCode,
          name: countryMap[countryCode] || countryCode
        };
      });
      

      layout21Service.getW1()
        .then(function (data) {
          // IMPORTANTE: Pasar vm.view.countryNames como segundo parámetro
          vm.view.chart.data = layout21Service.getChartData(data && data.series, vm.view.countryNames);
          vm.view.chart.categories = layout21Service.getCategories(data && data.categories);
          var min = _.chain(vm.view.chart.data).flatMap('data').map('y').min().value();
          var max = _.chain(vm.view.chart.data).flatMap('data').map('y').max().value();
          var calculatedMax = max > LAYOUT21_CHART_SCALE.threshold ? 100 : max * LAYOUT21_CHART_SCALE.maxMultiplier;
          var calculatedMin = min * LAYOUT21_CHART_SCALE.minMultiplier;
          vm.view.chart.config = layout21Service.getConfigChart(calculatedMax, calculatedMin);
          vm.view.hasData = true;
          vm.copyXls.copyToXlsData = vm.view.chart;
        })
        .catch(function () {
          vm.view.hasData = false;
        })
        .finally(function () {
          vm.view.loading = false;
          $rootScope.$emit('printReport', true);
        });
    }

    function preApplyFilter(filter) {
      /**
       * Validación previa a la aplicación del filtro.
       * Ahora comprobamos:
       * 1. Que haya entre 1 y 8 países seleccionados (según la config: minSelections:1, maxSelections:8)
       * 2. Que haya exactamente una marca seleccionada (type:'single')
       */
      
      // Validar países
      var countryFilter = {
        numberSelected: _.chain(filter)
          .find({ 'id': 'country' })
          .result('data')
          .first()
          .result('selectedNode')
          .size()
          .value(),
        max: LAYOUT21_VALIDATION.maxCountries,
        min: LAYOUT21_VALIDATION.minCountries
      };

      if (!checkRange(countryFilter.numberSelected, countryFilter.min, countryFilter.max)) {
        var message = countryFilter.numberSelected < countryFilter.min 
          ? $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_COUNTRIES_L21')
          : $filter('translationWithPrefix')('NO_MAXIMUM_SELECTIONS_COUNTRIES_L21');
        errorHandlerService.callbackWarning.call({ text: message });
        return false;
      }


      //if (brandFilter.numberSelected !== 1) {
      //  errorHandlerService.callbackWarning.call({ 
      //    text: $filter('translationWithPrefix')('MUST_SELECT_ONE_BRAND_L21') 
      //  });
      //  return false;
      //}

      return true;
    }

    function checkRange(value, min, max) {
      return value >= min && value <= max ? true : false;
    }

    function copyToXlsFn(data) {
      var columnHeaders = [].concat("", _.chain(data)
        .result('categories')
        .map(function(item) {
          return $filter('lowercase')(item);
        })
        .value());

      var rowData = [columnHeaders];

      _.each(_.chain(data).result('data').value(), function (item) {
        rowData.push([].concat(item.name, _.chain(item.data)
          .map(function(item) {
            // Mostrar guion si el valor es null, undefined o 0
            if (item.y === null || item.y === undefined || item.y === 0) {
              return '-';
            }
            return $filter('round')(item.y, 0);
          })
          .value()));
      });

      var rows = _.map(rowData, function (i) {
        return i.join('\t');
      });
      return rows.join('\n');
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('layout20Service', layout20Service);

    layout20Service.$inject = ['$http', 'filterHelperService', '$q'];
    function layout20Service($http, filterHelperService, $q) {
        var service = {
            getW1: getW1 
        };

        return service;

        // --- Funciones Auxiliares ---

        // Obtiene los países seleccionados como un array, incluso si es solo un string.
        function getCountryArray() {
            var countries = filterHelperService.getPropertySelected('country');
            if (!countries) {
                return [];
            }
            if (typeof countries === 'string') {
                return [countries];
            }
            // Si es un array, devolvemos el array directamente
            return countries;
        }
        
        // --- Función Principal del Widget (W1) ---

        function getW1() { 
            var countries = getCountryArray();
            
            if (countries.length === 0) {
                return $q.when([]); 
            }

            // Crear una promesa por cada país
            var allCountryPromises = _.map(countries, function(countryId) {
                // Llamadas a la API para el Funnel y el Total, pasando el countryId
                return $q.all([
                    getWidgetFunnel('PUIG-22', 'T', 'Columns', countryId), 
                    getTotalFunnel('PUIG-22MUES', countryId)          
                ])
                // --- INICIO DE LA MODIFICACIÓN ---
                // Agregamos un .catch() A CADA PROMESA INDIVIDUAL
                .catch(function () {
                    // Si este país falla, en lugar de rechazar $q.all,
                    // resolvemos con [null, null] para [widgetData, totalData].
                    // La directiva sabrá cómo manejar esto.
                    return [null, null];
                });
                // --- FIN DE LA MODIFICACIÓN ---
            });

            // $q.all ahora NUNCA fallará, solo devolverá un array
            // con los resultados o [null, null] para los países con error.
            // Ej: [[data_FR, total_FR], [null, null], [data_ES, total_ES]]
            return $q.all(allCountryPromises); 
        }

        // --- Funciones de Llamada a la API (Lógica de Filtros) ---

        // Función que construye los filtros específicos para un solo país
        function buildFiltersForCountry(countryId) {
            // --- INICIO DE LA MODIFICACIÓN ---

            // 1. brand será un STRING (ej: 'T0001')
            var brand = filterHelperService.getPropertySelected('brand');
            
            // 2. Convertimos el string de nuevo en un array
            var brandAsArray = _.concat([], brand); // -> ['T0001']

            // 3. Ahora el resto de la lógica funciona, porque itera sobre el array
            var parentBrand = _.chain(brandAsArray).map(function (item) {
                return item.charAt(0) && item.charAt(0).toUpperCase();
            }).uniq().value(); 
            // --- FIN DE LA MODIFICACIÓN ---

            var f23 = {};
            var parentKey = parentBrand.length > 0 ? parentBrand[0] : 'T'; 
            
            // 4. Asegúrate de pasar el array a la API
            f23[parentKey] = brandAsArray;

            var filters = {
                FWAVE: [filterHelperService.getPropertySelected('period')],
                F23X: [f23],
                '#GROUP1': [
                    { F5: [countryId] }, 
                    { CRITERIA: [filterHelperService.getPropertySelected('criteria')] }
                ]
            };
            return filters;
        }

        // getWidgetFunnel construye sus filtros y llama a getData
        function getWidgetFunnel(dataSource, querySuffix, grouping, countryId) {
            var filters = buildFiltersForCountry(countryId);
            return getData(dataSource, querySuffix, filters, grouping, countryId); 
        }

        // getTotalFunnel construye sus filtros y llama a getDataCompact
        function getTotalFunnel(dataSource, countryId) {
            var filters = buildFiltersForCountry(countryId);
            return getDataCompact(dataSource, 'AP', filters, countryId) 
                .catch(function () {
                    // Si falla, devolvemos un array vacío, no un string
                    return $q.when([]);
                });
        }
        
        // --- Funciones HTTP Base ---
        
        // getData (Signification Template)
        function getData(dataSource, marketSelected, filters, grouping, countryId) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        // Usamos el ID del país específico
                        $country$: countryId 
                    },
                    filters: filters,
                    transform: {
                        template: 'Signification',
                        parameters: {
                            groupOn: grouping
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }

        // getDataCompact (Compact Template)
        function getDataCompact(dataSource, marketSelected, filters, countryId) {
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-extract',
                data: {
                    datasource: dataSource,
                    query: dataSource + marketSelected,
                    parameters: {
                        // Usamos el ID del país específico
                        $country$: countryId
                    },
                    filters: filters,
                    transform: {
                        template: "Compact",
                        parameters: {
                            itemsBy: "Rows",
                            filterExpression: "$.[?(@.id =~ /^BASE|TOTAL(.*)$/)]"
                        }
                    }
                }
            })
                .then(function (data) {
                    return data && data.data;
                })
                .catch(function () {
                    return $q.reject([]);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.layout20', {
                url: '/brandFunnelAcrossCountries?web&jobId', // URL modificado
                breadcrumb: { icon: 'icon-layout-6', label: 'MAIN_HOME_LAYOUT20' }, // Label modificado
                views: {
                    content: {
                        templateUrl: 'app/crossCountry/layout20/layout20.html',
                        controller: 'Layout20Controller',
                        controllerAs: 'layout20'
                    }
                },
                resolve: {
                    validateAccess: validateAccess,
                    reportParams:getReportParams,
                    transition: transition,
                    filterData: getFilter
                }
            });

        validateAccess.$inject = ['configurationLoaderService', '$state', '$q'];
        function validateAccess(configurationLoaderService, $state, $q) {
            if (!configurationLoaderService.isModuleEnabled('layout20')) {
                // Si el módulo no está habilitado, redirigir a main
                $state.go('main');
                return $q.reject('Module layout20 is not enabled');
            }
            return $q.resolve();
        }

            function getReportParams(mainService, $stateParams, $state) {
                return mainService.getReportParameters($stateParams && $stateParams.jobId, $state);
            }
    
            getFilter.$inject = ['mainService', 'filterService', 'filterViewConfigurationService', 'reportParams'];
            function getFilter(mainService, filterService, filterViewConfigurationService, reportParams) {
                var newContext = {
                    // Asegúrate de que estas propiedades existen si no hay reportParams
                    country: reportParams ? reportParams.country : null,
                    year: reportParams ? reportParams.year : null,
                    period: reportParams ? reportParams.period : null,
                    market: reportParams ? reportParams.market : null,
                    brand: reportParams ? reportParams.brand : null,
                    criteria: reportParams ? reportParams.criteria : null
                };

                // Lo más importante: Este identificador 'layout20' debe coincidir con la configuración del backend.
                return mainService.getFilterModule('layout20', newContext, filterService, !!reportParams, filterViewConfigurationService);
            }

        transition.$inject = ['configurationLoaderService', 'configuration', '$timeout'];
        function transition(configurationLoaderService, _configuration, $timeout) {
            return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('Layout20Controller', Layout20Controller);

  /** @ngInject */
  function Layout20Controller($rootScope, $scope, filterData, $stateParams, $state, $filter, layout20Service, errorHandlerService) {
    var vm = this;
    var listeners;

    vm.filter = {
      data: [],
      applied:false,
      preApplyFilter:preApplyFilter
    };
    
    vm.isWeb = $stateParams && $stateParams.web === 'true';
    
    vm.cover = {
      icon: $state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.icon,
      text: $filter('translationWithPrefix')($state && $state.current && $state.current.breadcrumb && $state.current.breadcrumb.label)
    };

    vm.serviceView = layout20Service;

    vm.statusWidgets = {
      allLoaded: false,
      widgets: [
        {
          id: 'purchaseFunnelL20',
          value: false
        }
      ]
    };

    init();

    /** listeners */
    var filterApply = $rootScope.$on('filter:apply', function(_event,args){
      vm.filter.applied = {value:true};
      init(args && args.filter);
    });

    $scope.$on('$destroy', function () {
      filterApply();
      destroyListenerCombo();
    });

    ////////////////

    function init(args) {
      if(!args){
        vm.filter.applied = false;
      }
      vm.filter.data = args || filterData;
      createListenersCombo();
    }

    function preApplyFilter(filter){
      /**Validacion previa a la aplicación del filtro.
       * Comprueba si los filtros de Brand y Country cumplen los mínimos/maximos.
       */
       
      

      // --- MODIFICACIÓN PARA COUNTRY ---
      // Obtenemos el objeto de datos del filtro 'country'
      var countryData = _.chain(filter).find({'id':'country'}).result('data').first();

      var countryFilter = {
        numberSelected: countryData.result('selectedNode').size().value(),
        min: countryData.result('minSelections').value(), // <-- Valor dinámico
        max: countryData.result('maxSelections').value()  // <-- Valor dinámico
      };
      
      
      // --- BLOQUE DE VALIDACIÓN DE BRAND ELIMINADO ---
      // El bloque comentado if(!checkRange(brandFilter...)) se elimina 
      // porque la restricción (min 1, max 1) la maneja el componente.
      

       // --- VALIDACIÓN DE COUNTRY ACTUALIZADA ---
       // El filtro Country no cumple con el número mínimo/máximo de selecciones
      if(!checkRange(countryFilter.numberSelected, countryFilter.min, countryFilter.max)){
        errorHandlerService.callbackWarning.call({text: $filter('translationWithPrefix')('NO_MINIMUM_SELECTIONS_COUNTRIES_L20')});
        return false;
      }

      return true;
    }

    function checkRange(value, min, max){
      return value >= min && value <=max ? true: false;
    }

    function updateStateWidget(_event, nameWidget) {
      var indexWidget = _.chain(vm.statusWidgets.widgets).findIndex({ 'id': nameWidget }).value();
      vm.statusWidgets.widgets[indexWidget].value = true;
      checkAllWidgetsLoaded();
    }

    function checkAllWidgetsLoaded() {
      var isAllLoaded = _.chain(vm.statusWidgets.widgets).every({ 'value': true }).value();
      if (isAllLoaded) {
        $rootScope.$emit('printReport', true);
      }
    }

    function createListenersCombo() {
      listeners = _.chain(vm.statusWidgets.widgets).map(function (item) {
        var widgetListener = $rootScope.$on(item.id + 'Loaded', updateStateWidget);
        return widgetListener;
      }).value();
    }

    function destroyListenerCombo() {
      _.each(listeners, function (item) {
        item();
      });
    }
  }
})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .config(routerConfig);
  
    routerConfig.$inject = ['$stateProvider'];
    function routerConfig($stateProvider) {
      $stateProvider
        .state('worldMap', {
          url: '/worldMap',
          templateUrl: 'app/worldMap/worldMap.html',
          controller: 'WorldMapController',
          controllerAs: 'worldMap',
          doNotTrack:true,
          resolve: {
            configuration: getConfiguration,
            redirect:redirect
          }
        });
    }

    /* @ngInject */
      function getConfiguration(errorHandlerService, configurationLoaderService) {
        if (!configurationLoaderService.getConfig()) {
          return configurationLoaderService.getRemoteConfig()
            .catch(errorHandlerService.callbackError);
        }
        else {
          return configurationLoaderService.getConfig();
        }
      }

    redirect.$inject = ['configuration', 'storageService', '$state','configurationLoaderService'];
    function redirect (_configuration, storageService, $state, configurationLoaderService) {
      var user = storageService.retrieve('user');
      var stateToGoDefault = _.chain(configurationLoaderService.getConfig()).result('onAuthenticationStateCountry').value();

      //Si ya hemos pasado por el mapa anteriormente y se ha seleccionado un pais.
      if(user && user.selectionMap && user.selectionMap.selected){
        $state.go(stateToGoDefault.url, stateToGoDefault.state, { reload: stateToGoDefault.url });
        return;
      }

      /*var countryUser =  _.chain(user).result('userProperties').find({'name':'country'}).result('value').value();
      countryUser = null;
      //value === null ==> TOTAL, value === 'ES' ==> COUNTRY
      var isTotal = !countryUser ? true : false;

      var stateToGoDefault = _.chain(configurationLoaderService.getConfig()).result('onAuthenticationStateCountry').value();
      if(!isTotal){
        $state.go(stateToGoDefault.url, stateToGoDefault.state, { reload: stateToGoDefault.url });
        return;
      }*/
      
    }
  
  })();
  
(function () {
    'use strict';

    angular
        .module('app')
        .controller('WorldMapController', WorldMapController);

    WorldMapController.$inject = ['$state', 'userHelperService', 'storageService'];
    function WorldMapController($state, userHelperService, storageService) {
        var vm = this;
        vm.clickCountry = clickCountry;

        var user = userHelperService.getUser();
        vm.countrySelected = userHelperService.getCountry();
        
        function clickCountry(cSelected) {
            user.selectionMap = {
                selected: true,
                country: cSelected || vm.countrySelected
            };
            storageService.save('user', user);
            $state.go('landingPage');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('snapshotsService', snapshotsService);

    snapshotsService.$inject = ['$rootScope', 'stateManagerService', '$http', 'exportService'];
    function snapshotsService($rootScope, stateManagerService, $http, exportService) {
        var service = {
            setSnapshots:setSnapshots,
            appendSnapshot: appendSnapshot,
            getSnapshots: getSnapshots,
            clearSnapshots: clearSnapshots,
            exportPPT: exportPPT
        };



        return service;

        /** private methods */

        function setSnapshots(collection) { 
            stateManagerService.setState('snapshots', [].concat(collection));
            $rootScope.$emit('snapshots:notification',{count:collection.length});
        }

        function appendSnapshot(obj) {
            var snapshots = stateManagerService.getState('snapshots') || [];
            stateManagerService.setState('snapshots', [].concat(snapshots, obj));
            $rootScope.$emit('snapshots:notification',{count:snapshots.length + 1});
        }

        function getSnapshots() {
            return stateManagerService.getState('snapshots') || [];
        }

        function clearSnapshots() {
            stateManagerService.setState('snapshots', null);
            $rootScope.$emit('snapshots:notification',{count:0});
        }

        function exportPPT(obj) {
            return $http({
                method: 'POST',
                url: './api/pptx/img2PptxCover/egmCopeTemplates/egmCope/plantillaCope',
                data: obj,
                transformRequest: [].concat([transformationPPT,toString]),
                transformResponse: $http.defaults.transformResponse.concat([getUrl])
            })
            .then(download);                
        }

        function getUrl(_data, header, _status) {
            return header()['x-doclocation'].replace('/egmCope', '.');
        }

        function download(data) {
            if (!data.data) {
                throw ('Descarga de PowerPoint no disponible');
            }

            return exportService.downloadUrl(data.data);
        }

        // function transformation(data) {
        //     return _.chain(data)
        //         .map(function (obj) {
        //             return {
        //                 imgBase64: obj.image,
        //                 titulo: obj.title,
        //                 descripcion: obj.description,
        //                 filtros: [obj.filter],
        //                 anchoPagina: '1200',
        //                 orientacion: '1'

        //             };
        //         })
        //         .value();
        // }

        function transformationPPT(data) {
            return _.chain(data)
                .map(function (obj) {
                    return {
                        imgBase64: obj.image,
                        elements: [
                            {
                                key: 'titulo',
                                value: obj.title || ' '
                            },
                            {
                                key: 'descripcion',
                                value: obj.description || ' '
                            }, {
                                key: 'filtros',
                                value: obj.filter.toString() || ' '
                            }, {
                                key: 'date',
                                value: new Date().toLocaleString()
                            }, {
                                key: 'nodo',
                                value: ' '
                            }
                        ]
                    };
                })
                .value();
        }

        function toString(data) {
            return angular.toJson(data);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.snapshots', {
                url: '/snapshots',
                views: {
                    content: {
                        templateUrl: 'app/snapshots/snapshots.html',
                        controller: 'SnapshotsController',
                        controllerAs: 'snapshots'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService, _configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
'use strict';

    angular
        .module('app')
        .controller('SnapshotsController', SnapshotsController);

    SnapshotsController.$inject = ['snapshotsService','routingService','$state','errorHandlerService'];
    function SnapshotsController(snapshotsService,routingService,$state,errorHandlerService) {
        var vm = this;
        vm.snapshotsCollection = [];
        vm.selectedImage = null;
        vm.createPPT = createPPT;
        vm.clearAll = clearAll;
        vm.goBack = goBack;
        vm.lastState = routingService.getLastState();
        vm.update = update;
        vm.remove = remove;
        vm.exportingPPT = false;        

        init();

        /** private methods */

        function goBack() {
            $state.go(vm.lastState.state,vm.lastState.params);
        }

        function createPPT(collection) {
            vm.exportingPPT = true;
            return snapshotsService.exportPPT(collection)
            .catch(errorHandlerService.callbackError)
            .finally(function(){
                vm.exportingPPT = false;
            });
        }

        function clearAll() {
            snapshotsService.clearSnapshots();
            vm.snapshotsCollection = [];
            vm.selectedImage = null;
        }

        function update(obj) {
            var temp = angular.copy(vm.snapshotsCollection);
            var pre = obj.index > 0 ? _.slice(temp,0,obj.index): [];
            var post = obj.index < temp.length ? _.slice(temp,obj.index + 1): [];

            temp = [].concat(pre,obj,post);
            
            vm.snapshotsCollection = temp;
            vm.selectedImage = null;
            snapshotsService.setSnapshots(temp);
        }

        function remove(obj) {
            var temp = angular.copy(vm.snapshotsCollection);
            _.chain(temp).splice(obj.index,1).value();
            vm.snapshotsCollection = temp;
            vm.selectedImage = null;
            return snapshotsService.setSnapshots(temp);
        }

        function init() { 
            vm.snapshotsCollection = snapshotsService.getSnapshots();     

            //translate titles
            vm.snapshotsCollection = _.chain(vm.snapshotsCollection)
                .map(function (item) {
                    var title = item.title;
                    item.title = title;
                    return item;
                })
                .value();                    
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .factory('mainService', mainService);

  mainService.$inject = ['$q', '$http', '$log'];
  function mainService($q, $http, $log) {

    /** methods exposed */
    var service = {
      getReportParameters: getReportParameters,
      getFilterModule: getFilterModule
    };

    return service;

    function getReportParameters(jobID, stateGo) {
      if (jobID) {
        return getParams(jobID)
          .then(function (parameters) {
            var reportParameters = {
              country: parameters && parameters.country,
              year: parameters && parameters.year,
              period: parameters && parameters.period,
              market: parameters && parameters.market,
              brand: parameters && parameters.brand,
              image: parameters && parameters.image,
              criteria: parameters && parameters.criteria,
              metric: parameters && parameters.metric,
              campaigns: parameters && parameters.campaigns,
              events: parameters && parameters.events,
              typeEvent: parameters && parameters.typeEvent,
              typeMedia: parameters && parameters.typeMedia
            };
            return reportParameters;
          })
          .catch(function (err) {
            $log.log(err);
            return stateGo.go('login');
          });
      }
      else {
        return $q.when(undefined);
      }
    }

    function getParams(jobID) {
      return $http({
        method: 'GET',
        url: './api/tasks',
        params: {
          jobId: jobID
        }
      })
        .then(function (data) {
          var params = angular.fromJson(_.chain(data && data.data).result('data').find({'jobId':jobID}).result('parameters').value());
          //return angular.fromJson(_.chain(data && data.data).find({ 'name': 'Filter' }).result('value').first().value());
          return angular.fromJson(_.chain(params).find({'name':'Filter'}).result('value').first().value());
        });
    }

    function getFilterModule(layout, newContext, filterService, hasReportParams, filterViewConfigurationService) {
      if (hasReportParams) {
        filterService.clearContext();
        filterService.setContext(newContext);

        return filterService.getData(filterViewConfigurationService.getFilterDefinition(layout), false, true, false);
      }
      return filterService.getData(filterViewConfigurationService.getFilterDefinition(layout), false, true, true);
    }


  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve: {
          ganalytics: ganalytics,
          authenticateSocket: authenticateSocket,
          translations: getTranslations,
          configuration: getConfiguration,
          viewsConfiguration: getViewsConfiguration,
          listenToResize: listenToResize
        },
        onExit: onExit
      });
  }

  ganalytics.$inject = ['Analytics','userHelperService'];
  function ganalytics(Analytics, userHelperService){
    Analytics.set('userId', userHelperService && userHelperService.getUser() && userHelperService.getUser().user);
    Analytics.set('dimension1', userHelperService && userHelperService.getUser() && userHelperService.getUser().user);
    Analytics.set('&uid', userHelperService && userHelperService.getUser() && userHelperService.getUser().user);
    Analytics.pageView();
  }

  authenticateSocket.$inject = ['socketService','userHelperService'];
  function authenticateSocket(socketService, userHelperService) {
    socketService.socketAuthenticate(userHelperService.getToken());
  }

  getTranslations.$inject = ['$translate'];
  function getTranslations($translate) {
    return $translate.use('en');
  }

  getConfiguration.$inject = ['errorHandlerService', 'configurationLoaderService'];
  function getConfiguration(errorHandlerService, configurationLoaderService) {
    if (!configurationLoaderService.getConfig()){
      return configurationLoaderService.getRemoteConfig()
        .catch(errorHandlerService.callbackError);
    }
    else{
      return configurationLoaderService.getConfig();
    }
  }

  getViewsConfiguration.$inject = ['configurationLoaderService', 'errorHandlerService'];
  function getViewsConfiguration(configurationLoaderService, errorHandlerService) {
    return configurationLoaderService.loadViewsConfiguration()
      .catch(function(error) {
        errorHandlerService.log('error', 'Failed to load views configuration: ' + error);
        // Rechazar para que no se muestren vistas si falla la carga
        return errorHandlerService.callbackError(error);
      });
  }

  listenToResize.$inject = ['windowResizeManagerService'];
  function listenToResize(windowResizeManagerService) {
    return windowResizeManagerService.startListening();
  }

  onExit.$inject = ['socketService'];
  function onExit(socketService) {
    socketService.socketLogout();
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('MainController', MainController);

  MainController.$inject = ['$timeout', '$scope', '$state', '$rootScope', 'storageService','errorHandlerService','$filter','configurationLoaderService','filterHelperService','$log','reportPrintService'];
  function MainController($timeout, $scope, $state, $rootScope, storageService, errorHandlerService, $filter, configurationLoaderService,filterHelperService, $log, reportPrintService) {
    var vm = this;

    vm.hideFilter = {
      opened: false,
      close: close
    };

    vm.notifications = {
      snapshots: 0
    };

    vm.actions = {
      stateGo: stateGo,
      states: {
        logout: 'login',
        changePassword: 'main.changePassword'
      }
    };

    vm.print = {
      loading: false,
      printModule: printModule,
      nameModule: ''
    };

    vm.glossary = {
      contenGlossary:getGlossary(),
      tooltipOpen:false,
      openGlossary:openGlossary
    };

    vm.user = storageService.retrieve('user');
    vm.productionDate = false;
    vm.showTaskScheduler = $state && $state.params && $state.params.web === 'true' ? true : false;

    init();

    /** listeners */
    var snapshotsNotificationListener = $rootScope.$on('snapshots:notification', setNotifications);
    var productionDateAdded = $rootScope.$on('printReport', addProductionDate);

    var openFilterListener = $rootScope.$on('filter:open', function (_event, value) {
      vm.hideFilter.opened = value;
    });

    $scope.$on('$destroy', function () {
      openFilterListener();
      snapshotsNotificationListener();
      productionDateAdded();
    });

    function printModule() {
      var name = $state && $state.current && $state.current.name && $state.current.name.split('.');
      var typeR = $filter('uppercase')(name[1]);
      var params = {
        jobName: _.chain(configurationLoaderService && configurationLoaderService.getConfig()).result('views').result('taskHelper').result('tasksTypes').result('reports').result('name').value(),
        typeReport: _.chain(configurationLoaderService && configurationLoaderService.getConfig()).result('views').result('taskHelper').result('tasksTypes').result('reports').result('type').value(),
        modelTypeReport: typeR,
        moduleReport:$filter('translationWithPrefix')('MAIN_HOME_'+typeR),
        country:filterHelperService.getPropertySelected('country'),
        year:filterHelperService.getPropertySelected('year'),
        period:filterHelperService.getPropertySelected('period'),
        market:filterHelperService.getPropertySelected('market'),
        brand:filterHelperService.getPropertySelected('brand'),
        image:filterHelperService.getPropertySelected('image'),
        criteria:filterHelperService.getPropertySelected('criteria'),
        metric: filterHelperService.getPropertySelected('metric'),
        campaigns: filterHelperService.getPropertySelected('campaigns'),
        typeEvent: filterHelperService.getPropertySelected('typeEvent'),
        events: filterHelperService.getPropertySelected('events'),
        typeMedia: filterHelperService.getPropertySelected('typeMedia')
      };

      if(typeR === 'LAYOUT5'){
        params = _.extend({}, { brandSelected: $state && $state.params && $state.params.brand}, params);
        params = _.extend({}, params, {moduleReport:$filter('translationWithPrefix')('MAIN_HOME_'+typeR)+':'+($state && $state.params && $state.params.text)});
      }

      $log.log(params);
      vm.print.loading = true;
      reportPrintService.printReport(params, false)
        .then(function () {
          //errorHandlerService.callbackSuccess.call({text:  $filter('translationWithPrefix')('LAUNCH_TASK_SUCCESS')});
        }).catch(function () {
          errorHandlerService.callbackError( $filter('translationWithPrefix')('LAUNCH_TASK_ERROR'));
        }).finally(function () {
          vm.print.loading = false;
        });
    }

    /** private methods */
    function init() {
      var nameModule = $state && $state.current && $state.current.url && $state.current.url.split('?');
      vm.print.nameModule = nameModule && nameModule[0] && nameModule[0].replace('/','');  
    }

    function close(value) {
      $rootScope.$emit('filter:open', value);
    }

    function setNotifications(_event, args) {
      vm.notifications.snapshots = args.count;
    }

    function stateGo(state) {
      $state.go(state);
    }

    function addProductionDate(_event, value) {
      if (value) {
        $timeout(function () {
          vm.productionDate = value;
        }, 5000);
      }
      vm.productionDate = false;
    }

    function getGlossary(){
      return '<div class="padding--0_5 info-button display__flex flex-direction-column">'+
        '<div class="item-info">'+
            '<h2 class="no-margin text-left"><span class="bold--700">'+$filter('translationWithPrefix')('GLOSSARY_TITLE')+'</span></h2>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('AWARENESS_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('AWARENESS_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('CONSIDERATION_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('CONSIDERATION_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('BOUGHT_LAST_YEAR_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('BOUGHT_LAST_YEAR_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('EVER_BOUGHT_RECOMMEND_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('EVER_BOUGHT_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('DESIRABILITY_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('DESIRABILITY_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('LOVE_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('LOVE_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('UNIQUENESS_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('UNIQUENESS_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('ADVOCACY_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('ADVOCACY_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('PREMIUM_LUXURY_BRAND_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('PREMIUM_LUXURY_BRAND_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('BRAND_IMAGE_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('BRAND_IMAGE_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('TOTAL_COMUNICATION_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('TOTAL_COMUNICATION_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('RECOGNITION_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('RECOGNITION_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('ROUNDS_BRAND_IMAGE_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('ROUNDS_BRAND_IMAGE_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('ST_VALENTINE_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('ST_VALENTINE_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('PRE_EASTER_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('PRE_EASTER_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>' +
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('EASTER_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('EASTER_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>' +
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('FATHER_DAY_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('FATHER_DAY_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('MOTHER_DAY_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('MOTHER_DAY_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('SPRING_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('SPRING_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('SUMMER_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('SUMMER_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>'+
        '<div class="item-info display__flex margin-top--0_5">' +
        '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">' + $filter('uppercase')($filter('translationWithPrefix')('BACK_TO_SCHOOL_GLOSSARY_IB')) +
        '</span> ' + $filter('translationWithPrefix')('BACK_TO_SCHOOL_GLOSSARY_TEXT_IB') + '</p>' +
        '</div>' +
        '<div class="item-info display__flex margin-top--0_5">' +
        '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">' + $filter('uppercase')($filter('translationWithPrefix')('PREXMAS_GLOSSARY_IB')) +
        '</span> ' + $filter('translationWithPrefix')('PREXMAS_GLOSSARY_TEXT_IB') + '</p>' +
        '</div>' +
        '<div class="item-info display__flex margin-top--0_5">'+
            '<p class="no-margin header-item padding-right--0_5"><span class="bold--700">'+$filter('uppercase')($filter('translationWithPrefix')('XMAS_GLOSSARY_IB'))+
            '</span> '+$filter('translationWithPrefix')('XMAS_GLOSSARY_TEXT_IB')+'</p>'+
        '</div>';
    }

    function openGlossary(){
      vm.glossary.tooltipOpen = !vm.glossary.tooltipOpen;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('loginService', loginService);

    loginService.inject = ['$http', 'moment', 'storageService', 'configurationLoaderService', '$q', 'globalHelpersService','Analytics'];
    function loginService($http, moment, storageService, configurationLoaderService, $q, globalHelpersService, Analytics) {
        var service = {
            loginFullWorkflow: loginFullWorkflow,
            loginFullWorkflowWithToken:loginFullWorkflowWithToken,
            getUser: getUser,
            setUser: setUser,
            getToken: getToken,
            getUserLanguage: getUserLanguage,
            setMomentLocale: setMomentLocale,
            saveToStorage:saveToStorage
        };

        var user;

        return service;

        /** private methods */
        function loginFullWorkflow(username, password) {
            return $q.when(clearLocalstorage())
                .then(function () { return login(username, password); })
                .then(saveToStorage)
                .then(postLogin);
        }

        function loginFullWorkflowWithToken(token) {
            return $q.when(clearLocalstorage())
                .then(configurationLoaderService.getRemoteConfig)
                .then(function () { return loginWithToken(token); })
                .then(saveToStorage);
        }


        // login error
        function login(user, password) {
            return $http({
                method: 'POST',
                url: './api/authentication',
                data: {
                    user: user,
                    password: password,
                    strategy:'local'
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                transformRequest: globalHelpersService.httpPostParamsPrepare,
                transformResponse: $http.defaults.transformResponse.concat([transformProperties])
            });
        }

        function loginWithToken(token) {
           return $http({
                method: 'POST',
                url: './api/auth-with-token',
                data: {
                    token:token
                },
                transformResponse: $http.defaults.transformResponse.concat([transformProperties])
            });
        }

        // transforms hashmap from backend to object
        function transformProperties(data, _header, status) {
            if (status >= 400 && data.message) {
                return data;
            }

            data.profile = _.reduce(data.properties, function (aggr, item, _index) {
                var key = item.name,
                    value = item.value;

                aggr[key] = value;
                return aggr;
            }, {});

            return data;
        }


        /**
         * clear localstorage
         * 
         * @returns
         */
        function clearLocalstorage() {
            return storageService.clear();
        }

        /**
         * save user to localStorage
         * 
         * @param {any} userData
         * @returns
         */
        function saveToStorage(userData) {
            user = userData && userData.data && userData.data.userInfo;
            user.value = userData && userData.data && userData.data.accessToken;

            storageService.save('user', user);
            return user;
        }

        function postLogin(userData){
            //Google Analytics
            Analytics.set('dimension1', userData && userData.user);
            Analytics.set('&uid', userData && userData.user);
            Analytics.set('userId', userData && userData.user);
            Analytics.pageView();

            return userData;
        }
        /**
         * getter user variable
         * 
         * @returns
         */
        function getUser() {
            return user;
        }

        /**
         * setter user variable
         * 
         * @param {any} _user
         */
        function setUser(_user) {
            user = _user;
        }

        /**
         * getter for token
         * 
         * @returns
         */
        function getToken() {
            return ''; // user.value;
        }

        /**
         * getter for user language
         * 
         * @returns language
         */
        function getUserLanguage() {
            return 'es'; // user.profile.language;
        }

        /**
         * set momentjs locale
         * 
         * @param {any} localeCode
         * @returns
         */
        function setMomentLocale(localeCode) {
            return moment.locale(localeCode);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'login',
        doNotTrack: true,
        resolve: {
          transition: transition,
          configuration: getConfiguration
        },
        public: true
      });
  }

  transition.$inject = ['$timeout', 'storageService','stateManagerService'];
  function transition($timeout, storageService, stateManagerService) {
    storageService.clear();
    stateManagerService.clear();
    return $timeout(function () {}, 3000);
  }

  getConfiguration.$inject = ['errorHandlerService', 'configurationLoaderService', 'transition'];
  function getConfiguration(errorHandlerService, configurationLoaderService, _transition) {
    if (!configurationLoaderService.getConfig()) {
      return configurationLoaderService.getRemoteConfig()
        .catch(errorHandlerService.callbackError);
    }
    else {
      return configurationLoaderService.getConfig();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['errorHandlerService','loginService','$state','configurationLoaderService','storageService','filterService','$timeout'];
  function LoginController(errorHandlerService,loginService,$state,configurationLoaderService,storageService,filterService, $timeout) {

    errorHandlerService.log('log','Enter login Controller');

    var vm = this;
    vm.login = login;
    vm.errorMessage = '';
    vm.loading= false;

    //forgot password url
    vm.config = configurationLoaderService.getConfig();

    // login('total','odec');
    /** private methodes */
    function login(username,password) {
      vm.loading = true;

      // the same cleaning as in logout just in case 
      // the user arrives to login page without doing
      // logout
      storageService.clear();
      filterService.clearContext();

      // full login workflow
      return loginService.loginFullWorkflow(username,password)
              .then(moveOnLogin)
              .catch(onAuthenticationError)
              .finally(function(){
                vm.loading = false;
              });
    }

    function moveOnLogin() {
      $state.go.apply(null,[vm.config.onAuthenticationState.url,vm.config.onAuthenticationState.state]);
    }

    function onAuthenticationError(error) {
      errorHandlerService.log('error',error);
      
      vm.errorMessage = error.data && error.data.error || error.data && error.data.message || '';
      
      $timeout(function(){
        vm.errorMessage = null;
      }, 3500);
    }
  }
})();


(function () {
    'use strict';
  
    angular
      .module('app')
      .config(routerConfig);
  
    routerConfig.$inject = ['$stateProvider'];
    function routerConfig($stateProvider) {
      $stateProvider
        .state('landingPage', {
          url: '/landingPage',
          templateUrl: 'app/landingPage/landingPage.html',
          controller: 'LandingPageController',
          controllerAs: 'landingPage',
          doNotTrack: true,
          resolve: {
            transition: transition,
            translations: getTranslations,
            configuration: getConfiguration,
            viewsConfiguration: getViewsConfiguration,
            listenToResize: listenToResize,
            getModalData: getModalData
          }
        });
    }
  
    getConfiguration.$inject = ['errorHandlerService', 'configurationLoaderService'];
    function getConfiguration(errorHandlerService, configurationLoaderService) {
      if (!configurationLoaderService.getConfig()) {
        return configurationLoaderService.getRemoteConfig()
          .catch(errorHandlerService.callbackError);
      }
      else {
        return configurationLoaderService.getConfig();
      }
    }
  
    getViewsConfiguration.$inject = ['configurationLoaderService', 'errorHandlerService'];
    function getViewsConfiguration(configurationLoaderService, errorHandlerService) {
      return configurationLoaderService.loadViewsConfiguration()
        .catch(function(error) {
          errorHandlerService.log('error', 'Failed to load views configuration: ' + error);
          // Resolver con configuración vacía para mostrar todo por defecto
          return {modules: {}};
        });
    }

    listenToResize.$inject = ['windowResizeManagerService'];
    function listenToResize(windowResizeManagerService) {
      return windowResizeManagerService.startListening();
    }

    getTranslations.$inject = ['$translate'];
    function getTranslations($translate) {
      return $translate.use('en');
    }

    transition.$inject = ['configurationLoaderService','configuration','$timeout'];
    function transition (configurationLoaderService,_configuration, $timeout) {
      return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
    }

    getModalData.$inject = ['userHelperService','$http','filterHelperService','$q'];
    function getModalData(userHelperService, $http, filterHelperService, $q) {
      var user = userHelperService.getUser();
            var params = {
                layout:'LAYOUT_LANDING',
                parameters:{
                    "$country$": (function() {
                        var v = filterHelperService.getCountrySelected() 
                                || (user && user.selectionMap && user.selectionMap.country);
                        return Array.isArray(v) ? v[0] : v;
                      })(),
                    "COUNTRY": _.concat([], userHelperService.getCountry())
                }
            };

            
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-filters',
                data: params
            })
            .then(function(data){
              data = data && data.data;
              return _.chain(data).find({'name':'F21'}).result('content').map(function(item){
                item.brand = item && item.id && item.id.substring(0,2);
                item.id = item && item.id && item.id.substring(2);
                return item;
              }).value();
            })
            .catch(function(){
                return $q.when([]);
            });
    }
  
  })();
  
(function() {
    'use strict';

    angular
        .module('app')
        .controller('LandingPageController', LandingPageController);

    LandingPageController.$inject = ['configurationLoaderService', 'filterHelperService', 'userHelperService', '$rootScope','$scope','$window','$timeout','$state','getModalData'];
    function LandingPageController(configurationLoaderService, filterHelperService, userHelperService, $rootScope, $scope, $window, $timeout, $state, getModalData) {
        var vm = this;

        vm.menuLanding = configurationLoaderService.getConfig().menuLanding;

        var user = userHelperService.getUser();
        var countriesWithHistoric = configurationLoaderService.getConfig().countriesWithHistoric;
        var countryFromFilter = filterHelperService.getCountrySelected() || user && user.selectionMap && user.selectionMap.country;
        // Si el país es un array (viene de una vista cross country), tomar el primero
        var countrySelected = _.isArray(countryFromFilter) ? _.first(countryFromFilter) : countryFromFilter;

        // Función para filtrar bubbles según configuración de vistas
        function filterBubblesByViewsConfig(bubbles) {
            return _.map(bubbles, function (bubble) {
                // Primero aplicar filtro de histórico por país
                if(countriesWithHistoric.indexOf(countrySelected) === -1 && bubble.id === 'historicButton' ){
                    bubble.visible = false;
                } else {
                    if(bubble.id === 'historicButton'){ bubble.visible = true; }
                }

                // Aplicar filtro de configuración de vistas
                if (bubble.id && !configurationLoaderService.isModuleEnabled(bubble.id)) {
                    bubble.visible = false;
                }

                return bubble;
            });
        }

        // Función para verificar si hay al menos una bubble histórica habilitada
        function hasEnabledHistoricBubbles(allBubbles) {
            var historicBubbles = _.filter(allBubbles, function(item) {
                return item.historic === true;
            });
            return _.some(historicBubbles, function(item) {
                return configurationLoaderService.isModuleEnabled(item.id);
            });
        }

        // Aplicar filtros a todas las vistas del menú landing
        vm.menuLanding.generalView.bubbles = filterBubblesByViewsConfig(vm.menuLanding.generalView.bubbles);
        vm.menuLanding.countriesView.bubbles = filterBubblesByViewsConfig(vm.menuLanding.countriesView.bubbles);
        vm.menuLanding.detailedView.bubbles = filterBubblesByViewsConfig(vm.menuLanding.detailedView.bubbles);

        // Ocultar historicButton si no hay ninguna bubble histórica habilitada
        var allBubbles = _.flatMap(vm.menuLanding, 'bubbles');
        if (!hasEnabledHistoricBubbles(allBubbles)) {
            _.forEach(allBubbles, function(bubble) {
                if (bubble.id === 'historicButton') {
                    bubble.visible = false;
                }
            });
        }

        // Ocultar categorías completas si no tienen ninguna bubble visible
        vm.menuLanding.generalView.visible = _.some(vm.menuLanding.generalView.bubbles, {visible: true});
        vm.menuLanding.countriesView.visible = _.some(vm.menuLanding.countriesView.bubbles, {visible: true});
        vm.menuLanding.detailedView.visible = _.some(vm.menuLanding.detailedView.bubbles, {visible: true});

        // maxBubbles para detailed view (burbujas directas en landing)
        var visibleDetailedBubbles = _.filter(vm.menuLanding.detailedView.bubbles, {visible: true}).length;
        vm.menuLanding.detailedView.properties.maxBubbles = Math.min(5, visibleDetailedBubbles);

        // maxBubbles para generalView/countriesView (usado por sub-burbujas dentro del modal de grupo)
        vm.menuLanding.generalView.properties.maxBubbles = _.filter(vm.menuLanding.generalView.bubbles, {visible: true}).length;
        vm.menuLanding.countriesView.properties.maxBubbles = _.filter(vm.menuLanding.countriesView.bubbles, {visible: true}).length;

        vm.modalDiv = {
            width:0,
            height:0,
            show:false,
            close:close,
            collection:getModalData,
            state:null,
            web:null,
            goTo:goTo,
            historic:{
                isHistoric: false,
                elements: []
            },
            group:{
                isGroup: false,
                elements: [],
                properties: null
            }
        };

        vm.groupBubbleProps = {
            generalView: angular.extend({}, vm.menuLanding.generalView.properties, { maxBubbles: 2 }),
            countriesView: angular.extend({}, vm.menuLanding.countriesView.properties, { maxBubbles: 2 })
        };

        vm.fnBubble = fnBubble;

        var repaintListener = $rootScope.$on('window.resize', function(_event, value){
            $timeout(function(){
                vm.modalDiv.width = value && value.size &&  value.size[0] * .9;
                vm.modalDiv.height = value && value.size &&  value.size[1] * .85;
            },0);
        });

        var bubbleLandingClickedFn = $rootScope.$on('bubbleLandingClicked', function(_event, value){
            $timeout(function(){
                vm.modalDiv.show = true;
                if(value && value.isHistoric){
                    vm.modalDiv.historic.isHistoric = true;
                    vm.modalDiv.group.isGroup = false;
                    vm.modalDiv.historic.elements = _.filter(angular.copy(_.flatMap(vm.menuLanding, 'bubbles')), function(item){
                        return item.historic === true && configurationLoaderService.isModuleEnabled(item.id);
                    });
                } else if(value && value.isGroup){
                    vm.modalDiv.group.isGroup = true;
                    vm.modalDiv.historic.isHistoric = false;
                    var sourceKey = value.groupSource;
                    vm.modalDiv.group.elements = _.filter(vm.menuLanding[sourceKey].bubbles, function(item){
                        return item.visible !== false;
                    });
                    vm.modalDiv.group.properties = vm.menuLanding[sourceKey].properties;
                    vm.modalDiv.group.title = vm.menuLanding[sourceKey].groupBubble.text;
                } else {
                    vm.modalDiv.historic.isHistoric = false;
                    vm.modalDiv.group.isGroup = false;
                    vm.modalDiv.historic.elements = [];
                    vm.modalDiv.state = value && value.paramsUrlBubble && value.paramsUrlBubble.url;
                    vm.modalDiv.web = value && value.paramsUrlBubble && value.paramsUrlBubble.web;
                }
            },0);
        });

        $scope.$on('$destroy', function () {
            repaintListener();
            bubbleLandingClickedFn();
        });

        init();

        function init(){
            vm.modalDiv.width = $window.innerWidth * .9;
            vm.modalDiv.height = $window.innerHeight * .85;
        }

        function close(){
            vm.modalDiv.show = false;
        }

        function goTo(state, web, idParam, text){
            $state.go(state, { brand: idParam, web: web, text:text });
        }

        function fnBubble(params){
            if(params && params.url){
                $state.go.apply(null,[params && params.url,{ web: params && params.web}]);
            }
            return;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('yearFilterService', yearFilterService);

    /** @ngInject */
    function yearFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getYear:getYear,
            changeListener:function() {alert('wave');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getYear(options);
        }

        function getYear(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, _options) {
            data = _.chain(data).find({'name': _options && _options.nameFilter || 'F22' }).result('content').value();

            return {
                type:'select2',
                name: 'Year',
                label: 'Year',
                viewLabel: _options && _options.labelFilter || 'FILTER_YEAR',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.year? null :createPreselections(data, context.year),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                context.year = preselection;
                return preselection;
            }

            lastItem = _.chain(data).first().result('id').value();
            context.year = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('typeMediaFilterService', typeMediaFilterService);

    /** @ngInject */
    function typeMediaFilterService(stateManagerService, $q) {
        var service = {
            getFilter: getFilter,
            getTypeMedia: getTypeMedia,
            changeListener: function () { alert('wave'); }
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getTypeMedia(options);
        }

        function getTypeMedia(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, _options) {

            data = _.chain(data).find({ 'name': _options && _options.nameFilter || 'FMEDIOnew' || 'FMEDIOnewX' }).result('content').value();
            /** Transformamos la id para poder hacer el match con el filtro seleccionado  */
            var comboData = transformMedia(data);

            return {
                type: 'select2',
                name: 'typeMedia',
                label: 'typeMedia',
                viewLabel: _options && _options.labelFilter || 'FILTER_TYPE_MEDIA',
                datos: _.map(comboData, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.typeMedia ? null : createPreselections(comboData, context.typeMedia),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {

            var lastItem;
            if (preselection) {
                context.typeMedia = preselection;
                return preselection;
            }

            lastItem = _.chain(data).first().result('id').value();
            context.typeMedia = lastItem;
            return lastItem;
        }

        function transformMedia(dataCombo) {
            var newCombo = _.map(dataCombo, function(item) {
                switch (item && item.id){
                    case 'RECOG01X':
                        item.id = 'FRECOTOTAL';
                        break;
                    case 'RECOG01':
                        item.id = 'FRECOTOTAL';
                        break;
                    case 'RECOG11X':
                        if (item.text === 'VIDEO') {
                            item.id = 'FRECOVIDEO';
                        }
                        if (item.text === 'VIDEO SOCIAL NETWORKS') {
                            item.id = 'FRECOVIDEOX';
                        }                 
                        break;
                    case 'RECOG11':
                        if (item.text === 'VIDEO') {
                            item.id = 'FRECOVIDEO';
                        }
                        if (item.text === 'VIDEO SOCIAL NETWORKS') {
                            item.id = 'FRECOVIDEOX';
                        }                 
                        break;
                    case 'RECOG18X':
                        if (item.text === 'VISUAL') {
                            item.id = 'FRECOVISUAL';
                        }
                        if (item.text === 'VISUAL SOCIAL NETWORKS') {
                            item.id = 'FRECOVISUAX';
                        }                 
                        break;
                    case 'RECOG18':
                        if (item.text === 'VISUAL') {
                            item.id = 'FRECOVISUAL';
                        }
                        if (item.text === 'VISUAL SOCIAL NETWORKS') {
                            item.id = 'FRECOVISUAX';
                        }                 
                        break;                   
                }
                return item;
            });
            return newCombo;
        } 
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('typeEventFilterService', typeEventFilterService);

    /** @ngInject */
    function typeEventFilterService(stateManagerService, $q, $filter) {
        var service = {
            getFilter: getFilter,
            getTypeEvent: getTypeEvent,
            changeListener: function () { alert('typeEvents'); }
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getTypeEvent(options);
        }

        function getTypeEvent(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, _options) {
            data = [
                { 'id': 'E', 'text': $filter('translationWithPrefix')('TYPE_EVENT_EVENTS') },
                { 'id': 'M', 'text': $filter('translationWithPrefix')('TYPE_EVENT_MONTHS') }
            ];
            return {
                type: 'select2',
                name: 'typeEvent',
                label: 'typeEvent',
                viewLabel: 'FILTER_TYPE_EVENT',
                datos: data,
                selectedNode: this && this.notPreselected && !context.typeEvent ? null : createPreselections(data, context.typeEvent),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                if (_.chain(data).find({ 'id': preselection }).value()) {
                    context.typeEvent = preselection;
                    return preselection;
                }
                context.typeEvent = _.chain(data).first().result('id').value();
                return _.chain(data).first().result('id').value();
            }

            lastItem = _.chain(data).first().result('id').value();
            context.typeEvent = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('timeFilterCountryService', timeFilterCountryService);

    /** @ngInject */
    function timeFilterCountryService(stateManagerService, $q) {
        var service = {
            getFilter: getFilter,
            getTime: getTime,
            changeListener: function () { alert('wave'); }
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getTime(options);
        }

        function getTime(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            // Para el tipo 'granularity' - leer opciones dinámicamente del endpoint
            if(options && options.type === 'granularity') {
                var fwaveContent = _.chain(data)
                    .find({ 'name': options && options.nameFilter || 'FWAVE' })
                    .result('content')
                    .value();

                // Extraer las opciones de granularidad del contenido (M, T, S, A)
                var granularityOptions = _.map(fwaveContent, function(item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                });

                return {
                    type: 'select2',
                    name: options && options.nameContext || 'Time',
                    label: options && options.labelFilter || 'Time',
                    viewLabel: options && options.viewLabelFilter || 'FILTER_TIME',
                    datos: granularityOptions,
                    selectedNode: this && this.notPreselected && !context.granularity ? null : createPreselections(
                        granularityOptions,
                        context.granularity || 'M',
                        'granularity'
                    ),
                    notRemovable: true
                };
            }

            // Para el tipo 'period' - periodos según la granularidad seleccionada
            if(options && options.type === 'period') {
                var granularity = context && context.granularity || 'M';

                var fwaveData = _.chain(data)
                    .find({ 'name': options && options.nameFilter || 'FWAVE' })
                    .result('content')
                    .value();

                // Buscar el grupo que corresponde a la granularidad seleccionada
                var selectedGroup = _.find(fwaveData, { 'id': granularity });
                var periodData = selectedGroup && selectedGroup.children || [];

                return {
                    type: 'select2',
                    name: options && options.nameContext || 'Period',
                    label: options && options.labelFilter || 'Period',
                    viewLabel: options && options.viewLabelFilter || 'FILTER_PERIOD',
                    datos: _.map(periodData, function (item) {
                        return {
                            id: item && item.id,
                            text: item && item.text
                        };
                    }),
                    selectedNode: this && this.notPreselected && !context.period ? null : createPreselections(periodData, context.period, 'period'),
                    notRemovable: true
                };
            }
        }

        function createPreselections(data, preselection, type) {
            var lastItem;
            if (preselection) {
                if (_.chain(data).find({ 'id': preselection }).value()) {
                    context[type] = preselection;
                    return preselection;
                }
                context[type] = _.chain(data).first().result('id').value();
                return context[type];
            }

            lastItem = _.chain(data).first().result('id').value();
            context[type] = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('timeFilterService', timeFilterService);

    /** @ngInject */
    function timeFilterService(stateManagerService, $q) {
        var service = {
            getFilter: getFilter,
            getTime: getTime,
            changeListener: function () { alert('wave'); }
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getTime(options);
        }

        function getTime(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            switch(options && options.type){
                case 'year':
                    data = _.chain(data).find({ 'name': options && options.nameFilter || 'F22' }).result('content').find({ 'id': options && options.typeEvent || 'M' }).result('children').value();
                    break;
                case 'period':
                    data = _.chain(data).find({ 'name': options && options.nameFilter || 'F22' }).result('content').find({ 'id': options && options.typeEvent || 'M' }).result('children').find({ 'id': context && context.year }).result('children').value();
                    break;
            }
            
            return {
                type: 'select2',
                name: options && options.nameContext,
                label: options && options.labelFilter || '',
                viewLabel: options && options.labelFilter || '',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context[options && options.type] ? null : createPreselections(data, context[options && options.type], options && options.type),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection, type) {
            var lastItem;
            if (preselection) {
                if (_.chain(data).find({ 'id': preselection }).value()) {
                    context[type] = preselection;
                    return preselection;
                }
                context[type] = _.chain(data).first().result('id').value();
                return context[type];
            }

            lastItem = _.chain(data).first().result('id').value();
            context[type] = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('periodMultipleFilterService', periodMultipleFilterService);

    /** @ngInject */
    function periodMultipleFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getPeriods:getPeriods,
            changeListener:function() {alert('countries');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getPeriods(options);
        }

        function getPeriods(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            //data = _.chain(data).find({'name': options && options.nameFilter || 'F22'}).result('content').flatMap('children').value();
            data = _.chain(data).find({ 'name': options && options.nameFilter || 'F22' }).result('content').find({ 'id': context && context.year }).result('children').value();

            return {
                type: 'multiple',
                name: 'Period',
                label: 'Period',
                viewLabel: 'FILTER_PERIOD',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.period? null :createPreselections(data, context.period, options),
                notRemovable: true,
                maxSelections: options && options.type === 'multiple' ? options && options.maxSelections :  0,
                minSelections: options && options.type === 'multiple' ? options && options.minSelections :  0
            };
        }

        function createPreselections(data, preselection, options) {
            var lastItem;
            preselection = preselection || options.preselection; 
            if (preselection) {
                    context.period = _.chain(data).reduce(function(aggr,item){
                        if (_.includes(preselection, item && item.id)){
                            aggr.push(item);
                        }
                        
                        return aggr;
                    },[]).map('id').value();
                    
                    if (context.period && context.period.length === 0) {
                        context.period = _.chain(data).take((options && options.maxSelections) || 2).map('id').value();
                    }
                    return context.period; 
            } 
            else{
                lastItem = _.chain(data).take(2).map('id').value();
                context.period = lastItem;
                return lastItem;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('periodFilterService', periodFilterService);

    /** @ngInject */
    function periodFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getPeriods:getPeriods,
            changeListener:function() {alert('countries');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getPeriods(options);
        }

        function getPeriods(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, _options) {
            data = _.chain(data).find({'name': _options && _options.nameFilter || 'F22'}).result('content').find({'id':context && context.year	}).result('children').value();

            return {
                type:'select2',
                name: 'Period',
                label: 'Period',
                viewLabel: 'FILTER_PERIOD',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.period? null :createPreselections(data, context.period),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                if(_.chain(data).find({'id':preselection}).value()){
                    context.period = preselection;
                    return preselection;
                }
                context.period = _.chain(data).first().result('id').value();
                return _.chain(data).first().result('id').value();
            }

            lastItem = _.chain(data).first().result('id').value();
            context.period = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('networkFilterService', networkFilterService);

    /** @ngInject */
    function networkFilterService($http, userHelperService, $filter, errorHandlerService,$q) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo,
            changeListener:function() {alert('network');}
        };

        var context;

        return service;

        /** private methods */

        /**
         * options
         * 
         * notPreselected: Avoid set a value by default
         * waveNullable: Allow to get data even when there is no wave selected
         */
        function getFilter(options) {
            context = this;
            return getNetwork(options);
        }

        function getNetwork(options) {
            var waveNullable =  options && options.waveNullable; 
            if (!context.project || (!context.wave && !waveNullable)) {
                return $q.when(null);
            }

            //If we have a context (user admin so far) we need to do an special 
            //call in order to get the data from other contexsts 
            var networkUrl = context.context ? './api/Entrevistas/getListContext/' : './api/Entrevistas/getList/'; 

            var params = {
                token: userHelperService.getToken(),
                referenceDate: context.wave && $filter('waveToFullDate')(context.wave.toString()),
                selectedIds: context.network,
                context: context.context ||  null 
            };
            
            return $http({
                method: 'GET',
                url: networkUrl + context.project,
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            var selectedId;
            if (data.error || !data.response || data.response.length < 1) {
                errorHandlerService.log('error', 'networkFilterService::transformData -> no response');
                return null;
            }
            
            selectedId = getLastSelected(data.response);
            
            if (selectedId) {
                context.network = selectedId;
            }

            return _.map(data.response, fnTransformation);
        }

        function fnTransformation(networkItem) {
            return {
                type: 'select2',
                name: networkItem.name,
                label: networkItem.name.toUpperCase(),
                viewLabel: networkItem.name,
                allowClear: true,
                hide: false,
                datos: _.map(networkItem.nodes, function (comboItem) {
                    return {
                        id: comboItem.id,
                        text: comboItem.label,
                        externalId: comboItem.externalId,
                        selected: comboItem.selected
                    };
                }),
                selectedNode: networkItem.selectedNode
            };
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = _.chain(data.selection)
                .filter(function (item) {
                    return item.id !== null;
                })
                .last()
                .value();
            return data;
        }

        function getLastSelected(data) {
            return _.chain(data)
                .map('selectedNode')
                .filter(function(item){ return item !== null;})
                .last()
                .value();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('metricFilterService', metricFilterService);

    /** @ngInject */
    function metricFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getMetric:getMetric,
            changeListener:function() {alert('images');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getMetric(options);
        }

        function getMetric(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            // Buscar por el nombre correcto del filtro
            var filterName = (options && options.nameFilter) || 'F29X';
            
            // Obtener el filtro completo
            var filter = _.chain(data).find({ 'name': filterName }).value();
            
            if (!filter) {
                return {
                    type: options && options.type === 'multiple' ? 'multiple' : 'select2',
                    name: 'Metric',
                    label: options && options.labelFilter || 'Metric',
                    viewLabel: options && options.viewLabelFilter || 'FILTER_METRIC',
                    datos: [],
                    selectedNode: null,
                    notRemovable: true,
                    maxSelections: 0,
                    minSelections: 0
                };
            }
            
            // Buscar el market seleccionado en el contenido del filtro
            var marketId = context && context.market;
            var marketData = _.chain(filter.content).find({ 'id': marketId }).value();
            
            // Si no hay market seleccionado o no se encuentra, usar el primero disponible
            if (!marketData) {
                marketData = _.first(filter.content);
            }
            
            // Obtener las métricas (children del market)
            var metricsData = marketData && marketData.children ? marketData.children : [];
            
            return {
                type: options && options.type === 'multiple' ? 'multiple' : 'select2',
                name: 'Metric',
                label: options && options.labelFilter || 'Metric',
                viewLabel: options && options.viewLabelFilter || 'FILTER_METRIC',
                datos: _.map(metricsData, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: options && options.notPreselected && !context.metric ? null : createPreselections(metricsData, context.metric || (options && options.preselection), options),
                notRemovable: true,
                maxSelections: options && options.type === 'multiple' ? options && options.maxSelections : 0,
                minSelections: options && options.type === 'multiple' ? options && options.minSelections : 0
            };
        }

        function createPreselections(data, preselection, options) {
            var lastItem;
            if (preselection) {
                if(options && options.type === 'multiple'){
                    context.metric = _.chain(data).reduce(function(aggr,item){
                        if(_.includes(preselection, item && item.id)){
                            aggr.push(item);
                        }
                        
                        return aggr;
                    },[]).map('id').value();
                    if (context.metric && context.metric.length === 0) {
                        context.metric = _.chain(data).take((options && options.maxSelections) || 2).map('id').value();
                    }
                    return context.metric;
                }
                else{
                    if(_.chain(data).find({'id':preselection}).value()){
                        context.metric = preselection;
                        return preselection;
                    }
                    context.metric = _.chain(data).first().result('id').value();
                    return _.chain(data).first().result('id').value();
                } 
            }

            if(options && options.type === 'multiple'){
                lastItem = _.chain(data).take((options && options.maxSelections) || 2).map('id').value();
            }
            else{
                lastItem = _.chain(data).first().result('id').value();
            }
            context.metric = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('mediaFilterService', mediaFilterService);

    /** @ngInject */
    function mediaFilterService(stateManagerService, $q) {
        var service = {
            getFilter: getFilter,
            getYear: getYear,
            changeListener: function () { alert('wave'); }
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getYear(options);
        }

        function getYear(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, _options) {
            data = _.chain(data).find({ 'name': _options && _options.nameFilter || 'F35' }).result('content').value();

            return {
                type: 'select2',
                name: 'Media',
                label: 'Media',
                viewLabel: _options && _options.labelFilter || 'FILTER_MEDIA',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.media ? null : createPreselections(data, context.media),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                context.media = preselection;
                return preselection;
            }

            lastItem = _.chain(data).first().result('id').value();
            context.media = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('marketFilterService', marketFilterService);

    /** @ngInject */
    function marketFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getMarkets:getMarkets,
            changeListener:function() {alert('countries');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getMarkets(options);
        }

        function getMarkets(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            var filterName = options && options.nameFilter || 'F23'; // Valor por defecto F23
            data = _.chain(data).find({'name': filterName}).result('content').value();

            return {
                type:'select2',
                name: 'Market',
                label: 'Market',
                viewLabel: 'FILTER_MARKET',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.market? null :createPreselections(data, context.market),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                if(_.chain(data).find({'id':preselection}).value()){
                    context.market = preselection;
                    return preselection;
                }
                context.market = _.chain(data).first().result('id').value();
                return _.chain(data).first().result('id').value();
            }

            lastItem = _.chain(data).first().result('id').value();
            context.market = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('imageFilterService', imageFilterService);

    /** @ngInject */
    function imageFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getImage:getImage,
            changeListener:function() {alert('images');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getImage(options);
        }

        function getImage(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            data =  data = _.chain(data).find({'name':'F27'}).result('content').value();
            return {
                type: options && options.type === 'multiple' ? 'multiple' : 'select2',
                name: 'Image',
                label: 'Image',
                viewLabel: 'FILTER_IMAGE',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.image ? null : createPreselections(data, context.image || (options && options.preselection), options),
                notRemovable: true,
                maxSelections: options && options.type === 'multiple' ? options && options.maxSelections :  0,
                minSelections: options && options.type === 'multiple' ? options && options.minSelections :  0
            };
        }

        function createPreselections(data, preselection, options) {
            var lastItem;
            if (preselection) {
                if(options && options.type === 'multiple'){
                    context.image = _.chain(data).reduce(function(aggr,item){
                        if(_.includes(preselection, item && item.id)){
                            aggr.push(item);
                        }
                        
                        return aggr;
                    },[]).map('id').value();
                    
                    if (context.image && context.image.length === 0) {
                        context.image = _.chain(data).take(2).map('id').value();
                    }
                    return context.image;
                }
                else{
                    if(_.chain(data).find({'id':preselection}).value()){
                        context.image = preselection;
                        return preselection;
                    }
                    context.image = _.chain(data).first().result('id').value();
                    return _.chain(data).first().result('id').value();
                }
            }

            if(options && options.type === 'multiple'){
                lastItem = _.chain(data).take(2).map('id').value();
            }
            else{
                lastItem = _.chain(data).first().result('id').value();
            }
            context.image = lastItem;
            return lastItem;
        }
    }
})();
(function () {
  'use strict';

  /** Module used to manage the configuration for the filter for each view */
  angular
    .module('app')
    .factory('filterViewConfigurationService', filterViewConfigurationService);

  filterViewConfigurationService.$inject = [
    'yearFilterService', 'periodFilterService', 'countryFilterService', 
    'filterSelectionsService','marketFilterService','brandFilterService',
    'criteriaFilterService','imageFilterService','periodMultipleFilterService',
    'metricFilterService', 'campaignFilterService', 'eventMultipleFilterService',
    'typeEventFilterService', 'timeFilterService', 'timeFilterCountryService', 'mediaFilterService', 'typeMediaFilterService',
    'countryMultipleFilterService', 'contextVariableService'
  ];
  function filterViewConfigurationService(
    yearFilterService, periodFilterService, countryFilterService, 
    filterSelectionsService, marketFilterService, brandFilterService,
    criteriaFilterService, imageFilterService, periodMultipleFilterService,
    metricFilterService, campaignFilterService, eventMultipleFilterService,
    typeEventFilterService, timeFilterService, timeFilterCountryService, mediaFilterService, typeMediaFilterService,
    countryMultipleFilterService, contextVariableService
    ) {
    var service = {
      getFilterDefinition: getFilterDefinition
    };

    var configs = {
      layout1: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_1' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [], deps: ['year', 'country'] }
          ]
        }
      ],
      layout2: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_2' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [], deps: ['year', 'country'] }
          ]
        }
      ],
      layout3: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_3' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [], deps: ['year', 'country'] }
          ]
        }
      ],
      layout4: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_4' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [{'nameFilter':'F222'}], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [{'nameFilter':'F222'}], deps: ['year', 'country'] }
          ]
        }
      ],
      layout5: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_5' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [], deps: ['year', 'country'] }
          ]
        }
      ],
      layout6: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_6' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [], deps: ['year', 'country'] }
          ]
        },
        {
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'market', method: marketFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [], deps: ['market','country'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        }
      ],
      layout7: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_7' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [], deps: ['year', 'country'] }
          ]
        },
        {
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'market', method: marketFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [{ 'type':'multiple', 'maxSelections':4, 'minSelections':2 }], deps: ['market','country'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'image', label: 'FILTER_IMAGE', viewLabel: 'FILTER_IMAGE', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'image', method: imageFilterService, args: [{ 'type':'multiple', 'maxSelections':4, 'minSelections':2, 'preselection':['IMA002','IMA004','IMA019','IMA021'] }], deps: ['country'] }
          ]
        }
      ],
      layout8: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_8' }], deps: ['country'] }
          ]
        },
        // {
        //   group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
        //   sources: [
        //     { eventId: 'period', method: periodMultipleFilterService, args: [{ 'type':'multiple', 'maxSelections':2, 'minSelections':2 }], deps: ['country'] }
        //   ]
        // },
        {
          group: { id: 'year', label: 'FILTER_TIME', viewLabel: 'FILTER_TIME', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [{ nameFilter: 'F28', 'labelFilter': 'FILTER_TIME' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodMultipleFilterService, args: [{ nameFilter: 'F28', 'type': 'multiple', 'maxSelections': 2, 'minSelections': 2 }], deps: ['year', 'country'] }
          ]
        },
        {
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'market', method: marketFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [], deps: ['market','country'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        }
      ],
      layout9: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_9' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_TIME', viewLabel: 'FILTER_TIME', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [{ nameFilter: 'F28', 'labelFilter': 'FILTER_TIME' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [{nameFilter:'F28'}], deps: ['year', 'country'] }
          ]
        },
        {
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'market', method: marketFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [{ 'type':'multiple', 'maxSelections':4, 'minSelections':2 }], deps: ['market','country'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'metric', label: 'FILTER_METRIC', viewLabel: 'FILTER_METRIC', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'metric', method: metricFilterService, args: [{nameFilter:'F29'}], deps: ['country','market'] }
          ]
        }
      ],
      layout10: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_10' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_TIME', viewLabel: 'FILTER_TIME', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [{ nameFilter: 'F28', 'labelFilter': 'FILTER_TIME' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [{ nameFilter: 'F28' }], deps: ['year', 'country'] }
          ]
        },
        {
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'market', method: marketFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [], deps: ['market', 'country'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'metric', label: 'FILTER_METRIC', viewLabel: 'FILTER_METRIC', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'metric', method: metricFilterService, args: [{ 'type': 'multiple', 'maxSelections': 4, 'minSelections': 1, nameFilter:'F29' }], deps: ['country','market'] }
          ]
        }
      ],
      layout11: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_11', 'includeSystemVariables': true }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: timeFilterService, args: [{ 'nameFilter': 'F32', 'type': 'year','typeEvent':'E', 'nameContext': 'year', 'labelFilter': 'FILTER_YEAR' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_EVENT', viewLabel: 'FILTER_EVENT', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterService, args: [{ 'nameFilter': 'F32', 'type': 'period', 'typeEvent': 'E', 'nameContext': 'period', 'labelFilter': 'FILTER_EVENT' }], deps: ['country', 'year'] }
          ]
        }
      ],
      layout12: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_12', 'includeSystemVariables': true }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'campaigns', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'campaigns', method: campaignFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'typeEvent', label: 'FILTER_TYPE_EVENT', viewLabel: 'FILTER_TYPE_EVENT', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeEvent', method: typeEventFilterService, args: [], deps: [] }
          ]
        },
        {
          group: { id: 'events', label: 'FILTER_PERIODS', viewLabel: 'FILTER_PERIODS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'events', method: eventMultipleFilterService, args: [{ 'type': 'multiple', 'maxSelections': 8, 'minSelections': 2, 'historic': true}], deps: ['country','typeEvent'] }
          ]
        }
      ],
      layout13: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_13','includeSystemVariables':true }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'campaigns', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'campaigns', method: campaignFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: timeFilterService, args: [{ 'nameFilter': 'F31', 'type': 'year', 'nameContext': 'year', 'labelFilter':'FILTER_YEAR'}], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterService, args: [{ 'nameFilter': 'F31', 'type': 'period', 'nameContext':'period', 'labelFilter':'FILTER_PERIOD'}], deps: ['country','year'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        }
      ],
      layout14: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_14', 'includeSystemVariables': true }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'campaigns', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'campaigns', method: campaignFilterService, args: [{ 'type': 'multiple', 'maxSelections': 4, 'minSelections': 2 }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: timeFilterService, args: [{ 'nameFilter': 'F31', 'type': 'year', 'nameContext': 'year', 'labelFilter': 'FILTER_YEAR' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterService, args: [{ 'nameFilter': 'F31', 'type': 'period', 'nameContext': 'period', 'labelFilter': 'FILTER_PERIOD' }], deps: ['country', 'year'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'media', label: 'FILTER_MEDIA', viewLabel: 'FILTER_MEDIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'media', method: mediaFilterService, args: [], deps: ['country'] }
          ]
        }
      ],
      layout15: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_15' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: timeFilterService, args: [{ 'nameFilter': 'F32X', 'type': 'year','typeEvent':'E', 'nameContext': 'year', 'labelFilter': 'FILTER_YEAR' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_EVENT', viewLabel: 'FILTER_EVENT', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterService, args: [{ 'nameFilter': 'F32X', 'type': 'period', 'typeEvent': 'E', 'nameContext': 'period', 'labelFilter': 'FILTER_EVENT' }], deps: ['country', 'year'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'typeMedia', label: 'FILTER_TYPE_MEDIA', viewLabel: 'FILTER_TYPE_MEDIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeMedia', method: typeMediaFilterService, args: [{'nameFilter': 'FMEDIOnew', 'typeFilter': 'FILTER_TYPE_MEDIA'}], deps: ['country'] }
          ]
        }
      ],
      layout16: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_16' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'campaigns', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'campaigns', method: campaignFilterService, args: [{'nameFilter': 'F30X'}], deps: ['country'] }
          ]
        },
        {
          group: { id: 'typeEvent', label: 'FILTER_TYPE_EVENT', viewLabel: 'FILTER_TYPE_EVENT', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeEvent', method: typeEventFilterService, args: [], deps: [] }
          ]
        },
        {
          group: { id: 'events', label: 'FILTER_PERIODS', viewLabel: 'FILTER_PERIODS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'events', method: eventMultipleFilterService, args: [{ 'type': 'multiple', 'maxSelections': 6, 'minSelections': 2, 'historic': false}], deps: ['country','typeEvent'] }
          ]
        },
        {
          group: { id: 'typeMedia', label: 'FILTER_TYPE_MEDIA', viewLabel: 'FILTER_TYPE_MEDIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeMedia', method: typeMediaFilterService, args: [{'nameFilter': 'FMEDIOnewX', 'typeFilter': 'FILTER_TYPE_MEDIA'}], deps: ['country'] }
          ]
        }
      ],
      layout17: [
        {
          group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'country', method: countryFilterService, args: [{ 'layout': 'LAYOUT_17', 'periodId': 'period' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'campaigns', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'campaigns', method: campaignFilterService, args: [{'nameFilter': 'F30X'}], deps: ['country'] }
          ]
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: timeFilterService, args: [{ 'nameFilter': 'F31X', 'type': 'year', 'nameContext': 'year', 'labelFilter':'FILTER_YEAR'}], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterService, args: [{ 'nameFilter': 'F31X', 'type': 'period', 'nameContext':'period', 'labelFilter':'FILTER_PERIOD'}], deps: ['country','year'] }
          ]
        },
        {
          group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'criteria', method: criteriaFilterService, args: [], deps: ['country'] }
          ]
        },
        {
          group: { id: 'typeMedia', label: 'FILTER_TYPE_MEDIA', viewLabel: 'FILTER_TYPE_MEDIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeMedia', method: typeMediaFilterService, args: [{'nameFilter': 'FMEDIOnew', 'typeFilter': 'FILTER_TYPE_MEDIA'}], deps: ['country'] }
          ]
        }
      ],
      layout20: [
        { 
          group: { id:'country', label:'FILTER_COUNTRY', viewLabel:'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources: [
            { eventId: 'country', method: countryMultipleFilterService, args: [{layout:'LAYOUT_20', type:'multiple', minSelections:1, maxSelections:8, nameFilter:'F5'}], deps:['country'] }
          ] 
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [{nameFilter:'FWAVE', type:'year'}], deps: ['country'] } 
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [{nameFilter:'FWAVE', type:'period'}], deps: ['year', 'country'] } 
          ]
        },
        { 
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources: [
            { eventId: 'market', method: marketFilterService, args: [{ nameFilter: 'F23X' }], deps: ['country'] }
          ] 
        },
        { 
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [{ 'type':'single', nameFilter: 'F23X' }], deps: ['market','country'] }
          ] 
        },
        { 
          group:{ id:'criteria', label:'FILTER_CRITERIA', viewLabel:'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources:[
            { eventId:'criteria', method: criteriaFilterService, args:[{nameFilter:'CRITERIA'}], deps:['country']}
          ] 
        }
      ],
      layout21: [
          {
              group: { id: 'country', label: 'FILTER_COUNTRY', viewLabel: 'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'country', method: countryMultipleFilterService, args: [{ 'layout': 'LAYOUT_21', type:'multiple', minSelections:1, maxSelections:8 }], deps: ['country'] }
              ]
          },
          {
              group: { id: 'time', label: 'FILTER_TIME', viewLabel: 'FILTER_TIME', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'granularity', method: timeFilterCountryService, args: [{ nameFilter: 'FWAVE2', type: 'granularity', nameContext: 'Time', labelFilter: 'Year', viewLabelFilter: 'FILTER_TIME' }], deps: ['country'] }
              ]
          },
          {
              group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'period', method: timeFilterCountryService, args: [{ nameFilter: 'FWAVE2', type: 'period', nameContext: 'Period', labelFilter: 'Period', viewLabelFilter: 'FILTER_PERIOD' }], deps: ['country', 'granularity'] }
              ]
          },
          {
              group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'market', method: marketFilterService, args: [{ nameFilter: 'F23X' }], deps: ['country'] }
              ]
          },
          {
              group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'brand', method: brandFilterService, args: [{ 'type':'single', nameFilter: 'F23X' }], deps: ['market','country'] }
              ]
          },
          {
              group: { id: 'criteria', label: 'FILTER_CRITERIA', viewLabel: 'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'criteria', method: criteriaFilterService, args: [{nameFilter:'CRITERIA'}], deps: ['country'] }
              ]
          },
          {
              group: { id: 'metric', label: 'FILTER_FUNNEL', viewLabel: 'FILTER_FUNNEL', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
              sources: [
                  { eventId: 'metric', method: metricFilterService, args: [{nameFilter:'F29X', labelFilter: 'Funnel / Image', viewLabelFilter: 'FILTER_FUNNEL'}], deps: ['country','market'] }
              ]
          }
      ],
      layout22: [
        { 
          group: { id:'country', label:'FILTER_COUNTRY', viewLabel:'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources: [
            { eventId: 'country', method: countryMultipleFilterService, args: [{layout:'LAYOUT_22', type:'multiple', minSelections:1, maxSelections:8, nameFilter:'F5'}], deps:['country'] }
          ] 
        },
        {
          group: { id: 'year', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'year', method: yearFilterService, args: [{nameFilter:'FWAVEI', type:'year'}], deps: ['country'] } 
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: periodFilterService, args: [{nameFilter:'FWAVEI', type:'period'}], deps: ['year', 'country'] } 
          ]
        },
        { 
          group: { id: 'market', label: 'FILTER_MARKET', viewLabel: 'FILTER_MARKET', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources: [
            { eventId: 'market', method: marketFilterService, args: [{nameFilter:'F23X'}], deps: ['country'] }
          ] 
        },
        { 
          group: { id: 'brand', label: 'FILTER_BRAND', viewLabel: 'FILTER_BRAND', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources: [
            { eventId: 'brand', method: brandFilterService, args: [{maxSelections: 1, minSelections: 1, nameFilter:'F23X'}], deps: ['market','country'] }
          ] 
        },
        { 
          group:{ id:'criteria', label:'FILTER_CRITERIA', viewLabel:'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo}, 
          sources:[
            { eventId:'criteria', method: criteriaFilterService, args:[{nameFilter:'CRITERIA'}], deps:['country']}
          ] 
        }

      ],
      layout23: [
        {
          group: { id:'country', label:'FILTER_COUNTRY', viewLabel:'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo},
          sources: [
            { eventId: 'country', method: countryMultipleFilterService, args: [{layout:'LAYOUT_23', type:'multiple', minSelections:1, maxSelections:8, nameFilter:'F5'}], deps:['country'] }
          ]
        },
        {
          group: { id: 'time', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'granularity', method: timeFilterCountryService, args: [{ nameFilter: 'FWAVE4', type: 'granularity', nameContext: 'Time', labelFilter: 'Year', viewLabelFilter: 'FILTER_YEAR' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterCountryService, args: [{ nameFilter: 'FWAVE4', type: 'period', nameContext: 'Period', labelFilter: 'Period', viewLabelFilter: 'FILTER_PERIOD' }], deps: ['country', 'granularity'] }
          ]
        },
        {
          group: { id: 'brands', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brands', method: campaignFilterService, args: [{ nameFilter: 'FCAMPA', type: 'single' }], deps: ['country'] }
          ]
        },
        {
          group:{ id:'criteria', label:'FILTER_CRITERIA', viewLabel:'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo},
          sources:[
            { eventId:'criteria', method: criteriaFilterService, args:[{nameFilter:'CRITERIA'}], deps:['country']}
          ]
        },
        {
          group: { id: 'typeMedia', label: 'FILTER_TYPE_MEDIA', viewLabel: 'FILTER_TYPE_MEDIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeMedia', method: typeMediaFilterService, args: [{'nameFilter': 'FMEDIOnewX', 'typeFilter': 'FILTER_TYPE_MEDIA'}], deps: ['country'] }
          ]
        }
      ],
      layout24: [
        {
          group: { id:'country', label:'FILTER_COUNTRY', viewLabel:'FILTER_COUNTRY', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo},
          sources: [
            { eventId: 'country', method: countryMultipleFilterService, args: [{layout:'LAYOUT_24', type:'multiple', minSelections:1, maxSelections:8, nameFilter:'F5'}], deps:['country'] }
          ]
        },
        {
          group: { id: 'time', label: 'FILTER_YEAR', viewLabel: 'FILTER_YEAR', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'granularity', method: timeFilterCountryService, args: [{ nameFilter: 'FWAVE4', type: 'granularity', nameContext: 'Time', labelFilter: 'Year', viewLabelFilter: 'FILTER_YEAR' }], deps: ['country'] }
          ]
        },
        {
          group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'period', method: timeFilterCountryService, args: [{ nameFilter: 'FWAVE4', type: 'period', nameContext: 'Period', labelFilter: 'Period', viewLabelFilter: 'FILTER_PERIOD' }], deps: ['country', 'granularity'] }
          ]
        },
        {
          group: { id: 'brands', label: 'FILTER_CAMPAIGNS', viewLabel: 'FILTER_CAMPAIGNS', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'brands', method: campaignFilterService, args: [{ nameFilter: 'FCAMPA', type: 'single' }], deps: ['country'] }
          ]
        },
        {
          group:{ id:'criteria', label:'FILTER_CRITERIA', viewLabel:'FILTER_CRITERIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo},
          sources:[
            { eventId:'criteria', method: criteriaFilterService, args:[{nameFilter:'CRITERIA'}], deps:['country']}
          ]
        },
        {
          group: { id: 'typeMedia', label: 'FILTER_TYPE_MEDIA', viewLabel: 'FILTER_TYPE_MEDIA', setSelection: filterSelectionsService.generateSelections, setFilterInfo: filterSelectionsService.generateFilterInfo },
          sources: [
            { eventId: 'typeMedia', method: typeMediaFilterService, args: [{'nameFilter': 'FMEDIOnewX', 'typeFilter': 'FILTER_TYPE_MEDIA'}], deps: ['country'] }
          ]
        }
      ]
    };

    return service;

    /** private function */

    function getFilterDefinition(id) {
      return configs[id];
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('filterSelectionsService', filterSelectionsService);

    filterSelectionsService.$inject = [];
    function filterSelectionsService() {
        var service = {
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };
        
        return service;

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected;
                    if(item.type === 'multiple') {
                        nodeSelected = generateMultipleSelection(item);
                     }
                    else {
                        nodeSelected = generateSingleSelection(item);
                    } 
                    if(nodeSelected) {aggr.push(nodeSelected);}
                    return aggr;
                },[]);
    
                data.selection = selection;
                return data;
        }
        
        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }


        function generateSingleSelection(item) {
            var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                nodeSelected.eventName = item.eventId;
                nodeSelected.hidePill = item.hidePill;
            return nodeSelected;
        }

        function generateMultipleSelection(item) {
            var nodeSelected = {};

            if (item.selectedNode) {
                nodeSelected.id = [].concat(item.selectedNode);  
                //Multiple options and grouped items
                if(item && item.groupedCombo){
                    nodeSelected.text = _.join(
                        _.chain(nodeSelected.id).reduce(function (aggr, nodeSelectedId) {
                            var itemFind = _.chain(item.datos).flatMap('children').find({ 'id': nodeSelectedId }).value();
                            if (itemFind) {
                                aggr.push(itemFind.text);
                            }
                            return aggr;
                        }, []).value(), ', ');  
                }
                else{
                    nodeSelected.text = _.join(
                        _.chain(nodeSelected.id).reduce(function (aggr, nodeSelectedId) {
                            var itemFind = _.chain(item.datos).find({ 'id': nodeSelectedId }).value();
                            if (itemFind) {
                                aggr.push(itemFind.text);
                            }
                            return aggr;
                        }, []).value(), ', ');  
                }
                
            } else {
                return null;
            }
            nodeSelected.label = item.label;
            nodeSelected.viewLabel = item.viewLabel;
            nodeSelected.eventId = item.eventId;
            nodeSelected.eventName = item.eventId;
            nodeSelected.hidePill = item.hidePill;
            return nodeSelected;
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app')
        .factory('eventMultipleFilterService', eventMultipleFilterService);

    /** @ngInject */
    function eventMultipleFilterService(stateManagerService, $q) {
        var service = {
            getFilter: getFilter,
            getEvents: getEvents,
            changeListener: function () { alert('events'); }
        };

        var context;
        var nameFilterSelected;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getEvents(options);
        }

        function getEvents(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            
            var typeEventSelected = context && context.typeEvent;
            if (typeEventSelected === 'E') {
                nameFilterSelected = options && options.historic ? 'F32' : 'F32X';
            }
            else {
              nameFilterSelected = options && options.historic ? 'F31' : 'F31X';
            }
            // var nameFilterSelected = typeEventSelected === 'E' ? 'F32' : 'F31';
            data = _.chain(data).find({ 'name': options && options.nameFilter || nameFilterSelected })
                        .result('content')
                        .find({ 'id': typeEventSelected })
                        .result('children')
                        .value();

            return {
                type: options && options.type,
                name: 'events',
                label: 'events',
                viewLabel: 'FILTER_PERIODS',
                datos: data,
                selectedNode: this && this.notPreselected && !context.events ? null : createPreselections(data, context.events, options),
                maxSelections: options && options.type === 'multiple' ? options && options.maxSelections : 0,
                minSelections: options && options.type === 'multiple' ? options && options.minSelections : 0,
                groupedCombo: true
            };
        }

        function createPreselections(data, preselection, options) {
            var lastItem;
            preselection = preselection || options.preselection;
            if (preselection) {
                context.events = _.chain(data).flatMap('children').reduce(function (aggr, item) {
                    if (_.includes(preselection, item && item.id)) {
                        aggr.push(item);
                    }

                    return aggr;
                }, []).map('id').value();

                if (context.events && context.events.length === 0) {
                    context.events = _.chain(data).flatMap('children').take( options && options.maxSelections).map('id').value();
                }
                return context.events;
            }
            else {
                lastItem = _.chain(data).flatMap('children').take( options && options.maxSelections).map('id').value();
                context.events = lastItem;
                return lastItem;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('criteriaFilterService', criteriaFilterService);

    /** @ngInject */
    function criteriaFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getCriteria:getCriteria,
            changeListener:function() {alert('countries');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getCriteria(options);
        }

        function getCriteria(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, _options) {
            data =  data = _.chain(data).find({'name':'CRITERIA'}).result('content').value();

            return {
                type:'select2',
                name: 'Criteria',
                label: 'Criteria',
                viewLabel: 'FILTER_CRITERIA',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.criteria? null :createPreselections(data, context.criteria),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                if(_.chain(data).find({'id':preselection}).value()){
                    context.criteria = preselection;
                    return preselection;
                }
                context.criteria = _.chain(data).first().result('id').value();
                return _.chain(data).first().result('id').value();
            }

            lastItem = _.chain(data).first().result('id').value();
            context.criteria = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('countryMultipleFilterService', countryMultipleFilterService);

    /** @ngInject */
    function countryMultipleFilterService(stateManagerService, $http, userHelperService, $q, filterHelperService) {
        var service = {
            getFilter: getFilter,
            getCountries:getCountries,
            changeListener:function() {alert('country');}
        };

        var context;
        
        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getCountries(options);
        }

        function getCountries(options) {
            var user = userHelperService.getUser();
            
            // --- INICIO DE LA CORRECCIÓN ---
            var initialCountry = context.country || 
                                filterHelperService.getCountrySelected() || 
                                (user && user.selectionMap && user.selectionMap.country);
            
            // 4. Nos aseguramos de que el valor para el parámetro $country$ sea SIEMPRE un string.
            //    Tomamos el primero del array efectivo (o el string si no es un array).
            // var countryParamValue = _.isArray(effectiveSelection) ? _.first(effectiveSelection) : effectiveSelection;
            var countryParamValue = _.isArray(initialCountry) ? _.first(initialCountry) : initialCountry;

            
            // --- FIN DE LA CORRECCIÓN ---

            var params = {
                layout:options && options.layout,
                parameters:{
                    // 5. Usamos el valor (string) que acabamos de asegurar.
                    //    Esto evita enviar 'undefined' y previene el error 400.
                    "$country$":  countryParamValue,
                    "COUNTRY": _.concat([], userHelperService.getCountry())
                }
            };
            if (options && angular.isDefined(options.includeSystemVariables)){
                params['includeSystemVariables'] = options && options.includeSystemVariables || false;
            }

            
            return $http({
                method: 'POST',
                url: './api/crosstab-engine-filters',
                data: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)]) 
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        // ... (transformData no cambia) ...
        function transformData(data, _options) {
            var options = this; // Recuperamos las opciones
            
            stateManagerService.setState('filterLayout', data);
            data = _.chain(data).find({'name':'F5'}).result('content').value();
            
            var isMultiple = options && options.type === 'multiple'; 

            return {
                type: isMultiple ? 'multiple' : 'select2', 
                name: 'Country',
                label: 'Country',
                viewLabel: 'FILTER_COUNTRY',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: options && options.notPreselected && !context.country? null :createPreselections(data, context.country, isMultiple),
                notRemovable: true,
                maxSelections: isMultiple ? options.maxSelections : 0, 
                minSelections: isMultiple ? options.minSelections : 0 
            };
        }

        // ... (createPreselections no cambia, ya es correcto) ...
        function createPreselections(data, preselection, isMultiple) {
            var user = userHelperService.getUser();
            var defaultSelection;
            
            if (preselection) {
                context.country = preselection;
                return preselection;
            }
            
            if (isMultiple) {
                // CAMBIO PRINCIPAL: En lugar de usar minSelections (que es 2),
                // establecemos el número por defecto en 8
                var count = 8; // <-- Cambiado de minSelections a 8
                
                var userSelection = user && user.selectionMap && user.selectionMap.country;
                
                // Si el usuario tiene una selección previa con al menos 8 países, la usamos
                if(userSelection && userSelection.length >= count){
                    defaultSelection = userSelection;
                } else {
                    // Si no, tomamos los primeros 8 países disponibles de los datos
                    defaultSelection = _.chain(data).take(count).map('id').value();
                }

                if (_.isEmpty(defaultSelection)) {
                    return null;
                }
                
                context.country = defaultSelection;
                return defaultSelection;

            } else {
                defaultSelection = context.country || filterHelperService.getCountrySelected() || user && user.selectionMap && user.selectionMap.country || _.chain(data).first().result('id').value();
                
                context.country = defaultSelection;
                return defaultSelection;
            }
        }    
}
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('countryFilterService', countryFilterService);

    /** @ngInject */
    function countryFilterService(stateManagerService, $http, userHelperService, $q, filterHelperService) {
        var service = {
            getFilter: getFilter,
            getCountries:getCountries,
            changeListener:function() {alert('country');}
        };

        var context;
        
        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getCountries(options);
        }

        function getCountries(options) {
            var user = userHelperService.getUser();
            
            // Obtener el país seleccionado (puede ser un string o un array del layout20)
            var selectedCountry = context.country || 
                                 filterHelperService.getCountrySelected() || 
                                 (user && user.selectionMap && user.selectionMap.country);
            
            // CRÍTICO: Asegurar que SIEMPRE sea un string (tomar el primero si es array)
            var countryParam = _.isArray(selectedCountry) ? _.first(selectedCountry) : selectedCountry;
            
            var params = {
                layout: options && options.layout,
                parameters: {
                    "$country$": countryParam, // Siempre un string
                    "COUNTRY": _.concat([], userHelperService.getCountry())
                }
            };
            
            if (options && angular.isDefined(options.includeSystemVariables)){
                params['includeSystemVariables'] = options && options.includeSystemVariables || false;
            }

            return $http({
                method: 'POST',
                url: './api/crosstab-engine-filters',
                data: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            })
            .catch(function(){
                return $q.when(null);
            });
            
            return req1;
        }

        function transformData(data, _options) {
            stateManagerService.setState('filterLayout', data);
            data = _.chain(data).find({'name':'F5'}).result('content').value();
            
            return {
                type:'select2',
                name: 'Country',
                label: 'Country',
                viewLabel: 'FILTER_COUNTRY',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.country? null :createPreselections(data, context.country),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem, user = userHelperService.getUser();

            if (preselection) {
                // Si preselection es un array (viene del layout20), tomar el primero
                var countryValue = _.isArray(preselection) ? _.first(preselection) : preselection;
                context.country = countryValue;
                return countryValue;
            }

            var selectedCountry = context.country || 
                                 filterHelperService.getCountrySelected() || 
                                 (user && user.selectionMap && user.selectionMap.country) || 
                                 _.chain(data).first().result('id').value();
            
            // Asegurar que sea un string
            lastItem = _.isArray(selectedCountry) ? _.first(selectedCountry) : selectedCountry;
            context.country = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('contextVariableService', contextVariableService);

    /** @ngInject */
    function contextVariableService(stateManagerService, $http, userHelperService, $q, filterHelperService) {
        var service = {
            getFilter: getFilter,
            getContextVariables: getContextVariables
        };

        var context;

        return service;
     

        function getFilter(_eventId, options) {
            context = this;
            return getContextVariables(options);
        }

        function getContextVariables(options) {
            var user = userHelperService.getUser();
            var filterLayout = stateManagerService.getState('filterLayout');

            // 1. Retrieve Year and Target defaults from filterLayout if available
            // Logic copied from countryFilterService to handle default extraction
            var yearContent = _.chain(filterLayout).find(function(f) { 
                return f.name === 'F22' || f.name === 'F31' || f.name === 'F31X' || f.name === 'F32X'; 
            }).result('content').value();

            var defaultYear;
            if (yearContent) {
                var mNode = _.find(yearContent, {id: 'M'});
                if (mNode && mNode.children) {
                    defaultYear = _.chain(mNode.children).first().result('id').value();
                } else {
                    defaultYear = _.chain(yearContent).first().result('id').value();
                }
            }

            var targetContent = _.chain(filterLayout).find({'name': 'CRITERIA'}).result('content').value();
            var defaultTarget = options && options.allTargets 
                ? _.chain(targetContent).map(function(item) { return item.id; }).value() 
                : _.chain(targetContent).first().result('id').value();

            // 2. Determine Effective Values
            var yearVal = (context && context.period) || (context && context.events) || defaultYear;
            var targetVal = (context && context.criteria) || defaultTarget;
            
            if (options && options.filterPeriodInfo.fixedPeriods) {

                var periodGroupChildren = _.chain(filterLayout).find({ 'name': options.filterPeriodInfo.nameFilter }).result('content').find({ 'id': 'M' }).result('children').value();
                var elementsF31XAll = _.flatMap(periodGroupChildren, 'children');
                if (!elementsF31XAll || elementsF31XAll.length === 0) {
                    elementsF31XAll = periodGroupChildren || [];
                }
                var indexPeriodSelected =  context && context.period ? _.findIndex(elementsF31XAll, { 'id': context.period  }) : 0;                //Periodos hacia atras máximos
                
                var elementsF31XNext = [].concat(_.chain(elementsF31XAll).slice(indexPeriodSelected, indexPeriodSelected + options.filterPeriodInfo.fixedPeriods).map('id').value());
                var extractedYear = extractYearFromPeriodId(elementsF31XNext);
            } else {
                //Si yearVal empieza por MA llamamos a la función extractYearFromPeriodId
                if (yearVal &&!Array.isArray(yearVal) && (yearVal.startsWith('MA') || yearVal.startsWith('EA'))) {
                    var extractedYear = extractYearFromYearId(yearVal);
                } else {
                    var extractedYear = extractYearFromPeriodId(yearVal);
                }
            }
          



            var contextParams = {
                "$country$": _.concat([], (context && context.country) || filterHelperService.getCountrySelected() || (user && user.selectionMap && user.selectionMap.country)),
                "$year$": extractedYear && extractedYear.length ? extractedYear : ["25"],
                "$target$": targetVal ? (_.isArray(targetVal) ? targetVal : [targetVal]) : []
            };

            return $http({
                method: 'POST',
                url: './api/crosstab-engine-context-variables',
                data: contextParams
            }).then(function(response) {
                var responseData = response.data;
                var systemVariablesContent = [];

                if (responseData && responseData.results && responseData.results.length > 0) {
                     // Iteramos sobre todos los resultados, no solo el primero
                     _.forEach(responseData.results, function(resultItem) {
                         var resultVariables = [];
                        if (resultItem && resultItem.contextVariables) {
                            _.forEach(resultItem.contextVariables, function(value, key) {
                                resultVariables.push({
                                    name: key,
                                    value: typeof value === 'number' ? Math.round(value) : value
                                });
                            });
                        }
                         // Añadimos el objeto con variables y parámetros
                         systemVariablesContent.push({
                             parameters: resultItem.parameters,
                             variables: resultVariables
                         });
                     });
                }

                // We structure this as a single "filter" item named SYSTEM::REQUESTVARIABLES
                // content será un array de objetos {parameters: ..., variables: [...]}
                var resultData = [];
                if (systemVariablesContent.length > 0) {
                    var systemFilter = {
                        name: 'SYSTEM::REQUESTVARIABLES',
                        content: systemVariablesContent,
                        id: 'SYSTEM::REQUESTVARIABLES', 
                        text: 'SYSTEM::REQUESTVARIABLES',
                        hide: true
                    };
                    resultData.push(systemFilter);

                    // Update filterLayout state to include this new "filter"
                    if (filterLayout) {
                        var existingIndex = _.findIndex(filterLayout, { name: 'SYSTEM::REQUESTVARIABLES' });
                        if (existingIndex > -1) {
                            filterLayout[existingIndex] = systemFilter;
                        } else {
                            filterLayout.push(systemFilter);
                        }
                        stateManagerService.setState('filterLayout', filterLayout);
                    }
                }
                
                return {
                    data: {
                        type: 'hidden',
                        name: 'SYSTEM::REQUESTVARIABLES',
                        hide: true,
                        data: resultData
                    }
                };
            });
        }

        function extractYearFromPeriodId(periodId) {
            if (Array.isArray(periodId)) {
                var uniqueYears = [];
                for (var i = 0; i <= periodId.length - 1; i++) {
                    var m = String(periodId[i] || '').match(/\d{2}/);                       
                    if (m && !uniqueYears.includes(m[0])) {
                        uniqueYears.push(m[0]);
                    }
                }
                return uniqueYears;
            } else {
                var m = String(periodId || '').match(/\d{2}/);
                return m ? [m[0]] : [];
            }
        }



        function extractYearFromYearId(yearId) {
            if (Array.isArray(yearId)) {
                var uniqueYears = [];
                for (var i = 0; i <= yearId.length - 1; i++) {
                    var m = String(yearId || '').match(/(\d{2})$/);                   
                    if (m && !uniqueYears.includes(m[0])) {
                        uniqueYears.push(m[0]);
                    }
                }
                return uniqueYears;
            } else {
                var m = String(yearId || '').match(/(\d{2})$/);
                return m ? [m[0]] : [];
            }           
           
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app')
        .factory('campaignFilterService', campaignFilterService);

    /** @ngInject */
    function campaignFilterService(stateManagerService, $q) {
        var service = {
            getFilter: getFilter,
            getCampaings: getCampaings,
            changeListener: function () { alert('campaigns'); }
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId, options) {
            context = this;
            return getCampaings(options);
        }

        function getCampaings(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when({ data: transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            data = _.chain(data).find({ 'name': options && options.nameFilter || 'F30' }).result('content').value();

            return {
                type: options && options.type === 'multiple' ? 'multiple' : 'select2',
                name: 'campaigns',
                label: 'campaigns',
                viewLabel: options && options.labelFilter || 'FILTER_CAMPAIGNS',
                datos: _.map(data, function (item) {
                    var textSplited = item && item.text && item.text.split('-');
                    return {
                        id: item && item.id,
                        text: textSplited && textSplited[0]
                    };
                }),
                selectedNode: this && this.notPreselected && !context.campaigns ? null : createPreselections(data, context.campaigns, options),
                notRemovable: true,
                maxSelections: options && options.type === 'multiple' ? options && options.maxSelections : 0,
                minSelections: options && options.type === 'multiple' ? options && options.minSelections : 0
            };
        }

        function createPreselections(data, preselection, options) {
            var lastItem;
            if (preselection) {
                if (options && options.type === 'multiple') {
                    context.campaigns = _.chain(data).reduce(function (aggr, item) {
                        if (_.includes(preselection, item && item.id)) {
                            aggr.push(item);
                        }

                        return aggr;
                    }, []).map('id').value();
                    if (context.campaigns && context.campaigns.length === 0) {
                        context.campaigns = _.chain(data).take(4).map('id').value();
                    }
                    return context.campaigns;
                }
                else {
                    if (_.chain(data).find({ 'id': preselection }).value()) {
                        context.campaigns = preselection;
                        return preselection;
                    }
                    context.campaigns = _.chain(data).first().result('id').value();
                    return _.chain(data).first().result('id').value();
                }

            }
            if (options && options.type === 'multiple') {
                lastItem = _.chain(data).take(4).map('id').value();
            }
            else {
                lastItem = _.chain(data).first().result('id').value();
            }

            context.campaigns = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('brandFilterService', brandFilterService);

    /** @ngInject */
    function brandFilterService(stateManagerService,$q) {
        var service = {
            getFilter: getFilter,
            getBrands:getBrands,
            changeListener:function() {alert('countries');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(_eventId,options) {
            context = this;
            return getBrands(options);
        }

        function getBrands(options) {
            var filtersLayout = stateManagerService.getState('filterLayout');
            return $q.when( {data:transformData(filtersLayout, options) });
        }

        function transformData(data, options) {
            var filterName = options && options.nameFilter || 'F23'; // Valor por defecto F23
            data = _.chain(data).find({'name': filterName}).result('content').find({'id':context && context.market}).result('children').value();

            return {
                type: options && options.type === 'multiple' ? 'multiple' : 'select2',
                name: 'Brand',
                label: 'Brand',
                viewLabel: 'FILTER_BRAND',
                datos: _.map(data, function (item) {
                    return {
                        id: item && item.id,
                        text: item && item.text
                    };
                }),
                selectedNode: this && this.notPreselected && !context.brand ? null : createPreselections(data, context.brand || (options && options.preselection), options),
                notRemovable: true,
                maxSelections: options && options.type === 'multiple' ? options && options.maxSelections :  0,
                minSelections: options && options.type === 'multiple' ? options && options.minSelections :  0
            };
        }

        function createPreselections(data, preselection, options) {
            var lastItem;
            if (preselection) {
                if(options && options.type === 'multiple'){
                        context.brand = _.chain(data).reduce(function(aggr,item){
                            if(_.includes(preselection, item && item.id)){
                                aggr.push(item);
                            }
                            
                            return aggr;
                        },[]).map('id').value();
                        if (context.brand && context.brand.length === 0){
                            context.brand = _.chain(data).take(4).map('id').value();
                        }
                        return context.brand;
                }
                else{
                    if (_.chain(data).find({ 'id': preselection }).value()) {
                        context.brand = preselection;
                        return preselection;
                    }
                    context.brand = _.chain(data).first().result('id').value();
                    return _.chain(data).first().result('id').value();
                }
                
            }
            if(options && options.type === 'multiple'){
                lastItem = _.chain(data).take(4).map('id').value();
            }
            else{
                lastItem = _.chain(data).first().result('id').value();
            }
            
            context.brand = lastItem;
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('windowResizeManagerService', windowResizeManagerService);

    windowResizeManagerService.$inject = ['$window','lodash','$rootScope','$log'];
    function windowResizeManagerService($window,lodash,$rootScope,$log) {
        var size = [];
        var service = {
            startListening: startListening,
            getWindowSize: getWindowSize
        };

        return service;

        /** private methods */
        function getWindowSize() {
            return size;
        }

        function onResize(_event) {
            size[0] = $window.innerWidth;
            size[1] = $window.innerHeight;
            $log.log('resize',size);
            $rootScope.$emit('window.resize',{size:size});
        }

        function startListening() {
            size[0] = $window.innerWidth;
            size[1] = $window.innerHeight;

            angular.element($window).bind('resize', lodash.debounce(onResize,600));
            $log.log(size);
            return size;
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('widgetLoaderService', widgetLoaderService);

    widgetLoaderService.$inject = ['$http', '$q', 'propertybagHandlerService', 'errorHandlerService', 'stateManagerService', 'configurationLoaderService','globalHelpersService'];
    function widgetLoaderService($http, $q, _propertybagHandlerService, errorHandlerService, _stateManagerService, configurationLoaderService,globalHelpersService) {
        var service = {
            getData: getData
        };

        return service;

        // private methods

        // main entrance point
        function getData(stationSelected, programSelected, waveSelected) {
            return $q.all([getWidgetDefinition(programSelected), $q.when(stationSelected), $q.when(programSelected), $q.when(waveSelected)])
                .then(spread)
                .then(postOperations)
                .then(resolveBodyRequest)
                .catch(errorHandlerService.callbackError);

        }

        // get widget configuration
        function getWidgetDefinition(programSelected) {
            var fileNameExt = programSelected && programSelected.id !== 'TOTAL' ? programSelected.id : '';
            var fileName = 'widgetDefinitionAimc' + fileNameExt + '.json';
            return $http({
                method: 'GET',
                url: './data/' + fileName,
                params: {
                    cacheFix: new Date()
                }
            })
                .then(function (data) {
                    return data && data.data;
                });
        }

        function postOperations(data) {
            data.widgetDefinition = _
                .chain(data.widgetDefinition)
                .map(function (item) {
                    //Station selected
                    if (item.competence) {
                        item.stationSelected = globalHelpersService.getCompetence(configurationLoaderService.getConfig().competences,data.stationSelected.competence);
                    } else {
                        item.stationSelected = data.stationSelected;
                    }

                    //Program selected
                    item.programSelected = data.programSelected;
                    
                    //Needed to make the api reques
                    item.project = data.stationSelected.idMiddle;
                    item.program = data.programSelected && data.programSelected.id !== 'TOTAL' ? data.programSelected.id : null;
                    item.wave = data.waveSelected.wave;

                    return item;
                })
                .value();

            return data;
        }

        // get propertyBag
        // function getPropertyBag() {
        //     return propertybagHandlerService.getData('widgetConfig')
        //         .then(function (data) {
        //             return data && data.data;
        //         });
        // }

        function spread(data) {
            return _.zipObject(['widgetDefinition', 'stationSelected', 'programSelected', 'waveSelected'], data);
        }

        // add node information to payload
        // function setNodes(data) {
        //     var settingsNodes;

        //     settingsNodes = _.chain(stateManagerService.getState('userInfo'))
        //         .extend()
        //         .reduce(nodesReducer, {})
        //         .value();

        //     data.widgetDefinition = _.chain(data.widgetDefinition)
        //         .map(function (item) {

        //             if (!settingsNodes[item.project.toUpperCase()]) {
        //                 return item;
        //             }

        //             if (data.propertyBag) {
        //                 item.attributes.visible = _.isUndefined(data.propertyBag[item.id]) ? item.attributes.visible : data.propertyBag[item.id];
        //             }

        //             // if widgetdefinition has concept level (HQ/COUNTRY) verify charge property on nodes in
        //             // settings. Only if both are the same add node definition to the widget
        //             if (item.level) {
        //                 if (item.level.toUpperCase() === settingsNodes[item.project.toUpperCase()].charge.toUpperCase()) {
        //                     item.nodeId = settingsNodes[item.project.toUpperCase()].id;
        //                     item.attributes.node = settingsNodes[item.project.toUpperCase()].code;
        //                 }
        //                 return item;
        //             }


        //             // if no level defined add node definition
        //             item.nodeId = settingsNodes[item.project.toUpperCase()].id;
        //             item.attributes.node = settingsNodes[item.project.toUpperCase()].externalID;

        //             return item;
        //         })
        //         .value();

        //     return data;
        // }

        // function nodesReducer(aggr, item, index) {

        //     if (!item.selectedNode) {
        //         throw ('widgetLoaderService::nodesReducer -> No selected Node');
        //     }

        //     // get all node info
        //     var info = _.chain(item.nodes)
        //         .find({ externalID: item.selectedNode })
        //         .value();

        //     if (!info) {
        //         throw ('widgetLoaderService::nodesReducer -> Selectedid not found in nodes');
        //     }

        //     // add HQ or COUNTRY
        //     info.charge = _.chain(configurationLoaderService.getConfig().HQLevels)
        //         .intersection([info.level.toUpperCase()])
        //         .some()
        //         .value() ?
        //         'HQ' :
        //         'COUNTRY';

        //     // add project
        //     aggr[item.project] = info;

        //     return aggr;
        // }

        //TODO --> FILTRADO VISIBILIDAD
        function resolveBodyRequest(data) {
            return _.chain(data.widgetDefinition)
                .filter(function (_item) {
                    return true;
                    //return item.nodeId && item.widgetAvailable && item.attributes.visible;
                })
                .value();
        }

        // function resolveSettingsData(data) {
        //     return _.chain(data.widgetDefinition)
        //         .filter(function (item) {
        //             return item.nodeId && item.widgetAvailable;
        //         })
        //         .value();
        // }

    }
})();
(function() {
'use strict';

    angular
        .module('app')
        .factory('userHelperService', userHelperService);

     /** @ngInject */
    function userHelperService(storageService) {
        var service = {
            getToken: getToken,
            getUserLanguage: getUserLanguage,
            getCountry: getCountry,
            getUser: getUser
        };
        
        return service;

        ////////////////
        /**
         * Getting the user context
         */
        function getToken() {
            return service.getUser().value;
        }   

        /**
         * Gettint the user lenguage
         */
        function getUserLanguage() {
            return service.getUser().profile.language;
        }

        function getUser(){
            return storageService.retrieve('user');
        }

        function getCountry(){
            return _.chain(service.getUser()).result('userProperties').find({ 'name': 'country' }).result('value').split(',').value();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('translationManagerService', translationManagerService);

    /* @ngInject */
    function translationManagerService() {
        var modules;
        
        var service = {
            getModules: getModules
        };

        modules = [
            { project: '', module: '' }
        ];

        return service;

        /* private methods */

        function getModules() { 
            return modules;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('taskHelper', taskHelper);

    /* ngInject */
    function taskHelper(
        configurationLoaderService, $q, $http,
        exportService, userHelperService, $log
    ) {
        var taskConfig = configurationLoaderService.getConfig().views.taskHelper;
        //Interval que realizará peticiones cada 'INTERVAL_TIME' hasta que 
        //todas las tareas estén marcada como hechas

        //Estados de las tareas
        var tasksState = taskConfig.tasksState;
        //Tipos de tareas. [Los params tienen que ser los mismos que nos devuelve la petición]
        var tasksTypes = taskConfig.tasksTypes;

        var downloadsError = 0;
        var descargas = 0;
        var isExecutingTaskList = false;
        var service = {
            tasksList: [],
            getTasksList: getTasksList,
            parseTasksList:parseTasksList,
            downloadReport: downloadReport,
            launchTask: launchTask,
            deleteTask: deleteTask
        };

        return service;

        function getTasksList(data) {
            if (isExecutingTaskList) {
                return null;
            }
            var errors = data ? data : null;


            return $http({
                method: 'GET',
                url: './api/tasks',
                params: {
                    $limit:50,
                    downloaded:false,
                    '$sort[createdAt]':1
                }
            })
                .then(function(data){
                    return data && data.data && data.data.data;
                })
                .then(parseTasksList)
                .then(downloadAuto) //Filtramos aquellas tareas que tienen el campo autodescargable a !=true;
                .then(function (data) {
                    service.tasksList = data;
                    if (errors && errors.data && errors.data.response) {
                        service.tasksList.errors = errors.data.response;
                    }
                    return data;
                })
                .catch(function (error) {
                    $log.log('Error obteniendo el listado de TASKS [ ' + error + ' ]');
                    service.tasksList = [];
                })
                .finally(function () {
                });
        }

        //Parseamos el listado de tareas que nos devuelve la petición
        function parseTasksList(data) {
            var auxData = angular.fromJson(data);
            var params, type, typeParams, autoDownload, nfile;

            return _.chain(auxData)
                .filter({ 'downloaded': false })
                .map(function (task) {
                    task.parameters = angular.fromJson(task.parameters);
                    //params = task.parameters.length > 0 ? angular.fromJson(_.find(task.parameters, { name: 'Filter' }).value[0]) : []; //0 porque es donde se almacenan los parámetros
                    params = task.parameters.length > 0 ? angular.fromJson(_.chain(task.parameters).find({ 'name': 'Filter' }).result('value').first().value()) : []; //0 porque es donde se almacenan los parámetros
                    autoDownload = angular.fromJson(_.find(task.parameters, { name: 'AutoDownload' })) ? _.find(task.parameters, { name: 'AutoDownload' }).value[0] : null; //0 porque es donde se almacenan los parámetros
                    nfile = angular.fromJson(_.find(task.parameters, { name: 'NameFileResult' })) ? _.find(task.parameters, { name: 'NameFileResult' }).value[0] : null; //0 porque es donde se almacenan los parámetros
                    type = task.name;
                    typeParams = _.find(tasksTypes, { 'type': type }) ? _.find(tasksTypes, { 'type': type }).params : null;

                    return {
                        id: task.id,
                        autoDownload: autoDownload,
                        nfile: nfile,
                        title: type, //El nombre es la traducción del tipo
                        state: task.state,
                        type: type, //Por ahora el nombre es lo que me está indicando el tipo de alerta
                        params: _.chain(angular.fromJson(params)) //Obtenemos las propiedades de la tarea en formato array de strings
                            .pick(typeParams)
                            .map(function (param) {
                                return param;
                            })
                            .values()
                            .value()
                    };
                })
                .value();
        }

        function downloadAuto(tasks) {
            $log.log('\nTaskHelper.Tasks ---> ', tasks);
            $log.log('TaskHelper.getAutodownloadedTasks ---> ', getAutodownloadedTasks(tasks));
            $log.log('TaskHelper.getNotAutodownloadedTasks ---> ', getNotAutodownloadedTasks(tasks));
            $log.log('TaskHelper.getAutodownloadedTasksNotPrepared ---> ', getAutodownloadedTasksNotPrepared(tasks));

            return PromiseAllDownload(getAutodownloadedTasks(tasks))
                .then(function () {
                    isExecutingTaskList = false;
                    return getNotAutodownloadedTasks(tasks);
                });
        }

        /* Devuelve todas las tareas con el campo autoDownload=true.*/
        function getAutodownloadedTasksNotPrepared(tasks) {
            return _.chain(tasks).filter(function (item) {
                return item.autoDownload === 'true';
            }).value();
        }

        /* Devuelve todas las tareas con el campo autoDownload=true & que esten preparadas para descargar. */
        function getAutodownloadedTasks(tasks) {
            return _.chain(tasks).filter(function (item) {
                return item.autoDownload === 'true' && (item.state === tasksState.done || item.state === tasksState.error);
            }).value();
        }

        /* Devuelve todas las tareas con el campo autoDownload=false*/
        function getNotAutodownloadedTasks(tasks) {
            return _.chain(tasks).filter(function (item) {
                return item.autoDownload !== 'true';
            }).value();
        }

        function PromiseAllDownload(tasks) {
            if (tasks.length > 0) {
                isExecutingTaskList = true;
                return $q.when(downloadSyncReducer(tasks))
                    .then(function () {
                        /*if(downloadsError>0){
                            loggingSrv.log('danger', 'There have been '+downloadsError+' errors.');
                        }*/
                        //loggingSrv.log('danger', '10');
                        $log.log('Nº errores ---> ' + downloadsError);
                        $log.log('Nº descargas ---> ' + descargas);
                        downloadsError = 0;
                    });
            }
            return $q.when(null);

        }

        function downloadSyncReducer(tasks) {
            var deferred = $q.defer();

            _.reduce(tasks, function (aggr, item) {
                return aggr
                    .then(downloadReport.bind(item))
                    .catch(function () {
                        //enviar un mensaje de error
                        downloadsError++;
                        return $q.when({});
                    });
            }, $q.when(null))
                .finally(function () {
                    //loggingSrv.log('danger', '10');
                    deferred.resolve();
                });

            return deferred.promise;
        }

        /**
         * Descargamos el documento generado
         * por la tarea
         */
        function downloadReport(taskId) {
            var _taskId = this.id || taskId;
            var _this = _.chain(this.tasksList).find({ 'id': taskId }).value();
            //var _params = _.chain(this.tasksList).find({ 'id': taskId }).result('params').value();
            $log.log(this || taskId);
            if (this && this.state === tasksState.error) {
                downloadsError++;
                return deleteTask(this.id);
            }
            return exportService.downloadUrl('./jobs/api/jobs/downloadSimpleResult/' + _taskId+'/'+_this.nfile+'.pdf')
            .then(deleteTask(taskId));
        }

        /**
         * Lanzamos una nueva tarea.
         *
         * Filter es la estructura de datos que necesita
         * el JOB para ejecutarse.
         */
        function launchTask(filter, taskType, translatedNameParams, filterStructureParam) {
            //Estructura de datos que va a necesitar el BE (siempre será así).
            //Se crea aquí para que este método sea usado
            //para la generación de cualquiere tarea que se 
            //vaya a necesitar en el futuro. Lo único que varía
            //es el JSON 'filter' que contedrá los parámetros
            //que cada tarea vaya a necesitar.
            //También evitamos que se tenga que hacer un middle solo para esto.
            var filterStructure = filterStructureParam || {
                parametros: [
                    { name: 'Filter', value: [angular.toJson(filter)] },
                    { name: 'Token', value: [userHelperService.getToken()] },
                    { name: 'NameFileResult', value: [] }
                ]
            };
            //Obtenemos el nombre del fichero
            return getFileName(filter, taskType, translatedNameParams)
                //Asignamos el nombre del fichero y se lo pasamos a los
                //parámetros de la primesa
                .then(function (data) {
                    //Obtenemos el nombre
                    var fileName = data;
                    //var fileName = data;
                    //Asignamos el nombre a el 'fileStructure'
                    _.find(filterStructure.parametros, { name: 'NameFileResult' }).value[0] = fileName; //[0]: Siempre habrá un solo elemento en el array
                    //Devolvemos los parámetros que el 'taskPromise' necesita
                    return { taskType: taskType, filterStructure: filterStructure };
                })
                //Lanzamos la tarea
                .then(taskPromise);
        }

        /**
         * Promesa para lanzar la tareas
         */
        function taskPromise(data) {
            return $http({
                method: 'POST',
                url: './api/run-job',
                headers: { 'Content-Type': 'application/json' },
                params: {
                    jobName: data.taskType,
                    body: 'x'
                },
                data: data.filterStructure
            });
        }

        /**
         * Hacemos un borrado lógico de las tareas
         */
        function deleteTask(taskId) {
            return $http({
                method: 'PATCH',
                url: './api/tasks/' + taskId,
                params: {
                },
                data: {
                    downloaded: true
                }
            });
        }

        /**
         * Obtenemos el nombre de fichero de descarga
         */
        function getFileName(_filter, _taskType, _translatedNameParams) {
            return $q.when(_filter && _filter.jobName);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('storageService', storageService);

    storageService.$inject = ['$cookies'];
    function storageService($cookies) {

        /** public methods */
        this.storageContext = null;
        this.save = save;
        this.retrieve = retrieve;
        this.remove = remove;
        this.clear = clear;

        /** private methods */

        function save(property, data) {
            if(sessionStorage){
                sessionStorage.setItem(property, angular.toJson(data));
            }
            else if (localStorage) {
                localStorage.setItem(property, angular.toJson(data));
            } else {
                $cookies.put(property, angular.toJson(data));
            }
        }

        function retrieve(property) {
            var value;
            if(sessionStorage){
                value = sessionStorage.getItem(property);
                if (!value) { return null;}
                return angular.fromJson(value);
            }
            else if (localStorage) {
                value = localStorage.getItem(property);
                if (!value) { return null;}
                return angular.fromJson(value);
            } else {
                value = $cookies.get(property);
                if (!value) { return null;}
                return angular.fromJson(value);
            }
        }

        function remove(property) {
            if(sessionStorage){
                sessionStorage.removeItem(property);
            }
            else if (localStorage) {
                localStorage.removeItem(property);
            } else {
                $cookies.remove(property);
            }
        }

        function clear() {
            var that = this;
            var storage = sessionStorage ? sessionStorage : localStorage;
            var allKeys = _.chain(storage).keys().value();

            _.each(allKeys, function (key) {
                that.remove(key);
            });
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app.core')
        .factory('stateManagerService', stateManagerService);

    //stateManagerService.$inject = [''];
    function stateManagerService() {
        var service = {
            getState:getState,
            setState:setState,
            clear: clear
        };

        var atomicState = {};
        
        return service;

        /** private methods */
        function getState(key) { 
            if (!key) {
                throw('stateManagerService::setState -> No key provided');
            }

            return angular.copy(atomicState[key]); 
        }

        function setState(key,state) {
            var _key,_state;
            // context parameters (state)
            if (this && this.prop) {
                _key = this.prop;
                _state = key;
            } else {
                _key = key;
                _state = state;
            }

            if (!_key) {
                throw('stateManagerService::setState -> No key provided');
            }

            return atomicState[_key] = _state;
        }

        function clear() {
            atomicState = {};
            return atomicState;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('socketService', socketService);

    socketService.$inject = ['$log','$window'];
    function socketService($log, $window) {
        var service = {
            socket:null,
            init:init,
            socketAuthenticate:socketAuthenticate,
            socketLogout:socketLogout
        };

        return service;

        function init(){
            $log.log('Init Socket...');
            service.socket = $window.io();
        }

        function socketAuthenticate(token) {
            service.socket.emit('authenticate', { strategy:'jwt', accessToken:token }, function (_message, _data) { 
                $log.log('Socked authenticate...');  
            });
        }

        function socketLogout(_payload) {
            $log.log('All listeners have been removed from the socket...');  
            service.socket.removeAllListeners();
        }
    }
})();
/*eslint angular/on-watch:0 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('routingService', routingService);

    routingService.$inject = ['$rootScope', '$log', 'storageService', 'userHelperService', 'loginService', '$state', '$window', '$timeout', 'errorHandlerService', '$filter'];
    function routingService($rootScope, $log, storageService, userHelperService, loginService, $state, $window, $timeout, errorHandlerService, $filter) {

        this.registerCallbacks = registerCallbacks;
        this.startTransitionHook = startTransitionHook;
        this.getLastState = getLastState;

        var lastState = null;
            

        /** private methods */

        function registerCallbacks() {
            $rootScope.$on('$stateChangeStart', startTransitionHook);
            $rootScope.$on('$stateChangeSuccess', successTransitionHook);
            $rootScope.$on('$stateChangeError', changeErroTransitionHook);
            $rootScope.$on('$stateNotFound', stateNotFoundTransitionHook);
            $rootScope.$on('core:timeIdleError', onTimeIdleError);
            $rootScope.$on('core:expiredToken', _.throttle( expiredToken, 5000, { 'trailing': false }));
        }

        function startTransitionHook(event, toState, _toParams, fromState, _fromParams) {
            $rootScope.$emit('transition:start');
            
            var urlHash = $window.location.hash.match(/[\?\&]token.*$/);
            var token, tokenInspection;
            var destinyUrl;


            var user, userStored;

            // there are two posibilities:
            // - has a token at the end of the urls -> means it's a loginByToken
            // - has no token at the end of the urls -> it's a refresh or an url change
            if (!urlHash) {
                // has no token, try to retrieve user info from localstorage
                user = userHelperService.getUser();

                // login state is always public...
                if (toState.public || toState.name === 'login') {
                    return;
                }

                if (!user) {
                    // if not auth restore from localstorage
                    userStored = storageService.retrieve('user');
                } else {
                    // if is authenticated then go on
                    return;
                }

                if (userStored) {
                    userHelperService.setUser(userStored);
                    userHelperService.setMomentLocale(userStored.profile.language);
                    // proceed
                } else {
                    // go to login
                    if (fromState.name === 'login') {
                        $rootScope.$emit('transition:end');
                        event.preventDefault();
                        return;
                        // do nothing, let it go...
                    } else {
                        event.preventDefault();
                        $state.go('login');
                    }

                    
                }
            } else {
                event.preventDefault();

                destinyUrl = $window.location.hash.replace(/[\?\&]token.*$/, '');
                tokenInspection = urlHash[0].match(/\=.*$/);

                if (!tokenInspection || tokenInspection.length === 0) {
                    $state.go('login');
                    return;
                }

                token = tokenInspection[0].replace('=', '');

                return loginService.loginFullWorkflowWithToken(token)
                    .then(function () {
                        $timeout(function() {
                            $window.location.replace(destinyUrl);    
                        }, 0);
                        
                    })
                    .catch(function () {
                        $log.error('User invalid');
                        $timeout(function() {
                            $window.location.replace('#/login');    
                            $window.location.reload();
                        }, 0);
                    });
            }
        }
        function successTransitionHook(_event, toState, toParams, fromState, fromParams) {
            $rootScope.$emit('transition:end');
            
            $rootScope.$emit('breadcrumb:toState', { toState: toState, toParams: toParams });
            lastState = { state: fromState, params: fromParams };
            storageService.save('lastState', lastState);
            //$log.warn('Succeded transitioning to:', event, toState, toParams, fromState, fromParams);
        }
        function changeErroTransitionHook(event, toState, toParams, fromState, fromParams, error) {
            $rootScope.$emit('transition:end');
            $log.warn('Error transitioning to:', event, toState, toParams, fromState, fromParams, error);
        }
        function stateNotFoundTransitionHook(event, unfoundState, fromState, fromParams) {
            $rootScope.$emit('transition:end');
            $log.warn('State not found:', event, unfoundState, fromState, fromParams);
        }

        function getLastState() {
            if (!lastState) {
                lastState = storageService.retrieve('lastState');
            }

            if (!lastState || !lastState.state.name) {
                return { state: 'main.cockpit', params: null };
            }

            return lastState;
        }

        function onTimeIdleError() {
            $log.error('TIMED_OUT');
            storageService.clear();  
            $state.go('login');  
            $window.location.reload();       
        }

        function expiredToken() {
            $log.error('TOKEN_EXPIRED');
            //$rootScope.$emit('transition:end');
            storageService.clear();
            $state.go('login');
            errorHandlerService.callbackError($filter('translationWithPrefix')('SESSION_HAS_EXPIRED'));
        }
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('reportPrintService', reportPrintService);

    reportPrintService.$inject = ['userHelperService', 'taskHelper'];
    function reportPrintService(userHelperService, taskHelper) {
        var _self = {
            printReport: printReport
        };

        return _self;

        function printReport(parameters) {
            var filter = parameters;

            var taskType = parameters && parameters.typeReport;
            var filterStructure = {
                parametros: [
                    { name: 'Token', value: [userHelperService.getToken()] },
                    { name: "userId", value: [_.chain(userHelperService.getUser()).result('id').value()] },
                    { name: "Brand", value: [parameters && parameters.brandSelected || ''] },
                    { name: 'Filter', value: [angular.toJson(filter)] },
                    { name: 'NameFileResult', value: [parameters && parameters.nameJob] },
                    { name: 'Type', value: [parameters && parameters.modelTypeReport] }
                ]
            };

            return taskHelper.launchTask(filter, taskType, [], filterStructure);
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('propertybagHandlerService', propertybagHandlerService);

    propertybagHandlerService.$inject = ['loginService', 'configurationLoaderService', '$http', '$q', 'globalHelpersService'];
    function propertybagHandlerService(loginService, configurationLoaderService, $http, $q, globalHelpersService) {
        var service = {
            getData: getData,
            setData: setData,
            restoreDefault:restoreDefault
        };

        return service;

        // private methodes

        function getData(storeName) {
            return $http({
                method: 'GET',
                url: './api/propertiesBag',
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: storeName
                },
                transformResponse: [transformProperties].concat($http.defaults.transformResponse)
            })
                .then(fnAccept)
                .catch(fnError);
        }

        function setData(store, value) {
            return $http({
                method: 'POST',
                url: './api/propertiesBag',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: store
                },
                data: {
                    content:angular.toJson(value)
                },
                transformRequest: globalHelpersService.httpPostParamsPrepare
            });
        }

        function restoreDefault(store) {
            return $http({
                method: 'DELETE',
                url: './api/propertiesBag',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: store
                }
            });
        }

        function fnAccept(data) {
            return $q.resolve(data);
        }

        function fnError(_error) {
            //errorHandlerService.warn(error);
            return $q.resolve(null);
        }

        function transformProperties(data, _header, status) {
            if (status >= 400) {
                return { error: data };
            }

            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('i18nService', i18nService);

    i18nService.inject = ['$http'];

    function i18nService($http) {
        return translationHelper;

        function translationHelper(options) {
            return $http({
                method: 'GET',
                url: './data/translations/'+(options && options.key)+'.json'
            })
            .then(function(data){
                return data && data.data && data.data.response;
            })
            .catch(function(){
                return null;
            });
        }
    }
} ());
/*global window*/
(function () {
  'use strict';

  angular
    .module('app')
    .provider('tokenInterceptor', tokenInterceptor);

  function tokenInterceptor() {
    var config = this;
    config.idleTimeout = 60;

    this.$get = ['$injector', '$q', 'storageService', '$rootScope', '$log',
      function (_$injector, $q, storageService, $rootScope, _$log) {
        return {
          request: function (request) {
            var actualTimeStamp,
              timeDiff;
            // podemos añadir un parametro mas a la configuracion del $http para que no pase por aqui
            if (request.skipAuthorization) {
              return request;
            }

            // vamos a guardar una fecha en el localstorage
            var lastResource = storageService.retrieve('lastResource');
            if (!lastResource) {
              actualTimeStamp = new Date();
              storageService.save('lastResource', actualTimeStamp.valueOf());
            } else {
              // verificamos que el tiempo pasado desde la ultima peticion no supera el tiempo del idle
              actualTimeStamp = new Date();
              timeDiff = (actualTimeStamp.valueOf() - lastResource) / 1000;
              if (timeDiff > config.idleTimeout) {
                //$log.log('core:timeIdleError::', timeDiff);
                //$rootScope.$emit('core:timeIdleError');
                //return $q.reject();
              }
              storageService.save('lastResource', actualTimeStamp.valueOf());
            }



            //obtenemos el token
            var _usuario = storageService.retrieve('user');
            if (_usuario && _usuario.value) {
              request.headers = request.headers || {};
              request.headers['Authorization'] = _usuario.value;
            }

            return request;
          },
          requestError: function (error) {
            return $q.reject(error);
          },
          response: function (response) {
            return response;
          },
          responseError: function (error) {
            if(error && error.status === 401 && (error && error.config && error.config.url !== './api/authentication')){
              $rootScope.$emit("core:expiredToken");
            }
            return $q.reject(error);
          }
        };
      }
    ];
  }
}());

(function () {
    'use strict';

    angular
        .module('app')
        .factory('globalHelpersService', globalHelpersService);

    globalHelpersService.$inject = ['errorHandlerService','exportService','d3'];
    function globalHelpersService(errorHandlerService,exportService,d3) {
        var service = {
            httpPostParamsPrepare: httpPostParamsPrepare,
            exportXLSCallback:exportXLSCallback,
            exportPDFCallback:exportPDFCallback,
            getFileExtension:getFileExtension,
            getCompetence:getCompetence,
            getLighterColor: getLighterColor,
            getDarkerColor: getDarkerColor,
            frontFixedDecimal: frontFixedDecimal
        };

        return service;

        // private methods
        function httpPostParamsPrepare(obj) {
            var str = [];
            for (var p in obj) {
                if (obj[p]) {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                }
            }
            return str.join('&');
        }

        function exportXLSCallback(data) {
            if (!data.data.response || data.data.error) {
                errorHandlerService.callbackError('SERVICE_UNAVAILABLE');
            }
            exportService.downloadUrl('./api/xlsx/res/' + data.data.response);
        }

        function exportPDFCallback(data) {
            if (!data.data.response || data.data.error) {
                errorHandlerService.callbackError('SERVICE_UNAVAILABLE');
            }
            exportService.downloadUrl('./api/pdf/res/' + data.data.response);
        }

        function getFileExtension(file) {
            var extensionMatch = file.match(/\.[^\.]+$/g);

            if (extensionMatch.length !== 1) {
                return null;
            }
            
            return extensionMatch[0];
        }

        function getCompetence(competences,competenceId) {
            var competence = _.chain(competences).find({id:competenceId}).value();

            if (!competence) { return null; }

            return competence;
        }

        function getLighterColor(originalColor, _step){
            var step = _step || 1;
            var brighterColor = d3.rgb(d3.rgb(originalColor).brighter(step).toString(16));
            var r = brighterColor.r.toString(16) === '0' ? '00' : brighterColor.r.toString(16);
            var g = brighterColor.g.toString(16) === '0' ? '00' : brighterColor.g.toString(16);
            var b = brighterColor.b.toString(16) === '0' ? '00' : brighterColor.b.toString(16);
            var hexColor = '#' + r + g + b;
            return hexColor;
        }

        function getDarkerColor(originalColor, _step){
            var step = _step || 1;
            var brighterColor = d3.rgb(d3.rgb(originalColor).darker(step).toString(16));
            var r = brighterColor.r.toString(16) === '0' ? '00' : brighterColor.r.toString(16);
            var g = brighterColor.g.toString(16) === '0' ? '00' : brighterColor.g.toString(16);
            var b = brighterColor.b.toString(16) === '0' ? '00' : brighterColor.b.toString(16);
            var hexColor = '#' + r + g + b;
            return hexColor;
        }

        function frontFixedDecimal(number){
            return parseFloat(number.toFixed(1));
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('filterHelperService', filterHelperService);

    /* ngInject */
    function filterHelperService(storageService) {
        var service = {
            getCountrySelected:getCountrySelected,
            getPropertySelected:getPropertySelected,
            getFilterElementSelected:getFilterElementSelected,
            getFilterElement:getFilterElement
        };

        return service;

        /** private method */
        function getCountrySelected(){
            var filter = storageService.retrieve('filter');

            return _.chain(filter).result('country').value();
        }

        function getPropertySelected(property){
            var filter = storageService.retrieve('filter');

            return _.chain(filter).result(property).value();
        }

        function getFilterElement(filterCollection, eventId) {
            return _.chain(filterCollection)
                .map('filterInfo')
                .flatten()
                .find({ eventId: eventId })
                .value();
        }

        function getFilterElementSelected(filterCollection, eventId,prop) {
            if (!prop) { prop = 'id'; }
            var item = getFilterElement(filterCollection, eventId);

            if (!item) {
                return null;
            }

            return item[prop];
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('filterService', filterService);

    /* @ngInject */
    function filterService($rootScope, $q, storageService, $log) {
        var mainDeferred,
            mainFilters = [],
            processing = false,
            DEFAULT_PERSISTENT = true,
            DEFAULT_USE_CACHE = true;

        var waterfallContext = {
            _tmp: [],
            options: {},
            filterCache: []
        };

        /** public methods */

        var service = {
            getData: getData,
            onChangeCallback: onChangeCallback,
            clearContext: fnClearContext,
            getContext: getContext,
            setContext: setContext,
            setOptions: setOptions,
            getFromCache: getFromCache,
            saveToLocalstorage: saveToLocalstorage
        };



        return service;

        /** private methods */

        function fnClearContext() {
            var oldWaterfallContext = waterfallContext;
            waterfallContext = {
                _tmp: [],
                options: oldWaterfallContext.options,
                filterCache: []
            };
        }

        function getContext() {
            return waterfallContext;
        }

        function setContext(obj) {
            return angular.extend(waterfallContext, obj);
        }

        function setOptions(obj) {
            return angular.extend(waterfallContext.options, obj);
        }

        // main entrance point
        // cancelable (return null on cancel)
        // waterfall register
        function getData(filterDefinition, useCache, persistent, clearContext, options) {
            waterfallContext.options = options || {};
            waterfallContext.options.initialPersistence = persistent;
            if (processing) {
                $log.error('Multiple filter processes running is not permited');
                return $q.reject('Multiple filter processes running is not permited');
            }

            processing = true;

            if (angular.isDefined(clearContext) && clearContext) {
                fnClearContext();
            }

            mainFilters = filterDefinition;
            waterfallContext.options.persistent = angular.isDefined(persistent) ? persistent : DEFAULT_PERSISTENT;
            mainDeferred = $q.defer();
            // storageService.save('filter', waterfallContext);
            getFromCache(useCache)
                .then(function (filter) {
                    if(useCache){
                        processing = false;
                        return mainDeferred.resolve(filter);
                    }
                    return fetchFilter(mainDeferred,mainFilters);
                })
                .catch(function (error) {
                    processing = false;
                    return mainDeferred.reject('filterService::getData ->', error);
                });


            return mainDeferred.promise;
        }

        function fetchFilter(mainDeferred,mainFilters){
            return getFilterGroupMultiple(mainFilters)
                .then(persistFilter)
                .then(function (response) {
                    processing = false;
                    return mainDeferred.resolve(response);
                });
        }

        function persistFilter(filter) {
            // as tmp is temporal during tree computations, on end of all computations clean update
            waterfallContext._tmp = [];
            waterfallContext.filterCache = filter;

            if (waterfallContext.options.persistent) {
                storageService.save('filter', waterfallContext);
            }

            return filter;
        }

        function saveToLocalstorage() {
            storageService.save('filter', waterfallContext);
        }

        // main entry point to interpret json statement
        // first part is for each group make all request and 
        // wrap them within the gruop
        function getFilterGroupMultiple(itemCollection) {
            return _.reduce(itemCollection, function (aggr, item) {
                return aggr
                    .then(function (o) {
                        var acumula = o || [];
                        return getFilterGroup.apply(waterfallContext, [item])
                            .then(function (response) {
                                if (!response) { return acumula; }
                                acumula.push(response);
                                // add to tmp so it can be accesible from other sources
                                waterfallContext._tmp.push(response);
                                return acumula;
                            });
                    });
            }, $q.when(null));
        }

        // foe each group make requests and extend info from command tree for
        // that group with the info returned by request
        function getFilterGroup(item) {
            return getMainFilters(item.sources)
                .then(function (response) {
                    // one request can return an array, but at the end 
                    // we want it to be flat
                    // add requests to group data
                    return _.extend({}, item.group, { data: _.flatten(response) });
                })
                .then(afterAll.bind({ source: item }));
        }

        function afterAll(data) {
            var source = this.source;

            var functionsToApply = [source.group.setSelection, source.group.setFilterInfo, setEventName, setHidden];

            return _.reduce(functionsToApply, function (aggr, item) {
                aggr = item.apply(null, [aggr]);
                return aggr;
            }, data);
        }

        function setEventName(data) {
            var eventNames = _.chain(data.data)
                .map('eventName')
                .value();

            data.selection = data.selection && _.chain([].concat(data.selection))
                .map(function (item, index) {
                    item.eventName = eventNames[index];
                    return item;
                })
                .value();

            data.filterInfo = data.filterInfo && _.chain([].concat(data.filterInfo))
                .map(function (item, index) {
                    item.eventName = eventNames[index];
                    return item;
                })
                .value();

            return data;
        }

        // pass hide attr from elements to selection and filterInfo
        function setHidden(data) {
            var output = data;
            var eventsHidden = _.chain(data.data)
            .filter({ hide: true })
            .map('eventName')
            .uniq()
            .reduce(function(aggr,item) {
                var isVisible = _.chain(data.data).some(function(el){
                    return el.eventName === item && el.hide !== true;
                })
                .value();

                if (!isVisible) {
                    aggr.push(item);
                }

                return aggr;
            },[])
            .value();
            
            if (eventsHidden && eventsHidden.length > 0) {
                output.selection = _.chain([].concat(data.selection)).map(function (node) {
                    if (eventsHidden.indexOf(node.eventName) !== -1) {
                        node.hide = true;
                    }

                    return node;
                })
                    .value();

                output.filterInfo = _.chain([].concat(data.filterInfo)).map(function (node) {
                    if (eventsHidden.indexOf(node.eventName) !== -1) {
                        node.hide = true;
                    }

                    return node;
                })
                    .value();
            }

            return output;
        }


        // main entry point to make an array of requests
        function getMainFilters(filters) {
            return _.reduce(filters, filterWaterfallReducer, $q.when(null));
        }

        // reducer used to make sequencial requests
        // each request is called using as a context 
        // waterfallContext. We assume each filter logic
        // has access to this context and can be modified
        // from within them. So if we need to share info between
        // filters this context can be used.
        // ex: we update the context with the info of project and
        // wave so we can use it to get the right network
        // ex: we use it in case we want to get the filter from 
        // cache/localStorage, to pass this args to the filters contructor        
        function filterWaterfallReducer(aggr, item) {
            return aggr
                .then(function (o) {
                    var acumula = o || [];
                    return getMethod(item)
                        .then(function (response) {
                            var output;
                            if (!response) { return acumula; }
                            // each filter can return an array or a unic element
                            // we need to inject the eventId to the data structure
                            // as we use it to emit events from within the component
                            // in case it's an array we pass the same event to each
                            // element.
                            // ex: network has one only method but it return an array
                            // of elements, all will have the same eventId as this eventId
                            // is linked to the method used to request data
                            // ex: in case of project and wave each method returns one element
                            // each, so each one has its own event.
                            if (_.isArray(response.data) && item.multiEventId) {
                                response.data = _.map(response.data, function (subitem, index) {
                                    subitem.eventId = item.eventId;
                                    subitem.eventName = item.eventId + ':' + index;
                                    subitem.extraFilter = item.extraFilter;
                                    if (item.hidden) {
                                        subitem.hide = item.hidden;
                                    }
                                    return subitem;
                                });
                            } else if (_.isArray(response.data)) {
                                response.data = _.map(response.data, function (subitem) {
                                    subitem.eventId = item.eventId;
                                    subitem.eventName = item.eventId;
                                    subitem.extraFilter = item.extraFilter;
                                    if (item.hidden) {
                                        subitem.hide = item.hidden;
                                    }
                                    return subitem;
                                });
                            } else {
                                response.data.eventId = item.eventId;
                                response.data.eventName = item.eventId;
                                response.data.extraFilter = item.extraFilter;
                                if (item.hidden) {
                                    response.data.hide = item.hidden;
                                }
                            }

                            
                            output = response.data;

                            output = runPostOperations(item, output);

                            acumula.push(output);
                            return acumula;
                        });
                });
        }

        function runPostOperations(source, result) {
            var output = result;
            if (source.postOperations && source.postOperations.length > 0) {
                output = _.reduce(source.postOperations, function (aggr, item) {
                    return item.apply(null, [source, waterfallContext, aggr]);
                }, output);
            }
            return output;
        }

        function getMethod(item) {
            if (item.state === 'cache') {
                return $q.when(getComboData(item.eventId));
            } else {
                return item.method['getFilter'].apply(waterfallContext, [].concat(item.eventId,item.args));
            }
        }

        function getComboData(eventId) {
            var combo;
            combo = _.chain(waterfallContext.filterCache)
                .map('data')
                .flatten()
                .filter({ eventId: eventId })
                .value();

            return { data: combo };
        }

        // method used to restore filters from localStorage, it should only update 
        // waterfallContext each filter will make use of it as needed
        function getFromCache(useCache) {
            var storedFilter = storageService.retrieve('filter');

            
            if (angular.isUndefined(useCache)) {
                useCache = DEFAULT_USE_CACHE;
            }

            if (!useCache || !storedFilter) {
                return $q.resolve(null);
            } else {
                // we use extend because on drillthrough from widgets persist:true is lost on localStorage
                waterfallContext = _.extend(storedFilter, { options: waterfallContext.options });
                return $q.resolve(waterfallContext && waterfallContext.filterCache);
            }


            /*return decodeSelectedId(storedFilter.selectedId, storedFilter.wave)
                .then(function (data) {
                    return data.data.response;
                });
            */
        }

        // transform id to hash
        /*function decodeSelectedId(node, wave) {
            var params = {
                token: loginService.getToken(),
                networkName: node.network,
                nodeExternalId: node.node,
                referenceDate: $filter('waveToFullDate')(wave)
            };

    
            return $http({
                method: 'GET',
                url: './api/networks/networkLinkToNodeId',
                params: params
            });
        }*/

        function onChangeCallback(_event, object, eventId, emit) {

            if (!emit) { emit = true; }

            return $q.when(updateChangedItem(eventId, object))
                .then(function (nodes) {
                    return resolveDependencies(nodes, eventId);
                })
                .then(updateNodeTree)
                .then(persistFilter)
                .then(function (data) {
                    if (emit) {
                        $rootScope.$emit('filter:update', { data: data });
                    }
                    return data;
                });

        }

        function updateChangedItem(eventName, object) {
            // eventName is constructed using eventId:index (in case of multiEventId:true) or eventId with the rest
            // but eventName doesn't exist on actiontree so we have to use eventId
            var eventId = eventName.split(':')[0];

            var event = _.chain(mainFilters).flatMap('sources').find({ eventId: eventId }).value();
            var resetEventObj;

            // when updating by an event could happen need to clear some selections from context, 
            // that can be done using resetContext in sources (it's an array with the names of the
            // eventids to clear')
            if (event && event.resetContext) {

                resetEventObj = _.reduce(event.resetContext, function (aggr, item) {
                    aggr[item] = null; return aggr;
                }, {});

                waterfallContext = _.extend({}, waterfallContext, resetEventObj);
            }

            var nodes = _.map(waterfallContext['filterCache'], function (node) {
                var datos = _.map(node.data, function (subnode) {
                    if (subnode.eventName === eventName) {
                        subnode.selectedNode = object.id;
                    }
                    return subnode;
                });

                node.data = datos;
                return node;
            });

            if (!nodes) {
                throw ('filterService::updateChangedItem -> On update node does not exist');
            }

            waterfallContext[eventName] = object.id;
            return nodes;
        }

        function resolveDependencies(_nodes, eventId) {
            var actionTree = angular.copy(mainFilters);

            actionTree = _.map(actionTree, function (parent) {
                parent.sources = _.map(parent.sources, function (child) {
                    if (child.deps && child.deps.indexOf(eventId) != -1) {
                        /*if (child.alwaysReprocess) {
                            waterfallContext[child.eventId] = null;
                        }*/
                        child.state = 'pending';
                    } else {
                        child.state = 'cache';
                    }

                    if (child.alwaysReprocess && child.eventId === eventId) {
                        child.state = 'pending';
                    }

                    return child;
                });

                return parent;
            });

            return actionTree;
        }

        function updateNodeTree(actionTree) {
            return getFilterGroupMultiple(actionTree);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('exportService', exportService);

    exportService.$inject = ['$q','$timeout','$log','$document'];
    function exportService($q, $timeout, $log,$document) {
        var service = {
            downloadUrl: downloadVfsUrl,
            downloadBlob:downloadBlob
        };

        return service;

        /** private methods */
        function downloadVfsUrl(url) {
            var deferred = $q.defer(); 
            $log.log('downloading', url); 
 
            var hiddenIFrameID = new Date().toDateString(); 
            var iframe = $document && $document[0] && $document[0].createElement('iframe'); 
            iframe.id = hiddenIFrameID; 
            iframe.style.display = 'none'; 
            $document[0].body.appendChild(iframe); 
            iframe.src = url; 
            $timeout(function () { 
                if (iframe.remove) { 
                    iframe.remove(); 
                } else { 
                    iframe.removeNode(true); 
                } 
                $log.log('download succesful'); 
                deferred.resolve(); 
            }, 3000); 
            return deferred.promise;
        }

        function downloadBlob(data, fileName){
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            var json = JSON.stringify(data),
                blob = new Blob([json], {type: "octet/stream"}),
                url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('errorHandlerService', errorHandlerService);

    errorHandlerService.$inject = ['$log', 'toastr', '$translate'];
    function errorHandlerService($log, toastr, $translate) {
        var service = {};
        service.log = log;
        service.callbackError = callbackError;
        service.callbackSuccess = callbackSuccess;
        service.callbackWarning = callbackWarning;

        return service;

        /** private methods */

        function log(type, message) {
            if (type === 'log') {
                $log.log(message);
            }
            else if (type === 'warn') {
                $log.warn(message);
            }
            else if (type === 'error') {
                $log.error(message);
            }
        }

        function callbackSuccess() {
            var text = this && this.text;
            var options = this && this.options;
            toastr.success($translate.instant(text),null,options);
        }

        function callbackWarning() {
            var text = this && this.text;
            var options = this && this.options; 
            toastr.warning($translate.instant(text),null,options);
        }

        function callbackError(error) {
            var _error;

            var options = this && this.options;

            if (error.data && error.data.error) {
                _error = error.data.error;
            } else if (error.data === null) {
                throw (_error);
            } else {
                _error = error;
            }

            toastr.error($translate.instant(_error), options);
            throw (_error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('waveToFullDate', waveToFullDate)
        .filter('waveToFullDateFilter', waveToFullDateFilter)
        .filter('waveToDate', waveToDate)
        .filter('waveToDateMonth',waveToDateMonth)
        .filter('waveToShortYearAndMonth', waveToShortYearAndMonth)
        .filter('lodashRange', lodashRange)
        .filter('trustAsHTML', trustAsHTML)
        .filter('projectFormat', projectFormat)
        .filter('decodeUri',decodeUri)
        .filter('toLocaleDate',toLocaleDate)
        .filter('formatKpiTitleProject',formatKpiTitleProject)
        .filter('formatKpiTitleNetwork',formatKpiTitleNetwork)
        .filter('formatKpiTitleWave',formatKpiTitleWave)
        .filter('translationWithPrefix',translationWithPrefix)
        .filter('round',round)
        .filter('split',split)
        .filter('ellipsis',ellipsis)
        .filter('capitalize',capitalize)
        .filter('htmlToString',htmlToString)
        .filter('boldWords', boldWords);
        


    /* @ngInject */
    function waveToFullDate() {
        return function (wave) {
            var year = wave.substr(0, 4),
                month = wave.substr(4, 2),
                day = '02';

            return year + '-' + month + '-' + day;

        };
    }

    function waveToFullDateFilter() {
        return function (wave) {
            
            wave = wave && wave.toString();

            var year = wave.substr(0, 4),
                month = wave.substr(4, 2),
                day = wave.substr(6, 2);

            return day + '-' + month + '-' + year;

        };
    }

    /* @ngInject */
    function waveToDate($translate) {
        return function (wave) {
            if (!wave) { return 'NO WAVE'; }
            // la idea es del formato 201501 -> Jan 2015
            var year = wave.toString().substr(0, 4);
            var month = wave.toString().substr(4, 2);

            switch (month) {
                case '01':
                    return $translate.instant('JAN') + ' ' + year;
                case '02':
                    return $translate.instant('FEB') + ' ' + year;
                case '03':
                    return $translate.instant('MAR') + ' ' + year;
                case '04':
                    return $translate.instant('APR') + ' ' + year;
                case '05':
                    return $translate.instant('MAY') + ' ' + year;
                case '06':
                    return $translate.instant('JUN') + ' ' + year;
                case '07':
                    return $translate.instant('JUL') + ' ' + year;
                case '08':
                    return $translate.instant('AUG') + ' ' + year;
                case '09':
                    return $translate.instant('SEP') + ' ' + year;
                case '10':
                    return $translate.instant('OCT') + ' ' + year;
                case '11':
                    return $translate.instant('NOV') + ' ' + year;
                case '12':
                    return $translate.instant('DEC') + ' ' + year;
            }

            return 'NO WAVE';
        };
    }

    /* @ngInject */
    function waveToDateMonth($translate) {
        return function (wave) {
            if (!wave) { return 'NO WAVE'; }
            // la idea es del formato 201501 -> Jan 2015
            var month = wave.toString().substr(4, 2);

            switch (month) {
                case '01':
                    return $translate.instant('JAN').toUpperCase().substring(0,3);
                case '02':
                    return $translate.instant('FEB').toUpperCase().substring(0,3);
                case '03':
                    return $translate.instant('MAR').toUpperCase().substring(0,3);
                case '04':
                    return $translate.instant('APR').toUpperCase().substring(0,3);
                case '05':
                    return $translate.instant('MAY').toUpperCase().substring(0,3);
                case '06':
                    return $translate.instant('JUN').toUpperCase().substring(0,3);
                case '07':
                    return $translate.instant('JUL').toUpperCase().substring(0,3);
                case '08':
                    return $translate.instant('AUG').toUpperCase().substring(0,3);
                case '09':
                    return $translate.instant('SEP').toUpperCase().substring(0,3);
                case '10':
                    return $translate.instant('OCT').toUpperCase().substring(0,3);
                case '11':
                    return $translate.instant('NOV').toUpperCase().substring(0,3);
                case '12':
                    return $translate.instant('DEC').toUpperCase().substring(0,3);
            }

            return 'NO WAVE';
        };
    }
    
    /* @ngInject */
    function waveToShortYearAndMonth() {
        return function (wave) {
            if (!wave) { return 'NO WAVE'; }
            // la idea es del formato 201501 -> 15/01
            var year = wave.toString().substr(2, 2);
            var month = wave.toString().substr(4, 2);

            return year + '/' + month;
        };
    }

    lodashRange.$inject = ['errorHandlerService'];
    function lodashRange(errorHandlerService) {
        return function(value) {
            try {
                if (!value) {return [];}
                
                var num = parseInt(value);
                
                return _.range(num);    
            } catch (error) {
                errorHandlerService.log('error','lodashRange --> Not valid number');
                return [];
            }
        };
    }

    trustAsHTML.$inject = ['$sce'];
    function trustAsHTML($sce) {
        return function(value) {
            return $sce.trustAsHtml(value);
        };
    }

    projectFormat.$inject = ['filterHelperService'];
    function projectFormat(filterHelperService) {
        return function(value, origin, target) {
            return filterHelperService.projectCodeManager(value, origin, target);
        };
    }

    function decodeUri() {
        return function(value) {
            return decodeURIComponent(value); 
        };
    }

    toLocaleDate.$inject = ['moment'];
    function toLocaleDate(moment) {
        return function(value) {
            return moment(value).format('lll'); 
        };
    }

    //formatKpiTitleProject.$inject = ['configurationLoaderService'];
    formatKpiTitleProject.$inject = ['$translate'];
    function formatKpiTitleProject($translate) {
        return function(value) {
            var project = $translate.instant(value.id);
            return project; 
        };
    }
    
    //formatKpiTitleProject.$inject = ['configurationLoaderService'];
    function formatKpiTitleNetwork() {
        return function(value) {
            var node = value.text;
            return node; 
        };
    }

    formatKpiTitleWave.$inject = ['moment'];
    function formatKpiTitleWave(moment) {
        return function(value) {
            var wave = value.id;
            var dateMoment = moment(wave,'YYYYMM');
            
            var month = moment.localeData().months(dateMoment);
            var year = dateMoment.year();

            return month + ', '  + year;
        };
    }

    translationWithPrefix.$inject = ['$translate','configurationLoaderService'];
    function translationWithPrefix($translate, configurationLoaderService) {
        return function(value, prefix) {
            var prefixDefault = _.chain(configurationLoaderService.getConfig()).result('prefix').value();
            var textToTranslate = (prefix || prefixDefault) + '_' + value;
            return $translate.instant(textToTranslate);
        };
    }

    ellipsis.$inject = ['$translate'];
    function ellipsis(){
        return function(value,length){ 
            if(value && length &&  value.length > length){
                return value.slice(0,length).concat('...');
            }
            else{
                if(value && value.length > 30 && !length){
                    return value.slice(0,30).concat('...');
                }
                return value;
            }
        };
    }

    function round(){
        return function(value,numberDecimals){ 
            numberDecimals = angular.isDefined(numberDecimals) ? numberDecimals: 2;
            value = parseFloat(value);
            if(_.isNil(value) || _.isNaN(value)){
                return ' - ';
            }
            else{
                return value.toFixed(numberDecimals);
            }
        };
    }

    function split(){
        return function(value){ 
            if(_.isNil(value)){
                return '';
            }
            else{
                var val = value.split('-');
                return _.last(val);
            }
        };
    }

    capitalize.$inject = [];
    function capitalize() {
        return function(input) {
            return !_.isNil(input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        };
    }

    boldWords.$inject = [];
    function boldWords(){
        return function(value, wordsToBold){
            var input = value.split(' ');
            var finalTexT = '<p>';
            _.chain(input).each(function(item,index){
                if(_.includes(wordsToBold, input[index])){
                    finalTexT += ' <span class="bold--700"> '+ (item && item.toUpperCase()) +' </span> ';
                }
                else{
                    finalTexT += ' '+(item && item.toUpperCase()) +' ';
                }
            }).value();
            finalTexT += '</p>';
            return finalTexT;
        };
    }

    htmlToString.$inject = [];
    function htmlToString() {
        return function(value) {
            // clone element so the mutations don't affect the element origin
            var width = value.clientWidth;
            var _element = angular.element(value).clone();
            // remove elements specified with no-snapshot 
            _element.find('.no-snapshot').remove();

            // put it on the middle
            _element = _element.css({'width': width+'px'});

            // return the node stringified             
            return _element.get(0).outerHTML;
        };
    }
})();
(function() {
'use strict';

  angular
    .module('app.core')
    .factory('configurationLoaderService', configurationLoaderService);

  /* ngInject */
  function configurationLoaderService($http, errorHandlerService, $q) {
    var service = {
      getRemoteConfig: getRemoteConfig,
      getConfig: getConfig,
      getMenu: getMenu,
      getViewsConfiguration: getViewsConfiguration,
      isModuleEnabled: isModuleEnabled,
      loadViewsConfiguration: loadViewsConfiguration
    };

    var config;
    var viewsConfiguration;
    // Usar assets/data/statics para que pase por el proxy del filemanager (igual que las imágenes)
    var VIEWS_CONFIG_URL = 'assets/data/statics/resources/viewsConfiguration.json';

    return service;

    /** private methods */
    function getRemoteConfig() {
      return $http({
        method:'GET',
        url:'./data/config.json'
      })
      .then(function(data) {
        config = data.data;
        errorHandlerService.log('log','configurationLoaderService OK');
      });
    }

    function getConfig() {
      return config;
    }

    function getMenu(menuCollection, roles){
      var visibleMenuCollection = _.map(menuCollection, function(item){
        item.visible = item.allowedRoles && item.allowedRoles.length > 0 && _.intersection(item.allowedRoles, roles).length === 0 ? false : true;
        return item;
      });

      return angular.copy(visibleMenuCollection);
    }

    /**
     * Carga la configuración de vistas desde el filemanager
     * Se carga una vez por sesión (en el login) y se mantiene en memoria
     * Al hacer refresh (F5), se pierde la memoria y se vuelve a cargar desde el servidor
     */
    function loadViewsConfiguration() {
      // Si ya está cargada en memoria, devolverla directamente
      if (viewsConfiguration) {
        errorHandlerService.log('log', 'viewsConfiguration already loaded in memory');
        return $q.resolve(viewsConfiguration);
      }

      // Cargar desde el servidor (siempre que no esté en memoria)
      errorHandlerService.log('log', 'Loading viewsConfiguration from: ' + VIEWS_CONFIG_URL);
      return $http({
        method: 'GET',
        url: VIEWS_CONFIG_URL,
        cache: false,
        timeout: 10000
      })
      .then(function(response) {
        errorHandlerService.log('log', 'viewsConfiguration response status: ' + response.status);
        errorHandlerService.log('log', 'viewsConfiguration response data: ' + JSON.stringify(response.data).substring(0, 200));

        if (response.data && response.data.modules) {
          viewsConfiguration = response.data;
          errorHandlerService.log('log', 'viewsConfiguration loaded from server successfully');
          return viewsConfiguration;
        } else {
          errorHandlerService.log('error', 'Invalid viewsConfiguration format - missing modules property');
          // Si no tiene el formato correcto, seguir mostrando todo
          return $q.resolve({modules: {}});
        }
      })
      .catch(function(error) {
        errorHandlerService.log('error', 'Error loading viewsConfiguration: ' + JSON.stringify(error));
        // Si falla la carga, resolver con configuración vacía para mostrar todo
        return $q.resolve({modules: {}});
      });
    }

    /**
     * Obtiene la configuración de vistas actual
     */
    function getViewsConfiguration() {
      return viewsConfiguration;
    }

    /**
     * Verifica si un módulo está habilitado
     * @param {string} moduleName - Nombre del módulo (ej: 'layout21')
     * @returns {boolean} - true si está habilitado, false si no
     */
    function isModuleEnabled(moduleName) {
      errorHandlerService.log('log', 'isModuleEnabled called for: ' + moduleName);
      errorHandlerService.log('log', 'viewsConfiguration state: ' + JSON.stringify(viewsConfiguration));

      if (!viewsConfiguration || !viewsConfiguration.modules) {
        // Si no hay configuración, mostrar todo por defecto (fallback)
        errorHandlerService.log('warn', 'No viewsConfiguration loaded, showing all modules by default');
        return true;
      }
      // Si el módulo no está en la configuración, mostrar por defecto
      if (viewsConfiguration.modules[moduleName] === undefined) {
        errorHandlerService.log('log', 'Module ' + moduleName + ' not in config, showing by default');
        return true;
      }
      var isEnabled = viewsConfiguration.modules[moduleName] === true;
      errorHandlerService.log('log', 'Module ' + moduleName + ' is ' + (isEnabled ? 'ENABLED' : 'DISABLED'));
      return isEnabled;
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  runBlock.$inject = ['errorHandlerService', 'routingService', 'Highcharts', 'socketService', 'Analytics', '$location','$rootScope'];
  function runBlock(errorHandlerService, routingService, Highcharts, socketService, Analytics, $location, $rootScope) {
    errorHandlerService.log('log', 'Enter run block');

    // register callbacks on route change
    routingService.registerCallbacks();

    Highcharts.setOptions({
      lang: {
        thousandsSep: '.',
        decimalPoint: ','
      }
    });
    socketService.init();    

    $rootScope.$on('$stateChangeSuccess', successTransitionHook);

    function successTransitionHook(_event, toState, _toParams, _fromState, _fromParams) { 
      if (toState && !toState.doNotTrack) {
        Analytics.trackPage( $location.url() );
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/login');
  }

})();

/* global moment:false, _:false, d3:false, Highcharts:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment)
    .constant('lodash', _)
    .constant('Highcharts', Highcharts)
    .constant('d3',d3);
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $translateProvider, $httpProvider, tmhDynamicLocaleProvider, AnalyticsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // translations
    $translateProvider.useLoader('i18nService', {});
    tmhDynamicLocaleProvider.localeLocationPattern('/bower_components/angular-i18n/angular-locale_{{locale}}.js');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.maxOpened = 7;
    toastrConfig.positionClass = 'toast-bottom-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.preventOpenDuplicates = false;
    toastrConfig.progressBar = false;
    toastrConfig.newestOnTop = true;

    $httpProvider.interceptors.push('tokenInterceptor');

    AnalyticsProvider.setAccount(
    {
      tracker: 'UA-11767541-22',
      set: {
        anonymizeIp: true
      },
      trackEvent: true
    }
  );

    AnalyticsProvider.trackUrlParams(true);
    AnalyticsProvider.ignoreFirstPageLoad(true);

  }

})();
